// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles
parcelRequire = (function (modules, cache, entry, globalName) {
  // Save the require from previous bundle to this closure if any
  var previousRequire = typeof parcelRequire === 'function' && parcelRequire;
  var nodeRequire = typeof require === 'function' && require;

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire = typeof parcelRequire === 'function' && parcelRequire;
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error('Cannot find module \'' + name + '\'');
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = cache[name] = new newRequire.Module(name);

      modules[name][0].call(module.exports, localRequire, module, module.exports, this);
    }

    return cache[name].exports;

    function localRequire(x){
      return newRequire(localRequire.resolve(x));
    }

    function resolve(x){
      return modules[name][1][x] || x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [function (require, module) {
      module.exports = exports;
    }, {}];
  };

  var error;
  for (var i = 0; i < entry.length; i++) {
    try {
      newRequire(entry[i]);
    } catch (e) {
      // Save first error but execute all entries
      if (!error) {
        error = e;
      }
    }
  }

  if (entry.length) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(entry[entry.length - 1]);

    // CommonJS
    if (typeof exports === "object" && typeof module !== "undefined") {
      module.exports = mainExports;

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
     define(function () {
       return mainExports;
     });

    // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }

  // Override the current require with this new one
  parcelRequire = newRequire;

  if (error) {
    // throw error from earlier, _after updating parcelRequire_
    throw error;
  }

  return newRequire;
})({"agGE":[function(require,module,exports) {
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"mzxU":[function(require,module,exports) {
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"rDlq":[function(require,module,exports) {
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"YHGW":[function(require,module,exports) {
var regeneratorDefine = require("./regeneratorDefine.js");
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./regeneratorDefine.js":"rDlq"}],"ZTF3":[function(require,module,exports) {
var OverloadYield = require("./OverloadYield.js");
var regeneratorDefine = require("./regeneratorDefine.js");
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./OverloadYield.js":"mzxU","./regeneratorDefine.js":"rDlq"}],"eYD0":[function(require,module,exports) {
var regenerator = require("./regenerator.js");
var regeneratorAsyncIterator = require("./regeneratorAsyncIterator.js");
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./regenerator.js":"YHGW","./regeneratorAsyncIterator.js":"ZTF3"}],"orQ5":[function(require,module,exports) {
var regeneratorAsyncGen = require("./regeneratorAsyncGen.js");
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./regeneratorAsyncGen.js":"eYD0"}],"AyZx":[function(require,module,exports) {
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"b9XL":[function(require,module,exports) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"QWEG":[function(require,module,exports) {
var _typeof = require("./typeof.js")["default"];
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":"b9XL"}],"mDCk":[function(require,module,exports) {
var OverloadYield = require("./OverloadYield.js");
var regenerator = require("./regenerator.js");
var regeneratorAsync = require("./regeneratorAsync.js");
var regeneratorAsyncGen = require("./regeneratorAsyncGen.js");
var regeneratorAsyncIterator = require("./regeneratorAsyncIterator.js");
var regeneratorKeys = require("./regeneratorKeys.js");
var regeneratorValues = require("./regeneratorValues.js");
function _regeneratorRuntime() {
  "use strict";

  var r = regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./OverloadYield.js":"mzxU","./regenerator.js":"YHGW","./regeneratorAsync.js":"orQ5","./regeneratorAsyncGen.js":"eYD0","./regeneratorAsyncIterator.js":"ZTF3","./regeneratorKeys.js":"AyZx","./regeneratorValues.js":"QWEG"}],"PMvg":[function(require,module,exports) {
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// TODO(Babel 8): Remove this file.

var runtime = require("../helpers/regeneratorRuntime")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
},{"../helpers/regeneratorRuntime":"mDCk"}],"BvG2":[function(require,module,exports) {
var _typeof = require("./typeof.js")["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":"b9XL"}],"GBoX":[function(require,module,exports) {
var _typeof = require("./typeof.js")["default"];
var toPrimitive = require("./toPrimitive.js");
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":"b9XL","./toPrimitive.js":"BvG2"}],"IxO8":[function(require,module,exports) {
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":"GBoX"}],"QFb6":[function(require,module,exports) {
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"AkAO":[function(require,module,exports) {
function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"dJhE":[function(require,module,exports) {
var isNativeReflectConstruct = require("./isNativeReflectConstruct.js");
var setPrototypeOf = require("./setPrototypeOf.js");
function _construct(t, e, r) {
  if (isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && setPrototypeOf(p, r.prototype), p;
}
module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./isNativeReflectConstruct.js":"QFb6","./setPrototypeOf.js":"AkAO"}],"NVR6":[function(require,module,exports) {
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"XfJI":[function(require,module,exports) {
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":"NVR6"}],"OMTj":[function(require,module,exports) {
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"UyFj":[function(require,module,exports) {
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":"NVR6"}],"wFNi":[function(require,module,exports) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"Fhqp":[function(require,module,exports) {
var arrayWithoutHoles = require("./arrayWithoutHoles.js");
var iterableToArray = require("./iterableToArray.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableSpread = require("./nonIterableSpread.js");
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithoutHoles.js":"XfJI","./iterableToArray.js":"OMTj","./unsupportedIterableToArray.js":"UyFj","./nonIterableSpread.js":"wFNi"}],"UJE0":[function(require,module,exports) {
function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"aYhM":[function(require,module,exports) {
var getPrototypeOf = require("./getPrototypeOf.js");
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = getPrototypeOf(t)););
  return t;
}
module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./getPrototypeOf.js":"UJE0"}],"J5UC":[function(require,module,exports) {
var superPropBase = require("./superPropBase.js");
function _get() {
  return module.exports = _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _get.apply(null, arguments);
}
module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./superPropBase.js":"aYhM"}],"fcMS":[function(require,module,exports) {
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"P8NW":[function(require,module,exports) {
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":"GBoX"}],"E7HD":[function(require,module,exports) {
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"pxk2":[function(require,module,exports) {
var _typeof = require("./typeof.js")["default"];
var assertThisInitialized = require("./assertThisInitialized.js");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":"b9XL","./assertThisInitialized.js":"E7HD"}],"d4H2":[function(require,module,exports) {
var setPrototypeOf = require("./setPrototypeOf.js");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./setPrototypeOf.js":"AkAO"}],"vNP7":[function(require,module,exports) {
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],"ozpi":[function(require,module,exports) {
var getPrototypeOf = require("./getPrototypeOf.js");
var setPrototypeOf = require("./setPrototypeOf.js");
var isNativeFunction = require("./isNativeFunction.js");
var construct = require("./construct.js");
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return module.exports = _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return construct(t, arguments, getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), setPrototypeOf(Wrapper, t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _wrapNativeSuper(t);
}
module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./getPrototypeOf.js":"UJE0","./setPrototypeOf.js":"AkAO","./isNativeFunction.js":"vNP7","./construct.js":"dJhE"}],"yHh2":[function(require,module,exports) {
var define;
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.5.4",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        objtos = Object.prototype.toString,
        Str = String,
        isArray = Array.isArray || function (ar) {
            return ar instanceof Array || objtos.call(ar) == "[object Array]";
        },
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        eve = function (name, scope) {
            var oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event;
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
    // Undocumented. Debug only.
    eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = isArray(name) ? name : name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/
    eve.separator = function (sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else {
            separator = /[\.\/]/;
        }
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        if (typeof f != "function") {
            return function () {};
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = isArray(name) ? name : Str(name).split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        }
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events],
            inodes = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                        inodes.unshift({
                            n: e,
                            name: names[i]
                        });
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                        inodes.unshift({
                            n: e,
                            name: key
                        });
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
        // prune inner nodes in path
        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
            e = inodes[i];
            for (key in e.n[e.name].f) {
                // not empty (has listeners)
                continue prune;
            }
            for (key in e.n[e.name].n) {
                // not empty (has children)
                continue prune;
            }
            // is empty
            delete e.n[e.name];
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    glob.eve = eve;
    typeof module != "undefined" && module.exports ? module.exports = eve : typeof define === "function" && define.amd ? define("eve", [], function () { return eve; }) : glob.eve = eve;
})(typeof window != "undefined" ? window : this);

},{}],"BQ54":[function(require,module,exports) {
var define;
var global = arguments[3];
"use strict";

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Snap.svg 0.5.1
//
// Copyright (c) 2013 – 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
//
// build: 2017-02-07

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.0 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
  var version = "0.5.0",
    has = "hasOwnProperty",
    separator = /[\.\/]/,
    comaseparator = /\s*,\s*/,
    wildcard = "*",
    fun = function fun() {},
    numsort = function numsort(a, b) {
      return a - b;
    },
    current_event,
    stop,
    events = {
      n: {}
    },
    firstDefined = function firstDefined() {
      for (var i = 0, ii = this.length; i < ii; i++) {
        if (typeof this[i] != "undefined") {
          return this[i];
        }
      }
    },
    lastDefined = function lastDefined() {
      var i = this.length;
      while (--i) {
        if (typeof this[i] != "undefined") {
          return this[i];
        }
      }
    },
    objtos = Object.prototype.toString,
    Str = String,
    isArray = Array.isArray || function (ar) {
      return ar instanceof Array || objtos.call(ar) == "[object Array]";
    };
  /*\
     * eve
     [ method ]
       * Fires event with given `name`, given scope and other parameters.
       > Arguments
       - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers
       = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
  eve = function (_eve) {
    function eve(_x, _x2) {
      return _eve.apply(this, arguments);
    }
    eve.toString = function () {
      return _eve.toString();
    };
    return eve;
  }(function (name, scope) {
    var e = events,
      oldstop = stop,
      args = Array.prototype.slice.call(arguments, 2),
      listeners = eve.listeners(name),
      z = 0,
      f = false,
      l,
      indexed = [],
      queue = {},
      out = [],
      ce = current_event,
      errors = [];
    out.firstDefined = firstDefined;
    out.lastDefined = lastDefined;
    current_event = name;
    stop = 0;
    for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
      indexed.push(listeners[i].zIndex);
      if (listeners[i].zIndex < 0) {
        queue[listeners[i].zIndex] = listeners[i];
      }
    }
    indexed.sort(numsort);
    while (indexed[z] < 0) {
      l = queue[indexed[z++]];
      out.push(l.apply(scope, args));
      if (stop) {
        stop = oldstop;
        return out;
      }
    }
    for (i = 0; i < ii; i++) {
      l = listeners[i];
      if ("zIndex" in l) {
        if (l.zIndex == indexed[z]) {
          out.push(l.apply(scope, args));
          if (stop) {
            break;
          }
          do {
            z++;
            l = queue[indexed[z]];
            l && out.push(l.apply(scope, args));
            if (stop) {
              break;
            }
          } while (l);
        } else {
          queue[l.zIndex] = l;
        }
      } else {
        out.push(l.apply(scope, args));
        if (stop) {
          break;
        }
      }
    }
    stop = oldstop;
    current_event = ce;
    return out;
  });
  // Undocumented. Debug only.
  eve._events = events;
  /*\
     * eve.listeners
     [ method ]
       * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
       > Arguments
       - name (string) name of the event, dot (`.`) or slash (`/`) separated
       = (array) array of event handlers
    \*/
  eve.listeners = function (name) {
    var names = isArray(name) ? name : name.split(separator),
      e = events,
      item,
      items,
      k,
      i,
      ii,
      j,
      jj,
      nes,
      es = [e],
      out = [];
    for (i = 0, ii = names.length; i < ii; i++) {
      nes = [];
      for (j = 0, jj = es.length; j < jj; j++) {
        e = es[j].n;
        items = [e[names[i]], e[wildcard]];
        k = 2;
        while (k--) {
          item = items[k];
          if (item) {
            nes.push(item);
            out = out.concat(item.f || []);
          }
        }
      }
      es = nes;
    }
    return out;
  };
  /*\
     * eve.separator
     [ method ]
       * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.
       - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/
  eve.separator = function (sep) {
    if (sep) {
      sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
      sep = "[" + sep + "]";
      separator = new RegExp(sep);
    } else {
      separator = /[\.\/]/;
    }
  };
  /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment. 
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
  eve.on = function (name, f) {
    if (typeof f != "function") {
      return function () {};
    }
    var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
    for (var i = 0, ii = names.length; i < ii; i++) {
      (function (name) {
        var names = isArray(name) ? name : Str(name).split(separator),
          e = events,
          exist;
        for (var i = 0, ii = names.length; i < ii; i++) {
          e = e.n;
          e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {
            n: {}
          });
        }
        e.f = e.f || [];
        for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
          exist = true;
          break;
        }
        !exist && e.f.push(f);
      })(names[i]);
    }
    return function (zIndex) {
      if (+zIndex == +zIndex) {
        f.zIndex = +zIndex;
      }
    };
  };
  /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     > Arguments
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
  eve.f = function (event) {
    var attrs = [].slice.call(arguments, 1);
    return function () {
      eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
    };
  };
  /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
  eve.stop = function () {
    stop = 1;
  };
  /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     > Arguments
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
  eve.nt = function (subname) {
    var cur = isArray(current_event) ? current_event.join(".") : current_event;
    if (subname) {
      return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
    }
    return cur;
  };
  /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
  eve.nts = function () {
    return isArray(current_event) ? current_event : current_event.split(separator);
  };
  /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
  /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
  eve.off = eve.unbind = function (name, f) {
    if (!name) {
      eve._events = events = {
        n: {}
      };
      return;
    }
    var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
    if (names.length > 1) {
      for (var i = 0, ii = names.length; i < ii; i++) {
        eve.off(names[i], f);
      }
      return;
    }
    names = isArray(name) ? name : Str(name).split(separator);
    var e,
      key,
      splice,
      i,
      ii,
      j,
      jj,
      cur = [events],
      inodes = [];
    for (i = 0, ii = names.length; i < ii; i++) {
      for (j = 0; j < cur.length; j += splice.length - 2) {
        splice = [j, 1];
        e = cur[j].n;
        if (names[i] != wildcard) {
          if (e[names[i]]) {
            splice.push(e[names[i]]);
            inodes.unshift({
              n: e,
              name: names[i]
            });
          }
        } else {
          for (key in e) if (e[has](key)) {
            splice.push(e[key]);
            inodes.unshift({
              n: e,
              name: key
            });
          }
        }
        cur.splice.apply(cur, splice);
      }
    }
    for (i = 0, ii = cur.length; i < ii; i++) {
      e = cur[i];
      while (e.n) {
        if (f) {
          if (e.f) {
            for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
              e.f.splice(j, 1);
              break;
            }
            !e.f.length && delete e.f;
          }
          for (key in e.n) if (e.n[has](key) && e.n[key].f) {
            var funcs = e.n[key].f;
            for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
              funcs.splice(j, 1);
              break;
            }
            !funcs.length && delete e.n[key].f;
          }
        } else {
          delete e.f;
          for (key in e.n) if (e.n[has](key) && e.n[key].f) {
            delete e.n[key].f;
          }
        }
        e = e.n;
      }
    }
    // prune inner nodes in path
    prune: for (i = 0, ii = inodes.length; i < ii; i++) {
      e = inodes[i];
      for (key in e.n[e.name].f) {
        // not empty (has listeners)
        continue prune;
      }
      for (key in e.n[e.name].n) {
        // not empty (has children)
        continue prune;
      }
      // is empty
      delete e.n[e.name];
    }
  };
  /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
  eve.once = function (name, f) {
    var _f = function f2() {
      eve.off(name, _f);
      return f.apply(this, arguments);
    };
    return eve.on(name, _f);
  };
  /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
  eve.version = version;
  eve.toString = function () {
    return "You are running Eve " + version;
  };
  typeof module != "undefined" && module.exports ? module.exports = eve : typeof define === "function" && define.amd ? define("eve", [], function () {
    return eve;
  }) : glob.eve = eve;
})(void 0);
(function (glob, factory) {
  // AMD support
  if (typeof define == "function" && define.amd) {
    // Define as an anonymous module
    define(["eve"], function (eve) {
      return factory(glob, eve);
    });
  } else if (typeof exports != "undefined") {
    // Next for Node.js or CommonJS
    var eve = require("eve");
    module.exports = factory(glob, eve);
  } else {
    // Browser globals (glob is window)
    // Snap adds itself to window
    factory(glob, glob.eve);
  }
})(window || void 0, function (window, eve) {
  // Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  var mina = function (eve) {
    var animations = {},
      requestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
        setTimeout(callback, 16, new Date().getTime());
        return true;
      },
      requestID,
      isArray = Array.isArray || function (a) {
        return a instanceof Array || Object.prototype.toString.call(a) == "[object Array]";
      },
      idgen = 0,
      idprefix = "M" + (+new Date()).toString(36),
      ID = function ID() {
        return idprefix + (idgen++).toString(36);
      },
      _diff = function diff(a, b, A, B) {
        if (isArray(a)) {
          res = [];
          for (var i = 0, ii = a.length; i < ii; i++) {
            res[i] = _diff(a[i], b, A[i], B);
          }
          return res;
        }
        var dif = (A - a) / (B - b);
        return function (bb) {
          return a + dif * (bb - b);
        };
      },
      timer = Date.now || function () {
        return +new Date();
      },
      sta = function sta(val) {
        var a = this;
        if (val == null) {
          return a.s;
        }
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
      },
      speed = function speed(val) {
        var a = this;
        if (val == null) {
          return a.spd;
        }
        a.spd = val;
      },
      duration = function duration(val) {
        var a = this;
        if (val == null) {
          return a.dur;
        }
        a.s = a.s * val / a.dur;
        a.dur = val;
      },
      stopit = function stopit() {
        var a = this;
        delete animations[a.id];
        a.update();
        eve("mina.stop." + a.id, a);
      },
      pause = function pause() {
        var a = this;
        if (a.pdif) {
          return;
        }
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
      },
      resume = function resume() {
        var a = this;
        if (!a.pdif) {
          return;
        }
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
        _frame();
      },
      update = function update() {
        var a = this,
          res;
        if (isArray(a.start)) {
          res = [];
          for (var j = 0, jj = a.start.length; j < jj; j++) {
            res[j] = +a.start[j] + (a.end[j] - a.start[j]) * a.easing(a.s);
          }
        } else {
          res = +a.start + (a.end - a.start) * a.easing(a.s);
        }
        a.set(res);
      },
      _frame = function frame(timeStamp) {
        // Manual invokation?
        if (!timeStamp) {
          // Frame loop stopped?
          if (!requestID) {
            // Start frame loop...
            requestID = requestAnimFrame(_frame);
          }
          return;
        }
        var len = 0;
        for (var i in animations) if (animations.hasOwnProperty(i)) {
          var a = animations[i],
            b = a.get(),
            res;
          len++;
          a.s = (b - a.b) / (a.dur / a.spd);
          if (a.s >= 1) {
            delete animations[i];
            a.s = 1;
            len--;
            (function (a) {
              setTimeout(function () {
                eve("mina.finish." + a.id, a);
              });
            })(a);
          }
          a.update();
        }
        requestID = len ? requestAnimFrame(_frame) : false;
      },
      /*\
      * mina
      [ method ]
      **
      * Generic animation of numbers
      **
      - a (number) start _slave_ number
      - A (number) end _slave_ number
      - b (number) start _master_ number (start time in general case)
      - B (number) end _master_ number (end time in general case)
      - get (function) getter of _master_ number (see @mina.time)
      - set (function) setter of _slave_ number
      - easing (function) #optional easing function, default is @mina.linear
      = (object) animation descriptor
      o {
      o         id (string) animation id,
      o         start (number) start _slave_ number,
      o         end (number) end _slave_ number,
      o         b (number) start _master_ number,
      o         s (number) animation status (0..1),
      o         dur (number) animation duration,
      o         spd (number) animation speed,
      o         get (function) getter of _master_ number (see @mina.time),
      o         set (function) setter of _slave_ number,
      o         easing (function) easing function, default is @mina.linear,
      o         status (function) status getter/setter,
      o         speed (function) speed getter/setter,
      o         duration (function) duration getter/setter,
      o         stop (function) animation stopper
      o         pause (function) pauses the animation
      o         resume (function) resumes the animation
      o         update (function) calles setter with the right value of the animation
      o }
      \*/
      _mina = function mina(a, A, b, B, get, set, easing) {
        var anim = {
          id: ID(),
          start: a,
          end: A,
          b: b,
          s: 0,
          dur: B - b,
          spd: 1,
          get: get,
          set: set,
          easing: easing || _mina.linear,
          status: sta,
          speed: speed,
          duration: duration,
          stop: stopit,
          pause: pause,
          resume: resume,
          update: update
        };
        animations[anim.id] = anim;
        var len = 0,
          i;
        for (i in animations) if (animations.hasOwnProperty(i)) {
          len++;
          if (len == 2) {
            break;
          }
        }
        len == 1 && _frame();
        return anim;
      };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/
    _mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/
    _mina.getById = function (id) {
      return animations[id] || null;
    };

    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.linear = function (n) {
      return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.easeout = function (n) {
      return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.easein = function (n) {
      return Math.pow(n, 0.48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.easeinout = function (n) {
      if (n == 1) {
        return 1;
      }
      if (n == 0) {
        return 0;
      }
      var q = 0.48 - n / 1.04,
        Q = Math.sqrt(0.1734 + q * q),
        x = Q - q,
        X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
        y = -Q - q,
        Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
        t = X + Y + 0.5;
      return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.backin = function (n) {
      if (n == 1) {
        return 1;
      }
      var s = 1.70158;
      return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.backout = function (n) {
      if (n == 0) {
        return 0;
      }
      n = n - 1;
      var s = 1.70158;
      return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.elastic = function (n) {
      if (n == !!n) {
        return n;
      }
      return Math.pow(2, -10 * n) * Math.sin((n - 0.075) * (2 * Math.PI) / 0.3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    _mina.bounce = function (n) {
      var s = 7.5625,
        p = 2.75,
        l;
      if (n < 1 / p) {
        l = s * n * n;
      } else {
        if (n < 2 / p) {
          n -= 1.5 / p;
          l = s * n * n + 0.75;
        } else {
          if (n < 2.5 / p) {
            n -= 2.25 / p;
            l = s * n * n + 0.9375;
          } else {
            n -= 2.625 / p;
            l = s * n * n + 0.984375;
          }
        }
      }
      return l;
    };
    window.mina = _mina;
    return _mina;
  }(typeof eve == "undefined" ? function () {} : eve);

  // Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.

  var Snap = function (root) {
    Snap.version = "0.5.1";
    /*\
    * Snap
    [ method ]
    **
    * Creates a drawing surface or wraps existing SVG element.
    **
    - width (number|string) width of surface
    - height (number|string) height of surface
    * or
    - DOM (SVGElement) element to be wrapped into Snap structure
    * or
    - array (array) array of elements (will return set of elements)
    * or
    - query (string) CSS query selector
    = (object) @Element
    \*/
    function Snap(w, h) {
      if (w) {
        if (w.nodeType) {
          return wrap(w);
        }
        if (is(w, "array") && Snap.set) {
          return Snap.set.apply(Snap, w);
        }
        if (w instanceof Element) {
          return w;
        }
        if (h == null) {
          try {
            w = glob.doc.querySelector(String(w));
            return wrap(w);
          } catch (e) {
            return null;
          }
        }
      }
      w = w == null ? "100%" : w;
      h = h == null ? "100%" : h;
      return new Paper(w, h);
    }
    Snap.toString = function () {
      return "Snap v" + this.version;
    };
    Snap._ = {};
    var glob = {
      win: root.window,
      doc: root.window.document
    };
    Snap._.glob = glob;
    var has = "hasOwnProperty",
      Str = String,
      toFloat = parseFloat,
      toInt = parseInt,
      math = Math,
      mmax = math.max,
      mmin = math.min,
      abs = math.abs,
      pow = math.pow,
      PI = math.PI,
      round = math.round,
      E = "",
      S = " ",
      objectToString = Object.prototype.toString,
      ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
      colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
      bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
      separator = Snap._.separator = /[,\s]+/,
      whitespace = /[\s]/g,
      commaSpaces = /[\s]*,[\s]*/,
      hsrg = {
        hs: 1,
        rg: 1
      },
      pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi,
      tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi,
      pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/gi,
      idgen = 0,
      idprefix = "S" + (+new Date()).toString(36),
      ID = function ID(el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
      },
      xlink = "http://www.w3.org/1999/xlink",
      xmlns = "http://www.w3.org/2000/svg",
      hub = {},
      /*\
      * Snap.url
      [ method ]
      **
      * Wraps path into `"url('<path>')"`.
      - value (string) path
      = (string) wrapped path
      \*/
      URL = Snap.url = function (url) {
        return "url('#" + url + "')";
      };
    function $(el, attr) {
      if (attr) {
        if (el == "#text") {
          el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
        }
        if (el == "#comment") {
          el = glob.doc.createComment(attr.text || attr["#text"] || "");
        }
        if (typeof el == "string") {
          el = $(el);
        }
        if (typeof attr == "string") {
          if (el.nodeType == 1) {
            if (attr.substring(0, 6) == "xlink:") {
              return el.getAttributeNS(xlink, attr.substring(6));
            }
            if (attr.substring(0, 4) == "xml:") {
              return el.getAttributeNS(xmlns, attr.substring(4));
            }
            return el.getAttribute(attr);
          } else if (attr == "text") {
            return el.nodeValue;
          } else {
            return null;
          }
        }
        if (el.nodeType == 1) {
          for (var key in attr) if (attr[has](key)) {
            var val = Str(attr[key]);
            if (val) {
              if (key.substring(0, 6) == "xlink:") {
                el.setAttributeNS(xlink, key.substring(6), val);
              } else if (key.substring(0, 4) == "xml:") {
                el.setAttributeNS(xmlns, key.substring(4), val);
              } else {
                el.setAttribute(key, val);
              }
            } else {
              el.removeAttribute(key);
            }
          }
        } else if ("text" in attr) {
          el.nodeValue = attr.text;
        }
      } else {
        el = glob.doc.createElementNS(xmlns, el);
      }
      return el;
    }
    Snap._.$ = $;
    Snap._.id = ID;
    function getAttrs(el) {
      var attrs = el.attributes,
        name,
        out = {};
      for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].namespaceURI == xlink) {
          name = "xlink:";
        } else {
          name = "";
        }
        name += attrs[i].name;
        out[name] = attrs[i].textContent;
      }
      return out;
    }
    function is(o, type) {
      type = Str.prototype.toLowerCase.call(type);
      if (type == "finite") {
        return isFinite(o);
      }
      if (type == "array" && (o instanceof Array || Array.isArray && Array.isArray(o))) {
        return true;
      }
      return type == "null" && o === null || type == (0, _typeof2.default)(o) && o !== null || type == "object" && o === Object(o) || objectToString.call(o).slice(8, -1).toLowerCase() == type;
    }
    /*\
    * Snap.format
    [ method ]
    **
    * Replaces construction of type `{<name>}` to the corresponding argument
    **
    - token (string) string to format
    - json (object) object which properties are used as a replacement
    = (string) formatted string
    > Usage
    | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
    | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
    |     x: 10,
    |     y: 20,
    |     dim: {
    |         width: 40,
    |         height: 50,
    |         "negative width": -40
    |     }
    | }));
    \*/
    Snap.format = function () {
      var tokenRegex = /\{([^\}]+)\}/g,
        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g,
        // matches .xxxxx or ["xxxxx"] to run over object properties
        replacer = function replacer(all, key, obj) {
          var res = obj;
          key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
            name = name || quotedName;
            if (res) {
              if (name in res) {
                res = res[name];
              }
              typeof res == "function" && isFunc && (res = res());
            }
          });
          res = (res == null || res == obj ? all : res) + "";
          return res;
        };
      return function (str, obj) {
        return Str(str).replace(tokenRegex, function (all, key) {
          return replacer(all, key, obj);
        });
      };
    }();
    function clone(obj) {
      if (typeof obj == "function" || Object(obj) !== obj) {
        return obj;
      }
      var res = new obj.constructor();
      for (var key in obj) if (obj[has](key)) {
        res[key] = clone(obj[key]);
      }
      return res;
    }
    Snap._.clone = clone;
    function repush(array, item) {
      for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
        return array.push(array.splice(i, 1)[0]);
      }
    }
    function cacher(f, scope, postprocessor) {
      function newf() {
        var arg = Array.prototype.slice.call(arguments, 0),
          args = arg.join("\u2400"),
          cache = newf.cache = newf.cache || {},
          count = newf.count = newf.count || [];
        if (cache[has](args)) {
          repush(count, args);
          return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        count.length >= 1e3 && delete cache[count.shift()];
        count.push(args);
        cache[args] = f.apply(scope, arg);
        return postprocessor ? postprocessor(cache[args]) : cache[args];
      }
      return newf;
    }
    Snap._.cacher = cacher;
    function angle(x1, y1, x2, y2, x3, y3) {
      if (x3 == null) {
        var x = x1 - x2,
          y = y1 - y2;
        if (!x && !y) {
          return 0;
        }
        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
      } else {
        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
      }
    }
    function rad(deg) {
      return deg % 360 * PI / 180;
    }
    function deg(rad) {
      return rad * 180 / PI % 360;
    }
    function x_y() {
      return this.x + S + this.y;
    }
    function x_y_w_h() {
      return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
    }

    /*\
    * Snap.rad
    [ method ]
    **
    * Transform angle to radians
    - deg (number) angle in degrees
    = (number) angle in radians
    \*/
    Snap.rad = rad;
    /*\
    * Snap.deg
    [ method ]
    **
    * Transform angle to degrees
    - rad (number) angle in radians
    = (number) angle in degrees
    \*/
    Snap.deg = deg;
    /*\
    * Snap.sin
    [ method ]
    **
    * Equivalent to `Math.sin()` only works with degrees, not radians.
    - angle (number) angle in degrees
    = (number) sin
    \*/
    Snap.sin = function (angle) {
      return math.sin(Snap.rad(angle));
    };
    /*\
    * Snap.tan
    [ method ]
    **
    * Equivalent to `Math.tan()` only works with degrees, not radians.
    - angle (number) angle in degrees
    = (number) tan
    \*/
    Snap.tan = function (angle) {
      return math.tan(Snap.rad(angle));
    };
    /*\
    * Snap.cos
    [ method ]
    **
    * Equivalent to `Math.cos()` only works with degrees, not radians.
    - angle (number) angle in degrees
    = (number) cos
    \*/
    Snap.cos = function (angle) {
      return math.cos(Snap.rad(angle));
    };
    /*\
    * Snap.asin
    [ method ]
    **
    * Equivalent to `Math.asin()` only works with degrees, not radians.
    - num (number) value
    = (number) asin in degrees
    \*/
    Snap.asin = function (num) {
      return Snap.deg(math.asin(num));
    };
    /*\
    * Snap.acos
    [ method ]
    **
    * Equivalent to `Math.acos()` only works with degrees, not radians.
    - num (number) value
    = (number) acos in degrees
    \*/
    Snap.acos = function (num) {
      return Snap.deg(math.acos(num));
    };
    /*\
    * Snap.atan
    [ method ]
    **
    * Equivalent to `Math.atan()` only works with degrees, not radians.
    - num (number) value
    = (number) atan in degrees
    \*/
    Snap.atan = function (num) {
      return Snap.deg(math.atan(num));
    };
    /*\
    * Snap.atan2
    [ method ]
    **
    * Equivalent to `Math.atan2()` only works with degrees, not radians.
    - num (number) value
    = (number) atan2 in degrees
    \*/
    Snap.atan2 = function (num) {
      return Snap.deg(math.atan2(num));
    };
    /*\
    * Snap.angle
    [ method ]
    **
    * Returns an angle between two or three points
    - x1 (number) x coord of first point
    - y1 (number) y coord of first point
    - x2 (number) x coord of second point
    - y2 (number) y coord of second point
    - x3 (number) #optional x coord of third point
    - y3 (number) #optional y coord of third point
    = (number) angle in degrees
    \*/
    Snap.angle = angle;
    /*\
    * Snap.len
    [ method ]
    **
    * Returns distance between two points
    - x1 (number) x coord of first point
    - y1 (number) y coord of first point
    - x2 (number) x coord of second point
    - y2 (number) y coord of second point
    = (number) distance
    \*/
    Snap.len = function (x1, y1, x2, y2) {
      return Math.sqrt(Snap.len2(x1, y1, x2, y2));
    };
    /*\
    * Snap.len2
    [ method ]
    **
    * Returns squared distance between two points
    - x1 (number) x coord of first point
    - y1 (number) y coord of first point
    - x2 (number) x coord of second point
    - y2 (number) y coord of second point
    = (number) distance
    \*/
    Snap.len2 = function (x1, y1, x2, y2) {
      return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
    };
    /*\
    * Snap.closestPoint
    [ method ]
    **
    * Returns closest point to a given one on a given path.
    - path (Element) path element
    - x (number) x coord of a point
    - y (number) y coord of a point
    = (object) in format
    {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
    }
    \*/
    // Copied from http://bl.ocks.org/mbostock/8027637
    Snap.closestPoint = function (path, x, y) {
      function distance2(p) {
        var dx = p.x - x,
          dy = p.y - y;
        return dx * dx + dy * dy;
      }
      var pathNode = path.node,
        pathLength = pathNode.getTotalLength(),
        precision = pathLength / pathNode.pathSegList.numberOfItems * 0.125,
        best,
        bestLength,
        bestDistance = Infinity;

      // linear scan for coarse approximation
      for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
          best = scan;
          bestLength = scanLength;
          bestDistance = scanDistance;
        }
      }

      // binary search for precise estimate
      precision *= 0.5;
      while (precision > 0.5) {
        var before, after, beforeLength, afterLength, beforeDistance, afterDistance;
        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
          best = before;
          bestLength = beforeLength;
          bestDistance = beforeDistance;
        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
          best = after;
          bestLength = afterLength;
          bestDistance = afterDistance;
        } else {
          precision *= 0.5;
        }
      }
      best = {
        x: best.x,
        y: best.y,
        length: bestLength,
        distance: Math.sqrt(bestDistance)
      };
      return best;
    };
    /*\
    * Snap.is
    [ method ]
    **
    * Handy replacement for the `typeof` operator
    - o (…) any object or primitive
    - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
    = (boolean) `true` if given value is of given type
    \*/
    Snap.is = is;
    /*\
    * Snap.snapTo
    [ method ]
    **
    * Snaps given value to given gridStep
    - values (array|number) given array of values or step of the gridStep
    - value (number) value to adjust
    - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
    = (number) adjusted value
    \*/
    Snap.snapTo = function (values, value, tolerance) {
      tolerance = is(tolerance, "finite") ? tolerance : 10;
      if (is(values, "array")) {
        var i = values.length;
        while (i--) if (abs(values[i] - value) <= tolerance) {
          return values[i];
        }
      } else {
        values = +values;
        var rem = value % values;
        if (rem < tolerance) {
          return value - rem;
        }
        if (rem > values - tolerance) {
          return value - rem + values;
        }
      }
      return value;
    };
    // Colour
    /*\
    * Snap.getRGB
    [ method ]
    **
    * Parses color string as RGB object
    - color (string) color string in one of the following formats:
    # <ul>
    #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
    #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
    #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
    #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
    #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
    #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
    #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
    #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
    #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
    #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
    #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
    #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
    #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
    #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
    #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
    # </ul>
    * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
    = (object) RGB object in the following format:
    o {
    o     r (number) red,
    o     g (number) green,
    o     b (number) blue,
    o     hex (string) color in HTML/CSS format: #••••••,
    o     error (boolean) true if string can't be parsed
    o }
    \*/
    Snap.getRGB = cacher(function (colour) {
      if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
        return {
          r: -1,
          g: -1,
          b: -1,
          hex: "none",
          error: 1,
          toString: rgbtoString
        };
      }
      if (colour == "none") {
        return {
          r: -1,
          g: -1,
          b: -1,
          hex: "none",
          toString: rgbtoString
        };
      }
      !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = _toHex(colour));
      if (!colour) {
        return {
          r: -1,
          g: -1,
          b: -1,
          hex: "none",
          error: 1,
          toString: rgbtoString
        };
      }
      var res,
        red,
        green,
        blue,
        opacity,
        t,
        values,
        rgb = colour.match(colourRegExp);
      if (rgb) {
        if (rgb[2]) {
          blue = toInt(rgb[2].substring(5), 16);
          green = toInt(rgb[2].substring(3, 5), 16);
          red = toInt(rgb[2].substring(1, 3), 16);
        }
        if (rgb[3]) {
          blue = toInt((t = rgb[3].charAt(3)) + t, 16);
          green = toInt((t = rgb[3].charAt(2)) + t, 16);
          red = toInt((t = rgb[3].charAt(1)) + t, 16);
        }
        if (rgb[4]) {
          values = rgb[4].split(commaSpaces);
          red = toFloat(values[0]);
          values[0].slice(-1) == "%" && (red *= 2.55);
          green = toFloat(values[1]);
          values[1].slice(-1) == "%" && (green *= 2.55);
          blue = toFloat(values[2]);
          values[2].slice(-1) == "%" && (blue *= 2.55);
          rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
          values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        }
        if (rgb[5]) {
          values = rgb[5].split(commaSpaces);
          red = toFloat(values[0]);
          values[0].slice(-1) == "%" && (red /= 100);
          green = toFloat(values[1]);
          values[1].slice(-1) == "%" && (green /= 100);
          blue = toFloat(values[2]);
          values[2].slice(-1) == "%" && (blue /= 100);
          (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
          rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
          values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
          return Snap.hsb2rgb(red, green, blue, opacity);
        }
        if (rgb[6]) {
          values = rgb[6].split(commaSpaces);
          red = toFloat(values[0]);
          values[0].slice(-1) == "%" && (red /= 100);
          green = toFloat(values[1]);
          values[1].slice(-1) == "%" && (green /= 100);
          blue = toFloat(values[2]);
          values[2].slice(-1) == "%" && (blue /= 100);
          (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
          rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
          values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
          return Snap.hsl2rgb(red, green, blue, opacity);
        }
        red = mmin(math.round(red), 255);
        green = mmin(math.round(green), 255);
        blue = mmin(math.round(blue), 255);
        opacity = mmin(mmax(opacity, 0), 1);
        rgb = {
          r: red,
          g: green,
          b: blue,
          toString: rgbtoString
        };
        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
        rgb.opacity = is(opacity, "finite") ? opacity : 1;
        return rgb;
      }
      return {
        r: -1,
        g: -1,
        b: -1,
        hex: "none",
        error: 1,
        toString: rgbtoString
      };
    }, Snap);
    /*\
    * Snap.hsb
    [ method ]
    **
    * Converts HSB values to a hex representation of the color
    - h (number) hue
    - s (number) saturation
    - b (number) value or brightness
    = (string) hex representation of the color
    \*/
    Snap.hsb = cacher(function (h, s, b) {
      return Snap.hsb2rgb(h, s, b).hex;
    });
    /*\
    * Snap.hsl
    [ method ]
    **
    * Converts HSL values to a hex representation of the color
    - h (number) hue
    - s (number) saturation
    - l (number) luminosity
    = (string) hex representation of the color
    \*/
    Snap.hsl = cacher(function (h, s, l) {
      return Snap.hsl2rgb(h, s, l).hex;
    });
    /*\
    * Snap.rgb
    [ method ]
    **
    * Converts RGB values to a hex representation of the color
    - r (number) red
    - g (number) green
    - b (number) blue
    = (string) hex representation of the color
    \*/
    Snap.rgb = cacher(function (r, g, b, o) {
      if (is(o, "finite")) {
        var round = math.round;
        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
      }
      return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
    });
    var _toHex = function toHex(color) {
        var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
          red = "rgb(255, 0, 0)";
        _toHex = cacher(function (color) {
          if (color.toLowerCase() == "red") {
            return red;
          }
          i.style.color = red;
          i.style.color = color;
          var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
          return out == red ? null : out;
        });
        return _toHex(color);
      },
      hsbtoString = function hsbtoString() {
        return "hsb(" + [this.h, this.s, this.b] + ")";
      },
      hsltoString = function hsltoString() {
        return "hsl(" + [this.h, this.s, this.l] + ")";
      },
      rgbtoString = function rgbtoString() {
        return this.opacity == 1 || this.opacity == null ? this.hex : "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
      },
      prepareRGB = function prepareRGB(r, g, b) {
        if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
          b = r.b;
          g = r.g;
          r = r.r;
        }
        if (g == null && is(r, string)) {
          var clr = Snap.getRGB(r);
          r = clr.r;
          g = clr.g;
          b = clr.b;
        }
        if (r > 1 || g > 1 || b > 1) {
          r /= 255;
          g /= 255;
          b /= 255;
        }
        return [r, g, b];
      },
      packageRGB = function packageRGB(r, g, b, o) {
        r = math.round(r * 255);
        g = math.round(g * 255);
        b = math.round(b * 255);
        var rgb = {
          r: r,
          g: g,
          b: b,
          opacity: is(o, "finite") ? o : 1,
          hex: Snap.rgb(r, g, b),
          toString: rgbtoString
        };
        is(o, "finite") && (rgb.opacity = o);
        return rgb;
      };
    /*\
    * Snap.color
    [ method ]
    **
    * Parses the color string and returns an object featuring the color's component values
    - clr (string) color string in one of the supported formats (see @Snap.getRGB)
    = (object) Combined RGB/HSB object in the following format:
    o {
    o     r (number) red,
    o     g (number) green,
    o     b (number) blue,
    o     hex (string) color in HTML/CSS format: #••••••,
    o     error (boolean) `true` if string can't be parsed,
    o     h (number) hue,
    o     s (number) saturation,
    o     v (number) value (brightness),
    o     l (number) lightness
    o }
    \*/
    Snap.color = function (clr) {
      var rgb;
      if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
        rgb = Snap.hsb2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
      } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
        rgb = Snap.hsl2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
      } else {
        if (is(clr, "string")) {
          clr = Snap.getRGB(clr);
        }
        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
          rgb = Snap.rgb2hsl(clr);
          clr.h = rgb.h;
          clr.s = rgb.s;
          clr.l = rgb.l;
          rgb = Snap.rgb2hsb(clr);
          clr.v = rgb.b;
        } else {
          clr = {
            hex: "none"
          };
          clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
          clr.error = 1;
        }
      }
      clr.toString = rgbtoString;
      return clr;
    };
    /*\
    * Snap.hsb2rgb
    [ method ]
    **
    * Converts HSB values to an RGB object
    - h (number) hue
    - s (number) saturation
    - v (number) value or brightness
    = (object) RGB object in the following format:
    o {
    o     r (number) red,
    o     g (number) green,
    o     b (number) blue,
    o     hex (string) color in HTML/CSS format: #••••••
    o }
    \*/
    Snap.hsb2rgb = function (h, s, v, o) {
      if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
        v = h.b;
        s = h.s;
        o = h.o;
        h = h.h;
      }
      h *= 360;
      var R, G, B, X, C;
      h = h % 360 / 60;
      C = v * s;
      X = C * (1 - abs(h % 2 - 1));
      R = G = B = v - C;
      h = ~~h;
      R += [C, X, 0, 0, X, C][h];
      G += [X, C, C, X, 0, 0][h];
      B += [0, 0, X, C, C, X][h];
      return packageRGB(R, G, B, o);
    };
    /*\
    * Snap.hsl2rgb
    [ method ]
    **
    * Converts HSL values to an RGB object
    - h (number) hue
    - s (number) saturation
    - l (number) luminosity
    = (object) RGB object in the following format:
    o {
    o     r (number) red,
    o     g (number) green,
    o     b (number) blue,
    o     hex (string) color in HTML/CSS format: #••••••
    o }
    \*/
    Snap.hsl2rgb = function (h, s, l, o) {
      if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
        l = h.l;
        s = h.s;
        h = h.h;
      }
      if (h > 1 || s > 1 || l > 1) {
        h /= 360;
        s /= 100;
        l /= 100;
      }
      h *= 360;
      var R, G, B, X, C;
      h = h % 360 / 60;
      C = 2 * s * (l < 0.5 ? l : 1 - l);
      X = C * (1 - abs(h % 2 - 1));
      R = G = B = l - C / 2;
      h = ~~h;
      R += [C, X, 0, 0, X, C][h];
      G += [X, C, C, X, 0, 0][h];
      B += [0, 0, X, C, C, X][h];
      return packageRGB(R, G, B, o);
    };
    /*\
    * Snap.rgb2hsb
    [ method ]
    **
    * Converts RGB values to an HSB object
    - r (number) red
    - g (number) green
    - b (number) blue
    = (object) HSB object in the following format:
    o {
    o     h (number) hue,
    o     s (number) saturation,
    o     b (number) brightness
    o }
    \*/
    Snap.rgb2hsb = function (r, g, b) {
      b = prepareRGB(r, g, b);
      r = b[0];
      g = b[1];
      b = b[2];
      var H, S, V, C;
      V = mmax(r, g, b);
      C = V - mmin(r, g, b);
      H = C == 0 ? null : V == r ? (g - b) / C : V == g ? (b - r) / C + 2 : (r - g) / C + 4;
      H = (H + 360) % 6 * 60 / 360;
      S = C == 0 ? 0 : C / V;
      return {
        h: H,
        s: S,
        b: V,
        toString: hsbtoString
      };
    };
    /*\
    * Snap.rgb2hsl
    [ method ]
    **
    * Converts RGB values to an HSL object
    - r (number) red
    - g (number) green
    - b (number) blue
    = (object) HSL object in the following format:
    o {
    o     h (number) hue,
    o     s (number) saturation,
    o     l (number) luminosity
    o }
    \*/
    Snap.rgb2hsl = function (r, g, b) {
      b = prepareRGB(r, g, b);
      r = b[0];
      g = b[1];
      b = b[2];
      var H, S, L, M, m, C;
      M = mmax(r, g, b);
      m = mmin(r, g, b);
      C = M - m;
      H = C == 0 ? null : M == r ? (g - b) / C : M == g ? (b - r) / C + 2 : (r - g) / C + 4;
      H = (H + 360) % 6 * 60 / 360;
      L = (M + m) / 2;
      S = C == 0 ? 0 : L < 0.5 ? C / (2 * L) : C / (2 - 2 * L);
      return {
        h: H,
        s: S,
        l: L,
        toString: hsltoString
      };
    };

    // Transformations
    /*\
    * Snap.parsePathString
    [ method ]
    **
    * Utility method
    **
    * Parses given path string into an array of arrays of path segments
    - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
    = (array) array of segments
    \*/
    Snap.parsePathString = function (pathString) {
      if (!pathString) {
        return null;
      }
      var pth = Snap.path(pathString);
      if (pth.arr) {
        return Snap.path.clone(pth.arr);
      }
      var paramCounts = {
          a: 7,
          c: 6,
          o: 2,
          h: 1,
          l: 2,
          m: 2,
          r: 4,
          q: 4,
          s: 4,
          t: 2,
          v: 1,
          u: 3,
          z: 0
        },
        data = [];
      if (is(pathString, "array") && is(pathString[0], "array")) {
        // rough assumption
        data = Snap.path.clone(pathString);
      }
      if (!data.length) {
        Str(pathString).replace(pathCommand, function (a, b, c) {
          var params = [],
            name = b.toLowerCase();
          c.replace(pathValues, function (a, b) {
            b && params.push(+b);
          });
          if (name == "m" && params.length > 2) {
            data.push([b].concat(params.splice(0, 2)));
            name = "l";
            b = b == "m" ? "l" : "L";
          }
          if (name == "o" && params.length == 1) {
            data.push([b, params[0]]);
          }
          if (name == "r") {
            data.push([b].concat(params));
          } else while (params.length >= paramCounts[name]) {
            data.push([b].concat(params.splice(0, paramCounts[name])));
            if (!paramCounts[name]) {
              break;
            }
          }
        });
      }
      data.toString = Snap.path.toString;
      pth.arr = Snap.path.clone(data);
      return data;
    };
    /*\
    * Snap.parseTransformString
    [ method ]
    **
    * Utility method
    **
    * Parses given transform string into an array of transformations
    - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
    = (array) array of transformations
    \*/
    var parseTransformString = Snap.parseTransformString = function (TString) {
      if (!TString) {
        return null;
      }
      var paramCounts = {
          r: 3,
          s: 4,
          t: 2,
          m: 6
        },
        data = [];
      if (is(TString, "array") && is(TString[0], "array")) {
        // rough assumption
        data = Snap.path.clone(TString);
      }
      if (!data.length) {
        Str(TString).replace(tCommand, function (a, b, c) {
          var params = [],
            name = b.toLowerCase();
          c.replace(pathValues, function (a, b) {
            b && params.push(+b);
          });
          data.push([b].concat(params));
        });
      }
      data.toString = Snap.path.toString;
      return data;
    };
    function svgTransform2string(tstr) {
      var res = [];
      tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
        params = params.split(/\s*,\s*|\s+/);
        if (name == "rotate" && params.length == 1) {
          params.push(0, 0);
        }
        if (name == "scale") {
          if (params.length > 2) {
            params = params.slice(0, 2);
          } else if (params.length == 2) {
            params.push(0, 0);
          }
          if (params.length == 1) {
            params.push(params[0], 0, 0);
          }
        }
        if (name == "skewX") {
          res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
        } else if (name == "skewY") {
          res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
        } else {
          res.push([name.charAt(0)].concat(params));
        }
        return all;
      });
      return res;
    }
    Snap._.svgTransform2string = svgTransform2string;
    Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
    function transform2matrix(tstr, bbox) {
      var tdata = parseTransformString(tstr),
        m = new Snap.Matrix();
      if (tdata) {
        for (var i = 0, ii = tdata.length; i < ii; i++) {
          var t = tdata[i],
            tlen = t.length,
            command = Str(t[0]).toLowerCase(),
            absolute = t[0] != command,
            inver = absolute ? m.invert() : 0,
            x1,
            y1,
            x2,
            y2,
            bb;
          if (command == "t" && tlen == 2) {
            m.translate(t[1], 0);
          } else if (command == "t" && tlen == 3) {
            if (absolute) {
              x1 = inver.x(0, 0);
              y1 = inver.y(0, 0);
              x2 = inver.x(t[1], t[2]);
              y2 = inver.y(t[1], t[2]);
              m.translate(x2 - x1, y2 - y1);
            } else {
              m.translate(t[1], t[2]);
            }
          } else if (command == "r") {
            if (tlen == 2) {
              bb = bb || bbox;
              m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
            } else if (tlen == 4) {
              if (absolute) {
                x2 = inver.x(t[2], t[3]);
                y2 = inver.y(t[2], t[3]);
                m.rotate(t[1], x2, y2);
              } else {
                m.rotate(t[1], t[2], t[3]);
              }
            }
          } else if (command == "s") {
            if (tlen == 2 || tlen == 3) {
              bb = bb || bbox;
              m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
            } else if (tlen == 4) {
              if (absolute) {
                x2 = inver.x(t[2], t[3]);
                y2 = inver.y(t[2], t[3]);
                m.scale(t[1], t[1], x2, y2);
              } else {
                m.scale(t[1], t[1], t[2], t[3]);
              }
            } else if (tlen == 5) {
              if (absolute) {
                x2 = inver.x(t[3], t[4]);
                y2 = inver.y(t[3], t[4]);
                m.scale(t[1], t[2], x2, y2);
              } else {
                m.scale(t[1], t[2], t[3], t[4]);
              }
            }
          } else if (command == "m" && tlen == 7) {
            m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
          }
        }
      }
      return m;
    }
    Snap._.transform2matrix = transform2matrix;
    Snap._unit2px = unit2px;
    var contains = glob.doc.contains || glob.doc.compareDocumentPosition ? function (a, b) {
      var adown = a.nodeType == 9 ? a.documentElement : a,
        bup = b && b.parentNode;
      return a == bup || !!(bup && bup.nodeType == 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    } : function (a, b) {
      if (b) {
        while (b) {
          b = b.parentNode;
          if (b == a) {
            return true;
          }
        }
      }
      return false;
    };
    function getSomeDefs(el) {
      var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || el.node.parentNode && wrap(el.node.parentNode) || Snap.select("svg") || Snap(0, 0),
        pdefs = p.select("defs"),
        defs = pdefs == null ? false : pdefs.node;
      if (!defs) {
        defs = make("defs", p.node).node;
      }
      return defs;
    }
    function getSomeSVG(el) {
      return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
    }
    Snap._.getSomeDefs = getSomeDefs;
    Snap._.getSomeSVG = getSomeSVG;
    function unit2px(el, name, value) {
      var svg = getSomeSVG(el).node,
        out = {},
        mgr = svg.querySelector(".svg---mgr");
      if (!mgr) {
        mgr = $("rect");
        $(mgr, {
          x: -9e9,
          y: -9e9,
          width: 10,
          height: 10,
          class: "svg---mgr",
          fill: "none"
        });
        svg.appendChild(mgr);
      }
      function getW(val) {
        if (val == null) {
          return E;
        }
        if (val == +val) {
          return val;
        }
        $(mgr, {
          width: val
        });
        try {
          return mgr.getBBox().width;
        } catch (e) {
          return 0;
        }
      }
      function getH(val) {
        if (val == null) {
          return E;
        }
        if (val == +val) {
          return val;
        }
        $(mgr, {
          height: val
        });
        try {
          return mgr.getBBox().height;
        } catch (e) {
          return 0;
        }
      }
      function set(nam, f) {
        if (name == null) {
          out[nam] = f(el.attr(nam) || 0);
        } else if (nam == name) {
          out = f(value == null ? el.attr(nam) || 0 : value);
        }
      }
      switch (el.type) {
        case "rect":
          set("rx", getW);
          set("ry", getH);
        case "image":
          set("width", getW);
          set("height", getH);
        case "text":
          set("x", getW);
          set("y", getH);
          break;
        case "circle":
          set("cx", getW);
          set("cy", getH);
          set("r", getW);
          break;
        case "ellipse":
          set("cx", getW);
          set("cy", getH);
          set("rx", getW);
          set("ry", getH);
          break;
        case "line":
          set("x1", getW);
          set("x2", getW);
          set("y1", getH);
          set("y2", getH);
          break;
        case "marker":
          set("refX", getW);
          set("markerWidth", getW);
          set("refY", getH);
          set("markerHeight", getH);
          break;
        case "radialGradient":
          set("fx", getW);
          set("fy", getH);
          break;
        case "tspan":
          set("dx", getW);
          set("dy", getH);
          break;
        default:
          set(name, getW);
      }
      svg.removeChild(mgr);
      return out;
    }
    /*\
    * Snap.select
    [ method ]
    **
    * Wraps a DOM element specified by CSS selector as @Element
    - query (string) CSS selector of the element
    = (Element) the current element
    \*/
    Snap.select = function (query) {
      query = Str(query).replace(/([^\\]):/g, "$1\\:");
      return wrap(glob.doc.querySelector(query));
    };
    /*\
    * Snap.selectAll
    [ method ]
    **
    * Wraps DOM elements specified by CSS selector as set or array of @Element
    - query (string) CSS selector of the element
    = (Element) the current element
    \*/
    Snap.selectAll = function (query) {
      var nodelist = glob.doc.querySelectorAll(query),
        set = (Snap.set || Array)();
      for (var i = 0; i < nodelist.length; i++) {
        set.push(wrap(nodelist[i]));
      }
      return set;
    };
    function add2group(list) {
      if (!is(list, "array")) {
        list = Array.prototype.slice.call(arguments, 0);
      }
      var i = 0,
        j = 0,
        node = this.node;
      while (this[i]) delete this[i++];
      for (i = 0; i < list.length; i++) {
        if (list[i].type == "set") {
          list[i].forEach(function (el) {
            node.appendChild(el.node);
          });
        } else {
          node.appendChild(list[i].node);
        }
      }
      var children = node.childNodes;
      for (i = 0; i < children.length; i++) {
        this[j++] = wrap(children[i]);
      }
      return this;
    }
    // Hub garbage collector every 10s
    setInterval(function () {
      for (var key in hub) if (hub[has](key)) {
        var el = hub[key],
          node = el.node;
        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
          delete hub[key];
        }
      }
    }, 1e4);
    function Element(el) {
      if (el.snap in hub) {
        return hub[el.snap];
      }
      var svg;
      try {
        svg = el.ownerSVGElement;
      } catch (e) {}
      /*\
      * Element.node
      [ property (object) ]
      **
      * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
      > Usage
      | // draw a circle at coordinate 10,10 with radius of 10
      | var c = paper.circle(10, 10, 10);
      | c.node.onclick = function () {
      |     c.attr("fill", "red");
      | };
      \*/
      this.node = el;
      if (svg) {
        this.paper = new Paper(svg);
      }
      /*\
      * Element.type
      [ property (string) ]
      **
      * SVG tag name of the given element.
      \*/
      this.type = el.tagName || el.nodeName;
      var id = this.id = ID(this);
      this.anims = {};
      this._ = {
        transform: []
      };
      el.snap = id;
      hub[id] = this;
      /*
      if (this.type == "g") {
        this.add = add2group;
      }
      */
      if (this.type in {
        g: 1,
        mask: 1,
        pattern: 1,
        symbol: 1
      }) {
        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
          this[method] = Paper.prototype[method];
        }
      }
    }
    /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/
    Element.prototype.attr = function (params, value) {
      var el = this,
        node = el.node;
      if (!params) {
        if (node.nodeType != 1) {
          return {
            text: node.nodeValue
          };
        }
        var attr = node.attributes,
          out = {};
        for (var i = 0, ii = attr.length; i < ii; i++) {
          out[attr[i].nodeName] = attr[i].nodeValue;
        }
        return out;
      }
      if (is(params, "string")) {
        if (arguments.length > 1) {
          var json = {};
          json[params] = value;
          params = json;
        } else {
          return eve("snap.util.getattr." + params, el).firstDefined();
        }
      }
      for (var att in params) {
        if (params[has](att)) {
          eve("snap.util.attr." + att, el, params[att]);
        }
      }
      return el;
    };
    Element.prototype.add = function (list) {
      if (this.type == "g") {
        add2group.apply(this, list);
      }
    };
    /*\
    * Snap.parse
    [ method ]
    **
    * Parses SVG fragment and converts it into a @Fragment
    **
    - svg (string) SVG string
    = (Fragment) the @Fragment
    \*/
    Snap.parse = function (svg) {
      var f = glob.doc.createDocumentFragment(),
        full = true,
        div = glob.doc.createElement("div");
      svg = Str(svg);
      if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
        svg = "<svg>" + svg + "</svg>";
        full = false;
      }
      div.innerHTML = svg;
      svg = div.getElementsByTagName("svg")[0];
      if (svg) {
        if (full) {
          f = svg;
        } else {
          while (svg.firstChild) {
            f.appendChild(svg.firstChild);
          }
        }
      }
      return new Fragment(f);
    };
    function Fragment(frag) {
      this.node = frag;
    }
    /*\
    * Snap.fragment
    [ method ]
    **
    * Creates a DOM fragment from a given list of elements or strings
    **
    - varargs (…) SVG string
    = (Fragment) the @Fragment
    \*/
    Snap.fragment = function () {
      var args = Array.prototype.slice.call(arguments, 0),
        f = glob.doc.createDocumentFragment();
      for (var i = 0, ii = args.length; i < ii; i++) {
        var item = args[i];
        if (item.node && item.node.nodeType) {
          f.appendChild(item.node);
        }
        if (item.nodeType) {
          f.appendChild(item);
        }
        if (typeof item == "string") {
          f.appendChild(Snap.parse(item).node);
        }
      }
      return new Fragment(f);
    };
    function make(name, parent) {
      var res = $(name);
      parent.appendChild(res);
      var el = wrap(res);
      return el;
    }
    function Paper(w, h) {
      var res,
        desc,
        defs,
        proto = Paper.prototype;
      if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
        if (w.snap in hub) {
          return hub[w.snap];
        }
        var doc = w.ownerDocument;
        res = new Element(w);
        desc = w.getElementsByTagName("desc")[0];
        defs = w.getElementsByTagName("defs")[0];
        if (!desc) {
          desc = $("desc");
          desc.appendChild(doc.createTextNode("Created with Snap"));
          res.node.appendChild(desc);
        }
        if (!defs) {
          defs = $("defs");
          res.node.appendChild(defs);
        }
        res.defs = defs;
        for (var key in proto) if (proto[has](key)) {
          res[key] = proto[key];
        }
        res.paper = res.root = res;
      } else {
        res = make("svg", glob.doc.body);
        $(res.node, {
          height: h,
          version: 1.1,
          width: w,
          xmlns: xmlns
        });
      }
      return res;
    }
    function wrap(dom) {
      if (!dom) {
        return dom;
      }
      if (dom instanceof Element || dom instanceof Fragment) {
        return dom;
      }
      if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
        return new Paper(dom);
      }
      if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
      }
      return new Element(dom);
    }
    Snap._.make = make;
    Snap._.wrap = wrap;
    /*\
    * Paper.el
    [ method ]
    **
    * Creates an element on paper with a given name and no attributes
    **
    - name (string) tag name
    - attr (object) attributes
    = (Element) the current element
    > Usage
    | var c = paper.circle(10, 10, 10); // is the same as...
    | var c = paper.el("circle").attr({
    |     cx: 10,
    |     cy: 10,
    |     r: 10
    | });
    | // and the same as
    | var c = paper.el("circle", {
    |     cx: 10,
    |     cy: 10,
    |     r: 10
    | });
    \*/
    Paper.prototype.el = function (name, attr) {
      var el = make(name, this.node);
      attr && el.attr(attr);
      return el;
    };
    /*\
    * Element.children
    [ method ]
    **
    * Returns array of all the children of the element.
    = (array) array of Elements
    \*/
    Element.prototype.children = function () {
      var out = [],
        ch = this.node.childNodes;
      for (var i = 0, ii = ch.length; i < ii; i++) {
        out[i] = Snap(ch[i]);
      }
      return out;
    };
    function jsonFiller(root, o) {
      for (var i = 0, ii = root.length; i < ii; i++) {
        var item = {
            type: root[i].type,
            attr: root[i].attr()
          },
          children = root[i].children();
        o.push(item);
        if (children.length) {
          jsonFiller(children, item.childNodes = []);
        }
      }
    }
    /*\
    * Element.toJSON
    [ method ]
    **
    * Returns object representation of the given element and all its children.
    = (object) in format
    o {
    o     type (string) this.type,
    o     attr (object) attributes map,
    o     childNodes (array) optional array of children in the same format
    o }
    \*/
    Element.prototype.toJSON = function () {
      var out = [];
      jsonFiller([this], out);
      return out[0];
    };
    // default
    eve.on("snap.util.getattr", function () {
      var att = eve.nt();
      att = att.substring(att.lastIndexOf(".") + 1);
      var css = att.replace(/[A-Z]/g, function (letter) {
        return "-" + letter.toLowerCase();
      });
      if (cssAttr[has](css)) {
        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
      } else {
        return $(this.node, att);
      }
    });
    var cssAttr = {
      "alignment-baseline": 0,
      "baseline-shift": 0,
      clip: 0,
      "clip-path": 0,
      "clip-rule": 0,
      color: 0,
      "color-interpolation": 0,
      "color-interpolation-filters": 0,
      "color-profile": 0,
      "color-rendering": 0,
      cursor: 0,
      direction: 0,
      display: 0,
      "dominant-baseline": 0,
      "enable-background": 0,
      fill: 0,
      "fill-opacity": 0,
      "fill-rule": 0,
      filter: 0,
      "flood-color": 0,
      "flood-opacity": 0,
      font: 0,
      "font-family": 0,
      "font-size": 0,
      "font-size-adjust": 0,
      "font-stretch": 0,
      "font-style": 0,
      "font-variant": 0,
      "font-weight": 0,
      "glyph-orientation-horizontal": 0,
      "glyph-orientation-vertical": 0,
      "image-rendering": 0,
      kerning: 0,
      "letter-spacing": 0,
      "lighting-color": 0,
      marker: 0,
      "marker-end": 0,
      "marker-mid": 0,
      "marker-start": 0,
      mask: 0,
      opacity: 0,
      overflow: 0,
      "pointer-events": 0,
      "shape-rendering": 0,
      "stop-color": 0,
      "stop-opacity": 0,
      stroke: 0,
      "stroke-dasharray": 0,
      "stroke-dashoffset": 0,
      "stroke-linecap": 0,
      "stroke-linejoin": 0,
      "stroke-miterlimit": 0,
      "stroke-opacity": 0,
      "stroke-width": 0,
      "text-anchor": 0,
      "text-decoration": 0,
      "text-rendering": 0,
      "unicode-bidi": 0,
      visibility: 0,
      "word-spacing": 0,
      "writing-mode": 0
    };
    eve.on("snap.util.attr", function (value) {
      var att = eve.nt(),
        attr = {};
      att = att.substring(att.lastIndexOf(".") + 1);
      attr[att] = value;
      var style = att.replace(/-(\w)/gi, function (all, letter) {
          return letter.toUpperCase();
        }),
        css = att.replace(/[A-Z]/g, function (letter) {
          return "-" + letter.toLowerCase();
        });
      if (cssAttr[has](css)) {
        this.node.style[style] = value == null ? E : value;
      } else {
        $(this.node, attr);
      }
    });
    (function (proto) {})(Paper.prototype);

    // simple ajax
    /*\
    * Snap.ajax
    [ method ]
    **
    * Simple implementation of Ajax
    **
    - url (string) URL
    - postData (object|string) data for post request
    - callback (function) callback
    - scope (object) #optional scope of callback
    * or
    - url (string) URL
    - callback (function) callback
    - scope (object) #optional scope of callback
    = (XMLHttpRequest) the XMLHttpRequest object, just in case
    \*/
    Snap.ajax = function (url, postData, callback, errorCallback, scope) {
      var req = new XMLHttpRequest(),
        id = ID();
      if (req) {
        if (is(postData, "function")) {
          scope = errorCallback;
          errorCallback = callback;
          callback = postData;
          postData = null;
        } else if (is(postData, "object")) {
          var pd = [];
          for (var key in postData) if (postData.hasOwnProperty(key)) {
            pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
          }
          postData = pd.join("&");
        }
        req.open(postData ? "POST" : "GET", url, true);
        if (postData) {
          req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
          req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }
        req.onreadystatechange = function () {
          if (req.readyState != 4) return;
          if (req.status >= 200 && req.status <= 299 || req.status >= 300 && req.status <= 399) {
            callback && callback(req);
          } else {
            errorCallback && errorCallback(req);
          }
        };
        if (req.readyState == 4) {
          return req;
        }
        req.send(postData);
        return req;
      }
    };
    /*\
    * Snap.load
    [ method ]
    **
    * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
    **
    - url (string) URL
    - callback (function) callback
    - scope (object) #optional scope of callback
    \*/
    Snap.load = function (url, callback, errorCallback, scope) {
      Snap.ajax(url, function (req) {
        var f = Snap.parse(req.responseText);
        scope ? callback.call(scope, f) : callback(f);
      }, function (req) {
        errorCallback && errorCallback(req);
      });
    };
    var getOffset = function getOffset(elem) {
      var box = elem.getBoundingClientRect(),
        doc = elem.ownerDocument,
        body = doc.body,
        docElem = doc.documentElement,
        clientTop = docElem.clientTop || body.clientTop || 0,
        clientLeft = docElem.clientLeft || body.clientLeft || 0,
        top = box.top + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop) - clientTop,
        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
      return {
        y: -top,
        x: -left
      };
    };
    /*\
    * Snap.getElementByPoint
    [ method ]
    **
    * Returns you topmost element under given point.
    **
    = (object) Snap element object
    - x (number) x coordinate from the top left corner of the window
    - y (number) y coordinate from the top left corner of the window
    > Usage
    | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
    \*/
    Snap.getElementByPoint = function (x, y) {
      var paper = this,
        svg = paper.canvas,
        target = glob.doc.elementFromPoint(x, y);
      if (glob.win.opera && target.tagName == "svg") {
        var so = getOffset(target),
          sr = target.createSVGRect();
        sr.x = x - so.x;
        sr.y = y - so.y;
        sr.width = sr.height = 1;
        var hits = target.getIntersectionList(sr, null);
        if (hits.length) {
          target = hits[hits.length - 1];
        }
      }
      if (!target) {
        return null;
      }
      return wrap(target);
    };
    /*\
    * Snap.plugin
    [ method ]
    **
    * Let you write plugins. You pass in a function with five arguments, like this:
    | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
    |     Snap.newmethod = function () {};
    |     Element.prototype.newmethod = function () {};
    |     Paper.prototype.newmethod = function () {};
    | });
    * Inside the function you have access to all main objects (and their
    * prototypes). This allow you to extend anything you want.
    **
    - f (function) your plugin body
    \*/
    Snap.plugin = function (f) {
      f(Snap, Element, Paper, glob, Fragment);
    };
    glob.win.Snap = Snap;
    return Snap;
  }(window || this);

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
      is = Snap.is,
      Str = String,
      unit2px = Snap._unit2px,
      $ = Snap._.$,
      make = Snap._.make,
      getSomeDefs = Snap._.getSomeDefs,
      has = "hasOwnProperty",
      wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/
    elproto.getBBox = function (isWithoutTransform) {
      if (this.type == "tspan") {
        return Snap._.box(this.node.getClientRects().item(0));
      }
      if (!Snap.Matrix || !Snap.path) {
        return this.node.getBBox();
      }
      var el = this,
        m = new Snap.Matrix();
      if (el.removed) {
        return Snap._.box();
      }
      while (el.type == "use") {
        if (!isWithoutTransform) {
          m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
        }
        if (el.original) {
          el = el.original;
        } else {
          var href = el.attr("xlink:href");
          el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
        }
      }
      var _ = el._,
        pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
      try {
        if (isWithoutTransform) {
          _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
          return Snap._.box(_.bboxwt);
        } else {
          el.realPath = pathfinder(el);
          el.matrix = el.transform().localMatrix;
          _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
          return Snap._.box(_.bbox);
        }
      } catch (e) {
        // Firefox doesn’t give you bbox of hidden element
        return Snap._.box();
      }
    };
    var propString = function propString() {
      return this.string;
    };
    function extractTransform(el, tstr) {
      if (tstr == null) {
        var doReturn = true;
        if (el.type == "linearGradient" || el.type == "radialGradient") {
          tstr = el.node.getAttribute("gradientTransform");
        } else if (el.type == "pattern") {
          tstr = el.node.getAttribute("patternTransform");
        } else {
          tstr = el.node.getAttribute("transform");
        }
        if (!tstr) {
          return new Snap.Matrix();
        }
        tstr = Snap._.svgTransform2string(tstr);
      } else {
        if (!Snap._.rgTransform.test(tstr)) {
          tstr = Snap._.svgTransform2string(tstr);
        } else {
          tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
        }
        if (is(tstr, "array")) {
          tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
        }
        el._.transform = tstr;
      }
      var m = Snap._.transform2matrix(tstr, el.getBBox(1));
      if (doReturn) {
        return m;
      } else {
        el.matrix = m;
      }
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/
    elproto.transform = function (tstr) {
      var _ = this._;
      if (tstr == null) {
        var papa = this,
          global = new Snap.Matrix(this.node.getCTM()),
          local = extractTransform(this),
          ms = [local],
          m = new Snap.Matrix(),
          i,
          localString = local.toTransformString(),
          string = Str(local) == Str(this.matrix) ? Str(_.transform) : localString;
        while (papa.type != "svg" && (papa = papa.parent())) {
          ms.push(extractTransform(papa));
        }
        i = ms.length;
        while (i--) {
          m.add(ms[i]);
        }
        return {
          string: string,
          globalMatrix: global,
          totalMatrix: m,
          localMatrix: local,
          diffMatrix: global.clone().add(local.invert()),
          global: global.toTransformString(),
          total: m.toTransformString(),
          local: localString,
          toString: propString
        };
      }
      if (tstr instanceof Snap.Matrix) {
        this.matrix = tstr;
        this._.transform = tstr.toTransformString();
      } else {
        extractTransform(this, tstr);
      }
      if (this.node) {
        if (this.type == "linearGradient" || this.type == "radialGradient") {
          $(this.node, {
            gradientTransform: this.matrix
          });
        } else if (this.type == "pattern") {
          $(this.node, {
            patternTransform: this.matrix
          });
        } else {
          $(this.node, {
            transform: this.matrix
          });
        }
      }
      return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/
    elproto.parent = function () {
      return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/
    /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/
    elproto.append = elproto.add = function (el) {
      if (el) {
        if (el.type == "set") {
          var it = this;
          el.forEach(function (el) {
            it.add(el);
          });
          return this;
        }
        el = wrap(el);
        this.node.appendChild(el.node);
        el.paper = this.paper;
      }
      return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/
    elproto.appendTo = function (el) {
      if (el) {
        el = wrap(el);
        el.append(this);
      }
      return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/
    elproto.prepend = function (el) {
      if (el) {
        if (el.type == "set") {
          var it = this,
            first;
          el.forEach(function (el) {
            if (first) {
              first.after(el);
            } else {
              it.prepend(el);
            }
            first = el;
          });
          return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.insertBefore(el.node, this.node.firstChild);
        this.add && this.add();
        el.paper = this.paper;
        this.parent() && this.parent().add();
        parent && parent.add();
      }
      return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/
    elproto.prependTo = function (el) {
      el = wrap(el);
      el.prepend(this);
      return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.before = function (el) {
      if (el.type == "set") {
        var it = this;
        el.forEach(function (el) {
          var parent = el.parent();
          it.node.parentNode.insertBefore(el.node, it.node);
          parent && parent.add();
        });
        this.parent().add();
        return this;
      }
      el = wrap(el);
      var parent = el.parent();
      this.node.parentNode.insertBefore(el.node, this.node);
      this.parent() && this.parent().add();
      parent && parent.add();
      el.paper = this.paper;
      return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.after = function (el) {
      el = wrap(el);
      var parent = el.parent();
      if (this.node.nextSibling) {
        this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
      } else {
        this.node.parentNode.appendChild(el.node);
      }
      this.parent() && this.parent().add();
      parent && parent.add();
      el.paper = this.paper;
      return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertBefore = function (el) {
      el = wrap(el);
      var parent = this.parent();
      el.node.parentNode.insertBefore(this.node, el.node);
      this.paper = el.paper;
      parent && parent.add();
      el.parent() && el.parent().add();
      return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertAfter = function (el) {
      el = wrap(el);
      var parent = this.parent();
      el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
      this.paper = el.paper;
      parent && parent.add();
      el.parent() && el.parent().add();
      return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/
    elproto.remove = function () {
      var parent = this.parent();
      this.node.parentNode && this.node.parentNode.removeChild(this.node);
      delete this.paper;
      this.removed = true;
      parent && parent.add();
      return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/
    elproto.select = function (query) {
      return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/
    elproto.selectAll = function (query) {
      var nodelist = this.node.querySelectorAll(query),
        set = (Snap.set || Array)();
      for (var i = 0; i < nodelist.length; i++) {
        set.push(wrap(nodelist[i]));
      }
      return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/
    elproto.asPX = function (attr, value) {
      if (value == null) {
        value = this.attr(attr);
      }
      return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/
    elproto.use = function () {
      var use,
        id = this.node.id;
      if (!id) {
        id = this.id;
        $(this.node, {
          id: id
        });
      }
      if (this.type == "linearGradient" || this.type == "radialGradient" || this.type == "pattern") {
        use = make(this.type, this.node.parentNode);
      } else {
        use = make("use", this.node.parentNode);
      }
      $(use.node, {
        "xlink:href": "#" + id
      });
      use.original = this;
      return use;
    };
    function fixids(el) {
      var els = el.selectAll("*"),
        it,
        url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
        ids = [],
        uses = {};
      function urltest(it, name) {
        var val = $(it.node, name);
        val = val && val.match(url);
        val = val && val[2];
        if (val && val.charAt() == "#") {
          val = val.substring(1);
        } else {
          return;
        }
        if (val) {
          uses[val] = (uses[val] || []).concat(function (id) {
            var attr = {};
            attr[name] = Snap.url(id);
            $(it.node, attr);
          });
        }
      }
      function linktest(it) {
        var val = $(it.node, "xlink:href");
        if (val && val.charAt() == "#") {
          val = val.substring(1);
        } else {
          return;
        }
        if (val) {
          uses[val] = (uses[val] || []).concat(function (id) {
            it.attr("xlink:href", "#" + id);
          });
        }
      }
      for (var i = 0, ii = els.length; i < ii; i++) {
        it = els[i];
        urltest(it, "fill");
        urltest(it, "stroke");
        urltest(it, "filter");
        urltest(it, "mask");
        urltest(it, "clip-path");
        linktest(it);
        var oldid = $(it.node, "id");
        if (oldid) {
          $(it.node, {
            id: it.id
          });
          ids.push({
            old: oldid,
            id: it.id
          });
        }
      }
      for (i = 0, ii = ids.length; i < ii; i++) {
        var fs = uses[ids[i].old];
        if (fs) {
          for (var j = 0, jj = fs.length; j < jj; j++) {
            fs[j](ids[i].id);
          }
        }
      }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/
    elproto.clone = function () {
      var clone = wrap(this.node.cloneNode(true));
      if ($(clone.node, "id")) {
        $(clone.node, {
          id: clone.id
        });
      }
      fixids(clone);
      clone.insertAfter(this);
      return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/
    elproto.toDefs = function () {
      var defs = getSomeDefs(this);
      defs.appendChild(this.node);
      return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/
    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
      var p = make("pattern", getSomeDefs(this));
      if (x == null) {
        x = this.getBBox();
      }
      if (is(x, "object") && "x" in x) {
        y = x.y;
        width = x.width;
        height = x.height;
        x = x.x;
      }
      $(p.node, {
        x: x,
        y: y,
        width: width,
        height: height,
        patternUnits: "userSpaceOnUse",
        id: p.id,
        viewBox: [x, y, width, height].join(" ")
      });
      p.node.appendChild(this.node);
      return p;
    };
    // SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
    // SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/
    // TODO add usage for markers
    elproto.marker = function (x, y, width, height, refX, refY) {
      var p = make("marker", getSomeDefs(this));
      if (x == null) {
        x = this.getBBox();
      }
      if (is(x, "object") && "x" in x) {
        y = x.y;
        width = x.width;
        height = x.height;
        refX = x.refX || x.cx;
        refY = x.refY || x.cy;
        x = x.x;
      }
      $(p.node, {
        viewBox: [x, y, width, height].join(" "),
        markerWidth: width,
        markerHeight: height,
        orient: "auto",
        refX: refX || 0,
        refY: refY || 0,
        id: p.id
      });
      p.node.appendChild(this.node);
      return p;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/
    elproto.data = function (key, value) {
      var data = eldata[this.id] = eldata[this.id] || {};
      if (arguments.length == 0) {
        eve("snap.data.get." + this.id, this, data, null);
        return data;
      }
      if (arguments.length == 1) {
        if (Snap.is(key, "object")) {
          for (var i in key) if (key[has](i)) {
            this.data(i, key[i]);
          }
          return this;
        }
        eve("snap.data.get." + this.id, this, data[key], key);
        return data[key];
      }
      data[key] = value;
      eve("snap.data.set." + this.id, this, value, key);
      return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/
    elproto.removeData = function (key) {
      if (key == null) {
        eldata[this.id] = {};
      } else {
        eldata[this.id] && delete eldata[this.id][key];
      }
      return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/
    /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/
    elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/
    elproto.innerSVG = toString();
    function toString(type) {
      return function () {
        var res = type ? "<" + this.type : "",
          attr = this.node.attributes,
          chld = this.node.childNodes;
        if (type) {
          for (var i = 0, ii = attr.length; i < ii; i++) {
            res += " " + attr[i].name + '="' + attr[i].value.replace(/"/g, '\\"') + '"';
          }
        }
        if (chld.length) {
          type && (res += ">");
          for (i = 0, ii = chld.length; i < ii; i++) {
            if (chld[i].nodeType == 3) {
              res += chld[i].nodeValue;
            } else if (chld[i].nodeType == 1) {
              res += wrap(chld[i]).toString();
            }
          }
          type && (res += "</" + this.type + ">");
        } else {
          type && (res += "/>");
        }
        return res;
      };
    }
    elproto.toDataURL = function () {
      if (window && window.btoa) {
        var bb = this.getBBox(),
          svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
            x: +bb.x.toFixed(3),
            y: +bb.y.toFixed(3),
            width: +bb.width.toFixed(3),
            height: +bb.height.toFixed(3),
            contents: this.outerSVG()
          });
        return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
      }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/
    Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/
    Fragment.prototype.selectAll = elproto.selectAll;
  });

  // Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
      is = Snap.is,
      Str = String,
      has = "hasOwnProperty";
    function slice(from, to, f) {
      return function (arr) {
        var res = arr.slice(from, to);
        if (res.length == 1) {
          res = res[0];
        }
        return f ? f(res) : res;
      };
    }
    var Animation = function Animation(attr, ms, easing, callback) {
      if (typeof easing == "function" && !easing.length) {
        callback = easing;
        easing = mina.linear;
      }
      this.attr = attr;
      this.dur = ms;
      easing && (this.easing = easing);
      callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/
    Snap.animation = function (attr, ms, easing, callback) {
      return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/
    elproto.inAnim = function () {
      var el = this,
        res = [];
      for (var id in el.anims) if (el.anims[has](id)) {
        (function (a) {
          res.push({
            anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
            mina: a,
            curStatus: a.status(),
            status: function status(val) {
              return a.status(val);
            },
            stop: function stop() {
              a.stop();
            }
          });
        })(el.anims[id]);
      }
      return res;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/
    Snap.animate = function (from, to, setter, ms, easing, callback) {
      if (typeof easing == "function" && !easing.length) {
        callback = easing;
        easing = mina.linear;
      }
      var now = mina.time(),
        anim = mina(from, to, now, now + ms, mina.time, setter, easing);
      callback && eve.once("mina.finish." + anim.id, callback);
      return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/
    elproto.stop = function () {
      var anims = this.inAnim();
      for (var i = 0, ii = anims.length; i < ii; i++) {
        anims[i].stop();
      }
      return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/
    elproto.animate = function (attrs, ms, easing, callback) {
      if (typeof easing == "function" && !easing.length) {
        callback = easing;
        easing = mina.linear;
      }
      if (attrs instanceof Animation) {
        callback = attrs.callback;
        easing = attrs.easing;
        ms = attrs.dur;
        attrs = attrs.attr;
      }
      var fkeys = [],
        tkeys = [],
        keys = {},
        from,
        to,
        f,
        eq,
        el = this;
      for (var key in attrs) if (attrs[has](key)) {
        if (el.equal) {
          eq = el.equal(key, Str(attrs[key]));
          from = eq.from;
          to = eq.to;
          f = eq.f;
        } else {
          from = +el.attr(key);
          to = +attrs[key];
        }
        var len = is(from, "array") ? from.length : 1;
        keys[key] = slice(fkeys.length, fkeys.length + len, f);
        fkeys = fkeys.concat(from);
        tkeys = tkeys.concat(to);
      }
      var now = mina.time(),
        anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
          var attr = {};
          for (var key in keys) if (keys[has](key)) {
            attr[key] = keys[key](val);
          }
          el.attr(attr);
        }, easing);
      el.anims[anim.id] = anim;
      anim._attrs = attrs;
      anim._callback = callback;
      eve("snap.animcreated." + el.id, anim);
      eve.once("mina.finish." + anim.id, function () {
        eve.off("mina.*." + anim.id);
        delete el.anims[anim.id];
        callback && callback.call(el);
      });
      eve.once("mina.stop." + anim.id, function () {
        eve.off("mina.*." + anim.id);
        delete el.anims[anim.id];
      });
      return el;
    };
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString,
      Str = String,
      math = Math,
      E = "";
    function Matrix(a, b, c, d, e, f) {
      if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
        this.a = a.a;
        this.b = a.b;
        this.c = a.c;
        this.d = a.d;
        this.e = a.e;
        this.f = a.f;
        return;
      }
      if (a != null) {
        this.a = +a;
        this.b = +b;
        this.c = +c;
        this.d = +d;
        this.e = +e;
        this.f = +f;
      } else {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.e = 0;
        this.f = 0;
      }
    }
    (function (matrixproto) {
      /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
      matrixproto.add = function (a, b, c, d, e, f) {
        if (a && a instanceof Matrix) {
          return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
        }
        var aNew = a * this.a + b * this.c,
          bNew = a * this.b + b * this.d;
        this.e += e * this.a + f * this.c;
        this.f += e * this.b + f * this.d;
        this.c = c * this.a + d * this.c;
        this.d = c * this.b + d * this.d;
        this.a = aNew;
        this.b = bNew;
        return this;
      };
      /*\
         * Matrix.multLeft
         [ method ]
         **
         * Multiplies a passed affine transform to the left: M * this.
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
      Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
        if (a && a instanceof Matrix) {
          return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
        }
        var aNew = a * this.a + c * this.b,
          cNew = a * this.c + c * this.d,
          eNew = a * this.e + c * this.f + e;
        this.b = b * this.a + d * this.b;
        this.d = b * this.c + d * this.d;
        this.f = b * this.e + d * this.f + f;
        this.a = aNew;
        this.c = cNew;
        this.e = eNew;
        return this;
      };
      /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/
      matrixproto.invert = function () {
        var me = this,
          x = me.a * me.d - me.b * me.c;
        return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
      };
      /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/
      matrixproto.clone = function () {
        return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
      };
      /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/
      matrixproto.translate = function (x, y) {
        this.e += x * this.a + y * this.c;
        this.f += x * this.b + y * this.d;
        return this;
      };
      /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/
      matrixproto.scale = function (x, y, cx, cy) {
        y == null && (y = x);
        (cx || cy) && this.translate(cx, cy);
        this.a *= x;
        this.b *= x;
        this.c *= y;
        this.d *= y;
        (cx || cy) && this.translate(-cx, -cy);
        return this;
      };
      /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/
      matrixproto.rotate = function (a, x, y) {
        a = Snap.rad(a);
        x = x || 0;
        y = y || 0;
        var cos = +math.cos(a).toFixed(9),
          sin = +math.sin(a).toFixed(9);
        this.add(cos, sin, -sin, cos, x, y);
        return this.add(1, 0, 0, 1, -x, -y);
      };
      /*\
         * Matrix.skewX
         [ method ]
         **
         * Skews the matrix along the x-axis
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
      matrixproto.skewX = function (x) {
        return this.skew(x, 0);
      };
      /*\
         * Matrix.skewY
         [ method ]
         **
         * Skews the matrix along the y-axis
         - y (number) Angle to skew along the y-axis (in degrees).
        \*/
      matrixproto.skewY = function (y) {
        return this.skew(0, y);
      };
      /*\
         * Matrix.skew
         [ method ]
         **
         * Skews the matrix
         - y (number) Angle to skew along the y-axis (in degrees).
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
      matrixproto.skew = function (x, y) {
        x = x || 0;
        y = y || 0;
        x = Snap.rad(x);
        y = Snap.rad(y);
        var c = math.tan(x).toFixed(9);
        var b = math.tan(y).toFixed(9);
        return this.add(1, b, c, 1, 0, 0);
      };
      /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/
      matrixproto.x = function (x, y) {
        return x * this.a + y * this.c + this.e;
      };
      /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/
      matrixproto.y = function (x, y) {
        return x * this.b + y * this.d + this.f;
      };
      matrixproto.get = function (i) {
        return +this[Str.fromCharCode(97 + i)].toFixed(4);
      };
      matrixproto.toString = function () {
        return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
      };
      matrixproto.offset = function () {
        return [this.e.toFixed(4), this.f.toFixed(4)];
      };
      function norm(a) {
        return a[0] * a[0] + a[1] * a[1];
      }
      function normalize(a) {
        var mag = math.sqrt(norm(a));
        a[0] && (a[0] /= mag);
        a[1] && (a[1] /= mag);
      }
      /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/
      matrixproto.determinant = function () {
        return this.a * this.d - this.b * this.c;
      };
      /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/
      matrixproto.split = function () {
        var out = {};
        // translation
        out.dx = this.e;
        out.dy = this.f;

        // scale and shear
        var row = [[this.a, this.b], [this.c, this.d]];
        out.scalex = math.sqrt(norm(row[0]));
        normalize(row[0]);
        out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
        row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
        out.scaley = math.sqrt(norm(row[1]));
        normalize(row[1]);
        out.shear /= out.scaley;
        if (this.determinant() < 0) {
          out.scalex = -out.scalex;
        }

        // rotation
        var sin = row[0][1],
          cos = row[1][1];
        if (cos < 0) {
          out.rotate = Snap.deg(math.acos(cos));
          if (sin < 0) {
            out.rotate = 360 - out.rotate;
          }
        } else {
          out.rotate = Snap.deg(math.asin(sin));
        }
        out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
        out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
        out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
        return out;
      };
      /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/
      matrixproto.toTransformString = function (shorter) {
        var s = shorter || this.split();
        if (!+s.shear.toFixed(9)) {
          s.scalex = +s.scalex.toFixed(4);
          s.scaley = +s.scaley.toFixed(4);
          s.rotate = +s.rotate.toFixed(4);
          return (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) + (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) + (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
        } else {
          return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
        }
      };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/
    Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/
    Snap.matrix = function (a, b, c, d, e, f) {
      return new Matrix(a, b, c, d, e, f);
    };
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty",
      make = Snap._.make,
      wrap = Snap._.wrap,
      is = Snap.is,
      getSomeDefs = Snap._.getSomeDefs,
      reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
      $ = Snap._.$,
      URL = Snap.url,
      Str = String,
      separator = Snap._.separator,
      E = "";
    /*\
     * Snap.deurl
     [ method ]
     **
     * Unwraps path from `"url(<path>)"`.
     - value (string) url path
     = (string) unwrapped path
    \*/
    Snap.deurl = function (value) {
      var res = String(value).match(reURLValue);
      return res ? res[2] : value;
    };
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function (value) {
      if (value instanceof Element || value instanceof Fragment) {
        eve.stop();
        if (value instanceof Fragment && value.node.childNodes.length == 1) {
          value = value.node.firstChild;
          getSomeDefs(this).appendChild(value);
          value = wrap(value);
        }
        if (value.type == "mask") {
          var mask = value;
        } else {
          mask = make("mask", getSomeDefs(this));
          mask.node.appendChild(value.node);
        }
        !mask.node.id && $(mask.node, {
          id: mask.id
        });
        $(this.node, {
          mask: URL(mask.id)
        });
      }
    });
    (function (clipIt) {
      eve.on("snap.util.attr.clip", clipIt);
      eve.on("snap.util.attr.clip-path", clipIt);
      eve.on("snap.util.attr.clipPath", clipIt);
    })(function (value) {
      if (value instanceof Element || value instanceof Fragment) {
        eve.stop();
        var clip,
          node = value.node;
        while (node) {
          if (node.nodeName === "clipPath") {
            clip = new Element(node);
            break;
          }
          if (node.nodeName === "svg") {
            clip = undefined;
            break;
          }
          node = node.parentNode;
        }
        if (!clip) {
          clip = make("clipPath", getSomeDefs(this));
          clip.node.appendChild(value.node);
          !clip.node.id && $(clip.node, {
            id: clip.id
          });
        }
        $(this.node, {
          "clip-path": URL(clip.node.id || clip.id)
        });
      }
    });
    function fillStroke(name) {
      return function (value) {
        eve.stop();
        if (value instanceof Fragment && value.node.childNodes.length == 1 && (value.node.firstChild.tagName == "radialGradient" || value.node.firstChild.tagName == "linearGradient" || value.node.firstChild.tagName == "pattern")) {
          value = value.node.firstChild;
          getSomeDefs(this).appendChild(value);
          value = wrap(value);
        }
        if (value instanceof Element) {
          if (value.type == "radialGradient" || value.type == "linearGradient" || value.type == "pattern") {
            if (!value.node.id) {
              $(value.node, {
                id: value.id
              });
            }
            var fill = URL(value.node.id);
          } else {
            fill = value.attr(name);
          }
        } else {
          fill = Snap.color(value);
          if (fill.error) {
            var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
            if (grad) {
              if (!grad.node.id) {
                $(grad.node, {
                  id: grad.id
                });
              }
              fill = URL(grad.node.id);
            } else {
              fill = value;
            }
          } else {
            fill = Str(fill);
          }
        }
        var attrs = {};
        attrs[name] = fill;
        $(this.node, attrs);
        this.node.style[name] = E;
      };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string) {
      string = Str(string);
      var tokens = string.match(gradrg);
      if (!tokens) {
        return null;
      }
      var type = tokens[1],
        params = tokens[2],
        stops = tokens[3];
      params = params.split(/\s*,\s*/).map(function (el) {
        return +el == el ? +el : el;
      });
      if (params.length == 1 && params[0] == 0) {
        params = [];
      }
      stops = stops.split("-");
      stops = stops.map(function (el) {
        el = el.split(":");
        var out = {
          color: el[0]
        };
        if (el[1]) {
          out.offset = parseFloat(el[1]);
        }
        return out;
      });
      var len = stops.length,
        start = 0,
        j = 0;
      function seed(i, end) {
        var step = (end - start) / (i - j);
        for (var k = j; k < i; k++) {
          stops[k].offset = +(+start + step * (k - j)).toFixed(2);
        }
        j = i;
        start = end;
      }
      len--;
      for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
        seed(i, stops[i].offset);
      }
      stops[len].offset = stops[len].offset || 100;
      seed(len, stops[len].offset);
      return {
        type: type,
        params: params,
        stops: stops
      };
    });
    eve.on("snap.util.attr.d", function (value) {
      eve.stop();
      if (is(value, "array") && is(value[0], "array")) {
        value = Snap.path.toString.call(value);
      }
      value = Str(value);
      if (value.match(/[ruo]/i)) {
        value = Snap.path.toAbsolute(value);
      }
      $(this.node, {
        d: value
      });
    })(-1);
    eve.on("snap.util.attr.#text", function (value) {
      eve.stop();
      value = Str(value);
      var txt = glob.doc.createTextNode(value);
      while (this.node.firstChild) {
        this.node.removeChild(this.node.firstChild);
      }
      this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function (value) {
      eve.stop();
      this.attr({
        d: value
      });
    })(-1);
    eve.on("snap.util.attr.class", function (value) {
      eve.stop();
      this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function (value) {
      var vb;
      if (is(value, "object") && "x" in value) {
        vb = [value.x, value.y, value.width, value.height].join(" ");
      } else if (is(value, "array")) {
        vb = value.join(" ");
      } else {
        vb = value;
      }
      $(this.node, {
        viewBox: vb
      });
      eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function (value) {
      this.transform(value);
      eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function (value) {
      if (this.type == "rect") {
        eve.stop();
        $(this.node, {
          rx: value,
          ry: value
        });
      }
    })(-1);
    eve.on("snap.util.attr.textpath", function (value) {
      eve.stop();
      if (this.type == "text") {
        var id, tp, node;
        if (!value && this.textPath) {
          tp = this.textPath;
          while (tp.node.firstChild) {
            this.node.appendChild(tp.node.firstChild);
          }
          tp.remove();
          delete this.textPath;
          return;
        }
        if (is(value, "string")) {
          var defs = getSomeDefs(this),
            path = wrap(defs.parentNode).path(value);
          defs.appendChild(path.node);
          id = path.id;
          path.attr({
            id: id
          });
        } else {
          value = wrap(value);
          if (value instanceof Element) {
            id = value.attr("id");
            if (!id) {
              id = value.id;
              value.attr({
                id: id
              });
            }
          }
        }
        if (id) {
          tp = this.textPath;
          node = this.node;
          if (tp) {
            tp.attr({
              "xlink:href": "#" + id
            });
          } else {
            tp = $("textPath", {
              "xlink:href": "#" + id
            });
            while (node.firstChild) {
              tp.appendChild(node.firstChild);
            }
            node.appendChild(tp);
            this.textPath = wrap(tp);
          }
        }
      }
    })(-1);
    eve.on("snap.util.attr.text", function (value) {
      if (this.type == "text") {
        var i = 0,
          node = this.node,
          _tuner = function tuner(chunk) {
            var out = $("tspan");
            if (is(chunk, "array")) {
              for (var i = 0; i < chunk.length; i++) {
                out.appendChild(_tuner(chunk[i]));
              }
            } else {
              out.appendChild(glob.doc.createTextNode(chunk));
            }
            out.normalize && out.normalize();
            return out;
          };
        while (node.firstChild) {
          node.removeChild(node.firstChild);
        }
        var tuned = _tuner(value);
        while (tuned.firstChild) {
          node.appendChild(tuned.firstChild);
        }
      }
      eve.stop();
    })(-1);
    function setFontSize(value) {
      eve.stop();
      if (value == +value) {
        value += "px";
      }
      this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);
    eve.on("snap.util.getattr.transform", function () {
      eve.stop();
      return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function () {
      eve.stop();
      return this.textPath;
    })(-1);
    // Markers
    (function () {
      function getter(end) {
        return function () {
          eve.stop();
          var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
          if (style == "none") {
            return style;
          } else {
            return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
          }
        };
      }
      function setter(end) {
        return function (value) {
          eve.stop();
          var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
          if (value == "" || !value) {
            this.node.style[name] = "none";
            return;
          }
          if (value.type == "marker") {
            var id = value.node.id;
            if (!id) {
              $(value.node, {
                id: value.id
              });
            }
            this.node.style[name] = URL(id);
            return;
          }
        };
      }
      eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
      eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
      eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
      eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
      eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
      eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
      eve.on("snap.util.attr.marker-end", setter("end"))(-1);
      eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
      eve.on("snap.util.attr.marker-start", setter("start"))(-1);
      eve.on("snap.util.attr.markerStart", setter("start"))(-1);
      eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
      eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    })();
    eve.on("snap.util.getattr.r", function () {
      if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
        eve.stop();
        return $(this.node, "rx");
      }
    })(-1);
    function textExtract(node) {
      var out = [];
      var children = node.childNodes;
      for (var i = 0, ii = children.length; i < ii; i++) {
        var chi = children[i];
        if (chi.nodeType == 3) {
          out.push(chi.nodeValue);
        }
        if (chi.tagName == "tspan") {
          if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
            out.push(chi.firstChild.nodeValue);
          } else {
            out.push(textExtract(chi));
          }
        }
      }
      return out;
    }
    eve.on("snap.util.getattr.text", function () {
      if (this.type == "text" || this.type == "tspan") {
        eve.stop();
        var out = textExtract(this.node);
        return out.length == 1 ? out[0] : out;
      }
    })(-1);
    eve.on("snap.util.getattr.#text", function () {
      return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.fill", function (internal) {
      if (internal) {
        return;
      }
      eve.stop();
      var value = eve("snap.util.getattr.fill", this, true).firstDefined();
      return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.stroke", function (internal) {
      if (internal) {
        return;
      }
      eve.stop();
      var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
      return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function () {
      eve.stop();
      var vb = $(this.node, "viewBox");
      if (vb) {
        vb = vb.split(separator);
        return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
      } else {
        return;
      }
    })(-1);
    eve.on("snap.util.getattr.points", function () {
      var p = $(this.node, "points");
      eve.stop();
      if (p) {
        return p.split(separator);
      } else {
        return;
      }
    })(-1);
    eve.on("snap.util.getattr.path", function () {
      var p = $(this.node, "d");
      eve.stop();
      return p;
    })(-1);
    eve.on("snap.util.getattr.class", function () {
      return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
      eve.stop();
      return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
  });

  // Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g,
      rgBadSpace = /[\t\r\n\f]/g,
      rgTrim = /(^\s+|\s+$)/g,
      Str = String,
      elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.addClass = function (value) {
      var classes = Str(value || "").match(rgNotSpace) || [],
        elem = this.node,
        className = elem.className.baseVal,
        curClasses = className.match(rgNotSpace) || [],
        j,
        pos,
        clazz,
        finalValue;
      if (classes.length) {
        j = 0;
        while (clazz = classes[j++]) {
          pos = curClasses.indexOf(clazz);
          if (!~pos) {
            curClasses.push(clazz);
          }
        }
        finalValue = curClasses.join(" ");
        if (className != finalValue) {
          elem.className.baseVal = finalValue;
        }
      }
      return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.removeClass = function (value) {
      var classes = Str(value || "").match(rgNotSpace) || [],
        elem = this.node,
        className = elem.className.baseVal,
        curClasses = className.match(rgNotSpace) || [],
        j,
        pos,
        clazz,
        finalValue;
      if (curClasses.length) {
        j = 0;
        while (clazz = classes[j++]) {
          pos = curClasses.indexOf(clazz);
          if (~pos) {
            curClasses.splice(pos, 1);
          }
        }
        finalValue = curClasses.join(" ");
        if (className != finalValue) {
          elem.className.baseVal = finalValue;
        }
      }
      return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/
    elproto.hasClass = function (value) {
      var elem = this.node,
        className = elem.className.baseVal,
        curClasses = className.match(rgNotSpace) || [];
      return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/
    elproto.toggleClass = function (value, flag) {
      if (flag != null) {
        if (flag) {
          return this.addClass(value);
        } else {
          return this.removeClass(value);
        }
      }
      var classes = (value || "").match(rgNotSpace) || [],
        elem = this.node,
        className = elem.className.baseVal,
        curClasses = className.match(rgNotSpace) || [],
        j,
        pos,
        clazz,
        finalValue;
      j = 0;
      while (clazz = classes[j++]) {
        pos = curClasses.indexOf(clazz);
        if (~pos) {
          curClasses.splice(pos, 1);
        } else {
          curClasses.push(clazz);
        }
      }
      finalValue = curClasses.join(" ");
      if (className != finalValue) {
        elem.className.baseVal = finalValue;
      }
      return this;
    };
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var operators = {
        "+": function _(x, y) {
          return x + y;
        },
        "-": function _(x, y) {
          return x - y;
        },
        "/": function _(x, y) {
          return x / y;
        },
        "*": function _(x, y) {
          return x * y;
        }
      },
      Str = String,
      reUnit = /[a-z]+$/i,
      reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
      return val;
    }
    function getUnit(unit) {
      return function (val) {
        return +val.toFixed(3) + unit;
      };
    }
    eve.on("snap.util.attr", function (val) {
      var plus = Str(val).match(reAddon);
      if (plus) {
        var evnt = eve.nt(),
          name = evnt.substring(evnt.lastIndexOf(".") + 1),
          a = this.attr(name),
          atr = {};
        eve.stop();
        var unit = plus[3] || "",
          aUnit = a.match(reUnit),
          op = operators[plus[1]];
        if (aUnit && aUnit == unit) {
          val = op(parseFloat(a), +plus[2]);
        } else {
          a = this.asPX(name);
          val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
        }
        if (isNaN(a) || isNaN(val)) {
          return;
        }
        atr[name] = val;
        this.attr(atr);
      }
    })(-10);
    eve.on("snap.util.equal", function (name, b) {
      var A,
        B,
        a = Str(this.attr(name) || ""),
        el = this,
        bplus = Str(b).match(reAddon);
      if (bplus) {
        eve.stop();
        var unit = bplus[3] || "",
          aUnit = a.match(reUnit),
          op = operators[bplus[1]];
        if (aUnit && aUnit == unit) {
          return {
            from: parseFloat(a),
            to: op(parseFloat(a), +bplus[2]),
            f: getUnit(aUnit)
          };
        } else {
          a = this.asPX(name);
          return {
            from: a,
            to: op(a, this.asPX(name, bplus[2] + unit)),
            f: getNumber
          };
        }
      }
    })(-10);
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype,
      is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/
    proto.rect = function (x, y, w, h, rx, ry) {
      var attr;
      if (ry == null) {
        ry = rx;
      }
      if (is(x, "object") && x == "[object Object]") {
        attr = x;
      } else if (x != null) {
        attr = {
          x: x,
          y: y,
          width: w,
          height: h
        };
        if (rx != null) {
          attr.rx = rx;
          attr.ry = ry;
        }
      }
      return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/
    proto.circle = function (cx, cy, r) {
      var attr;
      if (is(cx, "object") && cx == "[object Object]") {
        attr = cx;
      } else if (cx != null) {
        attr = {
          cx: cx,
          cy: cy,
          r: r
        };
      }
      return this.el("circle", attr);
    };
    var preload = function () {
      function onerror() {
        this.parentNode.removeChild(this);
      }
      return function (src, f) {
        var img = glob.doc.createElement("img"),
          body = glob.doc.body;
        img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
        img.onload = function () {
          f.call(img);
          img.onload = img.onerror = null;
          body.removeChild(img);
        };
        img.onerror = onerror;
        body.appendChild(img);
        img.src = src;
      };
    }();

    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/
    proto.image = function (src, x, y, width, height) {
      var el = this.el("image");
      if (is(src, "object") && "src" in src) {
        el.attr(src);
      } else if (src != null) {
        var set = {
          "xlink:href": src,
          preserveAspectRatio: "none"
        };
        if (x != null && y != null) {
          set.x = x;
          set.y = y;
        }
        if (width != null && height != null) {
          set.width = width;
          set.height = height;
        } else {
          preload(src, function () {
            Snap._.$(el.node, {
              width: this.offsetWidth,
              height: this.offsetHeight
            });
          });
        }
        Snap._.$(el.node, set);
      }
      return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/
    proto.ellipse = function (cx, cy, rx, ry) {
      var attr;
      if (is(cx, "object") && cx == "[object Object]") {
        attr = cx;
      } else if (cx != null) {
        attr = {
          cx: cx,
          cy: cy,
          rx: rx,
          ry: ry
        };
      }
      return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/
    proto.path = function (d) {
      var attr;
      if (is(d, "object") && !is(d, "array")) {
        attr = d;
      } else if (d) {
        attr = {
          d: d
        };
      }
      return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/
    /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/
    proto.group = proto.g = function (first) {
      var attr,
        el = this.el("g");
      if (arguments.length == 1 && first && !first.type) {
        el.attr(first);
      } else if (arguments.length) {
        el.add(Array.prototype.slice.call(arguments, 0));
      }
      return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/
    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
      var attrs = {};
      if (is(x, "object") && y == null) {
        attrs = x;
      } else {
        if (x != null) {
          attrs.x = x;
        }
        if (y != null) {
          attrs.y = y;
        }
        if (width != null) {
          attrs.width = width;
        }
        if (height != null) {
          attrs.height = height;
        }
        if (vbx != null && vby != null && vbw != null && vbh != null) {
          attrs.viewBox = [vbx, vby, vbw, vbh];
        }
      }
      return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/
    proto.mask = function (first) {
      var attr,
        el = this.el("mask");
      if (arguments.length == 1 && first && !first.type) {
        el.attr(first);
      } else if (arguments.length) {
        el.add(Array.prototype.slice.call(arguments, 0));
      }
      return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/
    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
      if (is(x, "object")) {
        var attr = x;
      } else {
        attr = {
          patternUnits: "userSpaceOnUse"
        };
        if (x) {
          attr.x = x;
        }
        if (y) {
          attr.y = y;
        }
        if (width != null) {
          attr.width = width;
        }
        if (height != null) {
          attr.height = height;
        }
        if (vx != null && vy != null && vw != null && vh != null) {
          attr.viewBox = [vx, vy, vw, vh];
        } else {
          attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
        }
      }
      return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/
    proto.use = function (id) {
      if (id != null) {
        if (id instanceof Element) {
          if (!id.attr("id")) {
            id.attr({
              id: Snap._.id(id)
            });
          }
          id = id.attr("id");
        }
        if (String(id).charAt() == "#") {
          id = id.substring(1);
        }
        return this.el("use", {
          "xlink:href": "#" + id
        });
      } else {
        return Element.prototype.use.call(this);
      }
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/
    proto.symbol = function (vx, vy, vw, vh) {
      var attr = {};
      if (vx != null && vy != null && vw != null && vh != null) {
        attr.viewBox = [vx, vy, vw, vh];
      }
      return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/
    proto.text = function (x, y, text) {
      var attr = {};
      if (is(x, "object")) {
        attr = x;
      } else if (x != null) {
        attr = {
          x: x,
          y: y,
          text: text || ""
        };
      }
      return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/
    proto.line = function (x1, y1, x2, y2) {
      var attr = {};
      if (is(x1, "object")) {
        attr = x1;
      } else if (x1 != null) {
        attr = {
          x1: x1,
          x2: x2,
          y1: y1,
          y2: y2
        };
      }
      return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/
    proto.polyline = function (points) {
      if (arguments.length > 1) {
        points = Array.prototype.slice.call(arguments, 0);
      }
      var attr = {};
      if (is(points, "object") && !is(points, "array")) {
        attr = points;
      } else if (points != null) {
        attr = {
          points: points
        };
      }
      return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/
    proto.polygon = function (points) {
      if (arguments.length > 1) {
        points = Array.prototype.slice.call(arguments, 0);
      }
      var attr = {};
      if (is(points, "object") && !is(points, "array")) {
        attr = points;
      } else if (points != null) {
        attr = {
          points: points
        };
      }
      return this.el("polygon", attr);
    };
    // gradients
    (function () {
      var $ = Snap._.$;
      // gradients' helpers
      /*\
         * Element.stops
         [ method ]
         **
         * Only for gradients!
         * Returns array of gradient stops elements.
         = (array) the stops array.
        \*/
      function Gstops() {
        return this.selectAll("stop");
      }
      /*\
         * Element.addStop
         [ method ]
         **
         * Only for gradients!
         * Adds another stop to the gradient.
         - color (string) stops color
         - offset (number) stops offset 0..100
         = (object) gradient element
        \*/
      function GaddStop(color, offset) {
        var stop = $("stop"),
          attr = {
            offset: +offset + "%"
          };
        color = Snap.color(color);
        attr["stop-color"] = color.hex;
        if (color.opacity < 1) {
          attr["stop-opacity"] = color.opacity;
        }
        $(stop, attr);
        var stops = this.stops(),
          inserted;
        for (var i = 0; i < stops.length; i++) {
          var stopOffset = parseFloat(stops[i].attr("offset"));
          if (stopOffset > offset) {
            this.node.insertBefore(stop, stops[i].node);
            inserted = true;
            break;
          }
        }
        if (!inserted) {
          this.node.appendChild(stop);
        }
        return this;
      }
      function GgetBBox() {
        if (this.type == "linearGradient") {
          var x1 = $(this.node, "x1") || 0,
            x2 = $(this.node, "x2") || 1,
            y1 = $(this.node, "y1") || 0,
            y2 = $(this.node, "y2") || 0;
          return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
        } else {
          var cx = this.node.cx || 0.5,
            cy = this.node.cy || 0.5,
            r = this.node.r || 0;
          return Snap._.box(cx - r, cy - r, r * 2, r * 2);
        }
      }
      /*\
         * Element.setStops
         [ method ]
         **
         * Only for gradients!
         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
         - str (string) gradient descriptor part after `()`.
         = (object) gradient element
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         | g.setStops("#fff-#000-#f00-#fc0");
        \*/
      function GsetStops(str) {
        var grad = str,
          stops = this.stops();
        if (typeof str == "string") {
          grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
        }
        if (!Snap.is(grad, "array")) {
          return;
        }
        for (var i = 0; i < stops.length; i++) {
          if (grad[i]) {
            var color = Snap.color(grad[i].color),
              attr = {
                offset: grad[i].offset + "%"
              };
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) {
              attr["stop-opacity"] = color.opacity;
            }
            stops[i].attr(attr);
          } else {
            stops[i].remove();
          }
        }
        for (i = stops.length; i < grad.length; i++) {
          this.addStop(grad[i].color, grad[i].offset);
        }
        return this;
      }
      function gradient(defs, str) {
        var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
          el;
        if (!grad) {
          return null;
        }
        grad.params.unshift(defs);
        if (grad.type.toLowerCase() == "l") {
          el = gradientLinear.apply(0, grad.params);
        } else {
          el = gradientRadial.apply(0, grad.params);
        }
        if (grad.type != grad.type.toLowerCase()) {
          $(el.node, {
            gradientUnits: "userSpaceOnUse"
          });
        }
        var stops = grad.stops,
          len = stops.length;
        for (var i = 0; i < len; i++) {
          var stop = stops[i];
          el.addStop(stop.color, stop.offset);
        }
        return el;
      }
      function gradientLinear(defs, x1, y1, x2, y2) {
        var el = Snap._.make("linearGradient", defs);
        el.stops = Gstops;
        el.addStop = GaddStop;
        el.getBBox = GgetBBox;
        el.setStops = GsetStops;
        if (x1 != null) {
          $(el.node, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
          });
        }
        return el;
      }
      function gradientRadial(defs, cx, cy, r, fx, fy) {
        var el = Snap._.make("radialGradient", defs);
        el.stops = Gstops;
        el.addStop = GaddStop;
        el.getBBox = GgetBBox;
        if (cx != null) {
          $(el.node, {
            cx: cx,
            cy: cy,
            r: r
          });
        }
        if (fx != null && fy != null) {
          $(el.node, {
            fx: fx,
            fy: fy
          });
        }
        return el;
      }
      /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/
      proto.gradient = function (str) {
        return gradient(this.defs, str);
      };
      proto.gradientLinear = function (x1, y1, x2, y2) {
        return gradientLinear(this.defs, x1, y1, x2, y2);
      };
      proto.gradientRadial = function (cx, cy, r, fx, fy) {
        return gradientRadial(this.defs, cx, cy, r, fx, fy);
      };
      /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/
      proto.toString = function () {
        var doc = this.node.ownerDocument,
          f = doc.createDocumentFragment(),
          d = doc.createElement("div"),
          svg = this.node.cloneNode(true),
          res;
        f.appendChild(d);
        d.appendChild(svg);
        Snap._.$(svg, {
          xmlns: "http://www.w3.org/2000/svg"
        });
        res = d.innerHTML;
        f.removeChild(f.firstChild);
        return res;
      };
      /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/
      proto.toDataURL = function () {
        if (window && window.btoa) {
          return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
        }
      };
      /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/
      proto.clear = function () {
        var node = this.node.firstChild,
          next;
        while (node) {
          next = node.nextSibling;
          if (node.tagName != "defs") {
            node.parentNode.removeChild(node);
          } else {
            proto.clear.call({
              node: node
            });
          }
          node = next;
        }
      };
    })();
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
      is = Snap.is,
      clone = Snap._.clone,
      has = "hasOwnProperty",
      p2s = /,?([a-z]),?/gi,
      toFloat = parseFloat,
      math = Math,
      PI = math.PI,
      mmin = math.min,
      mmax = math.max,
      pow = math.pow,
      abs = math.abs;
    function paths(ps) {
      var p = paths.ps = paths.ps || {};
      if (p[ps]) {
        p[ps].sleep = 100;
      } else {
        p[ps] = {
          sleep: 100
        };
      }
      setTimeout(function () {
        for (var key in p) if (p[has](key) && key != ps) {
          p[key].sleep--;
          !p[key].sleep && delete p[key];
        }
      });
      return p[ps];
    }
    function box(x, y, width, height) {
      if (x == null) {
        x = y = width = height = 0;
      }
      if (y == null) {
        y = x.y;
        width = x.width;
        height = x.height;
        x = x.x;
      }
      return {
        x: x,
        y: y,
        width: width,
        w: width,
        height: height,
        h: height,
        x2: x + width,
        y2: y + height,
        cx: x + width / 2,
        cy: y + height / 2,
        r1: math.min(width, height) / 2,
        r2: math.max(width, height) / 2,
        r0: math.sqrt(width * width + height * height) / 2,
        path: rectPath(x, y, width, height),
        vb: [x, y, width, height].join(" ")
      };
    }
    function toString() {
      return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
      var res = clone(pathArray);
      res.toString = toString;
      return res;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
      if (length == null) {
        return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
      } else {
        return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
      }
    }
    function getLengthFactory(istotal, subpath) {
      function O(val) {
        return +(+val).toFixed(3);
      }
      return Snap._.cacher(function (path, length, onlystart) {
        if (path instanceof Element) {
          path = path.attr("d");
        }
        path = path2curve(path);
        var x,
          y,
          p,
          l,
          sp = "",
          subpaths = {},
          point,
          len = 0;
        for (var i = 0, ii = path.length; i < ii; i++) {
          p = path[i];
          if (p[0] == "M") {
            x = +p[1];
            y = +p[2];
          } else {
            l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
            if (len + l > length) {
              if (subpath && !subpaths.start) {
                point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                sp += ["C" + O(point.start.x), O(point.start.y), O(point.m.x), O(point.m.y), O(point.x), O(point.y)];
                if (onlystart) {
                  return sp;
                }
                subpaths.start = sp;
                sp = ["M" + O(point.x), O(point.y) + "C" + O(point.n.x), O(point.n.y), O(point.end.x), O(point.end.y), O(p[5]), O(p[6])].join();
                len += l;
                x = +p[5];
                y = +p[6];
                continue;
              }
              if (!istotal && !subpath) {
                point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                return point;
              }
            }
            len += l;
            x = +p[5];
            y = +p[6];
          }
          sp += p.shift() + p;
        }
        subpaths.end = sp;
        point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
        return point;
      }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1),
      getPointAtLength = getLengthFactory(),
      getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
      var t1 = 1 - t,
        t13 = pow(t1, 3),
        t12 = pow(t1, 2),
        t2 = t * t,
        t3 = t2 * t,
        x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
        y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
        mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
        my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
        nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
        ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
        ax = t1 * p1x + t * c1x,
        ay = t1 * p1y + t * c1y,
        cx = t1 * c2x + t * p2x,
        cy = t1 * c2y + t * p2y,
        alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
      // (mx > nx || my < ny) && (alpha += 180);
      return {
        x: x,
        y: y,
        m: {
          x: mx,
          y: my
        },
        n: {
          x: nx,
          y: ny
        },
        start: {
          x: ax,
          y: ay
        },
        end: {
          x: cx,
          y: cy
        },
        alpha: alpha
      };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
      if (!Snap.is(p1x, "array")) {
        p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
      }
      var bbox = curveDim.apply(null, p1x);
      return box(bbox.min.x, bbox.min.y, bbox.max.x - bbox.min.x, bbox.max.y - bbox.min.y);
    }
    function isPointInsideBBox(bbox, x, y) {
      return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
      bbox1 = box(bbox1);
      bbox2 = box(bbox2);
      return isPointInsideBBox(bbox2, bbox1.x, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2) || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x) && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
      var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
        t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
      return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
      if (z == null) {
        z = 1;
      }
      z = z > 1 ? 1 : z < 0 ? 0 : z;
      var z2 = z / 2,
        n = 12,
        Tvalues = [-0.1252, 0.1252, -0.3678, 0.3678, -0.5873, 0.5873, -0.7699, 0.7699, -0.9041, 0.9041, -0.9816, 0.9816],
        Cvalues = [0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032, 0.1601, 0.1601, 0.1069, 0.1069, 0.0472, 0.0472],
        sum = 0;
      for (var i = 0; i < n; i++) {
        var ct = z2 * Tvalues[i] + z2,
          xbase = base3(ct, x1, x2, x3, x4),
          ybase = base3(ct, y1, y2, y3, y4),
          comb = xbase * xbase + ybase * ybase;
        sum += Cvalues[i] * math.sqrt(comb);
      }
      return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
      if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
        return;
      }
      var t = 1,
        step = t / 2,
        t2 = t - step,
        l,
        e = 0.01;
      l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
      while (abs(l - ll) > e) {
        step /= 2;
        t2 += (l < ll ? 1 : -1) * step;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
      }
      return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
      if (mmax(x1, x2) < mmin(x3, x4) || mmin(x1, x2) > mmax(x3, x4) || mmax(y1, y2) < mmin(y3, y4) || mmin(y1, y2) > mmax(y3, y4)) {
        return;
      }
      var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
        ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
        denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
      if (!denominator) {
        return;
      }
      var px = nx / denominator,
        py = ny / denominator,
        px2 = +px.toFixed(2),
        py2 = +py.toFixed(2);
      if (px2 < +mmin(x1, x2).toFixed(2) || px2 > +mmax(x1, x2).toFixed(2) || px2 < +mmin(x3, x4).toFixed(2) || px2 > +mmax(x3, x4).toFixed(2) || py2 < +mmin(y1, y2).toFixed(2) || py2 > +mmax(y1, y2).toFixed(2) || py2 < +mmin(y3, y4).toFixed(2) || py2 > +mmax(y3, y4).toFixed(2)) {
        return;
      }
      return {
        x: px,
        y: py
      };
    }
    function inter(bez1, bez2) {
      return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
      return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
      var bbox1 = bezierBBox(bez1),
        bbox2 = bezierBBox(bez2);
      if (!isBBoxIntersect(bbox1, bbox2)) {
        return justCount ? 0 : [];
      }
      var l1 = bezlen.apply(0, bez1),
        l2 = bezlen.apply(0, bez2),
        n1 = ~~(l1 / 8),
        n2 = ~~(l2 / 8),
        dots1 = [],
        dots2 = [],
        xy = {},
        res = justCount ? 0 : [];
      for (var i = 0; i < n1 + 1; i++) {
        var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
        dots1.push({
          x: p.x,
          y: p.y,
          t: i / n1
        });
      }
      for (i = 0; i < n2 + 1; i++) {
        p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
        dots2.push({
          x: p.x,
          y: p.y,
          t: i / n2
        });
      }
      for (i = 0; i < n1; i++) {
        for (var j = 0; j < n2; j++) {
          var di = dots1[i],
            di1 = dots1[i + 1],
            dj = dots2[j],
            dj1 = dots2[j + 1],
            ci = abs(di1.x - di.x) < 0.001 ? "y" : "x",
            cj = abs(dj1.x - dj.x) < 0.001 ? "y" : "x",
            is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
          if (is) {
            if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
              continue;
            }
            xy[is.x.toFixed(4)] = is.y.toFixed(4);
            var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
              t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
            if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
              if (justCount) {
                res++;
              } else {
                res.push({
                  x: is.x,
                  y: is.y,
                  t1: t1,
                  t2: t2
                });
              }
            }
          }
        }
      }
      return res;
    }
    function pathIntersection(path1, path2) {
      return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
      return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
      path1 = path2curve(path1);
      path2 = path2curve(path2);
      var x1,
        y1,
        x2,
        y2,
        x1m,
        y1m,
        x2m,
        y2m,
        bez1,
        bez2,
        res = justCount ? 0 : [];
      for (var i = 0, ii = path1.length; i < ii; i++) {
        var pi = path1[i];
        if (pi[0] == "M") {
          x1 = x1m = pi[1];
          y1 = y1m = pi[2];
        } else {
          if (pi[0] == "C") {
            bez1 = [x1, y1].concat(pi.slice(1));
            x1 = bez1[6];
            y1 = bez1[7];
          } else {
            bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
            x1 = x1m;
            y1 = y1m;
          }
          for (var j = 0, jj = path2.length; j < jj; j++) {
            var pj = path2[j];
            if (pj[0] == "M") {
              x2 = x2m = pj[1];
              y2 = y2m = pj[2];
            } else {
              if (pj[0] == "C") {
                bez2 = [x2, y2].concat(pj.slice(1));
                x2 = bez2[6];
                y2 = bez2[7];
              } else {
                bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                x2 = x2m;
                y2 = y2m;
              }
              var intr = interHelper(bez1, bez2, justCount);
              if (justCount) {
                res += intr;
              } else {
                for (var k = 0, kk = intr.length; k < kk; k++) {
                  intr[k].segment1 = i;
                  intr[k].segment2 = j;
                  intr[k].bez1 = bez1;
                  intr[k].bez2 = bez2;
                }
                res = res.concat(intr);
              }
            }
          }
        }
      }
      return res;
    }
    function isPointInsidePath(path, x, y) {
      var bbox = pathBBox(path);
      return isPointInsideBBox(bbox, x, y) && interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
    }
    function pathBBox(path) {
      var pth = paths(path);
      if (pth.bbox) {
        return clone(pth.bbox);
      }
      if (!path) {
        return box();
      }
      path = path2curve(path);
      var x = 0,
        y = 0,
        X = [],
        Y = [],
        p;
      for (var i = 0, ii = path.length; i < ii; i++) {
        p = path[i];
        if (p[0] == "M") {
          x = p[1];
          y = p[2];
          X.push(x);
          Y.push(y);
        } else {
          var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
          X = X.concat(dim.min.x, dim.max.x);
          Y = Y.concat(dim.min.y, dim.max.y);
          x = p[5];
          y = p[6];
        }
      }
      var xmin = mmin.apply(0, X),
        ymin = mmin.apply(0, Y),
        xmax = mmax.apply(0, X),
        ymax = mmax.apply(0, Y),
        bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
      pth.bbox = clone(bb);
      return bb;
    }
    function rectPath(x, y, w, h, r) {
      if (r) {
        return [["M", +x + +r, y], ["l", w - r * 2, 0], ["a", r, r, 0, 0, 1, r, r], ["l", 0, h - r * 2], ["a", r, r, 0, 0, 1, -r, r], ["l", r * 2 - w, 0], ["a", r, r, 0, 0, 1, -r, -r], ["l", 0, r * 2 - h], ["a", r, r, 0, 0, 1, r, -r], ["z"]];
      }
      var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
      res.toString = toString;
      return res;
    }
    function ellipsePath(x, y, rx, ry, a) {
      if (a == null && ry == null) {
        ry = rx;
      }
      x = +x;
      y = +y;
      rx = +rx;
      ry = +ry;
      if (a != null) {
        var rad = Math.PI / 180,
          x1 = x + rx * Math.cos(-ry * rad),
          x2 = x + rx * Math.cos(-a * rad),
          y1 = y + rx * Math.sin(-ry * rad),
          y2 = y + rx * Math.sin(-a * rad),
          res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
      } else {
        res = [["M", x, y], ["m", 0, -ry], ["a", rx, ry, 0, 1, 1, 0, 2 * ry], ["a", rx, ry, 0, 1, 1, 0, -2 * ry], ["z"]];
      }
      res.toString = toString;
      return res;
    }
    var unit2px = Snap._unit2px,
      getPath = {
        path: function path(el) {
          return el.attr("path");
        },
        circle: function circle(el) {
          var attr = unit2px(el);
          return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function ellipse(el) {
          var attr = unit2px(el);
          return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function rect(el) {
          var attr = unit2px(el);
          return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function image(el) {
          var attr = unit2px(el);
          return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function line(el) {
          return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
        },
        polyline: function polyline(el) {
          return "M" + el.attr("points");
        },
        polygon: function polygon(el) {
          return "M" + el.attr("points") + "z";
        },
        deflt: function deflt(el) {
          var bbox = el.node.getBBox();
          return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
      };
    function pathToRelative(pathArray) {
      var pth = paths(pathArray),
        lowerCase = String.prototype.toLowerCase;
      if (pth.rel) {
        return pathClone(pth.rel);
      }
      if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
        pathArray = Snap.parsePathString(pathArray);
      }
      var res = [],
        x = 0,
        y = 0,
        mx = 0,
        my = 0,
        start = 0;
      if (pathArray[0][0] == "M") {
        x = pathArray[0][1];
        y = pathArray[0][2];
        mx = x;
        my = y;
        start++;
        res.push(["M", x, y]);
      }
      for (var i = start, ii = pathArray.length; i < ii; i++) {
        var r = res[i] = [],
          pa = pathArray[i];
        if (pa[0] != lowerCase.call(pa[0])) {
          r[0] = lowerCase.call(pa[0]);
          switch (r[0]) {
            case "a":
              r[1] = pa[1];
              r[2] = pa[2];
              r[3] = pa[3];
              r[4] = pa[4];
              r[5] = pa[5];
              r[6] = +(pa[6] - x).toFixed(3);
              r[7] = +(pa[7] - y).toFixed(3);
              break;
            case "v":
              r[1] = +(pa[1] - y).toFixed(3);
              break;
            case "m":
              mx = pa[1];
              my = pa[2];
            default:
              for (var j = 1, jj = pa.length; j < jj; j++) {
                r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
              }
          }
        } else {
          r = res[i] = [];
          if (pa[0] == "m") {
            mx = pa[1] + x;
            my = pa[2] + y;
          }
          for (var k = 0, kk = pa.length; k < kk; k++) {
            res[i][k] = pa[k];
          }
        }
        var len = res[i].length;
        switch (res[i][0]) {
          case "z":
            x = mx;
            y = my;
            break;
          case "h":
            x += +res[i][len - 1];
            break;
          case "v":
            y += +res[i][len - 1];
            break;
          default:
            x += +res[i][len - 2];
            y += +res[i][len - 1];
        }
      }
      res.toString = toString;
      pth.rel = pathClone(res);
      return res;
    }
    function pathToAbsolute(pathArray) {
      var pth = paths(pathArray);
      if (pth.abs) {
        return pathClone(pth.abs);
      }
      if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) {
        // rough assumption
        pathArray = Snap.parsePathString(pathArray);
      }
      if (!pathArray || !pathArray.length) {
        return [["M", 0, 0]];
      }
      var res = [],
        x = 0,
        y = 0,
        mx = 0,
        my = 0,
        start = 0,
        pa0;
      if (pathArray[0][0] == "M") {
        x = +pathArray[0][1];
        y = +pathArray[0][2];
        mx = x;
        my = y;
        start++;
        res[0] = ["M", x, y];
      }
      var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
      for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
        res.push(r = []);
        pa = pathArray[i];
        pa0 = pa[0];
        if (pa0 != pa0.toUpperCase()) {
          r[0] = pa0.toUpperCase();
          switch (r[0]) {
            case "A":
              r[1] = pa[1];
              r[2] = pa[2];
              r[3] = pa[3];
              r[4] = pa[4];
              r[5] = pa[5];
              r[6] = +pa[6] + x;
              r[7] = +pa[7] + y;
              break;
            case "V":
              r[1] = +pa[1] + y;
              break;
            case "H":
              r[1] = +pa[1] + x;
              break;
            case "R":
              var dots = [x, y].concat(pa.slice(1));
              for (var j = 2, jj = dots.length; j < jj; j++) {
                dots[j] = +dots[j] + x;
                dots[++j] = +dots[j] + y;
              }
              res.pop();
              res = res.concat(catmullRom2bezier(dots, crz));
              break;
            case "O":
              res.pop();
              dots = ellipsePath(x, y, pa[1], pa[2]);
              dots.push(dots[0]);
              res = res.concat(dots);
              break;
            case "U":
              res.pop();
              res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
              r = ["U"].concat(res[res.length - 1].slice(-2));
              break;
            case "M":
              mx = +pa[1] + x;
              my = +pa[2] + y;
            default:
              for (j = 1, jj = pa.length; j < jj; j++) {
                r[j] = +pa[j] + (j % 2 ? x : y);
              }
          }
        } else if (pa0 == "R") {
          dots = [x, y].concat(pa.slice(1));
          res.pop();
          res = res.concat(catmullRom2bezier(dots, crz));
          r = ["R"].concat(pa.slice(-2));
        } else if (pa0 == "O") {
          res.pop();
          dots = ellipsePath(x, y, pa[1], pa[2]);
          dots.push(dots[0]);
          res = res.concat(dots);
        } else if (pa0 == "U") {
          res.pop();
          res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
          r = ["U"].concat(res[res.length - 1].slice(-2));
        } else {
          for (var k = 0, kk = pa.length; k < kk; k++) {
            r[k] = pa[k];
          }
        }
        pa0 = pa0.toUpperCase();
        if (pa0 != "O") {
          switch (r[0]) {
            case "Z":
              x = +mx;
              y = +my;
              break;
            case "H":
              x = r[1];
              break;
            case "V":
              y = r[1];
              break;
            case "M":
              mx = r[r.length - 2];
              my = r[r.length - 1];
            default:
              x = r[r.length - 2];
              y = r[r.length - 1];
          }
        }
      }
      res.toString = toString;
      pth.abs = pathClone(res);
      return res;
    }
    function l2c(x1, y1, x2, y2) {
      return [x1, y1, x2, y2, x2, y2];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
      var _13 = 1 / 3,
        _23 = 2 / 3;
      return [_13 * x1 + _23 * ax, _13 * y1 + _23 * ay, _13 * x2 + _23 * ax, _13 * y2 + _23 * ay, x2, y2];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
      // for more information of where this math came from visit:
      // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
      var _120 = PI * 120 / 180,
        rad = PI / 180 * (+angle || 0),
        res = [],
        xy,
        rotate = Snap._.cacher(function (x, y, rad) {
          var X = x * math.cos(rad) - y * math.sin(rad),
            Y = x * math.sin(rad) + y * math.cos(rad);
          return {
            x: X,
            y: Y
          };
        });
      if (!rx || !ry) {
        return [x1, y1, x2, y2, x2, y2];
      }
      if (!recursive) {
        xy = rotate(x1, y1, -rad);
        x1 = xy.x;
        y1 = xy.y;
        xy = rotate(x2, y2, -rad);
        x2 = xy.x;
        y2 = xy.y;
        var cos = math.cos(PI / 180 * angle),
          sin = math.sin(PI / 180 * angle),
          x = (x1 - x2) / 2,
          y = (y1 - y2) / 2;
        var h = x * x / (rx * rx) + y * y / (ry * ry);
        if (h > 1) {
          h = math.sqrt(h);
          rx = h * rx;
          ry = h * ry;
        }
        var rx2 = rx * rx,
          ry2 = ry * ry,
          k = (large_arc_flag == sweep_flag ? -1 : 1) * math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
          cx = k * rx * y / ry + (x1 + x2) / 2,
          cy = k * -ry * x / rx + (y1 + y2) / 2,
          f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
          f2 = math.asin(((y2 - cy) / ry).toFixed(9));
        f1 = x1 < cx ? PI - f1 : f1;
        f2 = x2 < cx ? PI - f2 : f2;
        f1 < 0 && (f1 = PI * 2 + f1);
        f2 < 0 && (f2 = PI * 2 + f2);
        if (sweep_flag && f1 > f2) {
          f1 = f1 - PI * 2;
        }
        if (!sweep_flag && f2 > f1) {
          f2 = f2 - PI * 2;
        }
      } else {
        f1 = recursive[0];
        f2 = recursive[1];
        cx = recursive[2];
        cy = recursive[3];
      }
      var df = f2 - f1;
      if (abs(df) > _120) {
        var f2old = f2,
          x2old = x2,
          y2old = y2;
        f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
        x2 = cx + rx * math.cos(f2);
        y2 = cy + ry * math.sin(f2);
        res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
      }
      df = f2 - f1;
      var c1 = math.cos(f1),
        s1 = math.sin(f1),
        c2 = math.cos(f2),
        s2 = math.sin(f2),
        t = math.tan(df / 4),
        hx = 4 / 3 * rx * t,
        hy = 4 / 3 * ry * t,
        m1 = [x1, y1],
        m2 = [x1 + hx * s1, y1 - hy * c1],
        m3 = [x2 + hx * s2, y2 - hy * c2],
        m4 = [x2, y2];
      m2[0] = 2 * m1[0] - m2[0];
      m2[1] = 2 * m1[1] - m2[1];
      if (recursive) {
        return [m2, m3, m4].concat(res);
      } else {
        res = [m2, m3, m4].concat(res).join().split(",");
        var newres = [];
        for (var i = 0, ii = res.length; i < ii; i++) {
          newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
        }
        return newres;
      }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
      var t1 = 1 - t;
      return {
        x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
        y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
      };
    }

    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
      var tvalues = [],
        bounds = [[], []],
        a,
        b,
        c,
        t,
        t1,
        t2,
        b2ac,
        sqrtb2ac;
      for (var i = 0; i < 2; ++i) {
        if (i == 0) {
          b = 6 * x0 - 12 * x1 + 6 * x2;
          a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
          c = 3 * x1 - 3 * x0;
        } else {
          b = 6 * y0 - 12 * y1 + 6 * y2;
          a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
          c = 3 * y1 - 3 * y0;
        }
        if (abs(a) < 1e-12) {
          if (abs(b) < 1e-12) {
            continue;
          }
          t = -c / b;
          if (0 < t && t < 1) {
            tvalues.push(t);
          }
          continue;
        }
        b2ac = b * b - 4 * c * a;
        sqrtb2ac = math.sqrt(b2ac);
        if (b2ac < 0) {
          continue;
        }
        t1 = (-b + sqrtb2ac) / (2 * a);
        if (0 < t1 && t1 < 1) {
          tvalues.push(t1);
        }
        t2 = (-b - sqrtb2ac) / (2 * a);
        if (0 < t2 && t2 < 1) {
          tvalues.push(t2);
        }
      }
      var x,
        y,
        j = tvalues.length,
        jlen = j,
        mt;
      while (j--) {
        t = tvalues[j];
        mt = 1 - t;
        bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
        bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
      }
      bounds[0][jlen] = x0;
      bounds[1][jlen] = y0;
      bounds[0][jlen + 1] = x3;
      bounds[1][jlen + 1] = y3;
      bounds[0].length = bounds[1].length = jlen + 2;
      return {
        min: {
          x: mmin.apply(0, bounds[0]),
          y: mmin.apply(0, bounds[1])
        },
        max: {
          x: mmax.apply(0, bounds[0]),
          y: mmax.apply(0, bounds[1])
        }
      };
    }
    function path2curve(path, path2) {
      var pth = !path2 && paths(path);
      if (!path2 && pth.curve) {
        return pathClone(pth.curve);
      }
      var p = pathToAbsolute(path),
        p2 = path2 && pathToAbsolute(path2),
        attrs = {
          x: 0,
          y: 0,
          bx: 0,
          by: 0,
          X: 0,
          Y: 0,
          qx: null,
          qy: null
        },
        attrs2 = {
          x: 0,
          y: 0,
          bx: 0,
          by: 0,
          X: 0,
          Y: 0,
          qx: null,
          qy: null
        },
        processPath = function processPath(path, d, pcom) {
          var nx, ny;
          if (!path) {
            return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
          }
          !(path[0] in {
            T: 1,
            Q: 1
          }) && (d.qx = d.qy = null);
          switch (path[0]) {
            case "M":
              d.X = path[1];
              d.Y = path[2];
              break;
            case "A":
              path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
              break;
            case "S":
              if (pcom == "C" || pcom == "S") {
                // In "S" case we have to take into account, if the previous command is C/S.
                nx = d.x * 2 - d.bx; // And reflect the previous
                ny = d.y * 2 - d.by; // command's control point relative to the current point.
              } else {
                // or some else or nothing
                nx = d.x;
                ny = d.y;
              }
              path = ["C", nx, ny].concat(path.slice(1));
              break;
            case "T":
              if (pcom == "Q" || pcom == "T") {
                // In "T" case we have to take into account, if the previous command is Q/T.
                d.qx = d.x * 2 - d.qx; // And make a reflection similar
                d.qy = d.y * 2 - d.qy; // to case "S".
              } else {
                // or something else or nothing
                d.qx = d.x;
                d.qy = d.y;
              }
              path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
              break;
            case "Q":
              d.qx = path[1];
              d.qy = path[2];
              path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
              break;
            case "L":
              path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
              break;
            case "H":
              path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
              break;
            case "V":
              path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
              break;
            case "Z":
              path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
              break;
          }
          return path;
        },
        fixArc = function fixArc(pp, i) {
          if (pp[i].length > 7) {
            pp[i].shift();
            var pi = pp[i];
            while (pi.length) {
              pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
              p2 && (pcoms2[i] = "A"); // the same as above
              pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
            }
            pp.splice(i, 1);
            ii = mmax(p.length, p2 && p2.length || 0);
          }
        },
        fixM = function fixM(path1, path2, a1, a2, i) {
          if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
            path2.splice(i, 0, ["M", a2.x, a2.y]);
            a1.bx = 0;
            a1.by = 0;
            a1.x = path1[i][1];
            a1.y = path1[i][2];
            ii = mmax(p.length, p2 && p2.length || 0);
          }
        },
        pcoms1 = [],
        // path commands of original path p
        pcoms2 = [],
        // path commands of original path p2
        pfirst = "",
        // temporary holder for original path command
        pcom = ""; // holder for previous path command of original path
      for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
        p[i] && (pfirst = p[i][0]); // save current path command

        if (pfirst != "C") {
          // C is not saved yet, because it may be result of conversion
          pcoms1[i] = pfirst; // Save current path command
          i && (pcom = pcoms1[i - 1]); // Get previous path command pcom
        }
        p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

        if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
        // which may produce multiple C:s
        // so we have to make sure that C is also C in original path

        fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

        if (p2) {
          // the same procedures is done to p2
          p2[i] && (pfirst = p2[i][0]);
          if (pfirst != "C") {
            pcoms2[i] = pfirst;
            i && (pcom = pcoms2[i - 1]);
          }
          p2[i] = processPath(p2[i], attrs2, pcom);
          if (pcoms2[i] != "A" && pfirst == "C") {
            pcoms2[i] = "C";
          }
          fixArc(p2, i);
        }
        fixM(p, p2, attrs, attrs2, i);
        fixM(p2, p, attrs2, attrs, i);
        var seg = p[i],
          seg2 = p2 && p2[i],
          seglen = seg.length,
          seg2len = p2 && seg2.length;
        attrs.x = seg[seglen - 2];
        attrs.y = seg[seglen - 1];
        attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
        attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
        attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
        attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
        attrs2.x = p2 && seg2[seg2len - 2];
        attrs2.y = p2 && seg2[seg2len - 1];
      }
      if (!p2) {
        pth.curve = pathClone(p);
      }
      return p2 ? [p, p2] : p;
    }
    function mapPath(path, matrix) {
      if (!matrix) {
        return path;
      }
      var x, y, i, j, ii, jj, pathi;
      path = path2curve(path);
      for (i = 0, ii = path.length; i < ii; i++) {
        pathi = path[i];
        for (j = 1, jj = pathi.length; j < jj; j += 2) {
          x = matrix.x(pathi[j], pathi[j + 1]);
          y = matrix.y(pathi[j], pathi[j + 1]);
          pathi[j] = x;
          pathi[j + 1] = y;
        }
      }
      return path;
    }

    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
      var d = [];
      for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
        var p = [{
          x: +crp[i - 2],
          y: +crp[i - 1]
        }, {
          x: +crp[i],
          y: +crp[i + 1]
        }, {
          x: +crp[i + 2],
          y: +crp[i + 3]
        }, {
          x: +crp[i + 4],
          y: +crp[i + 5]
        }];
        if (z) {
          if (!i) {
            p[0] = {
              x: +crp[iLen - 2],
              y: +crp[iLen - 1]
            };
          } else if (iLen - 4 == i) {
            p[3] = {
              x: +crp[0],
              y: +crp[1]
            };
          } else if (iLen - 2 == i) {
            p[2] = {
              x: +crp[0],
              y: +crp[1]
            };
            p[3] = {
              x: +crp[2],
              y: +crp[3]
            };
          }
        } else {
          if (iLen - 4 == i) {
            p[3] = p[2];
          } else if (!i) {
            p[0] = {
              x: +crp[i],
              y: +crp[i + 1]
            };
          }
        }
        d.push(["C", (-p[0].x + 6 * p[1].x + p[2].x) / 6, (-p[0].y + 6 * p[1].y + p[2].y) / 6, (p[1].x + 6 * p[2].x - p[3].x) / 6, (p[1].y + 6 * p[2].y - p[3].y) / 6, p[2].x, p[2].y]);
      }
      return d;
    }

    // export
    Snap.path = paths;

    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/
    Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    Snap.path.getSubpath = function (path, from, to) {
      if (this.getTotalLength(path) - to < 1e-6) {
        return getSubpathsAtLength(path, from).end;
      }
      var a = getSubpathsAtLength(path, to, 1);
      return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/
    elproto.getTotalLength = function () {
      if (this.node.getTotalLength) {
        return this.node.getTotalLength();
      }
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    elproto.getPointAtLength = function (length) {
      return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    elproto.getSubpath = function (from, to) {
      return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/
    Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/
    Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function (x, y, X, Y) {
      var r = 100,
        b = box(x - r / 2, y - r / 2, r, r),
        inside = [],
        getter = X[0].hasOwnProperty("x") ? function (i) {
          return {
            x: X[i].x,
            y: X[i].y
          };
        } : function (i) {
          return {
            x: X[i],
            y: Y[i]
          };
        },
        found = 0;
      while (r <= 1e6 && !found) {
        for (var i = 0, ii = X.length; i < ii; i++) {
          var xy = getter(i);
          if (isPointInsideBBox(b, xy.x, xy.y)) {
            found++;
            inside.push(xy);
            break;
          }
        }
        if (!found) {
          r *= 2;
          b = box(x - r / 2, y - r / 2, r, r);
        }
      }
      if (r == 1e6) {
        return;
      }
      var len = Infinity,
        res;
      for (i = 0, ii = inside.length; i < ii; i++) {
        var l = Snap.len(x, y, inside[i].x, inside[i].y);
        if (len > l) {
          len = l;
          inside[i].len = l;
          res = inside[i];
        }
      }
      return res;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/
    Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/
    Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/
    Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/
    Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/
    Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob) {
    var mmax = Math.max,
      mmin = Math.min;

    // Set
    var Set = function Set(items) {
        this.items = [];
        this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
          for (var i = 0, ii = items.length; i < ii; i++) {
            if (items[i]) {
              this[this.items.length] = this.items[this.items.length] = items[i];
              this.length++;
            }
          }
        }
      },
      setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/
    setproto.push = function () {
      var item, len;
      for (var i = 0, ii = arguments.length; i < ii; i++) {
        item = arguments[i];
        if (item) {
          len = this.items.length;
          this[len] = this.items[len] = item;
          this.length++;
        }
      }
      return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/
    setproto.pop = function () {
      this.length && delete this[this.length--];
      return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/
    setproto.forEach = function (callback, thisArg) {
      for (var i = 0, ii = this.items.length; i < ii; i++) {
        if (callback.call(thisArg, this.items[i], i) === false) {
          return this;
        }
      }
      return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/
    setproto.animate = function (attrs, ms, easing, callback) {
      if (typeof easing == "function" && !easing.length) {
        callback = easing;
        easing = mina.linear;
      }
      if (attrs instanceof Snap._.Animation) {
        callback = attrs.callback;
        easing = attrs.easing;
        ms = easing.dur;
        attrs = attrs.attr;
      }
      var args = arguments;
      if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
        var each = true;
      }
      var begin,
        handler = function handler() {
          if (begin) {
            this.b = begin;
          } else {
            begin = this.b;
          }
        },
        cb = 0,
        set = this,
        callbacker = callback && function () {
          if (++cb == set.length) {
            callback.call(this);
          }
        };
      return this.forEach(function (el, i) {
        eve.once("snap.animcreated." + el.id, handler);
        if (each) {
          args[i] && el.animate.apply(el, args[i]);
        } else {
          el.animate(attrs, ms, easing, callbacker);
        }
      });
    };
    /*\
     * Set.remove
     [ method ]
     **
     * Removes all children of the set.
     *
     = (object) Set object
    \*/
    setproto.remove = function () {
      while (this.length) {
        this.pop().remove();
      }
      return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/
    setproto.bind = function (attr, a, b) {
      var data = {};
      if (typeof a == "function") {
        this.bindings[attr] = a;
      } else {
        var aname = b || attr;
        this.bindings[attr] = function (v) {
          data[aname] = v;
          a.attr(data);
        };
      }
      return this;
    };
    /*\
     * Set.attr
     [ method ]
     **
     * Equivalent of @Element.attr.
     = (object) Set object
    \*/
    setproto.attr = function (value) {
      var unbound = {};
      for (var k in value) {
        if (this.bindings[k]) {
          this.bindings[k](value[k]);
        } else {
          unbound[k] = value[k];
        }
      }
      for (var i = 0, ii = this.items.length; i < ii; i++) {
        this.items[i].attr(unbound);
      }
      return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/
    setproto.clear = function () {
      while (this.length) {
        this.pop();
      }
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/
    setproto.splice = function (index, count, insertion) {
      index = index < 0 ? mmax(this.length + index, 0) : index;
      count = mmax(0, mmin(this.length - index, count));
      var tail = [],
        todel = [],
        args = [],
        i;
      for (i = 2; i < arguments.length; i++) {
        args.push(arguments[i]);
      }
      for (i = 0; i < count; i++) {
        todel.push(this[index + i]);
      }
      for (; i < this.length - index; i++) {
        tail.push(this[index + i]);
      }
      var arglen = args.length;
      for (i = 0; i < arglen + tail.length; i++) {
        this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
      }
      i = this.items.length = this.length -= count - arglen;
      while (this[i]) {
        delete this[i++];
      }
      return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/
    setproto.exclude = function (el) {
      for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
        this.splice(i, 1);
        return true;
      }
      return false;
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Inserts set elements after given element.
     **
     - element (object) set will be inserted after this element
     = (object) Set object
    \*/
    setproto.insertAfter = function (el) {
      var i = this.items.length;
      while (i--) {
        this.items[i].insertAfter(el);
      }
      return this;
    };
    /*\
     * Set.getBBox
     [ method ]
     **
     * Union of all bboxes of the set. See @Element.getBBox.
     = (object) bounding box descriptor. See @Element.getBBox.
    \*/
    setproto.getBBox = function () {
      var x = [],
        y = [],
        x2 = [],
        y2 = [];
      for (var i = this.items.length; i--;) if (!this.items[i].removed) {
        var box = this.items[i].getBBox();
        x.push(box.x);
        y.push(box.y);
        x2.push(box.x + box.width);
        y2.push(box.y + box.height);
      }
      x = mmin.apply(0, x);
      y = mmin.apply(0, y);
      x2 = mmax.apply(0, x2);
      y2 = mmax.apply(0, y2);
      return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: x2 - x,
        height: y2 - y,
        cx: x + (x2 - x) / 2,
        cy: y + (y2 - y) / 2
      };
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Creates a clone of the set.
     **
     = (object) New Set object
    \*/
    setproto.clone = function (s) {
      s = new Set();
      for (var i = 0, ii = this.items.length; i < ii; i++) {
        s.push(this.items[i].clone());
      }
      return s;
    };
    setproto.toString = function () {
      return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    /*\
     * Snap.Set
     [ property ]
     **
     * Set constructor.
    \*/
    Snap.Set = Set;
    /*\
     * Snap.set
     [ method ]
     **
     * Creates a set and fills it with list of arguments.
     **
     = (object) New Set object
     | var r = paper.rect(0, 0, 10, 10),
     |     s1 = Snap.set(), // empty set
     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
    \*/
    Snap.set = function () {
      var set = new Set();
      if (arguments.length) {
        set.push.apply(set, Array.prototype.slice.call(arguments, 0));
      }
      return set;
    };
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob) {
    var names = {},
      reUnit = /[%a-z]+$/i,
      Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
      var l = item[0];
      switch (l.toLowerCase()) {
        case "t":
          return [l, 0, 0];
        case "m":
          return [l, 1, 0, 0, 1, 0, 0];
        case "r":
          if (item.length == 4) {
            return [l, 0, item[2], item[3]];
          } else {
            return [l, 0];
          }
        case "s":
          if (item.length == 5) {
            return [l, 1, 1, item[3], item[4]];
          } else if (item.length == 3) {
            return [l, 1, 1];
          } else {
            return [l, 1];
          }
      }
    }
    function equaliseTransform(t1, t2, getBBox) {
      t1 = t1 || new Snap.Matrix();
      t2 = t2 || new Snap.Matrix();
      t1 = Snap.parseTransformString(t1.toTransformString()) || [];
      t2 = Snap.parseTransformString(t2.toTransformString()) || [];
      var maxlength = Math.max(t1.length, t2.length),
        from = [],
        to = [],
        i = 0,
        j,
        jj,
        tt1,
        tt2;
      for (; i < maxlength; i++) {
        tt1 = t1[i] || getEmpty(t2[i]);
        tt2 = t2[i] || getEmpty(tt1);
        if (tt1[0] != tt2[0] || tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) || tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])) {
          t1 = Snap._.transform2matrix(t1, getBBox());
          t2 = Snap._.transform2matrix(t2, getBBox());
          from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
          to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
          break;
        }
        from[i] = [];
        to[i] = [];
        for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
          j in tt1 && (from[i][j] = tt1[j]);
          j in tt2 && (to[i][j] = tt2[j]);
        }
      }
      return {
        from: path2array(from),
        to: path2array(to),
        f: getPath(from)
      };
    }
    function getNumber(val) {
      return val;
    }
    function getUnit(unit) {
      return function (val) {
        return +val.toFixed(3) + unit;
      };
    }
    function getViewBox(val) {
      return val.join(" ");
    }
    function getColour(clr) {
      return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
    }
    function getPath(path) {
      var k = 0,
        i,
        ii,
        j,
        jj,
        out,
        a,
        b = [];
      for (i = 0, ii = path.length; i < ii; i++) {
        out = "[";
        a = ['"' + path[i][0] + '"'];
        for (j = 1, jj = path[i].length; j < jj; j++) {
          a[j] = "val[" + k++ + "]";
        }
        out += a + "]";
        b[i] = out;
      }
      return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
      var out = [];
      for (var i = 0, ii = path.length; i < ii; i++) {
        for (var j = 1, jj = path[i].length; j < jj; j++) {
          out.push(path[i][j]);
        }
      }
      return out;
    }
    function isNumeric(obj) {
      return isFinite(obj);
    }
    function arrayEqual(arr1, arr2) {
      if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
        return false;
      }
      return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function (name, b) {
      return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function (name, b) {
      var A,
        B,
        a = Str(this.attr(name) || ""),
        el = this;
      if (names[name] == "colour") {
        A = Snap.color(a);
        B = Snap.color(b);
        return {
          from: [A.r, A.g, A.b, A.opacity],
          to: [B.r, B.g, B.b, B.opacity],
          f: getColour
        };
      }
      if (name == "viewBox") {
        A = this.attr(name).vb.split(" ").map(Number);
        B = b.split(" ").map(Number);
        return {
          from: A,
          to: B,
          f: getViewBox
        };
      }
      if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
        if (typeof b == "string") {
          b = Str(b).replace(/\.{3}|\u2026/g, a);
        }
        a = this.matrix;
        if (!Snap._.rgTransform.test(b)) {
          b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
        } else {
          b = Snap._.transform2matrix(b, this.getBBox());
        }
        return equaliseTransform(a, b, function () {
          return el.getBBox(1);
        });
      }
      if (name == "d" || name == "path") {
        A = Snap.path.toCubic(a, b);
        return {
          from: path2array(A[0]),
          to: path2array(A[1]),
          f: getPath(A[0])
        };
      }
      if (name == "points") {
        A = Str(a).split(Snap._.separator);
        B = Str(b).split(Snap._.separator);
        return {
          from: A,
          to: B,
          f: function f(val) {
            return val;
          }
        };
      }
      if (isNumeric(a) && isNumeric(b)) {
        return {
          from: parseFloat(a),
          to: parseFloat(b),
          f: getNumber
        };
      }
      var aUnit = a.match(reUnit),
        bUnit = Str(b).match(reUnit);
      if (aUnit && arrayEqual(aUnit, bUnit)) {
        return {
          from: parseFloat(a),
          to: parseFloat(b),
          f: getUnit(aUnit)
        };
      } else {
        return {
          from: this.asPX(name),
          to: this.asPX(name, b),
          f: getNumber
        };
      }
    });
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
      has = "hasOwnProperty",
      supportsTouch = "createTouch" in glob.doc,
      events = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "touchstart", "touchmove", "touchend", "touchcancel"],
      touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
      },
      getScroll = function getScroll(xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft",
          doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
      },
      preventDefault = function preventDefault() {
        this.returnValue = false;
      },
      preventTouch = function preventTouch() {
        return this.originalEvent.preventDefault();
      },
      stopPropagation = function stopPropagation() {
        this.cancelBubble = true;
      },
      stopTouch = function stopTouch() {
        return this.originalEvent.stopPropagation();
      },
      addEvent = function addEvent(obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
          f = function f(e) {
            var scrollY = getScroll("y", element),
              scrollX = getScroll("x", element);
            if (supportsTouch && touchMap[has](type)) {
              for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
                if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                  var olde = e;
                  e = e.targetTouches[i];
                  e.originalEvent = olde;
                  e.preventDefault = preventTouch;
                  e.stopPropagation = stopTouch;
                  break;
                }
              }
            }
            var x = e.clientX + scrollX,
              y = e.clientY + scrollY;
            return fn.call(element, e, x, y);
          };
        if (type !== realName) {
          obj.addEventListener(type, f, false);
        }
        obj.addEventListener(realName, f, false);
        return function () {
          if (type !== realName) {
            obj.removeEventListener(type, f, false);
          }
          obj.removeEventListener(realName, f, false);
          return true;
        };
      },
      drag = [],
      dragMove = function dragMove(e) {
        var x = e.clientX,
          y = e.clientY,
          scrollY = getScroll("y"),
          scrollX = getScroll("x"),
          dragi,
          j = drag.length;
        while (j--) {
          dragi = drag[j];
          if (supportsTouch) {
            var i = e.touches && e.touches.length,
              touch;
            while (i--) {
              touch = e.touches[i];
              if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                x = touch.clientX;
                y = touch.clientY;
                (e.originalEvent ? e.originalEvent : e).preventDefault();
                break;
              }
            }
          } else {
            e.preventDefault();
          }
          var node = dragi.el.node,
            o,
            next = node.nextSibling,
            parent = node.parentNode,
            display = node.style.display;
          // glob.win.opera && parent.removeChild(node);
          // node.style.display = "none";
          // o = dragi.el.paper.getElementByPoint(x, y);
          // node.style.display = display;
          // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
          // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
          x += scrollX;
          y += scrollY;
          eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
      },
      _dragUp = function dragUp(e) {
        Snap.unmousemove(dragMove).unmouseup(_dragUp);
        var i = drag.length,
          dragi;
        while (i--) {
          dragi = drag[i];
          dragi.el._drag = {};
          eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
          eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
      };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    for (var i = events.length; i--;) {
      (function (eventName) {
        Snap[eventName] = elproto[eventName] = function (fn, scope) {
          if (Snap.is(fn, "function")) {
            this.events = this.events || [];
            this.events.push({
              name: eventName,
              f: fn,
              unbind: addEvent(this.node || document, eventName, fn, scope || this)
            });
          } else {
            for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
              try {
                this.events[i].f.call(this);
              } catch (e) {}
            }
          }
          return this;
        };
        Snap["un" + eventName] = elproto["un" + eventName] = function (fn) {
          var events = this.events || [],
            l = events.length;
          while (l--) if (events[l].name == eventName && (events[l].f == fn || !fn)) {
            events[l].unbind();
            events.splice(l, 1);
            !events.length && delete this.events;
            return this;
          }
          return this;
        };
      })(events[i]);
    }
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/
    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
      return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/
    elproto.unhover = function (f_in, f_out) {
      return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/
    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
      var el = this;
      if (!arguments.length) {
        var origTransform;
        return el.drag(function (dx, dy) {
          this.attr({
            transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
          });
        }, function () {
          origTransform = this.transform().local;
        });
      }
      function start(e, x, y) {
        (e.originalEvent || e).preventDefault();
        el._drag.x = x;
        el._drag.y = y;
        el._drag.id = e.identifier;
        !drag.length && Snap.mousemove(dragMove).mouseup(_dragUp);
        drag.push({
          el: el,
          move_scope: move_scope,
          start_scope: start_scope,
          end_scope: end_scope
        });
        onstart && eve.on("snap.drag.start." + el.id, onstart);
        onmove && eve.on("snap.drag.move." + el.id, onmove);
        onend && eve.on("snap.drag.end." + el.id, onend);
        eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
      }
      function init(e, x, y) {
        eve("snap.draginit." + el.id, el, e, x, y);
      }
      eve.on("snap.draginit." + el.id, start);
      el._drag = {};
      draggable.push({
        el: el,
        start: start,
        init: init
      });
      el.mousedown(init);
      return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/
    // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/
    elproto.undrag = function () {
      var i = draggable.length;
      while (i--) if (draggable[i].el == this) {
        this.unmousedown(draggable[i].init);
        draggable.splice(i, 1);
        eve.unbind("snap.drag.*." + this.id);
        eve.unbind("snap.draginit." + this.id);
      }
      !draggable.length && Snap.unmousemove(dragMove).unmouseup(_dragUp);
      return this;
    };
  });

  // Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
      pproto = Paper.prototype,
      rgurl = /^\s*url\((.+)\)/,
      Str = String,
      $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    pproto.filter = function (filstr, filterSpec) {
      if (filterSpec == undefined) {
        filterSpec = {
          filterUnits: "userSpaceOnUse"
        };
      }
      var paper = this;
      if (paper.type != "svg") {
        paper = paper.paper;
      }
      var f = Snap.parse(Str(filstr)),
        id = Snap._.id(),
        width = paper.node.offsetWidth,
        height = paper.node.offsetHeight,
        filter = $("filter");
      filterSpec.id = id;
      $(filter, filterSpec);
      filter.appendChild(f.node);
      paper.defs.appendChild(filter);
      return new Element(filter);
    };
    eve.on("snap.util.getattr.filter", function () {
      eve.stop();
      var p = $(this.node, "filter");
      if (p) {
        var match = Str(p).match(rgurl);
        return match && Snap.select(match[1]);
      }
    });
    eve.on("snap.util.attr.filter", function (value) {
      if (value instanceof Element && value.type == "filter") {
        eve.stop();
        var id = value.node.id;
        if (!id) {
          $(value.node, {
            id: value.id
          });
          id = value.id;
        }
        $(this.node, {
          filter: Snap.url(id)
        });
      }
      if (!value || value == "none") {
        eve.stop();
        this.node.removeAttribute("filter");
      }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.blur = function (x, y) {
      if (x == null) {
        x = 2;
      }
      var def = y == null ? x : [x, y];
      return Snap.format('<feGaussianBlur stdDeviation="{def}"/>', {
        def: def
      });
    };
    Snap.filter.blur.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
      if (opacity == null) {
        if (color == null) {
          opacity = blur;
          blur = 4;
          color = "#000";
        } else {
          opacity = color;
          color = blur;
          blur = 4;
        }
      }
      if (blur == null) {
        blur = 4;
      }
      if (opacity == null) {
        opacity = 1;
      }
      if (dx == null) {
        dx = 0;
        dy = 2;
      }
      if (dy == null) {
        dy = dx;
      }
      color = Snap.color(color);
      return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
        color: color,
        dx: dx,
        dy: dy,
        blur: blur,
        opacity: opacity
      });
    };
    Snap.filter.shadow.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.grayscale = function (amount) {
      if (amount == null) {
        amount = 1;
      }
      return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
        a: 0.2126 + 0.7874 * (1 - amount),
        b: 0.7152 - 0.7152 * (1 - amount),
        c: 0.0722 - 0.0722 * (1 - amount),
        d: 0.2126 - 0.2126 * (1 - amount),
        e: 0.7152 + 0.2848 * (1 - amount),
        f: 0.0722 - 0.0722 * (1 - amount),
        g: 0.2126 - 0.2126 * (1 - amount),
        h: 0.0722 + 0.9278 * (1 - amount)
      });
    };
    Snap.filter.grayscale.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.sepia = function (amount) {
      if (amount == null) {
        amount = 1;
      }
      return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
        a: 0.393 + 0.607 * (1 - amount),
        b: 0.769 - 0.769 * (1 - amount),
        c: 0.189 - 0.189 * (1 - amount),
        d: 0.349 - 0.349 * (1 - amount),
        e: 0.686 + 0.314 * (1 - amount),
        f: 0.168 - 0.168 * (1 - amount),
        g: 0.272 - 0.272 * (1 - amount),
        h: 0.534 - 0.534 * (1 - amount),
        i: 0.131 + 0.869 * (1 - amount)
      });
    };
    Snap.filter.sepia.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.saturate = function (amount) {
      if (amount == null) {
        amount = 1;
      }
      return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
        amount: 1 - amount
      });
    };
    Snap.filter.saturate.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/
    Snap.filter.hueRotate = function (angle) {
      angle = angle || 0;
      return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
        angle: angle
      });
    };
    Snap.filter.hueRotate.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.invert = function (amount) {
      if (amount == null) {
        amount = 1;
      }
      //        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
      return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
        amount: amount,
        amount2: 1 - amount
      });
    };
    Snap.filter.invert.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.brightness = function (amount) {
      if (amount == null) {
        amount = 1;
      }
      return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
        amount: amount
      });
    };
    Snap.filter.brightness.toString = function () {
      return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.contrast = function (amount) {
      if (amount == null) {
        amount = 1;
      }
      return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
        amount: amount,
        amount2: 0.5 - amount / 2
      });
    };
    Snap.filter.contrast.toString = function () {
      return this();
    };
  });

  // Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box,
      is = Snap.is,
      firstLetter = /^[^a-z]*([tbmlrc])/i,
      toString = function toString() {
        return "T" + this.dx + "," + this.dy;
      };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/
    Element.prototype.getAlign = function (el, way) {
      if (way == null && is(el, "string")) {
        way = el;
        el = null;
      }
      el = el || this.paper;
      var bx = el.getBBox ? el.getBBox() : box(el),
        bb = this.getBBox(),
        out = {};
      way = way && way.match(firstLetter);
      way = way ? way[1].toLowerCase() : "c";
      switch (way) {
        case "t":
          out.dx = 0;
          out.dy = bx.y - bb.y;
          break;
        case "b":
          out.dx = 0;
          out.dy = bx.y2 - bb.y2;
          break;
        case "m":
          out.dx = 0;
          out.dy = bx.cy - bb.cy;
          break;
        case "l":
          out.dx = bx.x - bb.x;
          out.dy = 0;
          break;
        case "r":
          out.dx = bx.x2 - bb.x2;
          out.dy = 0;
          break;
        default:
          out.dx = bx.cx - bb.cx;
          out.dy = 0;
          break;
      }
      out.toString = toString;
      return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/
    Element.prototype.align = function (el, way) {
      return this.transform("..." + this.getAlign(el, way));
    };
  });

  // Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  Snap.plugin(function (Snap, Element, Paper, glob) {
    // Colours are from https://www.materialui.co
    var red = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
      pink = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
      purple = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
      deeppurple = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
      indigo = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
      blue = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
      lightblue = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
      cyan = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
      teal = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
      green = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
      lightgreen = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
      lime = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
      yellow = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
      amber = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
      orange = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
      deeporange = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
      brown = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
      grey = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
      bluegrey = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
    /*\
     * Snap.mui
     [ property ]
     **
     * Contain Material UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.mui = {};
    /*\
     * Snap.flat
     [ property ]
     **
     * Contain Flat UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.flat = {};
    function saveColor(colors) {
      colors = colors.split(/(?=#)/);
      var color = new String(colors[5]);
      color[50] = colors[0];
      color[100] = colors[1];
      color[200] = colors[2];
      color[300] = colors[3];
      color[400] = colors[4];
      color[500] = colors[5];
      color[600] = colors[6];
      color[700] = colors[7];
      color[800] = colors[8];
      color[900] = colors[9];
      if (colors[10]) {
        color.A100 = colors[10];
        color.A200 = colors[11];
        color.A400 = colors[12];
        color.A700 = colors[13];
      }
      return color;
    }
    Snap.mui.red = saveColor(red);
    Snap.mui.pink = saveColor(pink);
    Snap.mui.purple = saveColor(purple);
    Snap.mui.deeppurple = saveColor(deeppurple);
    Snap.mui.indigo = saveColor(indigo);
    Snap.mui.blue = saveColor(blue);
    Snap.mui.lightblue = saveColor(lightblue);
    Snap.mui.cyan = saveColor(cyan);
    Snap.mui.teal = saveColor(teal);
    Snap.mui.green = saveColor(green);
    Snap.mui.lightgreen = saveColor(lightgreen);
    Snap.mui.lime = saveColor(lime);
    Snap.mui.yellow = saveColor(yellow);
    Snap.mui.amber = saveColor(amber);
    Snap.mui.orange = saveColor(orange);
    Snap.mui.deeporange = saveColor(deeporange);
    Snap.mui.brown = saveColor(brown);
    Snap.mui.grey = saveColor(grey);
    Snap.mui.bluegrey = saveColor(bluegrey);
    Snap.flat.turquoise = "#1abc9c";
    Snap.flat.greensea = "#16a085";
    Snap.flat.sunflower = "#f1c40f";
    Snap.flat.orange = "#f39c12";
    Snap.flat.emerland = "#2ecc71";
    Snap.flat.nephritis = "#27ae60";
    Snap.flat.carrot = "#e67e22";
    Snap.flat.pumpkin = "#d35400";
    Snap.flat.peterriver = "#3498db";
    Snap.flat.belizehole = "#2980b9";
    Snap.flat.alizarin = "#e74c3c";
    Snap.flat.pomegranate = "#c0392b";
    Snap.flat.amethyst = "#9b59b6";
    Snap.flat.wisteria = "#8e44ad";
    Snap.flat.clouds = "#ecf0f1";
    Snap.flat.silver = "#bdc3c7";
    Snap.flat.wetasphalt = "#34495e";
    Snap.flat.midnightblue = "#2c3e50";
    Snap.flat.concrete = "#95a5a6";
    Snap.flat.asbestos = "#7f8c8d";
    /*\
     * Snap.importMUIColors
     [ method ]
     **
     * Imports Material UI colours into global object.
     | Snap.importMUIColors();
     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.importMUIColors = function () {
      for (var color in Snap.mui) {
        if (Snap.mui.hasOwnProperty(color)) {
          window[color] = Snap.mui[color];
        }
      }
    };
  });
  return Snap;
});
},{"@babel/runtime/helpers/typeof":"b9XL","eve":"yHh2"}],"FcC3":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _snap = _interopRequireDefault(require("../snap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var defaultContext = {
  ZOOM_STEP: 1.05,
  CRIMSON: "#dc143c",
  BLUE: "#4682b4",
  GREEN: "#33cc33",
  GREY: "#808080",
  MIDDLE_GREY: "#C0C0C0",
  SMOOTH_GREY: "#DCDCDC",
  LIGHT_GREY: "#F0F0F0",
  BLACK: "#0F0F0F",
  WHITE: "#FFFFFF",
  CHECK: String.fromCharCode(2714),
  images: {
    loaders: {}
  },
  svgImages: {
    loaders: {}
  },
  rasterImages: {
    loaders: {}
  },
  highlightColors: ["#FFFFFF", "#FF6666", "#6699FF", "#FFFF66", "#66FF66", "#EFA567", "#7C73B5", "#C4DB6C", "#53ACC4", "#C0C0C0"],
  canvas: undefined,
  memento: undefined,
  selection: undefined,
  globalDrag: undefined,
  selectShadow: undefined,
  visualizer: undefined,
  groupManager: undefined,
  copyPasteManager: undefined,
  readOnly: false,
  rescaleFactor: 1,
  saveFunction: undefined,
  loadFunction: undefined,
  menus: {},
  Element: new _snap.default(1, 1).group().constructor,
  evals: {},
  tools: [],
  focus: function focus() {
    var _this = this;
    if (!this._focus) {
      this._focus = document.querySelector("#svgfocus");
      this._focus.addEventListener("mouseup", function (event) {
        _this._focus.focus();
      });
      this._focus.addEventListener("mousedown", function (event) {
        if (event.target.nodeName != document.activeElement) {
          document.activeElement.blur();
        }
      });
    }
    return this._focus;
  },
  start: function start() {
    this.memento.opened = false;
    console.log("started");
  },
  stop: function stop() {
    console.log("stopped");
    var _iterator = _createForOfIteratorHelper(this.tools),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var tool = _step.value;
        tool.close();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    this.memento.opened = false;
    for (var key in this) {
      delete this[key];
    }
    Context.canvas && Context.canvas.close();
    Object.assign(this, defaultContext);
  }
};
var _default = exports.default = _objectSpread({}, defaultContext);
},{"@babel/runtime/helpers/defineProperty":"IxO8","../snap":"BQ54"}],"m1yP":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Visualizer = exports.TextToggleMenuOptionInstance = exports.TextToggleMenuOption = exports.TextToggleGlobalMenuOptionInstance = exports.TextMenuOption = exports.Selection = exports.ParentDragOperation = exports.Observer = exports.MenuOptionInstance = exports.MenuOption = exports.Menu = exports.Memento = exports.List = exports.GroupManager = exports.Group = exports.GlobalMenuOptionInstance = exports.DragSelectionOperation = exports.DragSelectPdfAreaOperation = exports.DragSelectAreaOperation = exports.DragScrollOperation = exports.DragOperation = exports.DragMovePdfOperation = exports.DragMoveOperation = exports.DragMouseOperation = exports.DragHandleOperation = exports.DragAbstractSelectAreaOperation = exports.Decoration = exports.CopyPasteManager = exports.ColorChooserMenuOption = exports.Canvas = void 0;
exports.addAssociated = addAssociated;
exports.arrayDuplicate = arrayDuplicate;
exports.boundingBox = _boundingBox;
exports.computePosition = computePosition;
exports.default = toolkit;
exports.duplicate = duplicate;
exports.evaluate = evaluate;
exports.getPdfAreas = getPdfAreas;
exports.globalOffset = globalOffset;
exports.imagesLoaded = imagesLoaded;
exports.localOffset = localOffset;
exports.myEvaluate = myEvaluate;
exports.pngImage = pngImage;
exports.rasterize = rasterize;
exports.rasterizedSvgImage = rasterizedSvgImage;
exports.sortByDistance = sortByDistance;
exports.svgImage = svgImage;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _snap = _interopRequireDefault(require("../snap"));
var _context = _interopRequireDefault(require("./context"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _superPropGet(t, o, e, r) { var p = (0, _get2.default)((0, _getPrototypeOf2.default)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
_context.default.evals.load = 1;
_context.default.MIN_PDF_AREA = 10;
function evaluate(label, code) {
  var tag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
  var begin = new Date().getTime();
  var result = code();
  var end = new Date().getTime();
  if (_context.default.evals[tag]) {
    console.log(label + ": " + (end - begin));
  }
  return result;
}
function myEvaluate(label, code) {
  var tag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
  var begin = new Date().getTime();
  var result = code();
  var end = new Date().getTime();
  console.log(label + ": " + (end - begin));
  return result;
}
function createUUID() {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}
Object.defineProperty(_context.default.Element.prototype, "owner", {
  get: function get() {
    return this.node._owner;
  },
  set: function set(_owner) {
    this.node._owner = _owner;
  }
});
var transform = _context.default.Element.prototype.transform;
_context.default.Element.prototype.transform = function (matrix) {
  if (matrix) {
    if (isNaN(matrix.a) || isNaN(matrix.b) || isNaN(matrix.c) || isNaN(matrix.d) || isNaN(matrix.e) || isNaN(matrix.f)) {
      badTransformSpecification();
    }
  }
  return transform.call(this, matrix);
};
Object.defineProperty(_context.default.Element.prototype, "localMatrix", {
  get: function get() {
    if (!this._matrix) {
      this._matrix = this.transform().localMatrix;
    }
    return this._matrix;
  },
  set: function set(_matrix) {
    this._matrix = _matrix;
    this.transform(_matrix);
  }
});
function localOffset() {
  var box = _context.default.canvas.canvas.node.getBoundingClientRect();
  var body = _context.default.canvas.canvas.node.ownerDocument.body,
    docElem = _context.default.canvas.canvas.node.ownerDocument.documentElement;
  var top = box.top + (window.pageYOffset || docElem.scrollTop || body.scrollTop);
  var left = box.left + (window.pageXOffset || docElem.scrollLeft || body.scrollLeft);
  return {
    y: -top,
    x: -left
  };
}
function globalOffset() {
  var box = _context.default.canvas.canvas.node.getBoundingClientRect();
  var top = box.top;
  var left = box.left;
  return {
    y: top,
    x: left
  };
}
function computePosition(source, target) {
  var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var sourceMatrix = source ? source.transform().globalMatrix : null;
  var targetMatrix = target.transform().globalMatrix;
  var finalMatrix = sourceMatrix ? sourceMatrix.multLeft(targetMatrix.invert()) : targetMatrix.invert();
  var fx = finalMatrix.x(x, y);
  var fy = finalMatrix.y(x, y);
  return {
    x: fx,
    y: fy
  };
}
function sortByDistance(elements, gx, gy) {
  elements.sort(function (elem1, elem2) {
    function distance(elem, x, y) {
      var egx = elem.globalX();
      var egy = elem.globalY();
      var distance = (egx - x) * (egx - x) + (egy - y) * (egy - y);
      return distance;
    }
    return distance(elem1, gx, gy) - distance(elem2, gx, gy);
  });
}
function duplicate(object) {
  if (!object) return object;
  var result = {};
  result.__proto__ = object.__proto__;
  var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(object)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      result[field] = object[field];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}
function arrayDuplicate(array) {
  if (!array) return array;
  var result = new List();
  var _iterator2 = _createForOfIteratorHelper(array),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var value = _step2.value;
      result.push(duplicate(value));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}
var List = exports.List = /*#__PURE__*/function (_Array) {
  function List() {
    (0, _classCallCheck2.default)(this, List);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _callSuper(this, List, [].concat(args));
  }
  (0, _inherits2.default)(List, _Array);
  return (0, _createClass2.default)(List, [{
    key: "add",
    value: function add(val) {
      var i = this.indexOf(val);
      i === -1 && this.push(val);
      return i === -1;
    }
  }, {
    key: "remove",
    value: function remove(val) {
      var i = this.indexOf(val);
      i > -1 && this.splice(i, 1);
      return i > -1;
    }
  }, {
    key: "contains",
    value: function contains(val) {
      return this.indexOf(val) >= 0;
    }
  }, {
    key: "equals",
    value: function equals(val) {
      if (val.length === undefined || val.length !== this.length) {
        return false;
      }
      for (var i = 0; i < this.length; i++) {
        if (val[i] !== this[i]) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.length = 0;
    }
  }, {
    key: "empty",
    value: function empty() {
      return this.length === 0;
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      return this.slice(0);
    }
  }]);
}(/*#__PURE__*/(0, _wrapNativeSuper2.default)(Array));
function rasterize(svgImg, width, height, loaded) {
  var svgNode = svgImg.node.querySelector("svg");
  var svgText = svgNode.outerHTML;
  var svgHeight = svgNode.getAttribute("height");
  svgHeight = svgHeight ? parseInt(svgHeight) : 200;
  var svgWidth = svgNode.getAttribute("width");
  svgWidth = svgWidth ? parseInt(svgWidth) : 200;
  if (!svgText.match(/xmlns=\"/im)) {
    svgText = svgText.replace("<svg ", '<svg xmlns="http://www.w3.org/2000/svg" ');
  }
  // make a blob from the svg
  var svg = new Blob([svgText], {
    type: "image/svg+xml;charset=utf-8"
  });
  var url = URL.createObjectURL(svg);
  // create a canvas element to pass through
  var canvas = document.createElement("canvas");
  canvas.setAttribute("style", "border:border-style: solid;border-width: 2px;");
  canvas.width = svgWidth;
  canvas.height = svgHeight;
  var ctx = canvas.getContext("2d");
  // create a new image to hold it the converted type
  var img = new Image();
  var svgimg = document.createElementNS("http://www.w3.org/2000/svg", "image");
  // draw it to the canvas
  img.onload = function () {
    ctx.drawImage(this, 0, 0);
    svg.raster = canvas.toDataURL();
    svgimg.setAttribute("height", "" + svgHeight);
    svgimg.setAttribute("width", "" + svgWidth);
    svgimg.setAttributeNS("http://www.w3.org/1999/xlink", "href", svg.raster);
    svgimg.setAttribute("x", "0");
    svgimg.setAttribute("y", "0");
    loaded(svgimg, width, height);
  };
  // load the image
  img.src = url;
  return svgimg;
}
function imagesLoaded() {
  var finished = true;
  for (var url in _context.default.svgImages.loaders) {
    if (_context.default.svgImages[url] === undefined) {
      finished = false;
    }
  }
  for (var _url in _context.default.images.loaders) {
    if (!_context.default.images[_url]) {
      finished = false;
    }
  }
  if (finished) {
    _context.default.canvas.canvas.node.dispatchEvent(new Event("images-loaded"));
  }
}
function svgImage(fileURL, width, height, loaded) {
  function createImage(img, image) {
    var node = image.node instanceof DocumentFragment ? image.node.querySelector("svg") : image.node;
    var svg = (0, _snap.default)(node.cloneNode(true));
    var viewBox = svg.attr("viewBox");
    svg.attr({
      viewBox: "",
      width: viewBox.width,
      height: viewBox.height
    });
    var pedestal = _context.default.canvas.canvas.group().add(svg);
    var bbox = pedestal.getBBox();
    img.add(pedestal);
    if (bbox.width) {
      var xFactor = width / bbox.width;
      var yFactor = height / bbox.height;
      img.transform(new _snap.default.Matrix().scale(xFactor, yFactor, 0, 0));
      pedestal.transform(new _snap.default.Matrix().translate(-bbox.x - bbox.width / 2, -bbox.y - bbox.height / 2));
    }
    img.svg = svg;
    return img;
  }
  var img = _context.default.canvas.canvas.group();
  if (_context.default.svgImages[fileURL]) {
    // forced timeout so that `loaded` is always called asynchronously
    // even if the image is in cache
    setTimeout(function () {
      createImage(img, _context.default.svgImages[fileURL]);
      loaded && loaded(img);
    }, 0);
  } else {
    if (!_context.default.svgImages.loaders[fileURL]) {
      _context.default.svgImages.loaders[fileURL] = [];
      _snap.default.load(fileURL, function (image) {
        _context.default.svgImages[fileURL] = image;
        var _iterator3 = _createForOfIteratorHelper(_context.default.svgImages.loaders[fileURL]),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var loader = _step3.value;
            loader(image);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        imagesLoaded();
      }, function (req) {
        _context.default.svgImages[fileURL] = null;
        var event = new Event("images-error");
        event.url = fileURL;
        event.status = req.status;
        _context.default.canvas.canvas.node.dispatchEvent(event);
        imagesLoaded();
      });
    }
    _context.default.svgImages.loaders[fileURL].push(function (image) {
      createImage(img, image);
      loaded && loaded(img);
    });
  }
  return img;
}
function rasterizedSvgImage(fileURL, spec, width, height, loaded) {
  var img = _context.default.canvas.canvas.group();
  img.remove();
  var specId = spec.join("|");
  if (_context.default.rasterImages[fileURL] && _context.default.rasterImages[fileURL][specId]) {
    // forced timeout so that `loaded` is always called asynchronously
    // even if the image is in cache
    img.append(_context.default.rasterImages[fileURL][specId].cloneNode(true));
    setTimeout(function () {
      return loaded(img, width, height);
    }, 0);
  } else {
    if (!_context.default.rasterImages.loaders[fileURL]) {
      _context.default.rasterImages[fileURL] = {};
      _context.default.rasterImages.loaders[fileURL] = {};
    }
    if (!_context.default.rasterImages.loaders[fileURL][specId]) {
      _context.default.rasterImages.loaders[fileURL][specId] = [];
      svgImage(fileURL, width, height, function (svg) {
        svg.remove();
        var _iterator4 = _createForOfIteratorHelper(spec),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var elem = _step4.value;
            var node = svg.node.querySelector("#" + elem);
            if (node) {
              node.setAttribute("opacity", "0");
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        rasterize(svg, width, height, function (rimg) {
          _context.default.rasterImages[fileURL][specId] = rimg;
          var _iterator5 = _createForOfIteratorHelper(_context.default.rasterImages.loaders[fileURL][specId]),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var loader = _step5.value;
              loader(rimg, width, height);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          imagesLoaded();
        });
      });
    }
    _context.default.rasterImages.loaders[fileURL][specId].push(function (image, width, height) {
      img.append(image.cloneNode(true));
      loaded && loaded(img, width, height);
    });
  }
  return img;
}
function pngImage(fileURL) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var loaded = arguments.length > 3 ? arguments[3] : undefined;
  if (_context.default.images[fileURL]) {
    // forced timeout so that `loaded` is always called asynchronously
    // even if the image is in cache
    setTimeout(function () {
      return loaded(_context.default.images[fileURL], width, height);
    }, 0);
  } else {
    if (!_context.default.images.loaders[fileURL]) {
      _context.default.images.loaders[fileURL] = [];
      var img = new Image();
      img.onload = function () {
        _context.default.images[fileURL] = img;
        var _iterator6 = _createForOfIteratorHelper(_context.default.images.loaders[fileURL]),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var loader = _step6.value;
            loader(img, width, height);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        imagesLoaded();
      };
      img.src = fileURL;
    }
    _context.default.images.loaders[fileURL].push(loaded);
  }
}
function addAssociated(elements, element) {
  if (!elements.has(element)) {
    elements.add(element);
    var _iterator7 = _createForOfIteratorHelper(element.carried),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var record = _step7.value;
        addAssociated(elements, record.element);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    var _iterator8 = _createForOfIteratorHelper(element.sticked),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _record = _step8.value;
        addAssociated(elements, _record.element);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
}
function _boundingBox(elements, host) {
  var left = Infinity;
  var right = -Infinity;
  var top = Infinity;
  var bottom = -Infinity;
  var _iterator9 = _createForOfIteratorHelper(elements),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var element = _step9.value;
      var _computePosition = computePosition(element.root, host, element.left, element.top),
        x1 = _computePosition.x,
        y1 = _computePosition.y;
      left = Math.min(left, x1);
      top = Math.min(top, y1);
      var _computePosition2 = computePosition(element.root, host, element.right, element.bottom),
        x2 = _computePosition2.x,
        y2 = _computePosition2.y;
      right = Math.max(right, x2);
      bottom = Math.max(bottom, y2);
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return left === Infinity ? null : {
    left: left,
    top: top,
    right: right,
    bottom: bottom,
    width: right - left,
    height: bottom - top,
    x: (right + left) / 2,
    y: (top + bottom) / 2
  };
}
var DragOperation = exports.DragOperation = /*#__PURE__*/function () {
  function DragOperation() {
    var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
      return true;
    };
    (0, _classCallCheck2.default)(this, DragOperation);
    this.predicate = predicate;
  }
  return (0, _createClass2.default)(DragOperation, [{
    key: "_accept",
    value: function _accept(element, x, y, event) {
      if (event.button > 1) return false;
      return this.accept(element, x, y);
    }
  }, {
    key: "_onDragStart",
    value: function _onDragStart(element, x, y, event) {
      return this.onDragStart(element, _context.default.canvas.canvasX(x), _context.default.canvas.canvasY(y), event);
    }
  }, {
    key: "_onDragMove",
    value: function _onDragMove(element, dx, dy, x, y, event) {
      return this.onDragMove(element, dx, dy, _context.default.canvas.canvasX(x), _context.default.canvas.canvasY(y), event);
    }
  }, {
    key: "_onDrop",
    value: function _onDrop(element, event) {
      this.onDrop(element, event);
    }
  }, {
    key: "accept",
    value: function accept(element, x, y, event) {
      return this.predicate(element, x, y);
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(element, x, y, event) {}
  }, {
    key: "onDragMove",
    value: function onDragMove(element, dx, dy, x, y, event) {}
  }, {
    key: "onDrop",
    value: function onDrop(element, event) {}
  }]);
}();
var DragMouseOperation = exports.DragMouseOperation = /*#__PURE__*/function (_DragOperation) {
  function DragMouseOperation(predicate) {
    var _this;
    (0, _classCallCheck2.default)(this, DragMouseOperation);
    _this = _callSuper(this, DragMouseOperation, [predicate]);
    _this.observers = new Set();
    return _this;
  }
  (0, _inherits2.default)(DragMouseOperation, _DragOperation);
  return (0, _createClass2.default)(DragMouseOperation, [{
    key: "_dispatchChange",
    value: function _dispatchChange(type, value, animate) {
      var _iterator0 = _createForOfIteratorHelper(this.observers.values()),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var observer = _step0.value;
          observer.changed(this, type, value, animate);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(element, x, y, event) {
      this.start = {
        x: x,
        y: y,
        event: event,
        moved: false
      };
    }
  }, {
    key: "onDragMove",
    value: function onDragMove(element, dx, dy, x, y, event) {
      var _this2 = this;
      if (!this.start.moved) {
        evaluate("doDragStart", function () {
          _this2.doDragStart(element, _this2.start.x, _this2.start.y, _this2.start.event);
          _this2._dispatchChange("drag-start", element);
        });
      }
      this.start.moved = true;
      evaluate("doDragMove", function () {
        _this2.doDragMove(element, dx, dy, x, y);
        _this2._dispatchChange("drag-move", element);
      });
    }
  }, {
    key: "onDrop",
    value: function onDrop(element, event) {
      var _this3 = this;
      if (this.start.moved) {
        evaluate("doDrop", function () {
          _this3.doDrop(element);
          _this3._dispatchChange("drag-drop", element);
        });
      }
      delete this.start;
    }
  }, {
    key: "doDragStart",
    value: function doDragStart(element, x, y, event) {}
  }, {
    key: "doDragMove",
    value: function doDragMove(element, dx, dy, x, y, event) {}
  }, {
    key: "doDrop",
    value: function doDrop(element) {}
  }]);
}(DragOperation);
var DragMoveOperation = exports.DragMoveOperation = /*#__PURE__*/function (_DragMouseOperation) {
  function DragMoveOperation(predicate) {
    (0, _classCallCheck2.default)(this, DragMoveOperation);
    return _callSuper(this, DragMoveOperation, [predicate]);
  }
  (0, _inherits2.default)(DragMoveOperation, _DragMouseOperation);
  return (0, _createClass2.default)(DragMoveOperation, [{
    key: "accept",
    value: function accept(element, x, y, event) {
      return !_context.default.isReadOnly() && _superPropGet(DragMoveOperation, "accept", this, 3)([element, x, y, event]) && element.moveable && element.moveable();
    }
  }, {
    key: "dragSet",
    value: function dragSet() {
      function inSelection(parent, dragSet) {
        while (parent != null) {
          if (dragSet.has(parent)) {
            return true;
          }
          parent = parent.parent ? parent.parent() : null;
        }
        return false;
      }
      var dragSet = _context.default.selection.extendedSelection(function (element) {
        return element.moveable && element.moveable();
      });
      for (var _i = 0, _arr = (0, _toConsumableArray2.default)(dragSet); _i < _arr.length; _i++) {
        var element = _arr[_i];
        for (var _i2 = 0, _arr2 = (0, _toConsumableArray2.default)(element.carriedBy); _i2 < _arr2.length; _i2++) {
          var support = _arr2[_i2];
          if (!dragSet.has(support)) {
            support.removeCarried(element);
          }
        }
        for (var _i3 = 0, _arr3 = (0, _toConsumableArray2.default)(element.stickedTo); _i3 < _arr3.length; _i3++) {
          var _support = _arr3[_i3];
          if (!dragSet.has(_support)) {
            _support.removeSticked(element);
          }
        }
        if (inSelection(element.parent(), dragSet)) {
          dragSet.delete(element);
        }
      }
      return dragSet;
    }
  }, {
    key: "_getGlass",
    value: function _getGlass(selectedElement) {
      if (selectedElement.layer === "down") {
        return _context.default.canvas.glassDownLayer;
      } else if (selectedElement.layer === "middle") {
        return _context.default.canvas.glassMiddleLayer;
      } else if (selectedElement.layer === "up") {
        return _context.default.canvas.glassUpLayer;
      } else if (selectedElement.layer === "cover") {
        return _context.default.canvas.glassCoverLayer;
      }
    }
  }, {
    key: "doDragStart",
    value: function doDragStart(element, x, y, event) {
      function selectElement(element, event) {
        var builder = element.onCatalogBuilder();
        if (builder) {
          builder.select();
        } else if (!_context.default.selection.selected(element.selectable())) {
          _context.default.groupManager.selectElement(element, event);
        }
      }
      _context.default.memento.open();
      this.dragSorted = new List();
      selectElement(element, event);
      _context.default.canvas.glass.transform(_context.default.canvas.base.transform().localMatrix);
      this._dragSet = this.dragSet();
      var _iterator1 = _createForOfIteratorHelper(this._dragSet.values()),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var selectedElement = _step1.value;
          selectedElement.register();
          var baseMatrix = selectedElement.globalChange;
          var ibmatrix = baseMatrix.invert();
          var ibsplit = ibmatrix.split();
          selectedElement.lastX = selectedElement.globalX();
          selectedElement.lastY = selectedElement.globalY();
          var dx = (x - selectedElement.lastX) * ibsplit.scalex;
          var dy = (y - selectedElement.lastY) * ibsplit.scaley;
          var split = baseMatrix.multLeft(_context.default.canvas.base.transform().localMatrix.invert()).split();
          var dragMatrix = new _snap.default.Matrix().translate(split.dx, split.dy).rotate(split.rotate, 0, 0);
          var pedestal = this._getGlass(selectedElement).group().transform(dragMatrix);
          pedestal.dragX = dx;
          pedestal.dragY = dy;
          selectedElement._dispatchChange("removed", selectedElement.parent());
          selectedElement.draggedFrom(selectedElement.parent());
          pedestal.add(selectedElement.root);
          selectedElement.free = _context.default.freeMode;
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      this.lastX = x;
      this._dispatchChange("drag-start-elements", new Set(this._dragSet));
      this.catalogHidden = _context.default.catalog.hidden;
      //if (!this.catalogHidden) Context.catalog.hide();
    }
  }, {
    key: "sortedSelection",
    value: function sortedSelection(dx, dy) {
      var index = 0,
        px = 0,
        py = 0;
      if (dx > 0) {
        index += 1;
        px = 10000;
      }
      if (dx < 0) {
        index += 2;
        px = -10000;
      }
      if (dy > 0) {
        index += 3;
        py = 10000;
      }
      if (dy < 0) {
        index += 6;
        py = -10000;
      }
      var result = this.dragSorted && this.dragSorted[index];
      if (!result) {
        result = (0, _toConsumableArray2.default)(this._dragSet);
        sortByDistance(result, px, py);
        this.dragSorted[index] = result;
      }
      return result;
    }
  }, {
    key: "doDragMove",
    value: function doDragMove(element, dx, dy, x, y, event) {
      _context.default.canvas.glass.transform(_context.default.canvas.base.transform().localMatrix);
      var sortedSelection = this.sortedSelection(x - this.lastX, y - this.lastY);
      var _iterator10 = _createForOfIteratorHelper(sortedSelection),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var selectedElement = _step10.value;
          var pedestal = selectedElement.root.parent();
          var invertedMatrix = pedestal.transform().globalMatrix.invert();
          var dX = invertedMatrix.x(x, y) - pedestal.dragX;
          var dY = invertedMatrix.y(x, y) - pedestal.dragY;
          selectedElement.lastX = selectedElement.globalX();
          selectedElement.lastY = selectedElement.globalY();
          selectedElement.translate(new _snap.default.Matrix().translate(dX, dY));
          selectedElement._dispatchChange("dragged", null);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      this._dispatchChange("drag-move-elements", sortedSelection);
      this.lastX = x;
      this.lastY = y;
    }
  }, {
    key: "getTarget",
    value: function getTarget(element) {
      var globalX = element.globalX(0, 0);
      var globalY = element.globalY(0, 0);
      _context.default.canvas.glass.remove();
      var target = _context.default.canvas.elementByPoint(globalX, globalY);
      if (!target) {
        _context.default.canvas.baseRoot.transform(new _snap.default.Matrix().translate(-globalX, -globalY));
        target = _context.default.canvas.elementByPoint(0, 0);
        _context.default.canvas.baseRoot.transform(new _snap.default.Matrix());
      }
      _context.default.canvas.glassSupport.add(_context.default.canvas.glass);
      while (target) {
        if (target.owner) {
          var elementTarget = target.owner;
          return element.dropTarget ? element.dropTarget(elementTarget) : elementTarget;
        }
        target = target.parent();
      }
      return null;
    }

    /*
    doDrop(element) {
      let pedestals = new Set();
      for (let selectedElement of this._dragSet) {
        pedestals.add(selectedElement.root.parent());
      }
      let targets = new Map();
      for (let selectedElement of this._dragSet) {
        if (!selectedElement.dropCancelled()) {
          let target = this.getTarget(selectedElement);
          if (target && (!target.onWorkingSpace || !target.onWorkingSpace())) {
            target = null;
          }
          if (target) {
            let { x, y } = computePosition(selectedElement.root, target.root);
            selectedElement.position(x, y);
            if (target.receiveDrop && !target.receiveDrop(selectedElement)) {
              console.log("cancelDrop: receive drop refused");
              selectedElement.cancelDrop();
            } else {
              targets.set(selectedElement, target);
              // Si receiveDrop n'a pas déja fait le boulot...
              if (pedestals.has(selectedElement.root.parent())) {
                target.add(selectedElement);
              }
            }
            selectedElement.droppedIn(target);
          } else {
            console.log("cancelDrop: no target");
            selectedElement.cancelDrop();
          }
        }
      }
      for (let selectedElement of this._dragSet) {
        if (!selectedElement.dropCancelled()) {
          let target = targets.get(selectedElement);
          target.adjustDrop && target.adjustDrop(selectedElement);
        }
      }
      for (let pedestal of pedestals) {
        pedestal.remove();
      }
      this._dispatchChange("drop-elements", new Set(this._dragSet));
      let allCancelled = true;
      for (let selectedElement of this._dragSet) {
        if (!selectedElement.dropCancelled()) {
          allCancelled = false;
        }
      }
      if (allCancelled) {
        Context.memento.cancel();
      }
    }
    */
  }, {
    key: "_acceptDrop",
    value: function _acceptDrop(targets, pedestals) {
      var _iterator11 = _createForOfIteratorHelper(this._dragSet),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var selectedElement = _step11.value;
          if (!selectedElement.dropCancelled()) {
            var target = this.getTarget(selectedElement);
            if (target && (!target.onWorkingSpace || !target.onWorkingSpace())) {
              target = null;
            }
            if (target) {
              var _computePosition3 = computePosition(selectedElement.root, target.root),
                x = _computePosition3.x,
                y = _computePosition3.y;
              selectedElement.position(x, y);
              if (target.receiveDrop && !target.receiveDrop(selectedElement)) {
                console.log("cancelDrop: receive drop refused");
                return false;
              } else {
                targets.set(selectedElement, target);
                // Si receiveDrop n'a pas déja fait le boulot...
                if (pedestals.has(selectedElement.root.parent())) {
                  target.add(selectedElement);
                }
              }
              selectedElement.droppedIn(target);
            } else {
              console.log("cancelDrop: no target");
              return false;
            }
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return true;
    }
  }, {
    key: "doDrop",
    value: function doDrop(element) {
      //if (!this.catalogHidden) Context.catalog.show();
      var pedestals = new Set();
      var _iterator12 = _createForOfIteratorHelper(this._dragSet),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _selectedElement = _step12.value;
          pedestals.add(_selectedElement.root.parent());
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      var targets = new Map();
      if (this._acceptDrop(targets, pedestals)) {
        var _iterator13 = _createForOfIteratorHelper(this._dragSet),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var selectedElement = _step13.value;
            if (!selectedElement.dropCancelled()) {
              var target = targets.get(selectedElement);
              target.adjustDrop && target.adjustDrop(selectedElement);
            }
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
        var _iterator14 = _createForOfIteratorHelper(pedestals),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var pedestal = _step14.value;
            pedestal.remove();
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
        this._dispatchChange("drop-elements", new Set(this._dragSet));
      } else {
        _context.default.memento.cancel();
      }
    }
  }]);
}(DragMouseOperation);
var DragMovePdfOperation = exports.DragMovePdfOperation = /*#__PURE__*/function (_DragMoveOperation) {
  function DragMovePdfOperation(predicate) {
    (0, _classCallCheck2.default)(this, DragMovePdfOperation);
    return _callSuper(this, DragMovePdfOperation, [predicate]);
  }
  (0, _inherits2.default)(DragMovePdfOperation, _DragMoveOperation);
  return (0, _createClass2.default)(DragMovePdfOperation, [{
    key: "accept",
    value: function accept(element, x, y, event) {
      return true;
    }
  }]);
}(DragMoveOperation);
var DragSelectionOperation = exports.DragSelectionOperation = /*#__PURE__*/function (_DragOperation2) {
  function DragSelectionOperation(predicate) {
    var _this4;
    (0, _classCallCheck2.default)(this, DragSelectionOperation);
    _this4 = _callSuper(this, DragSelectionOperation, [predicate]);
    _this4.operations = [];
    return _this4;
  }
  (0, _inherits2.default)(DragSelectionOperation, _DragOperation2);
  return (0, _createClass2.default)(DragSelectionOperation, [{
    key: "add",
    value: function add(operation) {
      this.operations.push(operation);
      return this;
    }
  }, {
    key: "accept",
    value: function accept(element, x, y, event) {
      if (!_superPropGet(DragSelectionOperation, "accept", this, 3)([element, x, y, event])) {
        return false;
      }
      var _iterator15 = _createForOfIteratorHelper(this.operations),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var operation = _step15.value;
          if (operation.accept(element, x, y, event)) {
            this.currentOperation = operation;
            return true;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return false;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(element, x, y, event) {
      this.currentOperation && this.currentOperation.onDragStart(element, x, y, event);
    }
  }, {
    key: "onDragMove",
    value: function onDragMove(element, dx, dy, x, y, event) {
      this.currentOperation && this.currentOperation.onDragMove(element, dx, dy, x, y, event);
    }
  }, {
    key: "onDrop",
    value: function onDrop(element, event) {
      this.currentOperation && this.currentOperation.onDrop(element, event);
    }
  }]);
}(DragOperation);
var ParentDragOperation = exports.ParentDragOperation = /*#__PURE__*/function (_DragOperation3) {
  function ParentDragOperation(predicate) {
    (0, _classCallCheck2.default)(this, ParentDragOperation);
    return _callSuper(this, ParentDragOperation, [predicate]);
  }
  (0, _inherits2.default)(ParentDragOperation, _DragOperation3);
  return (0, _createClass2.default)(ParentDragOperation, [{
    key: "accept",
    value: function accept(element, x, y, event) {
      if (!_superPropGet(ParentDragOperation, "accept", this, 3)([element, x, y, event])) {
        return false;
      }
      return element.parent() != null && element.parent().dragOp ? element.parent().dragOp.accept(element.parent(), x, y, event) : false;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(element, x, y, event) {
      if (element.parent().dragOp) {
        element.parent().dragOp.onDragStart(element.parent(), x, y, event);
      }
    }
  }, {
    key: "onDragMove",
    value: function onDragMove(element, dx, dy, x, y, event) {
      if (element.parent().dragOp) {
        element.parent().dragOp.onDragMove(element.parent(), dx, dy, x, y, event);
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(element, event) {
      if (element.parent().dragOp) {
        element.parent().dragOp.onDrop(element.parent(), event);
      }
    }
  }]);
}(DragOperation);
var DragScrollOperation = exports.DragScrollOperation = /*#__PURE__*/function (_DragOperation4) {
  function DragScrollOperation(predicate) {
    (0, _classCallCheck2.default)(this, DragScrollOperation);
    return _callSuper(this, DragScrollOperation, [predicate]);
  }
  (0, _inherits2.default)(DragScrollOperation, _DragOperation4);
  return (0, _createClass2.default)(DragScrollOperation, [{
    key: "accept",
    value: function accept(element, x, y, event) {
      return _superPropGet(DragScrollOperation, "accept", this, 3)([element, x, y, event]);
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(element, x, y, event) {
      this.dragMatrix = _context.default.canvas.baseTransform();
      var invertedMatrix = this.dragMatrix.invert();
      this.dragX = invertedMatrix.x(x, y);
      this.dragY = invertedMatrix.y(x, y);
      this.onDragMove(element, 0, 0, x, y, event);
    }
  }, {
    key: "onDragMove",
    value: function onDragMove(element, dx, dy, x, y, event) {
      var invertedMatrix = this.dragMatrix.invert();
      var localX = invertedMatrix.x(x, y);
      var localY = invertedMatrix.y(x, y);
      _context.default.canvas.adjustBase(this.dragMatrix.clone().translate(localX - this.dragX, localY - this.dragY));
    }
  }]);
}(DragOperation);
var DragAbstractSelectAreaOperation = exports.DragAbstractSelectAreaOperation = /*#__PURE__*/function (_DragOperation5) {
  function DragAbstractSelectAreaOperation(predicate) {
    (0, _classCallCheck2.default)(this, DragAbstractSelectAreaOperation);
    return _callSuper(this, DragAbstractSelectAreaOperation, [predicate]);
  }
  (0, _inherits2.default)(DragAbstractSelectAreaOperation, _DragOperation5);
  return (0, _createClass2.default)(DragAbstractSelectAreaOperation, [{
    key: "onDragStart",
    value: function onDragStart(element, x, y, event) {
      _context.default.canvas.glass.transform(new _snap.default.Matrix());
      this.dragMatrix = _context.default.canvas.glass.transform().globalMatrix;
      var invertedMatrix = this.dragMatrix.invert();
      this.startX = invertedMatrix.x(x, y);
      this.startY = invertedMatrix.y(x, y);
      this.selectArea = _context.default.canvas.glass.rect(this.startX, this.startY, 1, 1);
      this.prepareArea(this.selectArea);
      this.onDragMove(element, 0, 0, x, y, event);
    }
  }, {
    key: "prepareArea",
    value: function prepareArea(area) {}
  }, {
    key: "onDragMove",
    value: function onDragMove(element, dx, dy, x, y, event) {
      var invertedMatrix = this.dragMatrix.invert();
      var localX = invertedMatrix.x(x, y);
      var localY = invertedMatrix.y(x, y);
      var rwidth = localX - this.startX;
      var rheight = localY - this.startY;
      var rx = this.startX;
      var ry = this.startY;
      if (rwidth < 0) {
        rwidth = -rwidth;
        rx = rx - rwidth;
      }
      if (rheight < 0) {
        rheight = -rheight;
        ry = ry - rheight;
      }
      this.selectArea.attr({
        x: rx,
        y: ry,
        width: rwidth,
        height: rheight
      });
    }
  }, {
    key: "onDrop",
    value: function onDrop(element, event) {
      var _this5 = this;
      this.selectArea.remove();
      setTimeout(function () {
        _this5.doSelection(_this5.selectArea, event);
      }, 20);
    }
  }, {
    key: "doSelection",
    value: function doSelection(selectArea, event) {}
  }]);
}(DragOperation);
var DragSelectAreaOperation = exports.DragSelectAreaOperation = /*#__PURE__*/function (_DragAbstractSelectAr) {
  function DragSelectAreaOperation(predicate) {
    (0, _classCallCheck2.default)(this, DragSelectAreaOperation);
    return _callSuper(this, DragSelectAreaOperation, [predicate]);
  }
  (0, _inherits2.default)(DragSelectAreaOperation, _DragAbstractSelectAr);
  return (0, _createClass2.default)(DragSelectAreaOperation, [{
    key: "accept",
    value: function accept(element, x, y, event) {
      return _superPropGet(DragSelectAreaOperation, "accept", this, 3)([element, x, y, event]) && element instanceof BoardArea;
    }
  }, {
    key: "prepareArea",
    value: function prepareArea(selectArea) {
      selectArea.attr({
        fill: "none",
        stroke: _context.default.CRIMSON,
        "stroke-width": 2,
        "stroke-opacity": 0.9,
        "stroke-dasharray": "5,5"
      });
    }
  }, {
    key: "doSelection",
    value: function doSelection(selectArea, event) {
      function _inside(x, y, rect) {
        var rx = parseFloat(rect.attr("x"), 10);
        var ry = parseFloat(rect.attr("y"), 10);
        var rw = parseFloat(rect.attr("width"), 10);
        var rh = parseFloat(rect.attr("height"), 10);
        return rx <= x && rx + rw >= x && ry <= y && ry + rh >= y;
      }
      function _isSelected(element) {
        var x0 = element.globalX(element.x, element.y);
        var y0 = element.globalY(element.x, element.y);
        var x1 = element.globalX(element.x, element.y + element.height);
        var y1 = element.globalY(element.x, element.y + element.height);
        var x2 = element.globalX(element.x + element.width, element.y);
        var y2 = element.globalY(element.x + element.width, element.y);
        var x3 = element.globalX(element.x + element.width, element.y + element.height);
        var y3 = element.globalY(element.x + element.width, element.y + element.height);
        return _inside(x0, y0, selectArea) || _inside(x1, y1, selectArea) || _inside(x2, y2, selectArea) || _inside(x3, y3, selectArea);
      }
      function _doSelection(element) {
        var selectedElement = element.selectable();
        if (selectedElement && !selectedElement.isFixed() && _isSelected(selectedElement)) {
          _context.default.groupManager.addToSelection(selectedElement);
        } else {
          var _iterator16 = _createForOfIteratorHelper(element.children()),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var child = _step16.value;
              _doSelection(child);
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }
      }
      if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
        _context.default.selection.unselect();
      }
      var _iterator17 = _createForOfIteratorHelper(_context.default.canvas.baseChildren()),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var child = _step17.value;
          _doSelection(child.owner);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }]);
}(DragAbstractSelectAreaOperation);
var DragSelectPdfAreaOperation = exports.DragSelectPdfAreaOperation = /*#__PURE__*/function (_DragAbstractSelectAr2) {
  function DragSelectPdfAreaOperation(predicate) {
    (0, _classCallCheck2.default)(this, DragSelectPdfAreaOperation);
    return _callSuper(this, DragSelectPdfAreaOperation, [predicate]);
  }
  (0, _inherits2.default)(DragSelectPdfAreaOperation, _DragAbstractSelectAr2);
  return (0, _createClass2.default)(DragSelectPdfAreaOperation, [{
    key: "prepareArea",
    value: function prepareArea(selectArea) {
      selectArea.attr({
        stroke: _context.default.GREEN,
        fill: _context.default.GREEN,
        "fill-opacity": 0.1,
        "stroke-width": 1,
        "stroke-opacity": 0.9
      });
    }
  }, {
    key: "doSelection",
    value: function doSelection(selectArea, event) {
      var rx = parseFloat(selectArea.attr("x"), 10);
      var ry = parseFloat(selectArea.attr("y"), 10);
      var rw = parseFloat(selectArea.attr("width"), 10);
      var rh = parseFloat(selectArea.attr("height"), 10);
      var x1 = _context.default.table.localX(rx, ry);
      var y1 = _context.default.table.localY(rx, ry);
      var x2 = _context.default.table.localX(rx + rw, ry + rh);
      var y2 = _context.default.table.localY(rx + rw, ry + rh);
      if (x2 - x1 > _context.default.MIN_PDF_AREA && y2 - y1 > _context.default.MIN_PDF_AREA) {
        var pdfArea = new BoardPdfArea(x2 - x1, y2 - y1);
        pdfArea.position((x1 + x2) / 2, (y1 + y2) / 2);
        _context.default.table.pdfLayer.add(pdfArea);
        _context.default.groupManager.selectOne(pdfArea);
      }
    }
  }]);
}(DragAbstractSelectAreaOperation);
var Observer = exports.Observer = /*#__PURE__*/function () {
  function Observer(action) {
    (0, _classCallCheck2.default)(this, Observer);
    this.action = action;
  }
  return (0, _createClass2.default)(Observer, [{
    key: "_observe",
    value: function _observe(observable) {
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "observe",
    value: function observe(observable) {
      observable.register && observable.register();
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "forget",
    value: function forget(observable) {
      observable.register && observable.register();
      observable.observers.delete(this);
      return this;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      this.action(source, type, value);
    }
  }]);
}();
var Menu = exports.Menu = /*#__PURE__*/function () {
  function Menu(x, y, menuOptions) {
    var closeOnSelectOption = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    (0, _classCallCheck2.default)(this, Menu);
    this.root = _context.default.canvas.glass.group();
    this.x = x;
    this.y = y;
    this.menuOptions = menuOptions;
    _context.default.canvas.glass.transform(new _snap.default.Matrix());
    this._buildContent();
    this.closeOnSelectOption = closeOnSelectOption;
    this.root.node.addEventListener("mousedown", function (event) {
      event.stopPropagation();
    });
    this.root.node.addEventListener("mouseup", function (event) {
      event.stopPropagation();
    });
  }
  return (0, _createClass2.default)(Menu, [{
    key: "refresh",
    value: function refresh() {
      this.root.clear();
      this._buildContent();
    }
  }, {
    key: "_buildContent",
    value: function _buildContent() {
      var rect = this.root.rect(0, 0, 10, 10).attr({
        stroke: _context.default.BLACK,
        fill: _context.default.WHITE,
        filter: _context.default.shadow
      });
      var context = {
        width: 10,
        height: _context.default.MENU_MARGIN,
        left: 1
      };
      var lines = new List();
      var _iterator18 = _createForOfIteratorHelper(this.menuOptions),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var option = _step18.value;
          lines.add(option.line(this.root, context));
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      rect.attr({
        width: context.width + _context.default.MENU_MARGIN * 2,
        height: context.height
      });
      var _iterator19 = _createForOfIteratorHelper(lines),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var line = _step19.value;
          line.back.attr({
            width: context.width + _context.default.MENU_MARGIN * 2 - 2
          });
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      var x = this.x;
      var y = this.y;
      if (x + context.width + _context.default.MENU_MARGIN > _context.default.canvas.clientWidth) {
        x = _context.default.canvas.clientWidth - context.width - _context.default.MENU_MARGIN;
      }
      if (y + context.height + _context.default.MENU_MARGIN > _context.default.canvas.clientHeight) {
        y = _context.default.canvas.clientHeight - context.height - _context.default.MENU_MARGIN;
      }
      this.root.transform(new _snap.default.Matrix().translate(x, y));
    }
  }, {
    key: "close",
    value: function close() {
      this.root.remove();
    }
  }, {
    key: "menuEvent",
    value: function menuEvent(x, y) {
      var box = this.root.getBBox();
      return x >= box.x && x <= box.x2 && y >= box.y && y <= box.y2;
    }
  }]);
}();
var MenuOptionInstance = exports.MenuOptionInstance = /*#__PURE__*/function () {
  function MenuOptionInstance(menuOption, action) {
    var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return true;
    };
    (0, _classCallCheck2.default)(this, MenuOptionInstance);
    this.menuOption = menuOption;
    this._action = action;
    this._active = active;
  }
  return (0, _createClass2.default)(MenuOptionInstance, [{
    key: "label",
    get: function get() {
      return this.menuOption._label;
    }
  }, {
    key: "action",
    get: function get() {
      return this._action;
    }
  }, {
    key: "active",
    get: function get() {
      return this._active();
    }
  }, {
    key: "line",
    value: function line(root, context) {
      return this.menuOption.line(root, context, this);
    }
  }]);
}();
var GlobalMenuOptionInstance = exports.GlobalMenuOptionInstance = /*#__PURE__*/function (_MenuOptionInstance) {
  function GlobalMenuOptionInstance(menuOption, options) {
    var _this6;
    (0, _classCallCheck2.default)(this, GlobalMenuOptionInstance);
    _this6 = _callSuper(this, GlobalMenuOptionInstance, [menuOption, function () {
      var _menuOption$strategy;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_menuOption$strategy = menuOption.strategy).action.apply(_menuOption$strategy, [menuOption, options].concat(args));
    }, function () {
      return menuOption.strategy.active(menuOption, options);
    }]);
    _this6._options = options;
    return _this6;
  }
  (0, _inherits2.default)(GlobalMenuOptionInstance, _MenuOptionInstance);
  return (0, _createClass2.default)(GlobalMenuOptionInstance);
}(MenuOptionInstance);
var MenuOption = exports.MenuOption = /*#__PURE__*/function () {
  function MenuOption(label, strategy) {
    (0, _classCallCheck2.default)(this, MenuOption);
    this._label = label;
    this._strategy = strategy;
    _context.default.menuOptions.add(this);
  }
  return (0, _createClass2.default)(MenuOption, [{
    key: "strategy",
    get: function get() {
      return this._strategy;
    }
  }, {
    key: "globalOptions",
    value: function globalOptions(elements) {
      var element = elements[0];
      var options = null;
      if (element) {
        options = new Set();
        var menuOptions = element.collectMenuOptions();
        var _iterator20 = _createForOfIteratorHelper(menuOptions),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var menuOption = _step20.value;
            if (menuOption.menuOption === this) {
              options.add(menuOption);
            }
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
      }
      return options;
    }
  }, {
    key: "globalInstance",
    value: function globalInstance(options) {
      return new GlobalMenuOptionInstance(this, options);
    }
  }, {
    key: "size",
    get: function get() {
      return 1;
    }
  }]);
}();
var TextMenuOption = exports.TextMenuOption = /*#__PURE__*/function (_MenuOption) {
  function TextMenuOption(label, strategy) {
    (0, _classCallCheck2.default)(this, TextMenuOption);
    return _callSuper(this, TextMenuOption, [label, strategy]);
  }
  (0, _inherits2.default)(TextMenuOption, _MenuOption);
  return (0, _createClass2.default)(TextMenuOption, [{
    key: "instance",
    value: function instance(action, active) {
      this._action = action;
      this._active = active;
      return new MenuOptionInstance(this, action, active);
    }
  }, {
    key: "action",
    get: function get() {
      return this._action;
    }
  }, {
    key: "active",
    get: function get() {
      return this._active;
    }
  }, {
    key: "line",
    value: function line(root, context, instance) {
      var line = root.group();
      var back = line.rect(context.left, context.height - _context.default.MENU_MARGIN / 2, 10, 10);
      line.node.addEventListener("mouseup", function () {
        if (instance.active) {
          instance.action();
          if (_context.default.canvas.menu && _context.default.canvas.menu.closeOnSelectOption) {
            _context.default.canvas.closeMenu();
          } else {
            _context.default.canvas.refreshMenu();
          }
          event.stopPropagation();
        }
      });
      var text = line.text(_context.default.MENU_MARGIN + context.left, context.height + _context.default.MENU_MARGIN, _context.default.menus[instance.label]);
      if (instance.active) {
        line.addClass("menuOption");
        text.addClass("menuOptionText");
      } else {
        line.addClass("disabledMenuOption");
        text.addClass("disabledMenuOptionText");
      }
      var bbox = text.getBBox();
      if (bbox.width > context.width) {
        context.width = bbox.width;
      }
      back.attr({
        height: bbox.height
      });
      context.height += bbox.height;
      return {
        back: back
      };
    }
  }]);
}(MenuOption);
var TextToggleMenuOptionInstance = exports.TextToggleMenuOptionInstance = /*#__PURE__*/function (_MenuOptionInstance2) {
  function TextToggleMenuOptionInstance(menuOption, action, altAction, predicate) {
    var _this7;
    var active = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
      return true;
    };
    (0, _classCallCheck2.default)(this, TextToggleMenuOptionInstance);
    _this7 = _callSuper(this, TextToggleMenuOptionInstance, [menuOption, action, active]);
    _this7._predicate = predicate;
    _this7._altAction = altAction;
    return _this7;
  }
  (0, _inherits2.default)(TextToggleMenuOptionInstance, _MenuOptionInstance2);
  return (0, _createClass2.default)(TextToggleMenuOptionInstance, [{
    key: "label",
    get: function get() {
      return this._predicate() ? this.menuOption._altLabel : this.menuOption._label;
    }
  }, {
    key: "action",
    get: function get() {
      return this._predicate() ? this._altAction : _superPropGet(TextToggleMenuOptionInstance, "action", this, 1);
    }
  }]);
}(MenuOptionInstance);
var TextToggleGlobalMenuOptionInstance = exports.TextToggleGlobalMenuOptionInstance = /*#__PURE__*/function (_TextToggleMenuOption) {
  function TextToggleGlobalMenuOptionInstance(menuOption, options) {
    var _this8;
    (0, _classCallCheck2.default)(this, TextToggleGlobalMenuOptionInstance);
    _this8 = _callSuper(this, TextToggleGlobalMenuOptionInstance, [menuOption, function () {
      var _menuOption$strategy2;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_menuOption$strategy2 = menuOption.strategy).action.apply(_menuOption$strategy2, [menuOption, options].concat(args));
    }, function () {
      var _menuOption$strategy3;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      (_menuOption$strategy3 = menuOption.strategy).altAction.apply(_menuOption$strategy3, [menuOption, options].concat(args));
    }, function () {
      return menuOption.strategy.predicate(menuOption, options);
    }, function () {
      return menuOption.strategy.active(menuOption, options);
    }]);
    _this8._options = options;
    return _this8;
  }
  (0, _inherits2.default)(TextToggleGlobalMenuOptionInstance, _TextToggleMenuOption);
  return (0, _createClass2.default)(TextToggleGlobalMenuOptionInstance);
}(TextToggleMenuOptionInstance);
var TextToggleMenuOption = exports.TextToggleMenuOption = /*#__PURE__*/function (_TextMenuOption) {
  function TextToggleMenuOption(label, strategy, altLabel) {
    var _this9;
    (0, _classCallCheck2.default)(this, TextToggleMenuOption);
    _this9 = _callSuper(this, TextToggleMenuOption, [label, strategy]);
    _this9._altLabel = altLabel;
    return _this9;
  }
  (0, _inherits2.default)(TextToggleMenuOption, _TextMenuOption);
  return (0, _createClass2.default)(TextToggleMenuOption, [{
    key: "instance",
    value: function instance(action, altAction, predicate, active) {
      return new TextToggleMenuOptionInstance(this, action, altAction, predicate, active);
    }
  }, {
    key: "globalInstance",
    value: function globalInstance(options) {
      return new TextToggleGlobalMenuOptionInstance(this, options);
    }
  }]);
}(TextMenuOption);
var ColorChooserMenuOption = exports.ColorChooserMenuOption = /*#__PURE__*/function (_MenuOption2) {
  function ColorChooserMenuOption(label, strategy, colors) {
    var _this0;
    (0, _classCallCheck2.default)(this, ColorChooserMenuOption);
    _this0 = _callSuper(this, ColorChooserMenuOption, [label, strategy]);
    _this0.colors = colors;
    return _this0;
  }
  (0, _inherits2.default)(ColorChooserMenuOption, _MenuOption2);
  return (0, _createClass2.default)(ColorChooserMenuOption, [{
    key: "instance",
    value: function instance(action, active) {
      return new MenuOptionInstance(this, action, active);
    }
  }, {
    key: "size",
    get: function get() {
      return 4;
    }
  }, {
    key: "line",
    value: function line(root, context, instance) {
      var line = root.group();
      var colors = this.colors();
      var colorRowCount = Math.ceil(colors.length / _context.default.COLOR_ROW_LENGTH);
      var back = line.rect(context.left, context.height - _context.default.MENU_MARGIN / 2, 10, 10);
      var text = line.text(_context.default.MENU_MARGIN + context.left, context.height + _context.default.MENU_MARGIN, _context.default.menus[instance.label]);
      if (instance.active) {
        line.addClass("menuOption");
        text.addClass("menuOptionText");
      } else {
        line.addClass("disabledMenuOption");
        text.addClass("disabledMenuOptionText");
      }
      var colorWidth = _context.default.COLOR_ROW_LENGTH * (_context.default.COLOR_WIDTH + _context.default.COLOR_MARGIN) - _context.default.COLOR_MARGIN;
      if (context.width < colorWidth) {
        context.width = colorWidth;
      }
      var bbox = text.getBBox();
      if (bbox.width > context.width) {
        context.width = bbox.width;
      }
      var x = _context.default.COLOR_MARGIN + context.left;
      var y = context.height + bbox.height;
      var _loop = function _loop() {
        var color = colors[index];
        var colorRect = line.rect(x, y, _context.default.COLOR_WIDTH, _context.default.COLOR_HEIGHT).attr({
          fill: color,
          stroke: _context.default.BLACK
        });
        x += _context.default.COLOR_WIDTH + _context.default.COLOR_MARGIN;
        if ((index + 1) % _context.default.COLOR_ROW_LENGTH === 0) {
          x = _context.default.COLOR_MARGIN + context.left;
          y += _context.default.COLOR_HEIGHT + _context.default.COLOR_MARGIN;
        }
        colorRect.node.addEventListener("mouseup", function () {
          if (instance.active) {
            instance.action(color);
            if (_context.default.canvas.menu && _context.default.canvas.menu.closeOnSelectOption) {
              _context.default.canvas.closeMenu();
            } else {
              _context.default.canvas.refreshMenu();
            }
          }
          event.stopPropagation();
        });
      };
      for (var index = 0; index < colors.length; index++) {
        _loop();
      }
      var height = bbox.height + (_context.default.COLOR_HEIGHT + _context.default.COLOR_MARGIN) * colorRowCount + _context.default.COLOR_MARGIN;
      back.attr({
        height: height
      });
      context.height += height;
      return {
        back: back
      };
    }
  }]);
}(MenuOption);
window.BoardElement = /*#__PURE__*/function () {
  function BoardElement() {
    var _this1 = this;
    (0, _classCallCheck2.default)(this, BoardElement);
    this.id = createUUID();
    this._createStructure();
    this.observers = new Set();
    this.root.node.addEventListener("mousedown", function (event) {
      if (event.button === 2) {
        _context.default.canvas.closeMenu();
        _this1.menu(event.pageX + localOffset(_context.default.canvas.canvas.node).x, event.pageY + localOffset(_context.default.canvas.canvas.node).y);
      }
    });
  }
  return (0, _createClass2.default)(BoardElement, [{
    key: "layer",
    get: function get() {
      return "middle";
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {}
  }, {
    key: "_createStructure",
    value: function _createStructure() {
      this.root = _context.default.canvas.canvas.group();
      this.root.idx = "root";
      this.root.owner = this;
      this.owned = this.root.group();
      this.highlight = this.root.group();
      this.content = this.root.group();
      this.decorate = this.root.group();
      this.owned.idx = "owned";
      this.owned.owner = this;
      this.content.idx = "content";
      this.content.owner = this;
      this.decorate.idx = "decorate";
      this.decorate.owner = this;
      this.highlight.idx = "highlight";
      this.highlight.owner = this;
      this.menuOptions = new List();
    }
  }, {
    key: "dragOp",
    get: function get() {
      return this._dragOp;
    }
  }, {
    key: "localTranslation",
    get: function get() {
      return this.root.localMatrix;
    }
  }, {
    key: "globalChange",
    get: function get() {
      return this.root.transform().globalMatrix;
    }
  }, {
    key: "type",
    get: function get() {
      throw new Error("Not implemented");
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      this.register();
      delete this.highlightColor;
      this.highlight.clear();
    }
  }, {
    key: "applyHighlight",
    value: function applyHighlight(color) {
      this.register();
      this.highlightColor = color;
      var width = this.width;
      var height = this.height;
      this.highlight.clear();
      var rect = this.highlight.rect(-width / 2, -height / 2, width, height).attr({
        fill: color,
        stroke: "none",
        opacity: 0.25
      });
      rect.owner = this;
    }
  }, {
    key: "addMenuOption",
    value: function addMenuOption(menuOption) {
      this.register();
      this._addMenuOption(menuOption);
    }
  }, {
    key: "_addMenuOption",
    value: function _addMenuOption(menuOption) {
      this.menuOptions.add(menuOption);
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      return (0, _construct2.default)(List, (0, _toConsumableArray2.default)(this.menuOptions));
    }
  }, {
    key: "getMenuOptions",
    value: function getMenuOptions() {
      var builder = this.onCatalogBuilder();
      return builder ? builder.collectMenuOptions() : this.collectMenuOptions();
    }
  }, {
    key: "makeEditable",
    value: function makeEditable() {
      var _this10 = this;
      /*
      this._doubleClickHandler(() => {
        this.edit();
      });
      */
      this._addMenuOption(_context.default.editMenuOption.instance(function () {
        _this10.edit();
      }));
    }
  }, {
    key: "makeResizeable",
    value: function makeResizeable() {
      this._addMenuOption(_context.default.editSizeMenuOption.instance(function () {
        _context.default.table.paper.editSize();
      }));
    }
  }, {
    key: "makeMoveable",
    value: function makeMoveable() {
      var _this11 = this;
      this._addMenuOption(_context.default.moveMenuOption.instance(function () {
        _this11.callForMove();
      }));
    }
  }, {
    key: "modelId",
    value: function modelId() {
      throw new Error("Not implemented");
    }
  }, {
    key: "_menu",
    value: function _menu(x, y) {
      var menuOptions = this.getMenuOptions();
      if (menuOptions.length > 0) {
        _context.default.canvas.openMenu(x, y, menuOptions);
      }
    }
  }, {
    key: "menu",
    value: function menu(x, y) {
      if (!_context.default.isReadOnly()) {
        this._menu(x, y);
      }
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = {};
      memento.parent = this.parent();
      // MATRIX:  memento.rootMatrix = this.root ? this.root.transform().localMatrix : null;
      memento.rootMatrix = this.root ? this.root.localMatrix : null;
      memento.ownedMatrix = this.owned.transform().localMatrix;
      memento.decorateMatrix = this.decorate.transform().localMatrix;
      memento.highlightMatrix = this.highlight.transform().localMatrix;
      memento.contentMatrix = this.content.transform().localMatrix;
      memento.owned = (0, _toConsumableArray2.default)(this.owned.children());
      memento.decorate = (0, _toConsumableArray2.default)(this.decorate.children());
      memento.highlight = (0, _toConsumableArray2.default)(this.highlight.children());
      memento.content = (0, _toConsumableArray2.default)(this._children());
      memento.observers = new Set(this.observers);
      memento.menuOptions = (0, _toConsumableArray2.default)(this.menuOptions);
      memento.highlightColor = this.highlightColor;
      memento._dragOp = this._dragOp;
      memento._clickHdl = this._clickHdl;
      memento._dblClickHdl = this._dblClickHdl;
      return memento;
    }
  }, {
    key: "revertRoot",
    value: function revertRoot(memento) {
      if (!memento.parent || !(memento.parent instanceof BoardElement)) {
        this.root.remove();
      }
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      this.revertRoot(memento);
      this.root.localMatrix = memento.rootMatrix;
      this.root.transform(memento.rootMatrix);
      this.owned.transform(memento.ownedMatrix);
      this.decorate.transform(memento.decorateMatrix);
      this.highlight.transform(memento.highlightMatrix);
      this.content.transform(memento.contentMatrix);
      this.observers = new Set(memento.observers);
      var _iterator21 = _createForOfIteratorHelper(this.owned.children()),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var child = _step21.value;
          child.node.parentNode.removeChild(child.node);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      var _iterator22 = _createForOfIteratorHelper(memento.owned),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _child = _step22.value;
          this.owned.add(_child);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      var _iterator23 = _createForOfIteratorHelper(this.decorate.children()),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _child2 = _step23.value;
          _child2.node.parentNode.removeChild(_child2.node);
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      var _iterator24 = _createForOfIteratorHelper(memento.decorate),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _child3 = _step24.value;
          this.decorate.add(_child3);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      var _iterator25 = _createForOfIteratorHelper(this.highlight.children()),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _child4 = _step25.value;
          _child4.node.parentNode.removeChild(_child4.node);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      var _iterator26 = _createForOfIteratorHelper(memento.highlight),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _child5 = _step26.value;
          this.highlight.add(_child5);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      var _iterator27 = _createForOfIteratorHelper(this._children()),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _child6 = _step27.value;
          _child6.root.node.parentNode.removeChild(_child6.root.node);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      var _iterator28 = _createForOfIteratorHelper(memento.content),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var _child7 = _step28.value;
          this._add(_child7);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      this.menuOptions = (0, _construct2.default)(List, (0, _toConsumableArray2.default)(memento.menuOptions));
      this.highlightColor = memento.highlightColor;
      this._dragOperation(memento._dragOp);
      this._clickHandler(memento._clickHdl);
      this._doubleClickHandler(memento._dblClickHdl);
    }
  }, {
    key: "observe",
    value: function observe(observable) {
      observable.register && observable.register();
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "forget",
    value: function forget(observable) {
      observable.register && observable.register();
      observable.observers.delete(this);
      return this;
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value, animate) {
      var _iterator29 = _createForOfIteratorHelper(this.observers.values()),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var observer = _step29.value;
          observer.changed(this, type, value, animate);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }
  }, {
    key: "dragOperation",
    value: function dragOperation(operation) {
      this.register();
      this._dragOperation(operation);
      return this;
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(handler) {
      this.register();
      this._clickHandler(handler);
      return this;
    }
  }, {
    key: "doubleClickHandler",
    value: function doubleClickHandler(handler) {
      this.register();
      this._doubleClickHandler(handler);
      return this;
    }
  }, {
    key: "_dragOperation",
    value: function _dragOperation(operation) {
      var _this12 = this;
      if (operation === this._dragOp) return;
      this._dragOp && this.root.undrag();
      this._dragOp = operation;
      if (operation) {
        var accepted = false;
        var dragMove = function dragMove(dx, dy, x, y, event) {
          if (accepted) {
            operation._onDragMove(_this12, dx, dy, x, y, event);
          }
          event.stopPropagation();
        };
        var dragStart = function dragStart(x, y, event) {
          accepted = operation._accept(_this12, x, y, event);
          if (accepted) {
            operation._onDragStart(_this12, x, y, event);
          }
          event.stopPropagation();
        };
        var dragEnd = function dragEnd(event) {
          if (accepted) {
            operation._onDrop(_this12, event);
          }
          //event.stopPropagation();
        };
        this.root.drag(dragMove, dragStart, dragEnd);
      }
    }
  }, {
    key: "_clickHandler",
    value: function _clickHandler(handler) {
      var _this13 = this;
      this._clickHdl = handler;
      this.clickHdlImpl && this.root.unclick(this.clickHdlImpl);
      this.clickHdlImpl = function (event) {
        if (!_context.default.isScrollActivated()) {
          var selectedElement = _this13.selectable();
          if (selectedElement) {
            _context.default.groupManager.selectElement(_this13, event, true);
            handler && handler.call(_this13, event);
          }
        }
        event.stopPropagation();
      };
      this.root.click(this.clickHdlImpl);
    }
  }, {
    key: "_doubleClickHandler",
    value: function _doubleClickHandler(handler) {
      var _this14 = this;
      this._dblClickHdl = handler;
      this.doubleClickHdlImpl && this.root.undblclick(this.doubleClickHdlImpl);
      this.doubleClickHdlImpl = function (event) {
        if (!_context.default.isScrollActivated()) {
          var selectedElement = _this14.selectable();
          if (selectedElement) {
            _context.default.groupManager.selectElement(selectedElement, event);
            handler && handler.call(_this14, event);
          }
        }
        event.stopPropagation();
      };
      this.root.dblclick(this.doubleClickHdlImpl);
    }
  }, {
    key: "draggedFrom",
    value: function draggedFrom(parent) {
      this.origin = this.memento();
      if (this.origin.parent && this.origin.parent.remove) {
        this.origin.parent.remove(this);
      }
    }
  }, {
    key: "droppedIn",
    value: function droppedIn(parent) {}
  }, {
    key: "cancelDrop",
    value: function cancelDrop() {
      if (this.origin) {
        this.revert(this.origin);
        this.recover && this.recover(this.origin);
        this.origin.parent && this.origin.parent.add(this);
        delete this.origin;
      }
    }
  }, {
    key: "dropCancelled",
    value: function dropCancelled() {
      return !this.origin;
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      if (element.free) return true;
      if (element.INVALID) {
        console.log("cancelDrop: invalid drop");
        delete element.INVALID;
        return false;
      } else return undefined;
    }
  }, {
    key: "register",
    value: function register() {
      _context.default.memento.keep(this);
    }
  }, {
    key: "x",
    get: function get() {
      return -this.width / 2;
    }
  }, {
    key: "y",
    get: function get() {
      return -this.height / 2;
    }
  }, {
    key: "width",
    get: function get() {
      return 0;
    }
  }, {
    key: "height",
    get: function get() {
      return 0;
    }
  }, {
    key: "left",
    get: function get() {
      return this.x;
    }
  }, {
    key: "right",
    get: function get() {
      return this.x + this.width;
    }
  }, {
    key: "top",
    get: function get() {
      return this.y;
    }
  }, {
    key: "bottom",
    get: function get() {
      return this.y + this.height;
    }
  }, {
    key: "posX",
    get: function get() {
      return this.localTranslation.x(0, 0);
    }
  }, {
    key: "posY",
    get: function get() {
      return this.localTranslation.y(0, 0);
    }
  }, {
    key: "posLeft",
    get: function get() {
      return this.localTranslation.x(-this.width / 2, 0);
    }
  }, {
    key: "posRight",
    get: function get() {
      return this.localTranslation.x(this.width / 2, 0);
    }
  }, {
    key: "posTop",
    get: function get() {
      return this.localTranslation.y(0, -this.height / 2);
    }
  }, {
    key: "posBottom",
    get: function get() {
      return this.localTranslation.y(0, this.height / 2);
    }
  }, {
    key: "parent",
    value: function parent() {
      var parent = this.root ? this.root.parent() : null;
      while (parent) {
        if (parent.owner) return parent.owner;
        parent = parent.parent ? parent.parent() : null;
      }
      return null;
    }
  }, {
    key: "firstChild",
    value: function firstChild() {
      var children = this.content.children();
      return children[0] ? children[0].owner : undefined;
    }
  }, {
    key: "hover",
    value: function hover(element) {
      var _computePosition4 = computePosition(element.root, this.root),
        x = _computePosition4.x,
        y = _computePosition4.y;
      var width = this.width;
      var height = this.height;
      return x >= -width / 2 && x <= width / 2 && y >= -height / 2 && y <= height / 2;
    }
  }, {
    key: "_children",
    value: function _children() {
      var children = new List();
      var _iterator30 = _createForOfIteratorHelper(this.content.children()),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var child = _step30.value;
          child.owner && children.add(child.owner);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      return children;
    }
  }, {
    key: "children",
    value: function children() {
      return this._children();
    }
  }, {
    key: "descendants",
    value: function descendants() {
      var children = this.children();
      for (var _i4 = 0, _arr4 = (0, _toConsumableArray2.default)(children); _i4 < _arr4.length; _i4++) {
        var child = _arr4[_i4];
        children.push.apply(children, (0, _toConsumableArray2.default)(child.descendants()));
      }
      return children;
    }
  }, {
    key: "translate",
    value: function translate(transform) {
      this.register();
      this.root.localMatrix = transform;
      this._dispatchChange("move", transform);
    }
  }, {
    key: "visible",
    value: function visible() {
      var visibleAttr = this.root.attr("visibility");
      return !visibleAttr || visibleAttr === "visible";
    }
  }, {
    key: "show",
    value: function show() {
      this.root.attr({
        visibility: "visible"
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.root.attr({
        visibility: "hidden"
      });
    }
  }, {
    key: "_getPosition",
    value: function _getPosition(element) {
      var split = this.globalChange.multLeft(element.globalChange.invert()).split();
      return {
        x: split.dx,
        y: split.dy
      };
    }
  }, {
    key: "_setPosition",
    value: function _setPosition(x, y) {
      this.translate(new _snap.default.Matrix().translate(x, y));
    }
  }, {
    key: "position",
    value: function position(x, y) {
      if (arguments.length === 1 && arguments[0] instanceof BoardElement) {
        var element = arguments[0];
        return this._getPosition(element);
      } else {
        this._setPosition(x, y);
        return this;
      }
    }
  }, {
    key: "registerParent",
    value: function registerParent() {
      if (this.parent() && this.parent().register) {
        this.parent().register();
      }
    }
  }, {
    key: "_add",
    value: function _add(element) {
      this.content.add(element.root);
    }
  }, {
    key: "add",
    value: function add(element) {
      if (element.parent() !== this) {
        this.register();
        var parent = element.parent();
        parent && element._dispatchChange("removed", parent);
        parent && parent._dispatchChange && parent._dispatchChange("remove", element);
        this._add(element);
        element._dispatchChange("added", this);
        this._dispatchChange("add", element);
      }
      return this;
    }
  }, {
    key: "remove",
    value: function remove(element) {
      this.register();
      var parent = element.parent();
      if (parent === this) {
        element.removeSelf();
      }
      return this;
    }
  }, {
    key: "removeSelf",
    value: function removeSelf() {
      this.register();
      this.registerParent();
      var parent = this.parent();
      this.root.remove();
      if (parent) {
        this._dispatchChange("removed", parent);
        if (parent._dispatchChange) {
          parent._dispatchChange("remove", this);
        }
      }
      return this;
    }
  }, {
    key: "removeMe",
    value: function removeMe() {
      this.removeSelf();
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return null;
    }
  }, {
    key: "globalX",
    value: function globalX() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var matrix = this.globalChange;
      return matrix.x(x, y);
    }
  }, {
    key: "globalY",
    value: function globalY() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var matrix = this.globalChange;
      return matrix.y(x, y);
    }
  }, {
    key: "globalWidth",
    get: function get() {
      var factor = this.globalChange.split().scalex;
      return this.width * factor;
    }
  }, {
    key: "globalHeight",
    get: function get() {
      var factor = this.globalChange.split().scaley;
      return this.height * factor;
    }
  }, {
    key: "localX",
    value: function localX() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var matrix = this.globalChange.invert();
      return matrix.x(x, y);
    }
  }, {
    key: "localY",
    value: function localY() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var matrix = this.globalChange.invert();
      return matrix.y(x, y);
    }
  }, {
    key: "host",
    get: function get() {
      return this.parent().hostable;
    }
  }, {
    key: "hostable",
    get: function get() {
      return this.parent().hostable;
    }
  }, {
    key: "copy",
    value: function copy(elements) {
      var copy = this.duplicate();
      if (this.highlightColor) {
        copy.applyHighlight(this.highlightColor);
      }
      elements.set(this, copy);
      this.copyContent(copy, elements);
      return copy;
    }
  }, {
    key: "copyContent",
    value: function copyContent(copy, elements) {
      var _iterator31 = _createForOfIteratorHelper(this.children()),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var child = _step31.value;
          if (!elements.get(child)) {
            var childCopy = child.copy(elements);
            childCopy.position(child.posX, child.posY);
            copy._add(childCopy);
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      var _iterator32 = _createForOfIteratorHelper(this.children()),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var element = _step32.value;
          element.linkContent(elements);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return {
        id: this.modelId(),
        type: this.type
      };
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = {
        id: this.id,
        model: this.modelId(),
        locked: this.fixed
      };
      if (this.comment()) {
        result.comment = this.comment();
      }
      return result;
    }
  }, {
    key: "serialize",
    value: function serialize(models, objects) {
      if (!models.has(this.modelId())) {
        models.set(this.modelId(), this.serializeModel());
      }
      var current = this.serializeSpec();
      current.highlightColor = this.highlightColor;
      objects.set(this, current);
      this.serializeChildren(models, current, objects);
      return current;
    }
  }, {
    key: "serializeChild",
    value: function serializeChild(element, models, current, objects) {
      if (element.free) {
        var result = element.serialize(models, objects);
        if (!current.free) current.free = [];
        current.free.push(result);
        result.x = element.posX;
        result.y = element.posY;
      } else {
        var _result = element.serialize(models, objects);
        current.children.push(_result);
      }
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      var _iterator33 = _createForOfIteratorHelper(this.children()),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var element = _step33.value;
          this.serializeChild(element, models, current, objects);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
    }
  }, {
    key: "endSerialize",
    value: function endSerialize(models, objects) {
      var _iterator34 = _createForOfIteratorHelper(this.children()),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var element = _step34.value;
          element.endSerialize(models, objects);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      built.set(spec.id, this);
      if (spec.highlightColor) {
        this.applyHighlight(spec.highlightColor);
      }
      this.startDeserializeChildren(spec, models, built);
    }
  }, {
    key: "startDeserializeFreeChild",
    value: function startDeserializeFreeChild(childSpec, models, built) {
      var freeElement = BoardElement.deserializeItem(childSpec, models, built);
      freeElement.free = true;
      freeElement.position(childSpec.x, childSpec.y);
      return freeElement;
    }
  }, {
    key: "startDeserializeChild",
    value: function startDeserializeChild(childSpec, models, built) {
      return BoardElement.deserializeItem(childSpec, models, built);
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      if (spec.children) {
        var _iterator35 = _createForOfIteratorHelper(spec.children),
          _step35;
        try {
          for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
            var childSpec = _step35.value;
            this._add(this.startDeserializeChild(childSpec, models, built));
          }
        } catch (err) {
          _iterator35.e(err);
        } finally {
          _iterator35.f();
        }
      }
      if (spec.free) {
        var _iterator36 = _createForOfIteratorHelper(spec.free),
          _step36;
        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var _childSpec = _step36.value;
            this._add(this.startDeserializeFreeChild(_childSpec, models, built));
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }
      }
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      this.endDeserializeChildren(spec, built);
    }
  }, {
    key: "endDeserializeChildren",
    value: function endDeserializeChildren(spec, built) {
      if (spec.children) {
        var _iterator37 = _createForOfIteratorHelper(spec.children),
          _step37;
        try {
          for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
            var childSpec = _step37.value;
            var element = built.get(childSpec.id);
            element.endDeserialize(childSpec, built);
          }
        } catch (err) {
          _iterator37.e(err);
        } finally {
          _iterator37.f();
        }
      }
      if (spec.free) {
        var _iterator38 = _createForOfIteratorHelper(spec.free),
          _step38;
        try {
          for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
            var _childSpec2 = _step38.value;
            var _element = built.get(_childSpec2.id);
            _element.endDeserialize(_childSpec2, built);
          }
        } catch (err) {
          _iterator38.e(err);
        } finally {
          _iterator38.f();
        }
      }
    }
  }, {
    key: "onWorkingSpace",
    value: function onWorkingSpace() {
      var parent = this.root.parent();
      while (parent != null) {
        if (parent === _context.default.canvas.base) {
          return true;
        }
        parent = parent.parent();
      }
      return false;
    }
  }, {
    key: "onCatalogBuilder",
    value: function onCatalogBuilder() {
      var parent = this.root.parent();
      while (parent != null) {
        if (_context.default.isBuilder(parent.owner)) {
          return parent.owner;
        }
        parent = parent.parent();
      }
      return null;
    }
  }], [{
    key: "deserializeItem",
    value: function deserializeItem(spec, models, built) {
      var model = models.get(spec.model);
      var child = window["Board" + model.type].build(spec, models);
      child.id = spec.id;
      child.startDeserialize(spec, models, built);
      return child;
    }
  }]);
}();
window.BoardSupport = /*#__PURE__*/function (_BoardElement) {
  function BoardSupport(ownedOnContent) {
    var _this15;
    (0, _classCallCheck2.default)(this, BoardSupport);
    _this15 = _callSuper(this, BoardSupport, [ownedOnContent]);
    _this15._dragOperation(_context.default.parentDrag);
    return _this15;
  }
  (0, _inherits2.default)(BoardSupport, _BoardElement);
  return (0, _createClass2.default)(BoardSupport, [{
    key: "child",
    get: function get() {
      var children = this.children();
      return children.length ? children[0] : null;
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      return this.parent() ? this.parent().collectMenuOptions() : new List();
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this.parent() ? this.parent().selectable() : null;
    }
  }]);
}(BoardElement);
var Decoration = exports.Decoration = /*#__PURE__*/function () {
  function Decoration(host, image, index, action) {
    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        width: 16,
        height: 16,
        opacity: 0.8
      },
      width = _ref.width,
      height = _ref.height,
      opacity = _ref.opacity;
    (0, _classCallCheck2.default)(this, Decoration);
    this.host = host;
    this.index = index;
    this.position = 0;
    this.root = host.decorate.image(image, 0, 0, width, height);
    this.root.attr({
      opacity: opacity
    });
    if (action) {
      this.root.click(action);
    }
  }
  return (0, _createClass2.default)(Decoration, [{
    key: "adjust",
    value: function adjust() {
      this.host.decorate.add(this.root);
      this.root.attr({
        x: this.host.width / 2 - 18 * this.position,
        y: -this.host.height / 2 + 2
      });
    }
  }, {
    key: "remove",
    value: function remove() {
      delete this.host.decorations[this.index];
    }
  }]);
}();
window.BoardItem = /*#__PURE__*/function (_BoardElement2) {
  function BoardItem(width, height) {
    var _this17;
    var _this16;
    (0, _classCallCheck2.default)(this, BoardItem);
    _this16 = _callSuper(this, BoardItem);
    _this16._width = width;
    _this16._height = height;
    _this16.fixed = false;
    _this16.createContextMenu();
    for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
      args[_key5 - 2] = arguments[_key5];
    }
    (_this17 = _this16).createShape.apply(_this17, [width, height].concat(args));
    _this16.free = false;
    _this16.observe(_context.default.visualizer);
    _this16._visualization();
    _this16._clickHandler(null);
    _this16.carried = new Set();
    _this16.carriedBy = new Set();
    _this16.sticked = new Set();
    _this16.stickedTo = new Set();
    _this16.decorations = new List();
    _this16.selectFrame = _this16.root.rect(-_this16.width / 2, -_this16.height / 2, _this16.width, _this16.height).attr({
      stroke: "none",
      "stroke-width": 3.5,
      fill: "none",
      opacity: 0.75
    });
    new Observer(function (source, type, value) {
      if (source === _this16 && type === "geometry") {
        if (_this16.highlightColor) {
          _this16.applyHighlight(_this16.highlightColor);
        }
        var _iterator39 = _createForOfIteratorHelper(_this16.decorations),
          _step39;
        try {
          for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
            var decoration = _step39.value;
            if (decoration) {
              decoration.adjust();
            }
          }
        } catch (err) {
          _iterator39.e(err);
        } finally {
          _iterator39.f();
        }
      }
    })._observe(_this16);
    return _this16;
  }
  (0, _inherits2.default)(BoardItem, _BoardElement2);
  return (0, _createClass2.default)(BoardItem, [{
    key: "width",
    get: function get() {
      return this._width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
  }, {
    key: "_resize",
    value: function _resize(width, height) {
      this._width = width;
      this._height = height;
      this.selectFrame.attr({
        x: -this.width / 2,
        y: -this.height / 2,
        width: this.width,
        height: this.height
      });
    }
  }, {
    key: "createShape",
    value: function createShape() {
      this.frame = this.owned.group();
      this.plain = this.owned.group();
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeCopyPastable();
      this.makeRemovable();
      this.makeFixable();
      this.makeGroupable();
      this.makeCommentOwner();
      this.makeHighlightable();
      this.makeFavorizable();
    }
  }, {
    key: "addDecoration",
    value: function addDecoration(image, index, action, options) {
      this.register();
      var decorations = (0, _toConsumableArray2.default)(this.decorations);
      this.removeDecoration(index);
      this.decorations.add(new Decoration(this, image, index, action, options));
      this.adjustDecorations(decorations);
    }
  }, {
    key: "removeDecoration",
    value: function removeDecoration(index) {
      this.register();
      var decorations = (0, _toConsumableArray2.default)(this.decorations);
      this.decorations = this.decorations.filter(function (decoration) {
        return decoration.index !== index;
      });
      this.adjustDecorations(decorations);
    }
  }, {
    key: "adjustDecorations",
    value: function adjustDecorations(previous) {
      var _iterator40 = _createForOfIteratorHelper(previous),
        _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var previousDecoration = _step40.value;
          previousDecoration.root.remove();
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      this.decorations.sort(function (left, right) {
        return left.index - right.index;
      });
      for (var position = 0; position < this.decorations.length; position++) {
        this.decorations[position].position = position + 1;
        this.decorations[position].adjust();
      }
    }
  }, {
    key: "setCommentTip",
    value: function setCommentTip() {
      var _this18 = this;
      if (this.commentText) {
        this.tooltip = _snap.default.parse("<title>".concat(this.commentText, "</title>")).select("title");
        this.owned.add(this.tooltip);
        this.addDecoration(assets.icons.commentsTip, 1, function () {
          return _context.default.editComment([_this18]);
        }, {
          width: 16,
          height: 12,
          opacity: 0.8
        });
      } else {
        this.removeDecoration(1);
        delete this.tooltip;
      }
    }
  }, {
    key: "comment",
    value: function comment(commentText) {
      if (commentText !== undefined) {
        this.register();
        this._comment(commentText);
      }
      return this.commentText;
    }
  }, {
    key: "_comment",
    value: function _comment(commentText) {
      this.tooltip && this.tooltip.remove();
      this.commentText = commentText;
      this.setCommentTip();
    }
  }, {
    key: "cancelDrop",
    value: function cancelDrop() {
      var _iterator41 = _createForOfIteratorHelper(this.carried),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var record = _step41.value;
          console.log("cancelDrop: carrier ask for cancel");
          record.element.cancelDrop();
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
      var _iterator42 = _createForOfIteratorHelper(this.sticked),
        _step42;
      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var _record2 = _step42.value;
          console.log("cancelDrop: associated ask for cancel");
          _record2.element.cancelDrop();
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
      _superPropGet(BoardItem, "cancelDrop", this, 3)([]);
    }
  }, {
    key: "removeMe",
    value: function removeMe() {
      _superPropGet(BoardItem, "removeMe", this, 3)([]);
      var _iterator43 = _createForOfIteratorHelper(this.carried),
        _step43;
      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var record = _step43.value;
          this.removeCarried(record.element);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
      var _iterator44 = _createForOfIteratorHelper(this.sticked),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var _record3 = _step44.value;
          this.removeSticked(_record3.element);
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      var _iterator45 = _createForOfIteratorHelper(this.carriedBy),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var element = _step45.value;
          element.removeCarried(this);
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
      var _iterator46 = _createForOfIteratorHelper(this.stickedTo),
        _step46;
      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var _element2 = _step46.value;
          _element2.removeSticked(this);
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    }
  }, {
    key: "_adjustPosition",
    value: function _adjustPosition(x, y) {
      var dx = x - this.posX;
      var dy = y - this.posY;
      this.position(x, y);
      return {
        dx: dx,
        dy: dy
      };
    }
  }, {
    key: "adjustPosition",
    value: function adjustPosition(x, y) {
      var _this$_adjustPosition = this._adjustPosition(x, y),
        dx = _this$_adjustPosition.dx,
        dy = _this$_adjustPosition.dy;
      var _iterator47 = _createForOfIteratorHelper(this.carried),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var record = _step47.value;
          var element = record.element;
          element.adjustPosition(this.posX + record.dx, this.posY + record.dy);
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
      var _iterator48 = _createForOfIteratorHelper(this.sticked),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var _record4 = _step48.value;
          var _element3 = _record4.element;
          _element3.adjustPosition(this.posX + _record4.dx, this.posY + _record4.dy);
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
    }
  }, {
    key: "fix",
    value: function fix(fixed) {
      if (_context.default.isFixable(this)) {
        this.register();
        this.fixed = fixed;
        this.fixing();
      }
    }
  }, {
    key: "fixing",
    value: function fixing() {
      if (this.isFixed()) {
        this.addDecoration(assets.icons.lockTip, 2, undefined, {
          width: 8,
          height: 8,
          opacity: 0.3
        });
        this.dragOperation(_context.default.parentDrag);
      } else {
        this.removeDecoration(2);
        this.dragOperation(_context.default.standardDrag);
      }
    }
  }, {
    key: "isFixed",
    value: function isFixed() {
      return this.fixed;
    }
  }, {
    key: "selectable",
    value: function selectable() {
      if (!this.onWorkingSpace()) {
        if (this.carriedBy.size) {
          return this.carriedBy.values().next().value.selectable();
        } else if (this.stickedTo.size) {
          return this.stickedTo.values().next().value.selectable();
        } else if (this.parent() === null || !this.parent().selectable) {
          return this;
        } else {
          return this.parent().selectable();
        }
      } else {
        return this;
      }
    }
  }, {
    key: "select",
    value: function select() {
      this.selectFrame.attr({
        stroke: _context.default.GREEN
      });
    }
  }, {
    key: "unselect",
    value: function unselect() {
      this.selectFrame.attr({
        stroke: "none"
      });
    }
  }, {
    key: "moveable",
    value: function moveable() {
      return !this.isFixed();
    }
  }, {
    key: "removable",
    value: function removable() {
      return !this.isFixed();
    }
  }, {
    key: "copy",
    value: function copy(elements) {
      var copy = _superPropGet(BoardItem, "copy", this, 3)([elements]);
      copy.free = this.free;
      copy.fixed = this.fixed;
      copy.comment(this.comment());
      copy.setCommentTip();
      return copy;
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      _superPropGet(BoardItem, "linkContent", this, 3)([elements]);
      var copy = elements.get(this);
      var _iterator49 = _createForOfIteratorHelper(this.carried),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var record = _step49.value;
          copy.addCarried(elements.get(record.element));
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
      var _iterator50 = _createForOfIteratorHelper(this.sticked),
        _step50;
      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var _record5 = _step50.value;
          copy.addSticked(elements.get(_record5.element));
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
      copy.fixing();
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      var _iterator51 = _createForOfIteratorHelper(this.children()),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var element = _step51.value;
          if (!element.free) {
            var result = element.serialize(models, objects);
            current.children.push(result);
          }
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
    }
  }, {
    key: "endSerialize",
    value: function endSerialize(models, objects) {
      var spec = objects.get(this);
      if (this.carried.size > 0) {
        spec.carried = [];
        var _iterator52 = _createForOfIteratorHelper(this.carried.values()),
          _step52;
        try {
          for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
            var record = _step52.value;
            var elemSpec = objects.get(record.element);
            spec.carried.push(elemSpec.id);
          }
        } catch (err) {
          _iterator52.e(err);
        } finally {
          _iterator52.f();
        }
      }
      if (this.sticked.size > 0) {
        spec.sticked = [];
        var _iterator53 = _createForOfIteratorHelper(this.sticked.values()),
          _step53;
        try {
          for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
            var _record6 = _step53.value;
            var _elemSpec = objects.get(_record6.element);
            spec.sticked.push(_elemSpec.id);
          }
        } catch (err) {
          _iterator53.e(err);
        } finally {
          _iterator53.f();
        }
      }
      _superPropGet(BoardItem, "endSerialize", this, 3)([models, objects]);
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      if (spec.carried) {
        var _iterator54 = _createForOfIteratorHelper(spec.carried),
          _step54;
        try {
          for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
            var elemId = _step54.value;
            var element = built.get(elemId);
            this.addCarried(element);
          }
        } catch (err) {
          _iterator54.e(err);
        } finally {
          _iterator54.f();
        }
      }
      if (spec.sticked) {
        var _iterator55 = _createForOfIteratorHelper(spec.sticked),
          _step55;
        try {
          for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
            var _elemId = _step55.value;
            var _element4 = built.get(_elemId);
            this.addSticked(_element4);
          }
        } catch (err) {
          _iterator55.e(err);
        } finally {
          _iterator55.f();
        }
      }
      _superPropGet(BoardItem, "endDeserialize", this, 3)([spec, built]);
      this.setCommentTip();
      this._comment(spec.comment);
      this.fixed = spec.locked;
      this.fixing();
    }
  }, {
    key: "_visualizeRealistic",
    value: function _visualizeRealistic() {
      if (_context.default.visualizer.realistic) {
        this.owned.node.append(this.plain.node);
      } else {
        this.plain.node.remove();
      }
    }
  }, {
    key: "_visualization",
    value: function _visualization() {
      this._visualizeRealistic();
      this.highlight.attr({
        opacity: _context.default.visualizer.highlight ? 1 : 0
      });
      this.decorate && this.decorate.attr({
        opacity: _context.default.visualizer.legend ? 1 : 0
      });
    }
  }, {
    key: "addCarried",
    value: function addCarried(element) {
      this.register();
      this.carried.add({
        element: element,
        dx: element.posX - this.posX,
        dy: element.posY - this.posY
      });
      element.register();
      element.carriedBy.add(this);
    }
  }, {
    key: "removeCarried",
    value: function removeCarried(element) {
      this.register();
      for (var _i5 = 0, _arr5 = (0, _toConsumableArray2.default)(this.carried); _i5 < _arr5.length; _i5++) {
        var record = _arr5[_i5];
        if (record.element === element) this.carried.delete(record);
      }
      element.register();
      element.carriedBy.delete(this);
    }
  }, {
    key: "addSticked",
    value: function addSticked(element) {
      this.register();
      this.sticked.add({
        element: element,
        dx: element.posX - this.posX,
        dy: element.posY - this.posY
      });
      element.register();
      element.stickedTo.add(this);
    }
  }, {
    key: "removeSticked",
    value: function removeSticked(element) {
      this.register();
      for (var _i6 = 0, _arr6 = (0, _toConsumableArray2.default)(this.sticked); _i6 < _arr6.length; _i6++) {
        var record = _arr6[_i6];
        if (record.element === element) this.sticked.delete(record);
      }
      element.register();
      element.stickedTo.delete(this);
    }
  }, {
    key: "callForMove",
    value: function callForMove() {
      var _this19 = this;
      _context.default.canvas.openModal(moveItems, {
        x: this.posX / _context.default.rescaleFactor,
        xRelative: false,
        y: this.posY / _context.default.rescaleFactor,
        yRelative: false
      }, function (data) {
        _context.default.moveSelection(data.x * _context.default.rescaleFactor, data.xRelative, data.y * _context.default.rescaleFactor, data.yRelative, _this19);
      });
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardItem, "memento", this, 3)([]);
      memento._width = this._width;
      memento._height = this._height;
      memento.free = this.free;
      memento.fixed = this.fixed;
      memento.commentText = this.commentText;
      memento.tooltip = this.tooltip;
      memento.frameMatrix = this.frame.transform().localMatrix;
      memento.plainMatrix = this.plain.transform().localMatrix;
      memento.frame = (0, _toConsumableArray2.default)(this.frame.children());
      memento.plain = (0, _toConsumableArray2.default)(this.plain.children());
      memento.carried = (0, _toConsumableArray2.default)(this.carried.values());
      memento.carriedBy = (0, _toConsumableArray2.default)(this.carriedBy.values());
      memento.sticked = (0, _toConsumableArray2.default)(this.sticked.values());
      memento.stickedTo = (0, _toConsumableArray2.default)(this.stickedTo.values());
      memento.decorations = (0, _toConsumableArray2.default)(this.decorations);
      if (this.commentTip) {
        memento.commentTip = this.commentTip;
      }
      if (this.fixingTip) {
        memento.fixingTip = this.fixingTip;
      }
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardItem, "revert", this, 3)([memento]);
      this._width = memento._width;
      this._height = memento._height;
      this.free = memento.free;
      this.fixed = memento.fixed;
      this.frame.transform(memento.frameMatrix);
      this.plain.transform(memento.plainMatrix);
      var _iterator56 = _createForOfIteratorHelper(this.frame.children()),
        _step56;
      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var child = _step56.value;
          child.node.parentNode.removeChild(child.node);
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
      var _iterator57 = _createForOfIteratorHelper(memento.frame),
        _step57;
      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var _child8 = _step57.value;
          this.frame.add(_child8);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
      var _iterator58 = _createForOfIteratorHelper(this.plain.children()),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var _child9 = _step58.value;
          _child9.node.parentNode.removeChild(_child9.node);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
      var _iterator59 = _createForOfIteratorHelper(memento.plain),
        _step59;
      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var _child0 = _step59.value;
          this.plain.add(_child0);
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
      this.commentText = memento.commentText;
      this.tooltip = memento.tooltip;
      this.carried = new Set(memento.carried);
      this.carriedBy = new Set(memento.carriedBy);
      this.sticked = new Set(memento.sticked);
      this.stickedTo = new Set(memento.stickedTo);
      var decorations = (0, _toConsumableArray2.default)(this.decorations);
      this.decorations = (0, _construct2.default)(List, (0, _toConsumableArray2.default)(memento.decorations));
      this.adjustDecorations(decorations);
      if (memento.commentTip) {
        this.commentTip = memento.commentTip;
      }
      if (memento.fixingTip) {
        this.fixingTip = memento.fixingTip;
      }
      this._visualization();
    }
  }, {
    key: "clickable",
    value: function clickable() {
      return true;
    }
  }, {
    key: "makeFixable",
    value: function makeFixable() {
      var _this20 = this;
      var fixMenuOption = _context.default.fixMenuOption.instance(function () {
        _context.default.fixSelection(true, _this20);
      }, function () {
        _context.default.fixSelection(false, _this20);
      }, function () {
        return _context.default.selectionFixed(_this20);
      }, function () {
        return _context.default.isFixable(_this20);
      });
      this._addMenuOption(fixMenuOption);
    }
  }, {
    key: "makeRemovable",
    value: function makeRemovable() {
      var _this21 = this;
      this._addMenuOption(_context.default.removeMenuOption.instance(function () {
        _context.default.deleteSelectedElements(_this21);
      }, function () {
        return _context.default.removableInSelection(_this21);
      }));
    }
  }, {
    key: "makeCommentOwner",
    value: function makeCommentOwner() {
      var _this22 = this;
      var commentMenuOption = _context.default.commentMenuOption.instance(function () {
        _context.default.editComment(_this22);
      }, function () {
        return _context.default.isWorkingSelectionNotEmplty();
      });
      this._addMenuOption(commentMenuOption);
    }
  }, {
    key: "makeCopyPastable",
    value: function makeCopyPastable() {
      var _this23 = this;
      var copyMenuOption = _context.default.copyMenuOption.instance(function () {
        _context.default.copyFunction(_this23);
      }, function () {
        return _context.default.isWorkingSelectionNotEmplty();
      });
      this._addMenuOption(copyMenuOption);
      var pasteMenuOption = _context.default.pasteMenuOption.instance(function () {
        _context.default.pasteFunction();
      }, function () {
        return _context.default.copyPasteManager.pastable;
      });
      this._addMenuOption(pasteMenuOption);
    }
  }, {
    key: "makeGroupable",
    value: function makeGroupable() {
      var _this24 = this;
      var groupMenuOption = _context.default.groupMenuOption.instance(function () {
        _context.default.regroup(_this24);
      }, function () {
        return _context.default.isGroupable(_this24);
      });
      this._addMenuOption(groupMenuOption);
      var ungroupMenuOption = _context.default.ungroupMenuOption.instance(function () {
        _context.default.ungroup(_this24);
      }, function () {
        return _context.default.isUngroupable(_this24);
      });
      this._addMenuOption(ungroupMenuOption);
    }
  }, {
    key: "makeHighlightable",
    value: function makeHighlightable() {
      var _this25 = this;
      var highlightMenuOption = _context.default.highlightMenuOption.instance(function (color) {
        _context.default.highlightSelection(color, _this25);
      });
      this._addMenuOption(highlightMenuOption);
    }
  }, {
    key: "makeFavorizable",
    value: function makeFavorizable() {
      var _this26 = this;
      this._addMenuOption(_context.default.addToFavoritesMenuOption.instance(function () {
        _context.default.addToFavorites(_this26);
      }));
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      _superPropGet(BoardItem, "changed", this, 3)([source, type, value]);
      if (source === _context.default.visualizer) {
        this._visualization();
      }
    }
  }]);
}(BoardElement);
window.BoardLayer = /*#__PURE__*/function (_BoardElement3) {
  function BoardLayer(owner, sizeMargin) {
    var _this27;
    (0, _classCallCheck2.default)(this, BoardLayer);
    _this27 = _callSuper(this, BoardLayer);
    _this27.owner = owner;
    _this27.sizeMargin = sizeMargin;
    return _this27;
  }
  (0, _inherits2.default)(BoardLayer, _BoardElement3);
  return (0, _createClass2.default)(BoardLayer, [{
    key: "register",
    value: function register() {
      _superPropGet(BoardLayer, "register", this, 3)([]);
      this.owner.register();
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardLayer, "memento", this, 3)([]);
      memento.owner = this.owner;
      memento.sizeMargin = this.sizeMargin;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardLayer, "revert", this, 3)([memento]);
      this.owner = memento.owner;
      this.sizeMargin = memento.sizeMargin;
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value) {
      _superPropGet(BoardLayer, "_dispatchChange", this, 3)([type, value]);
      this.owner._dispatchChange(type, value);
    }
  }, {
    key: "width",
    get: function get() {
      return this.parent().width - this.sizeMargin * 2;
    }
  }, {
    key: "height",
    get: function get() {
      return this.parent().height - this.sizeMargin * 2;
    }
  }, {
    key: "show",
    value: function show() {
      this.root.add(this.content);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.content.remove();
    }
  }]);
}(BoardElement);
window.BoardArea = /*#__PURE__*/function (_BoardElement4) {
  function BoardArea(width, height, background) {
    var _this28;
    (0, _classCallCheck2.default)(this, BoardArea);
    _this28 = _callSuper(this, BoardArea);
    _this28.rect = _this28.owned.rect(-width / 2, -height / 2, width, height).attr({
      fill: background
    });
    _this28.rect.owner = _this28;
    _this28._dragOperation(_context.default.globalDrag);
    _this28._clickHandler(function (event) {
      _context.default.selection.unselect();
    });
    return _this28;
  }
  (0, _inherits2.default)(BoardArea, _BoardElement4);
  return (0, _createClass2.default)(BoardArea, [{
    key: "dragOp",
    get: function get() {
      return this._dragOp;
    }
  }, {
    key: "color",
    get: function get() {
      return this.rect.attr("fill");
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      this.register();
      this.rect.attr({
        width: width,
        height: height,
        x: -width / 2,
        y: -height / 2
      });
      this._dispatchChange("geometry");
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardArea, "memento", this, 3)([]);
      memento.rect = this.rect;
      memento._dragOp = this._dragOp;
      memento.width = this.width;
      memento.height = this.height;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardArea, "revert", this, 3)([memento]);
      this.rect = memento.rect;
      this.rect.attr({
        width: memento.width,
        height: memento.height,
        x: -memento.width / 2,
        y: -memento.height / 2
      });
      this._dragOp = memento._dragOp;
    }
  }, {
    key: "dragOperation",
    value: function dragOperation(operation) {
      _superPropGet(BoardArea, "register", this, 3)([]);
      this._dragOp = operation;
      this._dragOperation(this.dragOp);
      return this;
    }
  }, {
    key: "width",
    get: function get() {
      return parseFloat(this.rect.attr("width"));
    }
  }, {
    key: "height",
    get: function get() {
      return parseFloat(this.rect.attr("height"));
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      return undefined;
    }
  }]);
}(BoardElement);
var DragHandleOperation = exports.DragHandleOperation = /*#__PURE__*/function (_DragMouseOperation2) {
  function DragHandleOperation() {
    (0, _classCallCheck2.default)(this, DragHandleOperation);
    return _callSuper(this, DragHandleOperation);
  }
  (0, _inherits2.default)(DragHandleOperation, _DragMouseOperation2);
  return (0, _createClass2.default)(DragHandleOperation, [{
    key: "accept",
    value: function accept(element, x, y, event) {
      return true;
    }
  }, {
    key: "doDragStart",
    value: function doDragStart(element, x, y, event) {
      _context.default.memento.open();
      element.register();
      var invertedMatrix = element.globalChange.invert();
      this.dragX = invertedMatrix.x(x, y);
      this.dragY = invertedMatrix.y(x, y);
    }
  }, {
    key: "doDragMove",
    value: function doDragMove(element, dx, dy, x, y, event) {
      var invertedMatrix = element.parent().globalChange.invert();
      var dX = invertedMatrix.x(x, y) - this.dragX;
      var dY = invertedMatrix.y(x, y) - this.dragY;
      element._setPosition(dX, dY);
      element.parent()._receiveMove && element.parent()._receiveMove(element);
    }
  }, {
    key: "doDrop",
    value: function doDrop(element, x, y, event) {
      element.parent()._receiveDrop && element.parent()._receiveDrop(element);
    }
  }]);
}(DragMouseOperation);
window.BoardHandle = /*#__PURE__*/function (_BoardItem) {
  function BoardHandle() {
    var _this29;
    (0, _classCallCheck2.default)(this, BoardHandle);
    _this29 = _callSuper(this, BoardHandle, [_context.default.HANDLE_SIZE, _context.default.HANDLE_SIZE]);
    _this29.dragOperation(_context.default.dragHandleOperation);
    _this29.fr = _this29.frame.rect(0, 0, 1, 1).attr({
      stroke: _context.default.GREEN,
      fill: _context.default.WHITE,
      "fill-opacity": 0.001
    });
    _this29._setStroke();
    _this29.fr.owner = _this29;
    _this29.observe(_context.default.canvas);
    return _this29;
  }
  (0, _inherits2.default)(BoardHandle, _BoardItem);
  return (0, _createClass2.default)(BoardHandle, [{
    key: "changed",
    value: function changed(source, type, value) {
      if (type === "zoom") {
        this._setStroke();
      }
    }
  }, {
    key: "_setStroke",
    value: function _setStroke() {
      this.fr.attr({
        x: -this.width / 2 / _context.default.canvas.zoom,
        y: -this.height / 2 / _context.default.canvas.zoom,
        width: this.width / _context.default.canvas.zoom,
        height: this.height / _context.default.canvas.zoom,
        "stroke-width": 1 / _context.default.canvas.zoom
      });
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return null;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardHandle, "memento", this, 3)([]);
      memento.fr = this.fr;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardHandle, "revert", this, 3)([memento]);
      this.fr = memento.fr;
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      return false;
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }]);
}(BoardItem);
function getPdfAreas(boardTable) {
  var areas = new List();
  var _iterator60 = _createForOfIteratorHelper(boardTable.pdfLayer.children()),
    _step60;
  try {
    for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
      var area = _step60.value;
      if (area instanceof BoardPdfArea) {
        areas.add(area);
      }
    }
  } catch (err) {
    _iterator60.e(err);
  } finally {
    _iterator60.f();
  }
  return areas.sort(function (a1, a2) {
    return a1.order - a2.order;
  });
}
function pdfAreaName() {
  var areas = getPdfAreas(_context.default.table);
  var index = 0,
    finished = false,
    name;
  while (!finished) {
    finished = true;
    index++;
    name = "" + index;
    var _iterator61 = _createForOfIteratorHelper(areas),
      _step61;
    try {
      for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
        var area = _step61.value;
        if (area.name === name) finished = false;
      }
    } catch (err) {
      _iterator61.e(err);
    } finally {
      _iterator61.f();
    }
  }
  return name;
}
function getSortedPdfAreas(pdfArea) {
  function getSelectedPdfAreas(pdfAreas) {
    var selected = new List();
    var _iterator62 = _createForOfIteratorHelper(pdfAreas),
      _step62;
    try {
      for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
        var area = _step62.value;
        if (_context.default.selection.selected(area)) {
          selected.add(area);
        }
      }
    } catch (err) {
      _iterator62.e(err);
    } finally {
      _iterator62.f();
    }
    return selected;
  }
  var pdfAreas = getPdfAreas(_context.default.table);
  var selectedPdfAreas = getSelectedPdfAreas(pdfAreas);
  if (pdfArea) selectedPdfAreas.add(pdfArea);
  selectedPdfAreas.sort(function (a1, a2) {
    return a1.order - a2.order;
  });
  return {
    pdfAreas: pdfAreas,
    selectedPdfAreas: selectedPdfAreas
  };
}
window.BoardPdfArea = /*#__PURE__*/function (_BoardItem2) {
  function BoardPdfArea(width, height) {
    var _this30;
    (0, _classCallCheck2.default)(this, BoardPdfArea);
    _this30 = _callSuper(this, BoardPdfArea, [width, height]);
    _this30._name = pdfAreaName();
    _this30._dragOperation(_context.default.movePdfDrag);
    _this30.fr = _this30.frame.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context.default.GREEN,
      fill: _context.default.GREEN,
      "fill-opacity": 0.1
    });
    _this30._setLabel();
    _this30._setStroke();
    _this30.fr.owner = _this30;
    _this30.observe(_context.default.canvas);
    return _this30;
  }
  (0, _inherits2.default)(BoardPdfArea, _BoardItem2);
  return (0, _createClass2.default)(BoardPdfArea, [{
    key: "order",
    get: function get() {
      return this._order;
    },
    set: function set(order) {
      this._order = order;
      this._setLabel();
    }
  }, {
    key: "removeMe",
    value: function removeMe() {
      _superPropGet(BoardPdfArea, "removeMe", this, 3)([]);
      _context.default.table.pdfLayer.reorganize();
    }
  }, {
    key: "menu",
    value: function menu(x, y) {
      this._menu(x, y);
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      var _this31 = this;
      this._addMenuOption(_context.default.foregroundMenuOption.instance(function () {
        _context.default.putSelectedPdfAreaOnForeground(_this31);
      }, function () {
        return !_context.default.selectedPdfAreaAreOnFront(_this31);
      }));
      this._addMenuOption(_context.default.forwardMenuOption.instance(function () {
        _context.default.forwardSelectedArea(_this31);
      }, function () {
        return !_context.default.selectedPdfAreaAreOnFront(_this31);
      }));
      this._addMenuOption(_context.default.backwardMenuOption.instance(function () {
        _context.default.backwardSelectedArea(_this31);
      }, function () {
        return !_context.default.selectedPdfAreaAreOnBack(_this31);
      }));
      this._addMenuOption(_context.default.backgroundMenuOption.instance(function () {
        _context.default.putSelectedPdfAreaOnBackground(_this31);
      }, function () {
        return !_context.default.selectedPdfAreaAreOnBack(_this31);
      }));
    }
  }, {
    key: "copyContent",
    value: function copyContent() {}
  }, {
    key: "linkContent",
    value: function linkContent() {}
  }, {
    key: "fixing",
    value: function fixing() {}
  }, {
    key: "name",
    get: function get() {
      return this._name;
    },
    set: function set(name) {
      this.register();
      this._name = name;
      this._setLabel();
    }
  }, {
    key: "_setLabel",
    value: function _setLabel() {
      this.label && this.label.remove();
      var name = this._name;
      if (this._order) name += " - " + _context.default.pdf.pageLabel + " " + this.order;
      this.label = this.frame.text(-this.width / 2, -this.height / 2, name).attr({
        "font-size": "12px",
        "text-anchor": "start",
        "alignment-baseline": "text-before-edge"
      });
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      if (type === "zoom") {
        this._setStroke();
      }
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardPdfArea(this.width, this.height);
      return copy;
    }
  }, {
    key: "_setStroke",
    value: function _setStroke() {
      this.fr.attr({
        "stroke-width": 1 / _context.default.canvas.zoom
      });
    }
  }, {
    key: "dropTarget",
    value: function dropTarget(elementTarget) {
      return _context.default.table.pdfLayer;
    }
  }, {
    key: "_receiveMove",
    value: function _receiveMove(element) {
      if (element instanceof BoardHandle) {
        var width = this.width;
        var height = this.height;
        var lx = this.posX;
        var ly = this.posY;
        if (element === this._handles.nw || element === this._handles.w || element === this._handles.sw) {
          width = -element.posX + this.width / 2;
          lx += (this.width - width) / 2;
        } else if (element === this._handles.ne || element === this._handles.e || element === this._handles.se) {
          width = element.posX + this.width / 2;
          lx += (width - this.width) / 2;
        }
        if (element === this._handles.nw || element === this._handles.n || element === this._handles.ne) {
          height = -element.posY + this.height / 2;
          ly += (this.height - height) / 2;
        } else if (element === this._handles.sw || element === this._handles.s || element === this._handles.se) {
          height = element.posY + this.height / 2;
          ly += (height - this.height) / 2;
        }
        if (width < 0) {
          width = -width;
          var hdl = this._handles.nw;
          this._handles.nw = this._handles.ne;
          this._handles.ne = hdl;
          hdl = this._handles.w;
          this._handles.w = this._handles.e;
          this._handles.e = hdl;
          hdl = this._handles.sw;
          this._handles.sw = this._handles.se;
          this._handles.se = hdl;
        }
        if (height < 0) {
          height = -height;
          var _hdl = this._handles.nw;
          this._handles.nw = this._handles.sw;
          this._handles.sw = _hdl;
          _hdl = this._handles.n;
          this._handles.n = this._handles.s;
          this._handles.s = _hdl;
          _hdl = this._handles.ne;
          this._handles.ne = this._handles.se;
          this._handles.se = _hdl;
        }
        this.register();
        this._setPosition(lx, ly);
        this._resize(width, height);
      }
    }
  }, {
    key: "_resize",
    value: function _resize(width, height) {
      _superPropGet(BoardPdfArea, "_resize", this, 3)([width, height]);
      this.fr.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
      this.label.attr({
        x: -width / 2,
        y: -height / 2
      });
      this._positionHandles();
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.register();
      this._resize(width, height);
      this._dispatchChange("geometry");
      if (this.parent() && this.parent()._dispatchChange) {
        this.parent()._dispatchChange("child-geometry", this);
      }
    }
  }, {
    key: "update",
    value: function update(data, height) {
      this.register();
      this.resize(data.width * _context.default.rescaleFactor, data.height * _context.default.rescaleFactor);
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardPdfArea, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento._name = this._name;
      memento._order = this._order;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardPdfArea, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this._name = memento._name;
      this._order = memento._order;
      this._resize(memento._width, memento._height);
      this._setLabel();
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      return false;
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }, {
    key: "_positionHandles",
    value: function _positionHandles() {
      if (this._handles) {
        this._handles.nw._setPosition(-this.width / 2, -this.height / 2);
        this._handles.n._setPosition(0, -this.height / 2);
        this._handles.ne._setPosition(this.width / 2, -this.height / 2);
        this._handles.e._setPosition(this.width / 2, 0);
        this._handles.se._setPosition(this.width / 2, this.height / 2);
        this._handles.s._setPosition(0, this.height / 2);
        this._handles.sw._setPosition(-this.width / 2, this.height / 2);
        this._handles.w._setPosition(-this.width / 2, 0);
      }
    }
  }, {
    key: "_putHandles",
    value: function _putHandles() {
      this._handles = {
        nw: new BoardHandle(),
        n: new BoardHandle(),
        ne: new BoardHandle(),
        e: new BoardHandle(),
        se: new BoardHandle(),
        s: new BoardHandle(),
        sw: new BoardHandle(),
        w: new BoardHandle()
      };
      for (var handle in this._handles) {
        this.add(this._handles[handle]);
      }
      this._positionHandles();
    }
  }, {
    key: "_removeHandles",
    value: function _removeHandles() {
      for (var handle in this._handles) {
        this.remove(this._handles[handle]);
      }
      delete this._handles;
    }
  }, {
    key: "select",
    value: function select() {
      this._putHandles();
      _superPropGet(BoardPdfArea, "select", this, 3)([]);
      //this.fr.attr({ filter: Context.selectShadow });
    }
  }, {
    key: "unselect",
    value: function unselect() {
      this._removeHandles();
      _superPropGet(BoardPdfArea, "unselect", this, 3)([]);
      //this.fr.attr({ filter: null });
    }
  }, {
    key: "modelId",
    value: function modelId() {
      var color = this.fr.attr("fill");
      return "PdfArea|l:" + "w:" + this.width + "|h:" + this.height;
    }
  }, {
    key: "type",
    get: function get() {
      return "PdfArea";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardPdfArea, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context.default.rescaleFactor,
        height: this.height / _context.default.rescaleFactor
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = _objectSpread(_objectSpread({}, _superPropGet(BoardPdfArea, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context.default.rescaleFactor,
        y: this.posY / _context.default.rescaleFactor,
        name: this._name,
        order: this._order
      });
      return result;
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren() {}
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardPdfArea, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context.default.rescaleFactor, spec.y * _context.default.rescaleFactor);
      this._name = spec.name;
      this._order = spec.order;
      this._setLabel();
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardPdfArea.create(model.width, model.height);
    }
  }]);
}(BoardItem);
BoardPdfArea.create = function (width, height) {
  return new BoardPdfArea(width * _context.default.rescaleFactor, height * _context.default.rescaleFactor);
};
window.BoardPdfLayer = /*#__PURE__*/function (_BoardLayer) {
  function BoardPdfLayer(owner) {
    (0, _classCallCheck2.default)(this, BoardPdfLayer);
    return _callSuper(this, BoardPdfLayer, [owner, 0]);
  }
  (0, _inherits2.default)(BoardPdfLayer, _BoardLayer);
  return (0, _createClass2.default)(BoardPdfLayer, [{
    key: "receiveDrop",
    value: function receiveDrop(element) {
      return element instanceof BoardPdfArea;
    }
  }, {
    key: "add",
    value: function add(pdfArea) {
      _superPropGet(BoardPdfLayer, "add", this, 3)([pdfArea]);
      if (pdfArea.order === undefined) {
        pdfArea.order = this.children().length;
      }
    }
  }, {
    key: "reorganize",
    value: function reorganize() {
      var pdfAreas = this.children().sort(function (a1, a2) {
        return a1.order - a2.order;
      });
      for (var i = 0; i < pdfAreas.length; i++) {
        pdfAreas[i].order = i + 1;
      }
    }
  }]);
}(BoardLayer);
var Canvas = exports.Canvas = /*#__PURE__*/function () {
  function Canvas(anchor, width, height) {
    (0, _classCallCheck2.default)(this, Canvas);
    this.width = width;
    this.height = height;
    this.anchor = anchor;
    this.canvas = (0, _snap.default)(anchor);
    this.baseRoot = this.canvas.group();
    this.base = this.baseRoot.group();
    this.palette = this.canvas.group();
    this.paletteContent = this.palette.group();
    this.glassSupport = this.canvas.group();
    this.glass = this.glassSupport.group();
    this.glassDownLayer = this.glass.group();
    this.glassMiddleLayer = this.glass.group();
    this.glassUpLayer = this.glass.group();
    this.glassCoverLayer = this.glass.group();
    this.modal = this.canvas.group();
    this.modal.rect(0, 0, width, height).attr({
      fill: _context.default.BLACK,
      opacity: 0.5
    });
    this.modal.attr({
      visibility: "hidden"
    });
    this.observers = new Set();
    this.zoomOnWheel();
    this.manageKeyboardCommands();
    this.manageContextualMenus();
    this.manageGeometryChanges();
  }
  return (0, _createClass2.default)(Canvas, [{
    key: "close",
    value: function close() {
      clearInterval(this.intervalID);
    }
  }, {
    key: "manageGeometryChanges",
    value: function manageGeometryChanges() {
      var _this32 = this;
      var clientWidth = this.clientWidth;
      var clientHeight = this.clientHeight;
      this.intervalID = setInterval(function () {
        if (clientWidth !== _this32.clientWidth || clientHeight !== _this32.clientHeight) {
          _this32.adjustBase(_this32.base.transform().localMatrix);
          clientWidth = _this32.clientWidth;
          clientHeight = _this32.clientHeight;
          _this32._dispatchChange("geometry");
        }
      }, 1000);
    }
  }, {
    key: "manageKeyboardCommands",
    value: function manageKeyboardCommands() {
      var _this33 = this;
      var osMac = navigator.appVersion.toUpperCase().includes("MACINTOSH");
      _context.default.focus().addEventListener("keydown", function (event) {
        var macCommandKey = osMac && event.getModifierState("Meta");
        var processed = false;
        if (!_this33.modalOpened()) {
          if ((event.key === "Delete" || event.key === "Backspace") && event.target.nodeName.toLowerCase() != "input") {
            _context.default.deleteSelectedElements();
          } else if (event.ctrlKey || event.metaKey || macCommandKey) {
            if (event.key === "c") {
              _context.default.copyFunction && _context.default.copyFunction();
              processed = true;
            } else if (event.key === "v") {
              _context.default.pasteFunction && _context.default.pasteFunction();
              processed = true;
            } else if (event.key === "z") {
              _context.default.memento.undo();
              processed = true;
            } else if (event.key === "y") {
              _context.default.memento.redo();
              processed = true;
            } else if (event.key === "x") {
              _context.default.cutFunction && _context.default.cutFunction();
              processed = true;
            } else if (event.key === "g") {
              _context.default.regroup();
              processed = true;
            } else if (event.key === "u") {
              _context.default.ungroup();
              processed = true;
            } else if (event.key === "e") {
              _context.default.editSelected();
              processed = true;
            } else if (event.key === "p") {
              _context.default.print();
              processed = true;
            } else if (event.key === "f") {
              _context.default.addToFavorites(_context.default.selection.workingSelection);
              processed = true;
            } else if (event.key === "m") {
              _context.default.magnetize();
              processed = true;
              _context.default.catalog;
            } else if (event.key === "b") {
              if (_context.default.catalog.minimized) {
                _context.default.catalog.restoreMe();
              } else {
                _context.default.catalog.minimizeMe();
              }
              processed = true;
            } else if (event.key === "+") {
              _context.default.zoomInSelect();
              processed = true;
            } else if (event.key === "-") {
              _context.default.zoomOutSelect();
              processed = true;
            }
          } else if (event.keyCode === 18) {
            _context.default.activateScroll();
            processed = true;
          }
        }
        if (processed) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
      _context.default.focus().addEventListener("keyup", function (event) {
        var macCommandKey = osMac && event.getModifierState("Meta");
        var processed = false;
        if (!_this33.modalOpened()) {
          if (event.keyCode === 18) {
            _context.default.activateSelectArea();
            processed = true;
          }
        }
        if (processed) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }, {
    key: "zoomOnWheel",
    value: function zoomOnWheel() {
      var _this34 = this;
      this.anchor.addEventListener("wheel", function (event) {
        if (!_this34.modalOpened()) {
          var x = _this34.canvasX(event.pageX);
          var y = _this34.canvasY(event.pageY);
          if (event.deltaY > 0) {
            _this34.zoomOut(x, y);
          } else {
            _this34.zoomIn(x, y);
          }
          event.preventDefault();
        }
      });
    }

    /**
     * Canvas setSize not only change size, but also adjust base position in order to let the center to stay at the
     * same position.
     * @param width new width of canvas size
     * @param height new height of canvas size
     */
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      if (width !== this.width || height !== this.height) {
        var dx = width / 2 - this.width / 2;
        var dy = height / 2 - this.height / 2;
        var matrix = this.baseTransform();
        var invert = matrix.invert();
        // Retrieve actual position of canvas client area center
        var x = invert.x(this.clientWidth / 2, this.clientHeight / 2);
        var y = invert.y(this.clientWidth / 2, this.clientHeight / 2);
        this.width = width;
        this.height = height;
        this.baseMove(x + dx, y + dy);
        this.adjustBase();
      }
    }
  }, {
    key: "manageContextualMenus",
    value: function manageContextualMenus() {
      var _this35 = this;
      _context.default.focus().addEventListener("contextmenu", function (event) {
        event.preventDefault();
      });
      _context.default.focus().addEventListener("mousedown", function (event) {
        _this35.closeMenu();
      });
      _context.default.focus().addEventListener("mouseup", function (event) {
        _this35.closeMenu();
      });
      _context.default.focus().addEventListener("wheel", function (event) {
        _this35.closeMenu();
      });
    }
  }, {
    key: "openMenu",
    value: function openMenu(x, y, menuOptions) {
      var closeOnSelectOption = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      this.menu = new Menu(x, y, menuOptions, closeOnSelectOption);
    }

    /*
    askForClosingMenu() {
      let menu = this.menu;
      setTimeout(() => {
        if (menu) {
          menu.close();
          if (this.menu === menu) delete this.menu;
        }
      }, 200);
    }
    */
  }, {
    key: "menuEvent",
    value: function menuEvent(x, y) {
      if (this.menu) {
        return this.menu.menuEvent(x, y);
      }
      return false;
    }
  }, {
    key: "refreshMenu",
    value: function refreshMenu(x, y) {
      if (this.menu) {
        return this.menu.refresh();
      }
      return false;
    }
  }, {
    key: "closeMenuOnSelectOption",
    value: function closeMenuOnSelectOption() {
      if (this.menu) {
        return this.menu.closeOnSelectOption;
      }
      return false;
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      if (this.menu) {
        this.menu.close();
        delete this.menu;
      }
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value) {
      var _iterator63 = _createForOfIteratorHelper(this.observers.values()),
        _step63;
      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var observer = _step63.value;
          observer.changed(this, type, value);
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
    }
  }, {
    key: "zoomIn",
    value: function zoomIn(x, y) {
      var zoom = new _snap.default.Matrix().scale(_context.default.ZOOM_STEP, _context.default.ZOOM_STEP, x, y);
      var newMatrix = this.base.transform().localMatrix.multLeft(zoom);
      this.adjustBase(newMatrix);
      this._dispatchChange("zoom", newMatrix.split().scalex);
    }
  }, {
    key: "zoomOut",
    value: function zoomOut(x, y) {
      var zoom = new _snap.default.Matrix().scale(_context.default.ZOOM_STEP, _context.default.ZOOM_STEP, x, y);
      var newMatrix = this.base.transform().localMatrix.multLeft(zoom.invert());
      this.adjustBase(newMatrix);
      this._dispatchChange("zoom", newMatrix.split().scalex);
    }
  }, {
    key: "zoomSet",
    value: function zoomSet(scale, x, y) {
      var newMatrix = new _snap.default.Matrix().scale(scale, scale, x, y);
      this.adjustBase(newMatrix);
      this._dispatchChange("zoom", newMatrix.split().scalex);
    }
  }, {
    key: "zoom",
    get: function get() {
      return this.base.transform().localMatrix.split().scalex;
    }
  }, {
    key: "minZoom",
    get: function get() {
      return Math.max(this.clientWidth / this.width, this.clientHeight / this.height);
    }
  }, {
    key: "maxZoom",
    get: function get() {
      return 50;
    }
  }, {
    key: "baseMove",
    value: function baseMove(x, y) {
      var matrix = _context.default.canvas.baseTransform();
      var invertedMatrix = matrix.invert();
      var localX = invertedMatrix.x(_context.default.canvas.clientWidth / 2, _context.default.canvas.clientHeight / 2);
      var localY = invertedMatrix.y(_context.default.canvas.clientWidth / 2, _context.default.canvas.clientHeight / 2);
      _context.default.canvas.base.transform(matrix.clone().translate(localX - x, localY - y));
    }
  }, {
    key: "openModal",
    value: function openModal(onOpen, data, onValidate, onCancel) {
      var _this36 = this;
      var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      if (mask) {
        this.modal.attr({
          visibility: "visible"
        });
      }
      onOpen(data, function (data) {
        _this36.modal.attr({
          visibility: "hidden"
        });
        onValidate && onValidate(data);
      }, function (data) {
        _this36.modal.attr({
          visibility: "hidden"
        });
        onCancel && onCancel(data);
      });
    }
  }, {
    key: "modalOpened",
    value: function modalOpened() {
      return this.modal.attr("visibility") === "visible";
    }
  }, {
    key: "baseTransform",
    value: function baseTransform() {
      return this.base.transform().globalMatrix;
    }
  }, {
    key: "baseChildren",
    value: function baseChildren() {
      return this.base.children();
    }
  }, {
    key: "addToBase",
    value: function addToBase(element) {
      this.base.add(element);
      return this;
    }
  }, {
    key: "clientWidth",
    get: function get() {
      return this.canvas.node.clientWidth;
    }
  }, {
    key: "clientHeight",
    get: function get() {
      return this.canvas.node.clientHeight;
    }
  }, {
    key: "adjustBase",
    value: function adjustBase() {
      var matrix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.base.transform().localMatrix;
      var scale = Math.max(this.clientWidth / this.width, this.clientHeight / this.height);
      if (scale > matrix.split().scalex) {
        matrix = new _snap.default.Matrix().scale(scale, scale, 0, 0);
      }
      var invertMatrix = matrix.invert();
      var dx = invertMatrix.x(0, 0);
      var dy = invertMatrix.y(0, 0);
      if (dx > 0) dx = 0;
      if (dy > 0) dy = 0;
      if (dx < 0 || dy < 0) matrix.translate(dx, dy);
      dx = invertMatrix.x(this.clientWidth, this.clientHeight);
      dy = invertMatrix.y(this.clientWidth, this.clientHeight);
      if (dx < this.width) dx = this.width;
      if (dy < this.height) dy = this.height;
      if (dx > this.width || dy > this.height) matrix.translate(dx - this.width, dy - this.height);
      this.base.transform(matrix);
    }
  }, {
    key: "canvasX",
    value: function canvasX(x) {
      return x + localOffset(this.canvas.node).x;
    }
  }, {
    key: "canvasY",
    value: function canvasY(y) {
      return y + localOffset(this.canvas.node).y;
    }
  }, {
    key: "pageX",
    value: function pageX(x) {
      return x + globalOffset(this.canvas.node).x;
    }
  }, {
    key: "pageY",
    value: function pageY(y) {
      return y + globalOffset(this.canvas.node).y;
    }
  }, {
    key: "elementByPoint",
    value: function elementByPoint(x, y) {
      var target = _snap.default.getElementByPoint(this.pageX(x), this.pageY(y));
      return target;
    }
  }]);
}();
var Memento = exports.Memento = /*#__PURE__*/function () {
  function Memento() {
    (0, _classCallCheck2.default)(this, Memento);
    this.reset();
  }
  return (0, _createClass2.default)(Memento, [{
    key: "reset",
    value: function reset() {
      this.opened = false;
      this.undoTrx = new List();
      this.undoTrx.push(new Map());
      this.redoTrx = new List();
      this.observers = new Set();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.undoTrx.length = 0;
      this.redoTrx.length = 0;
      this.undoTrx.push(new Map());
      this._dispatchChange("clear", null);
      return this;
    }
  }, {
    key: "_current",
    value: function _current() {
      return this.undoTrx.length === 0 ? null : this.undoTrx[this.undoTrx.length - 1];
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value) {
      var _iterator64 = _createForOfIteratorHelper(this.observers.values()),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var observer = _step64.value;
          observer.changed(this, type, value);
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
    }
  }, {
    key: "undoable",
    value: function undoable() {
      return this.undoTrx.length > 1 || this._current() && this._current().keys().length > 0;
    }
  }, {
    key: "redoable",
    value: function redoable() {
      return this.redoTrx.length > 0;
    }
  }, {
    key: "open",
    value: function open() {
      var current = this._current();
      if (current.size !== 0) {
        this.undoTrx.push(new Map());
        this.redoTrx.length = 0;
        this._dispatchChange("open", this._current());
      }
      return this;
    }
  }, {
    key: "keep",
    value: function keep(element) {
      if (this.opened) {
        var current = this._current();
        if (!current.has(element)) {
          current.set(element, element.memento());
          this._dispatchChange("register", element);
        }
        return this;
      }
    }
  }, {
    key: "undo",
    value: function undo() {
      if (!_context.default.isReadOnly()) {
        var current = this.undoTrx.pop();
        if (current.size === 0) {
          current = this.undoTrx.pop();
        }
        if (current) {
          var opened = this.opened;
          this.opened = false;
          var redo = new Map();
          var _iterator65 = _createForOfIteratorHelper(current.keys()),
            _step65;
          try {
            for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
              var element = _step65.value;
              redo.set(element, element.memento());
            }
          } catch (err) {
            _iterator65.e(err);
          } finally {
            _iterator65.f();
          }
          var _iterator66 = _createForOfIteratorHelper(current.keys()),
            _step66;
          try {
            for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
              var _element5 = _step66.value;
              _element5.revert(current.get(_element5));
            }
          } catch (err) {
            _iterator66.e(err);
          } finally {
            _iterator66.f();
          }
          var _iterator67 = _createForOfIteratorHelper(current.keys()),
            _step67;
          try {
            for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
              var _element6 = _step67.value;
              _element6.recover && _element6.recover(current.get(_element6));
            }
          } catch (err) {
            _iterator67.e(err);
          } finally {
            _iterator67.f();
          }
          this.opened = opened;
          this.redoTrx.push(redo);
          this._dispatchChange("undo", null);
        }
        this.undoTrx.push(new Map());
      }
      return this;
    }
  }, {
    key: "redo",
    value: function redo() {
      if (!_context.default.isReadOnly()) {
        var current = this.redoTrx.pop();
        if (current) {
          var opened = this.opened;
          this.opened = false;
          var undo = new Map();
          var _iterator68 = _createForOfIteratorHelper(current.keys()),
            _step68;
          try {
            for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
              var element = _step68.value;
              undo.set(element, element.memento());
            }
          } catch (err) {
            _iterator68.e(err);
          } finally {
            _iterator68.f();
          }
          var _iterator69 = _createForOfIteratorHelper(current.keys()),
            _step69;
          try {
            for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
              var _element7 = _step69.value;
              _element7.revert(current.get(_element7));
            }
          } catch (err) {
            _iterator69.e(err);
          } finally {
            _iterator69.f();
          }
          var _iterator70 = _createForOfIteratorHelper(current.keys()),
            _step70;
          try {
            for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
              var _element8 = _step70.value;
              _element8.recover && _element8.recover(current.get(_element8));
            }
          } catch (err) {
            _iterator70.e(err);
          } finally {
            _iterator70.f();
          }
          if (this._current().size === 0) {
            this.undoTrx.pop();
          }
          this.opened = opened;
          this.undoTrx.push(undo);
          this._dispatchChange("redo", null);
        }
      }
      return this;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var current = this.undoTrx.pop();
      if (current) {
        var opened = this.opened;
        this.opened = false;
        var _iterator71 = _createForOfIteratorHelper(current.keys()),
          _step71;
        try {
          for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
            var element = _step71.value;
            element.revert(current.get(element));
          }
        } catch (err) {
          _iterator71.e(err);
        } finally {
          _iterator71.f();
        }
        var _iterator72 = _createForOfIteratorHelper(current.keys()),
          _step72;
        try {
          for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
            var _element9 = _step72.value;
            _element9.recover && _element9.recover(current.get(_element9));
          }
        } catch (err) {
          _iterator72.e(err);
        } finally {
          _iterator72.f();
        }
        this.opened = opened;
      }
      this.undoTrx.push(new Map());
      this._dispatchChange("undo", null);
      return this;
    }
  }]);
}();
var GroupManager = exports.GroupManager = /*#__PURE__*/function () {
  function GroupManager() {
    (0, _classCallCheck2.default)(this, GroupManager);
    this.reset();
  }
  return (0, _createClass2.default)(GroupManager, [{
    key: "reset",
    value: function reset() {
      this.elements = new Map();
    }
  }, {
    key: "register",
    value: function register() {
      _context.default.memento.keep(this);
    }
  }, {
    key: "memento",
    value: function memento() {
      return {
        elements: new Map(this.elements)
      };
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      this.elements = new Map(memento.elements);
      _context.default.selection.unselect();
    }
  }, {
    key: "group",
    value: function group(element) {
      return this.elements.get(element);
    }
  }, {
    key: "regroup",
    value: function regroup(element) {
      this.register();
      var content = new Set();
      var elements = this.selection(element);
      var _iterator73 = _createForOfIteratorHelper(elements),
        _step73;
      try {
        for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
          var _element0 = _step73.value;
          var _group = this.elements.get(_element0);
          if (!_group) {
            content.add(_element0);
          } else {
            content.add(_group);
            this.elements.delete(_element0);
          }
        }
      } catch (err) {
        _iterator73.e(err);
      } finally {
        _iterator73.f();
      }
      var group = new Group(content);
      this.registerGroup(group);
    }
  }, {
    key: "ungroup",
    value: function ungroup(element) {
      this.register();
      var group = element instanceof Group ? element : this.group(element);
      var done = new Set();
      if (group) {
        var _iterator74 = _createForOfIteratorHelper(group.content()),
          _step74;
        try {
          for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
            var part = _step74.value;
            this.elements.delete(part);
          }
        } catch (err) {
          _iterator74.e(err);
        } finally {
          _iterator74.f();
        }
        var _iterator75 = _createForOfIteratorHelper(group.content()),
          _step75;
        try {
          for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
            var _part = _step75.value;
            if (_part instanceof Group) {
              if (!done.has(_part)) {
                this.registerGroup(_part);
                done.add(_part);
              }
            }
          }
        } catch (err) {
          _iterator75.e(err);
        } finally {
          _iterator75.f();
        }
      }
    }
  }, {
    key: "registerGroup",
    value: function registerGroup(group) {
      var _iterator76 = _createForOfIteratorHelper(group.elements()),
        _step76;
      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var element = _step76.value;
          this.elements.set(element, group);
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
    }
  }, {
    key: "selectElement",
    value: function selectElement(element, event) {
      var unselectAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var selectedElement = element.selectable();
      if (selectedElement) {
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
          if (unselectAllowed && _context.default.selection.selected(selectedElement)) {
            this.removeFromSelection(selectedElement);
          } else {
            this.addToSelection(selectedElement);
          }
        } else {
          this.selectOne(selectedElement);
        }
      }
    }
  }, {
    key: "selectOne",
    value: function selectOne(element) {
      _context.default.selection.unselect();
      this.addToSelection(element);
    }
  }, {
    key: "addToSelection",
    value: function addToSelection(element) {
      var group = this.group(element);
      if (group) {
        var _iterator77 = _createForOfIteratorHelper(group.elements()),
          _step77;
        try {
          for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
            var part = _step77.value;
            _context.default.selection.add(part);
          }
        } catch (err) {
          _iterator77.e(err);
        } finally {
          _iterator77.f();
        }
      } else {
        _context.default.selection.add(element);
      }
    }
  }, {
    key: "removeFromSelection",
    value: function removeFromSelection(element) {
      var group = this.group(element);
      if (group) {
        var _iterator78 = _createForOfIteratorHelper(group.elements()),
          _step78;
        try {
          for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
            var part = _step78.value;
            _context.default.selection.remove(part);
          }
        } catch (err) {
          _iterator78.e(err);
        } finally {
          _iterator78.f();
        }
      } else {
        _context.default.selection.remove(element);
      }
    }
  }, {
    key: "selection",
    value: function selection(element) {
      var elements = (0, _construct2.default)(List, (0, _toConsumableArray2.default)(_context.default.selection.workingSelection));
      if (element) {
        elements.add(element);
      }
      return elements;
    }
  }, {
    key: "groupSelection",
    value: function groupSelection() {
      var result = new Set();
      var _iterator79 = _createForOfIteratorHelper(_context.default.selection.workingSelection),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var element = _step79.value;
          var group = this.elements.get(element);
          if (!group) {
            result.add(element);
          } else {
            result.add(group);
          }
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
      return (0, _toConsumableArray2.default)(result.values());
    }
  }, {
    key: "groupable",
    value: function groupable(element) {
      var group = null;
      var elements = this.selection(element);
      var count = 0;
      var _iterator80 = _createForOfIteratorHelper(elements),
        _step80;
      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var _element1 = _step80.value;
          var egroup = this.group(_element1);
          if (!egroup || !group || group !== egroup) {
            count++;
          }
          group = egroup;
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
      return count > 1;
    }
  }, {
    key: "ungroupable",
    value: function ungroupable(element) {
      var group = this.group(element);
      return !!group;
    }
  }]);
}();
var CopyPasteManager = exports.CopyPasteManager = /*#__PURE__*/function () {
  function CopyPasteManager() {
    (0, _classCallCheck2.default)(this, CopyPasteManager);
    this.reset();
  }
  return (0, _createClass2.default)(CopyPasteManager, [{
    key: "reset",
    value: function reset() {
      this.observers = new Set();
      this.models = new List();
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value) {
      var _iterator81 = _createForOfIteratorHelper(this.observers.values()),
        _step81;
      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var observer = _step81.value;
          observer.changed(this, type, value);
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
    }
  }, {
    key: "duplicate",
    value: function duplicate(element) {
      var duplicata = new Map();
      var copy = element.copy(duplicata);
      copy.root.remove();
      element.linkContent(duplicata);
      return copy;
    }
  }, {
    key: "copyGroups",
    value: function copyGroups(groups, elements, duplicata, register) {
      function isComplete(group, elements) {
        var _iterator82 = _createForOfIteratorHelper(group.content()),
          _step82;
        try {
          for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
            var element = _step82.value;
            if (element instanceof Group) {
              if (!isComplete(element, elements)) return false;
            } else {
              if (!elements.has(element)) return false;
            }
          }
        } catch (err) {
          _iterator82.e(err);
        } finally {
          _iterator82.f();
        }
        return true;
      }
      var _iterator83 = _createForOfIteratorHelper(groups),
        _step83;
      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var group = _step83.value;
          if (isComplete(group, elements)) {
            group.clone(duplicata, register);
          }
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
    }
  }, {
    key: "duplicateList",
    value: function duplicateList(elements, container) {
      function center() {
        var left = Infinity,
          right = -Infinity,
          bottom = -Infinity,
          top = Infinity;
        var _iterator84 = _createForOfIteratorHelper(elements),
          _step84;
        try {
          for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
            var element = _step84.value;
            var _computePosition5 = computePosition(element.root, container.root),
              x = _computePosition5.x,
              y = _computePosition5.y;
            if (x < left) left = x;
            if (x > right) right = x;
            if (y < top) top = y;
            if (y > bottom) bottom = y;
          }
        } catch (err) {
          _iterator84.e(err);
        } finally {
          _iterator84.f();
        }
        var cx = (left + right) / 2;
        var cy = (top + bottom) / 2;
        return {
          cx: cx,
          cy: cy
        };
      }
      var result = new Set();
      if ((0, _toConsumableArray2.default)(elements).length > 0) {
        var _center = center(),
          cx = _center.cx,
          cy = _center.cy;
        var duplicata = new Map();
        var groups = new Set();
        var _iterator85 = _createForOfIteratorHelper(elements),
          _step85;
        try {
          for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
            var element = _step85.value;
            var copy = element.copy(duplicata);
            copy.root.remove();
            var _computePosition6 = computePosition(element.root, container.root),
              x = _computePosition6.x,
              y = _computePosition6.y;
            copy.position(x - cx, y - cy);
            result.add(copy);
          }
        } catch (err) {
          _iterator85.e(err);
        } finally {
          _iterator85.f();
        }
        var _iterator86 = _createForOfIteratorHelper(elements),
          _step86;
        try {
          for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
            var _element10 = _step86.value;
            _element10.linkContent(duplicata);
            var group = _context.default.groupManager.group(_element10);
            if (group) groups.add(group);
          }
        } catch (err) {
          _iterator86.e(err);
        } finally {
          _iterator86.f();
        }
        this.copyGroups(groups, elements, duplicata, true);
      }
      return result;
    }
  }, {
    key: "duplicatePaste",
    value: function duplicatePaste(elements) {
      var pasted = new Set();
      var duplicata = new Map();
      var groups = new Set();
      var _iterator87 = _createForOfIteratorHelper(elements),
        _step87;
      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var element = _step87.value;
          var copy = element.copy(duplicata);
          copy.position(element.posX, element.posY);
          copy.fix && copy.fix(false);
          pasted.add(copy);
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
      var _iterator88 = _createForOfIteratorHelper(elements),
        _step88;
      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var _element11 = _step88.value;
          _element11.linkContent(duplicata);
          var group = _context.default.groupManager.group(_element11);
          if (group) groups.add(group);
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
      this.copyGroups(groups, elements, duplicata, true);
      return pasted;
    }
  }, {
    key: "copyModel",
    value: function copyModel(elements) {
      if (elements.size > 0) {
        this.models = this.duplicateList(elements, _context.default.table);
        this._dispatchChange("copy-model");
      }
    }
  }, {
    key: "paste",
    value: function paste() {
      _context.default.selection.unselect();
      var pasted = this.duplicatePaste(this.models);
      var matrix = _context.default.canvas.base.transform().globalMatrix.invert();
      var cx = _context.default.canvas.clientWidth / 2;
      var cy = _context.default.canvas.clientHeight / 2;
      var vx = matrix.x(cx, cy);
      var vy = matrix.y(cx, cy);
      var px = _context.default.canvas.width / 2;
      var py = _context.default.canvas.height / 2;
      var _iterator89 = _createForOfIteratorHelper(pasted),
        _step89;
      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var copy = _step89.value;
          copy.position(copy.posX + vx - px, copy.posY + vy - py);
          _context.default.selection.add(copy);
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
      this._dispatchChange("paste-model", pasted);
    }
  }, {
    key: "pastable",
    get: function get() {
      return this.models.size > 0;
    }
  }]);
}();
var Group = exports.Group = /*#__PURE__*/function () {
  function Group(elements) {
    (0, _classCallCheck2.default)(this, Group);
    this.id = createUUID();
    this._content = new Set();
    if (elements) {
      var _iterator90 = _createForOfIteratorHelper(elements.values()),
        _step90;
      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var element = _step90.value;
          this._content.add(element);
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
    }
  }
  return (0, _createClass2.default)(Group, [{
    key: "content",
    value: function content() {
      return (0, _construct2.default)(List, (0, _toConsumableArray2.default)(this._content.values()));
    }
  }, {
    key: "elements",
    value: function elements() {
      var result = new List();
      var _iterator91 = _createForOfIteratorHelper(this._content),
        _step91;
      try {
        for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
          var element = _step91.value;
          if (element instanceof Group) {
            result.push.apply(result, (0, _toConsumableArray2.default)(element.elements()));
          } else {
            result.push(element);
          }
        }
      } catch (err) {
        _iterator91.e(err);
      } finally {
        _iterator91.f();
      }
      return result;
    }
  }, {
    key: "clone",
    value: function clone(duplicata, register) {
      var content = new Set();
      var _iterator92 = _createForOfIteratorHelper(this._content),
        _step92;
      try {
        for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
          var element = _step92.value;
          if (element instanceof Group) {
            content.add(element.clone(duplicata, register));
          } else {
            content.add(duplicata.get(element));
          }
        }
      } catch (err) {
        _iterator92.e(err);
      } finally {
        _iterator92.f();
      }
      var group = new Group(content);
      if (register) {
        _context.default.groupManager.registerGroup(group);
      }
      return group;
    }
  }]);
}();
var Selection = exports.Selection = /*#__PURE__*/function () {
  function Selection() {
    (0, _classCallCheck2.default)(this, Selection);
    this.reset();
  }
  return (0, _createClass2.default)(Selection, [{
    key: "reset",
    value: function reset() {
      this.selection = new List();
      this.observers = new Set();
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value) {
      var _iterator93 = _createForOfIteratorHelper(this.observers.values()),
        _step93;
      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var observer = _step93.value;
          observer.changed(this, type, value);
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
    }
  }, {
    key: "selected",
    value: function selected(element) {
      return this.selection.contains(element);
    }
  }, {
    key: "selectOne",
    value: function selectOne(element) {
      this.unselect();
      this.add(element);
    }
  }, {
    key: "deselect",
    value: function deselect(element) {
      if (this.selected(element)) {
        this.selection.remove(element);
        element.unselect();
        this._dispatchChange("unselect", element);
        return true;
      }
      return false;
    }
  }, {
    key: "add",
    value: function add(element) {
      this.selection.add(element);
      element.select();
      this._dispatchChange("select", element);
    }
  }, {
    key: "remove",
    value: function remove(element) {
      this.selection.remove(element);
      element.unselect();
      this._dispatchChange("unselect", element);
    }
  }, {
    key: "unselect",
    value: function unselect() {
      var selection = (0, _toConsumableArray2.default)(this.selection);
      this.selection.clear();
      var _iterator94 = _createForOfIteratorHelper(selection),
        _step94;
      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var element = _step94.value;
          element.unselect();
          this._dispatchChange("unselect", element);
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
    }
  }, {
    key: "workingSelection",
    get: function get() {
      function inSelection(parent, selection) {
        while (parent != null) {
          if (selection.has(parent)) {
            return true;
          }
          parent = parent.parent ? parent.parent() : null;
        }
        return false;
      }
      //return this.selection.filter(element => element.onWorkingSpace());
      var selection = new Set(this.selection.filter(function (element) {
        return element.onWorkingSpace();
      }));
      var _iterator95 = _createForOfIteratorHelper(selection),
        _step95;
      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var element = _step95.value;
          if (inSelection(element.parent(), selection)) {
            selection.delete(element);
          }
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
      if (_context.default.selectPdfAreaActivated) {
        return (0, _toConsumableArray2.default)(selection).filter(function (element) {
          return element instanceof BoardPdfArea;
        });
      } else {
        return (0, _toConsumableArray2.default)(selection).filter(function (element) {
          return !(element instanceof BoardPdfArea);
        });
      }
    }
  }, {
    key: "extendedSelection",
    value: function extendedSelection() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (element) {
        return true;
      };
      var selection = new Set();
      var _iterator96 = _createForOfIteratorHelper(this.selection),
        _step96;
      try {
        for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
          var element = _step96.value;
          if (predicate(element)) {
            addAssociated(selection, element);
          }
        }
      } catch (err) {
        _iterator96.e(err);
      } finally {
        _iterator96.f();
      }
      return selection;
    }
  }, {
    key: "boundingBox",
    value: function boundingBox() {
      return _boundingBox(this.workingSelection, _context.default.canvas.base);
    }
  }]);
}();
var Visualizer = exports.Visualizer = /*#__PURE__*/function () {
  function Visualizer() {
    (0, _classCallCheck2.default)(this, Visualizer);
    this.reset();
  }
  return (0, _createClass2.default)(Visualizer, [{
    key: "reset",
    value: function reset() {
      this.observers = new Set();
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange(type, value) {
      var _iterator97 = _createForOfIteratorHelper(this.observers.values()),
        _step97;
      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var observer = _step97.value;
          observer.changed(this, type, value);
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
    }
  }, {
    key: "show",
    value: function show(type) {
      this[type] = true;
      this._dispatchChange(type, true);
      return this;
    }
  }, {
    key: "hide",
    value: function hide(type) {
      this[type] = false;
      this._dispatchChange(type, false);
      return this;
    }
  }, {
    key: "toggle",
    value: function toggle(type) {
      this[type] ? this.hide(type) : this.show(type);
      return this;
    }
  }, {
    key: "refreshRaster",
    value: function refreshRaster() {
      _context.default.rasterImages = {
        loaders: {}
      };
      this._dispatchChange("All");
    }
  }]);
}();
function toolkit(element) {
  _context.default.menuOptions = new List();
  _context.default.menuOptionStrategies = {
    ALWAYS: {
      active: function active(menuOption, options) {
        return menuOption.active || menuOption.active === undefined;
      },
      action: function action(menuOption, options) {
        for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
          args[_key6 - 2] = arguments[_key6];
        }
        return menuOption.action.apply(menuOption, args);
      },
      altAction: function altAction(menuOption, options) {
        return menuOption.action.apply(menuOption, (0, _toConsumableArray2.default)(args));
      },
      predicate: function predicate(menuOption, options) {
        return true;
      }
    },
    UNIQUE: {
      active: function active(menuOption, options) {
        return options.size === 1;
      },
      action: function action(menuOption, options) {
        var option = options.values().next().value;
        for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
          args[_key7 - 2] = arguments[_key7];
        }
        return option.action.apply(option, args);
      },
      altAction: function altAction(menuOption, options) {
        var option = options.values().next().value;
        return option.action.apply(option, (0, _toConsumableArray2.default)(args));
      },
      predicate: function predicate(menuOption, options) {
        var option = options.values().next().value;
        return option.predicate();
      }
    },
    EACH: {
      active: function active(menuOption, options) {
        if (!options.size) return false;
        var option = options.values().next().value;
        return option.active;
      },
      action: function action(menuOption, options) {
        for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
          args[_key8 - 2] = arguments[_key8];
        }
        var _iterator98 = _createForOfIteratorHelper(options),
          _step98;
        try {
          for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
            var option = _step98.value;
            if (this.predicate(options) && this._optionPredicate(option)) {
              option.action.apply(option, args);
            }
          }
        } catch (err) {
          _iterator98.e(err);
        } finally {
          _iterator98.f();
        }
      },
      altAction: function altAction(menuOption, options) {
        for (var _len9 = arguments.length, args = new Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
          args[_key9 - 2] = arguments[_key9];
        }
        var _iterator99 = _createForOfIteratorHelper(options),
          _step99;
        try {
          for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
            var option = _step99.value;
            if (!this.predicate(options) && !this._optionPredicate(option)) {
              option.action.apply(option, args);
            }
          }
        } catch (err) {
          _iterator99.e(err);
        } finally {
          _iterator99.f();
        }
      },
      predicate: function predicate(menuOption, options) {
        var result = true;
        var _iterator100 = _createForOfIteratorHelper(options),
          _step100;
        try {
          for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
            var option = _step100.value;
            result = result && this._optionPredicate(option);
          }
        } catch (err) {
          _iterator100.e(err);
        } finally {
          _iterator100.f();
        }
        return result;
      },
      _optionPredicate: function _optionPredicate(menuOption, option) {
        return option._predicate ? option._predicate() : false;
      }
    },
    SHAREABLE: {
      active: function active(menuOption, options) {
        if (!options.size) return false;
        var option = options.values().next().value;
        return option.active;
      },
      action: function action(menuOption, options) {
        var option = options.values().next().value;
        for (var _len0 = arguments.length, args = new Array(_len0 > 2 ? _len0 - 2 : 0), _key0 = 2; _key0 < _len0; _key0++) {
          args[_key0 - 2] = arguments[_key0];
        }
        return option.action.apply(option, args);
      },
      altAction: function altAction(menuOption, options) {
        var option = options.values().next().value;
        for (var _len1 = arguments.length, args = new Array(_len1 > 2 ? _len1 - 2 : 0), _key1 = 2; _key1 < _len1; _key1++) {
          args[_key1 - 2] = arguments[_key1];
        }
        return option.action.apply(option, args);
      },
      predicate: function predicate(menuOption, options) {
        var result = true;
        var _iterator101 = _createForOfIteratorHelper(options),
          _step101;
        try {
          for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
            var option = _step101.value;
            result = result && this._optionPredicate(option);
          }
        } catch (err) {
          _iterator101.e(err);
        } finally {
          _iterator101.f();
        }
        return result;
      },
      _optionPredicate: function _optionPredicate(option) {
        return option._predicate ? option._predicate() : false;
      }
    },
    NONE: {
      active: function active() {
        return false;
      },
      action: function action() {},
      altAction: function altAction() {},
      predicate: function predicate() {}
    }
  };
  _context.default.editMenuOption = new TextMenuOption("editLabel", _context.default.menuOptionStrategies.UNIQUE);
  _context.default.editSizeMenuOption = new TextMenuOption("editSizeLabel", _context.default.menuOptionStrategies.ALWAYS);
  _context.default.moveMenuOption = new TextMenuOption("moveLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.removeMenuOption = new TextMenuOption("removeLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.groupMenuOption = new TextMenuOption("groupLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.ungroupMenuOption = new TextMenuOption("ungroupLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.commentMenuOption = new TextMenuOption("commentLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.copyMenuOption = new TextMenuOption("copyLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.pasteMenuOption = new TextMenuOption("pasteLabel", _context.default.menuOptionStrategies.ALWAYS);
  _context.default.addToFavoritesMenuOption = new TextMenuOption("addToFavoritesLabel", _context.default.menuOptionStrategies.SHAREABLE);
  _context.default.fixMenuOption = new TextToggleMenuOption("fixLabel", _context.default.menuOptionStrategies.SHAREABLE, "unfixLabel");
  _context.default.highlightMenuOption = new ColorChooserMenuOption("highlightLabel", _context.default.menuOptionStrategies.SHAREABLE, function () {
    return _context.default.highlightColors;
  });
  _context.default.menus.editLabel = "Edit";
  _context.default.menus.editSizeLabel = "Resize Paper";
  _context.default.menus.removeLabel = "Remove";
  _context.default.menus.fixLabel = "Fix";
  _context.default.menus.unfixLabel = "Unfix";
  _context.default.menus.commentLabel = "Comment";
  _context.default.menus.copyLabel = "Copy";
  _context.default.menus.pasteLabel = "Paste";
  _context.default.menus.groupLabel = "Group";
  _context.default.menus.ungroupLabel = "Ungroup";
  _context.default.menus.highlightLabel = "Highlight";
  _context.default.menus.addToFavoritesLabel = "Add to favorites";
  _context.default.menus.moveLabel = "Move";
  _context.default.menus.foregroundLabel = "Foreground";
  _context.default.menus.forwardLabel = "Forward";
  _context.default.menus.backwardLabel = "Backward";
  _context.default.menus.backgroundLabel = "Background";
  _context.default.HANDLE_SIZE = 8;
  _context.default.dragHandleOperation = new DragHandleOperation();
  _context.default.foregroundMenuOption = new TextMenuOption("foregroundLabel", _context.default.menuOptionStrategies.NONE);
  _context.default.forwardMenuOption = new TextMenuOption("forwardLabel", _context.default.menuOptionStrategies.NONE);
  _context.default.backwardMenuOption = new TextMenuOption("backwardLabel", _context.default.menuOptionStrategies.NONE);
  _context.default.backgroundMenuOption = new TextMenuOption("backgroundLabel", _context.default.menuOptionStrategies.NONE);
  _context.default.pdf = {
    pageLabel: "page"
  };
  _context.default.putSelectedPdfAreaOnForeground = function (pdfArea) {
    var _getSortedPdfAreas = getSortedPdfAreas(pdfArea),
      pdfAreas = _getSortedPdfAreas.pdfAreas,
      selectedPdfAreas = _getSortedPdfAreas.selectedPdfAreas;
    var index = 1;
    var _iterator102 = _createForOfIteratorHelper(selectedPdfAreas),
      _step102;
    try {
      for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
        var area = _step102.value;
        area.order = index++;
      }
    } catch (err) {
      _iterator102.e(err);
    } finally {
      _iterator102.f();
    }
    var _iterator103 = _createForOfIteratorHelper(pdfAreas),
      _step103;
    try {
      for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
        var _area = _step103.value;
        if (!selectedPdfAreas.contains(_area)) {
          _area.order = index++;
        }
      }
    } catch (err) {
      _iterator103.e(err);
    } finally {
      _iterator103.f();
    }
  };
  _context.default.forwardSelectedArea = function (pdfArea) {
    var _getSortedPdfAreas2 = getSortedPdfAreas(pdfArea),
      pdfAreas = _getSortedPdfAreas2.pdfAreas,
      selectedPdfAreas = _getSortedPdfAreas2.selectedPdfAreas;
    var limit = 0;
    for (var i = 0; i < pdfAreas.length; i++) {
      if (selectedPdfAreas.contains(pdfAreas[i])) {
        if (limit === i) limit++;else {
          if (i > 0) {
            pdfAreas[i].order = i;
            pdfAreas[i - 1].order = i + 1;
            var tmp = pdfAreas[i];
            pdfAreas[i] = pdfAreas[i - 1];
            pdfAreas[i - 1] = tmp;
          }
        }
      }
    }
  };
  _context.default.backwardSelectedArea = function (pdfArea) {
    var _getSortedPdfAreas3 = getSortedPdfAreas(pdfArea),
      pdfAreas = _getSortedPdfAreas3.pdfAreas,
      selectedPdfAreas = _getSortedPdfAreas3.selectedPdfAreas;
    var limit = pdfAreas.length - 1;
    for (var i = pdfAreas.length - 1; i >= 0; i--) {
      if (selectedPdfAreas.contains(pdfAreas[i])) {
        if (limit === i) limit--;else {
          if (i < pdfAreas.length - 1) {
            pdfAreas[i].order = i + 2;
            pdfAreas[i + 1].order = i + 1;
            var tmp = pdfAreas[i];
            pdfAreas[i] = pdfAreas[i + 1];
            pdfAreas[i + 1] = tmp;
          }
        }
      }
    }
  };
  _context.default.selectedPdfAreaAreOnFront = function (pdfArea) {
    var _getSortedPdfAreas4 = getSortedPdfAreas(pdfArea),
      pdfAreas = _getSortedPdfAreas4.pdfAreas,
      selectedPdfAreas = _getSortedPdfAreas4.selectedPdfAreas;
    var _iterator104 = _createForOfIteratorHelper(selectedPdfAreas),
      _step104;
    try {
      for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
        var _pdfArea = _step104.value;
        if (_pdfArea.order > selectedPdfAreas.length) return false;
      }
    } catch (err) {
      _iterator104.e(err);
    } finally {
      _iterator104.f();
    }
    return true;
  };
  _context.default.selectedPdfAreaAreOnBack = function (pdfArea) {
    var _getSortedPdfAreas5 = getSortedPdfAreas(pdfArea),
      pdfAreas = _getSortedPdfAreas5.pdfAreas,
      selectedPdfAreas = _getSortedPdfAreas5.selectedPdfAreas;
    var _iterator105 = _createForOfIteratorHelper(selectedPdfAreas),
      _step105;
    try {
      for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
        var _pdfArea2 = _step105.value;
        if (_pdfArea2.order <= pdfAreas.length - selectedPdfAreas.length) return false;
      }
    } catch (err) {
      _iterator105.e(err);
    } finally {
      _iterator105.f();
    }
    return true;
  };
  _context.default.putSelectedPdfAreaOnBackground = function (pdfArea) {
    var _getSortedPdfAreas6 = getSortedPdfAreas(pdfArea),
      pdfAreas = _getSortedPdfAreas6.pdfAreas,
      selectedPdfAreas = _getSortedPdfAreas6.selectedPdfAreas;
    var index = 1;
    var _iterator106 = _createForOfIteratorHelper(pdfAreas),
      _step106;
    try {
      for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
        var area = _step106.value;
        if (!selectedPdfAreas.contains(area)) {
          area.order = index++;
        }
      }
    } catch (err) {
      _iterator106.e(err);
    } finally {
      _iterator106.f();
    }
    var _iterator107 = _createForOfIteratorHelper(selectedPdfAreas),
      _step107;
    try {
      for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
        var _area2 = _step107.value;
        _area2.order = index++;
      }
    } catch (err) {
      _iterator107.e(err);
    } finally {
      _iterator107.f();
    }
  };
  _context.default.freeMode = false;
  _context.default.moveDrag = new DragMoveOperation(function () {
    return !_context.default.selectPdfAreaActivated;
  });
  _context.default.movePdfDrag = new DragMovePdfOperation(function () {
    return !_context.default.selectPdfAreaActivated;
  });
  _context.default.parentDrag = new ParentDragOperation();
  _context.default.standardDrag = new DragSelectionOperation().add(new DragSelectPdfAreaOperation(function () {
    return _context.default.selectPdfAreaActivated;
  })).add(new DragScrollOperation(function () {
    return _context.default.isScrollActivated();
  })).add(_context.default.moveDrag);
  _context.default.globalDrag = new DragSelectionOperation().add(new DragScrollOperation(function () {
    return _context.default.isScrollActivated();
  })).add(new DragSelectAreaOperation(function () {
    return _context.default.selectAreaActivated;
  })).add(new DragSelectPdfAreaOperation(function () {
    return _context.default.selectPdfAreaActivated;
  }));
  //.add(new DragScrollOperation());

  _context.default.canvas = new Canvas(element, 2000, 1200);
  _context.default.shadow = _context.default.canvas.canvas.filter(_snap.default.filter.shadow(0, 0, 5, "#000000", 1), {
    //x: "-20%", y: "-20%", width: "140%", height: "140%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    "color-interpolation-filters": "linearRGB"
  });
  _context.default.selectShadow = _context.default.canvas.canvas.filter(_snap.default.filter.shadow(0, 0, 5, "#00A8E6", 1), {
    //x: "-20%", y: "-20%", width: "140%", height: "140%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    "color-interpolation-filters": "linearRGB"
  });
  _context.default.draftShadow = _context.default.canvas.canvas.filter(_snap.default.filter.shadow(0, 0, 5, "#E60005", 1), {
    //x: "-20%", y: "-20%", width: "140%", height: "140%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    "color-interpolation-filters": "linearRGB"
  });
  _context.default.memento = new Memento();
  _context.default.selection = new Selection();
  _context.default.groupManager = new GroupManager();
  _context.default.copyPasteManager = new CopyPasteManager();
  _context.default.visualizer = new Visualizer();
}
},{"@babel/runtime/helpers/defineProperty":"IxO8","@babel/runtime/helpers/construct":"dJhE","@babel/runtime/helpers/toConsumableArray":"Fhqp","@babel/runtime/helpers/get":"J5UC","@babel/runtime/helpers/classCallCheck":"fcMS","@babel/runtime/helpers/createClass":"P8NW","@babel/runtime/helpers/possibleConstructorReturn":"pxk2","@babel/runtime/helpers/getPrototypeOf":"UJE0","@babel/runtime/helpers/inherits":"d4H2","@babel/runtime/helpers/wrapNativeSuper":"ozpi","../snap":"BQ54","./context":"FcC3"}],"wHGe":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolSet = exports.ToolPopup = exports.ToggleCommand = exports.PaneContent = exports.PalettePane = exports.NewbiesTool = exports.FavoriteItemBuilder = exports.DragPopupOperation = exports.Command = exports.CatalogPopup = exports.CatalogPane = exports.CatalogFilter = exports.CatalogCategories = exports.BoardItemBuilder = void 0;
exports.createCatalog = createCatalog;
exports.createCommandPalette = createCommandPalette;
exports.createNewbiesTool = createNewbiesTool;
exports.createPdfEditor = createPdfEditor;
exports.default = tools;
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _context = _interopRequireDefault(require("./context"));
var _toolkit = require("./toolkit");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _superPropGet(t, o, e, r) { var p = (0, _get2.default)((0, _getPrototypeOf2.default)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ToolSet = exports.ToolSet = /*#__PURE__*/function () {
  function ToolSet(width, height) {
    (0, _classCallCheck2.default)(this, ToolSet);
    this.root = _context.default.canvas.paletteContent.group();
    this.content = this.root.group();
    this.height = height;
  }
  return (0, _createClass2.default)(ToolSet, [{
    key: "add",
    value: function add(element, x, y) {
      element.root.transform(new Snap.Matrix().translate(x, y));
      this.content.add(element.root);
      return this;
    }
  }, {
    key: "move",
    value: function move(x, y) {
      this.root.transform(new Snap.Matrix().translate(x, y));
      return this;
    }
  }]);
}();
var ToolPopup = exports.ToolPopup = /*#__PURE__*/function () {
  function ToolPopup(width, height) {
    var _this = this;
    (0, _classCallCheck2.default)(this, ToolPopup);
    _context.default.tools.push(this);
    this.root = _context.default.canvas.paletteContent.group();
    this.baseRect = this.root.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context.default.BLACK,
      fill: _context.default.LIGHT_GREY,
      rx: 5,
      ry: 5,
      filter: _context.default.shadow
    });
    this.baseRect.owner = this;
    this.width = width;
    this._height = height;
    this.contentSlot = this.root.group();
    this.content = this.contentSlot.group();
    this.maxClip = this.content.rect(-width / 2, -_context.default.HEADER_HEIGHT / 2, width, height).attr({
      rx: 5,
      ry: 5
    });
    this.minClip = this.content.rect(-width / 2, -_context.default.HEADER_HEIGHT / 2, width, _context.default.HEADER_HEIGHT).attr({
      rx: 5,
      ry: 5
    });
    this.minClip.remove();
    this.title = this.root.group().transform(new Snap.Matrix().translate(0, -height / 2 + _context.default.HEADER_HEIGHT / 2));
    this.titleRect = this.title.rect(-width / 2, -_context.default.HEADER_HEIGHT / 2, width, _context.default.HEADER_HEIGHT).attr({
      fill: _context.default.BLACK,
      clip: this.maxClip
    });
    this.titleRect.owner = this;
    this.minimize = this.command(0, assets.icons.minimize, function () {
      return _this.minimizeMe();
    });
    this.restore = this.command(0, assets.icons.restore, function () {
      return _this.restoreMe();
    });
    this.restore.remove();
    this.dragOperation(_context.default.dragPopup);
    this.observe(_context.default.canvas);
  }
  return (0, _createClass2.default)(ToolPopup, [{
    key: "close",
    value: function close() {}
  }, {
    key: "command",
    value: function command(position, imageURL, action) {
      var _this2 = this;
      var cmd = this.title.group();
      (0, _toolkit.pngImage)(imageURL, 0, 0, function (img) {
        var image = cmd.image(imageURL, -img.width / 2, -img.height / 2, img.width, img.height);
        image.owner = _this2;
        cmd.transform(new Snap.Matrix().translate(_this2.width / 2 - _context.default.HEADER_ICON_MARGIN * (1 + 2 * position), 0));
        cmd.click(action);
      });
      return cmd;
    }
  }, {
    key: "minimized",
    get: function get() {
      return !this.minimize.parent();
    }
  }, {
    key: "height",
    get: function get() {
      return this.minimized ? _context.default.HEADER_HEIGHT : this._height;
    }
  }, {
    key: "dragOperation",
    value: function dragOperation(operation) {
      var _this3 = this;
      var accepted;
      var dragMove = function dragMove(dx, dy, x, y, event) {
        if (accepted) {
          operation.onDragMove(_this3, dx, dy, x, y, event);
        }
      };
      var dragStart = function dragStart(x, y, event) {
        accepted = operation._accept(_this3, x, y, event);
        if (accepted) {
          operation.onDragStart(_this3, x, y, event);
        }
      };
      var dragEnd = function dragEnd(event) {
        if (accepted) {
          operation.onDrop(_this3, event);
        }
      };
      this.titleRect.drag(dragMove, dragStart, dragEnd);
    }
  }, {
    key: "minimizeMe",
    value: function minimizeMe() {
      this.title.add(this.restore);
      this.minimize.remove();
      this.titleRect.attr({
        clip: this.minClip
      });
      this.baseRect.attr({
        x: -this.width / 2,
        y: -_context.default.HEADER_HEIGHT / 2,
        width: this.width,
        height: _context.default.HEADER_HEIGHT
      });
      this.content.remove();
      var split = this.root.transform().localMatrix.split();
      var dY = this._height / 2 - _context.default.HEADER_HEIGHT / 2;
      this.title.transform(new Snap.Matrix().translate(0, 0));
      this.root.transform(new Snap.Matrix().translate(split.dx, split.dy - dY));
    }
  }, {
    key: "restoreMe",
    value: function restoreMe() {
      this.title.add(this.minimize);
      this.restore.remove();
      this.titleRect.attr({
        clip: this.maxClip
      });
      this.baseRect.attr({
        x: -this.width / 2,
        y: -this.height / 2,
        width: this.width,
        height: this.height
      });
      this.contentSlot.add(this.content);
      var split = this.root.transform().localMatrix.split();
      var dY = this._height / 2 - _context.default.HEADER_HEIGHT / 2;
      this.title.transform(new Snap.Matrix().translate(0, -dY));
      this.root.transform(new Snap.Matrix().translate(split.dx, split.dy + dY));
      this.adjustPosition();
    }
  }, {
    key: "adjustPosition",
    value: function adjustPosition() {
      var _this$root$transform$ = this.root.transform().globalMatrix.split(),
        x = _this$root$transform$.dx,
        y = _this$root$transform$.dy;
      if (x + this.width / 2 > _context.default.canvas.clientWidth) {
        x = _context.default.canvas.clientWidth - this.width / 2;
      }
      if (x - this.width / 2 < 0) {
        x = this.width / 2;
      }
      if (y + this.height / 2 > _context.default.canvas.clientHeight) {
        y = _context.default.canvas.clientHeight - this.height / 2;
      }
      if (y - this.height / 2 < 0) {
        y = this.height / 2;
      }
      this.root.transform(new Snap.Matrix().translate(x, y));
    }
  }, {
    key: "add",
    value: function add(block) {
      this.content.add(block.root);
      return this;
    }
  }, {
    key: "opened",
    value: function opened() {
      return this.root.node.parentNode !== null;
    }
  }, {
    key: "move",
    value: function move(x, y) {
      this.root.transform(new Snap.Matrix().translate(x, y));
      this.adjustPosition();
      return this;
    }
  }, {
    key: "posX",
    value: function posX() {
      return this.root.localMatrix.x(0, 0);
    }
  }, {
    key: "posY",
    value: function posY() {
      return this.root.localMatrix.y(0, 0);
    }
  }, {
    key: "observe",
    value: function observe(observable) {
      observable.register && observable.register();
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      if (source === _context.default.canvas && type === "geometry") {
        this.adjustPosition();
      }
    }
  }, {
    key: "show",
    value: function show() {
      delete this.hidden;
      _context.default.canvas.paletteContent.add(this.root);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.hidden = true;
      this.root.remove();
    }
  }]);
}();
var DragPopupOperation = exports.DragPopupOperation = /*#__PURE__*/function (_DragOperation) {
  function DragPopupOperation() {
    (0, _classCallCheck2.default)(this, DragPopupOperation);
    return _callSuper(this, DragPopupOperation, [function () {
      return true;
    }]);
  }
  (0, _inherits2.default)(DragPopupOperation, _DragOperation);
  return (0, _createClass2.default)(DragPopupOperation, [{
    key: "onDragStart",
    value: function onDragStart(popup, x, y, event) {
      _context.default.canvas.glass.transform(_context.default.canvas.paletteContent.transform().localMatrix);
      var split = popup.root.transform().globalMatrix.split();
      var dragMatrix = new Snap.Matrix().translate(split.dx, split.dy);
      var pedestal = _context.default.canvas.glass.group().transform(dragMatrix);
      var invertedMatrix = pedestal.transform().globalMatrix.invert();
      pedestal.dragX = invertedMatrix.x(x, y);
      pedestal.dragY = invertedMatrix.y(x, y);
      pedestal.add(popup.root);
      this.lastX = x;
      this.lastY = y;
      this.onDragMove(popup, 0, 0, x, y, event);
    }
  }, {
    key: "onDragMove",
    value: function onDragMove(popup, dx, dy, x, y, event) {
      _context.default.canvas.glass.transform(_context.default.canvas.paletteContent.transform().localMatrix);
      var pedestal = popup.root.parent();
      var invertedMatrix = pedestal.transform().globalMatrix.invert();
      var pdX = invertedMatrix.x(0, 0);
      var pdY = invertedMatrix.y(0, 0);
      var pX = invertedMatrix.x(x, y) - pedestal.dragX;
      var pY = invertedMatrix.y(x, y) - pedestal.dragY;
      if (pX + popup.width / 2 - pdX > _context.default.canvas.clientWidth) {
        pX = _context.default.canvas.clientWidth - popup.width / 2 + pdX;
      }
      if (pX - popup.width / 2 - pdX < 0) {
        pX = popup.width / 2 + pdX;
      }
      if (pY + popup.height / 2 - pdY > _context.default.canvas.clientHeight) {
        pY = _context.default.canvas.clientHeight - popup.height / 2 + pdY;
      }
      if (pY - popup.height / 2 - pdY < 0) {
        pY = popup.height / 2 + pdY;
      }
      popup.root.transform(new Snap.Matrix().translate(pX, pY));
      this.lastX = x;
      this.lastY = y;
    }
  }, {
    key: "onDrop",
    value: function onDrop(popup) {
      var pedestal = popup.root.parent();
      var _computePosition = (0, _toolkit.computePosition)(popup.root, _context.default.canvas.paletteContent),
        x = _computePosition.x,
        y = _computePosition.y;
      popup.root.transform(new Snap.Matrix().translate(x, y));
      _context.default.canvas.paletteContent.add(popup.root);
      pedestal.remove();
    }
  }]);
}(_toolkit.DragOperation);
var Command = exports.Command = /*#__PURE__*/function () {
  function Command(fileURL, action) {
    var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 32;
    (0, _classCallCheck2.default)(this, Command);
    this.root = _context.default.canvas.canvas.group();
    this.root.click(action.bind(this));
    this.img = (0, _toolkit.svgImage)(fileURL, size, size);
    this.img.owner = this;
    this.root.add(this.img);
  }
  return (0, _createClass2.default)(Command, [{
    key: "observe",
    value: function observe(observable) {
      observable.register && observable.register();
      observable.observers.add(this);
      return this;
    }
  }]);
}();
var ToggleCommand = exports.ToggleCommand = /*#__PURE__*/function (_Command) {
  function ToggleCommand(fileURL, activatedURL, action) {
    var _this4;
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 32;
    (0, _classCallCheck2.default)(this, ToggleCommand);
    _this4 = _callSuper(this, ToggleCommand, [fileURL, action, size]);
    _this4.altImg = (0, _toolkit.svgImage)(activatedURL, size, size, function (img) {
      _this4._refresh();
    });
    _this4.root.add(_this4.altImg);
    _this4.activated = false;
    return _this4;
  }
  (0, _inherits2.default)(ToggleCommand, _Command);
  return (0, _createClass2.default)(ToggleCommand, [{
    key: "_refresh",
    value: function _refresh() {
      this.altImg && this.altImg.attr({
        visibility: this.activated ? "visible" : "hidden"
      });
      this.img && this.img.attr({
        visibility: !this.activated ? "visible" : "hidden"
      });
    }
  }, {
    key: "activate",
    value: function activate() {
      this.activated = true;
      this._refresh();
    }
  }, {
    key: "desactivate",
    value: function desactivate() {
      this.activated = false;
      this._refresh();
    }
  }, {
    key: "activateOn",
    value: function activateOn(predicate) {
      var _this5 = this;
      var refreshThisActivation = function refreshThisActivation() {
        if (predicate(_this5)) {
          _this5.activate();
        } else {
          _this5.desactivate();
        }
      };
      refreshThisActivation();
      var refreshCommandActivation = _context.default.refreshCommandActivation;
      _context.default.refreshCommandActivation = function () {
        refreshCommandActivation();
        refreshThisActivation();
      };
      return this;
    }
  }]);
}(Command);
var CatalogPane = exports.CatalogPane = /*#__PURE__*/function () {
  function CatalogPane(title, predicate) {
    (0, _classCallCheck2.default)(this, CatalogPane);
    this.title = title;
    this.predicate = predicate;
    this.root = _context.default.canvas.canvas.group();
    this.root.owner = this;
    this.titleBar = this.root.group();
    this.background = this.titleBar.rect(0, -_context.default.TITLE_PANE_HEIGHT / 2, 10, _context.default.TITLE_PANE_HEIGHT);
    this.background.owner = this;
    this.setTitle(title);
    this.opened = false;
  }
  return (0, _createClass2.default)(CatalogPane, [{
    key: "setTitle",
    value: function setTitle(title) {
      this.text && this.text.remove();
      this.text = this.titleBar.text(0, _context.default.PANE_TITLE_TEXT_MARGIN / 2, title).attr({
        fill: _context.default.WHITE,
        "text-anchor": "middle"
      });
      this.text.owner = this;
      return this;
    }
  }, {
    key: "action",
    value: function action(_action) {
      var _this6 = this;
      this.titleBar.click(function () {
        _action(_this6);
      });
      return this;
    }
  }, {
    key: "open",
    value: function open() {
      this.opened = true;
      this.content.predicate = this.predicate;
      this.root.add(this.content.root);
    }
  }, {
    key: "close",
    value: function close() {
      this.opened = false;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (this.opened) {
        this.titleBar.transform(new Snap.Matrix().translate(0, -this.height / 2 + _context.default.PANE_MIN_HEIGHT / 2));
        this.content.refresh();
        this.content.root.transform(new Snap.Matrix().translate(0, _context.default.PANE_MIN_HEIGHT * 0.5));
      } else {
        this.titleBar.transform(new Snap.Matrix().translate(0, 0));
      }
    }
  }, {
    key: "width",
    get: function get() {
      return this.background.attr("width");
    },
    set: function set(width) {
      this.background.attr({
        width: width,
        x: -width / 2
      });
    }
  }, {
    key: "height",
    get: function get() {
      return this.opened ? _context.default.PANE_MIN_HEIGHT + this.content.height : _context.default.PANE_MIN_HEIGHT;
    }
  }]);
}();
var PaneContent = exports.PaneContent = /*#__PURE__*/function () {
  function PaneContent(stepX, stepY, width) {
    var _this7 = this;
    (0, _classCallCheck2.default)(this, PaneContent);
    this.root = _context.default.canvas.canvas.group();
    this.width = width;
    this.height = stepY;
    this.maxHeight = stepY;
    this.stepX = stepX;
    this.stepY = stepY;
    this.clip = this.root.rect(-this.width / 2 + 5, -this.height / 2 + 5, this.width - 10, this.height - 10);
    this.content = this.root.group();
    this.background = this.content.rect(-width / 2, -this.height / 2, width, this.height).attr({
      stroke: _context.default.BLACK,
      fill: _context.default.WHITE
    });
    this.background.owner = this;
    this.content.attr({
      clip: this.clip
    });
    this.builders = new _toolkit.List();
    this.content.node.addEventListener("wheel", function (event) {
      if (event.deltaY > 0) {
        _this7.scroll(-_context.default.SCROLL_WHEEL_STEP);
      } else {
        _this7.scroll(_context.default.SCROLL_WHEEL_STEP);
      }
      event.preventDefault();
      event.stopPropagation();
    });
  }
  return (0, _createClass2.default)(PaneContent, [{
    key: "scroll",
    value: function scroll(step) {
      var y = this.content.transform().localMatrix.split().dy;
      y += step;
      if (y + this.maxHeight < this.height) {
        y = this.height - this.maxHeight;
        _context.default.endOfCatalogContent && _context.default.endOfCatalogContent();
      }
      if (y >= 0) y = 0;
      this.move(y);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.clip.attr({
        y: -this.height / 2 + 5,
        height: this.height - 10
      });
      this.background.attr({
        y: -this.height / 2,
        height: this.height
      });
      if (this.contentLayer) {
        this.contentLayer.remove();
      }
      this.contentLayer = this.content.group();
      var startX = this.stepX / 2;
      var startY = this.stepY / 2;
      var _iterator = _createForOfIteratorHelper(this.builders),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var builder = _step.value;
          if (this.predicate && this.predicate(builder)) {
            if (startX > this.width) {
              startX = this.stepX / 2;
              startY += this.stepY;
            }
            builder.move(startX - this.width / 2, startY - this.height / 2);
            startX += this.stepX;
            this.contentLayer.add(builder.pedestal);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.maxHeight = startY + this.stepY / 2 + _context.default.TITLE_MARGIN;
      this.background.attr({
        height: this.maxHeight
      });
      this.move(0);
    }
  }, {
    key: "move",
    value: function move(y) {
      this.content.transform(new Snap.Matrix().translate(0, y));
      this.clip.transform(new Snap.Matrix().translate(0, -y));
    }
  }, {
    key: "add",
    value: function add(element) {
      element.removeMe();
    }
  }, {
    key: "addBuilder",
    value: function addBuilder(builder) {
      this.builders.add(builder);
      builder.init(this, this.stepX * 0.9, this.stepY * 0.7, this.stepY * 0.3);
      return this;
    }
  }, {
    key: "removeBuilder",
    value: function removeBuilder(builder) {
      this.builders.remove(builder);
      return this;
    }
  }, {
    key: "mode3D",
    value: function mode3D(on) {
      var _iterator2 = _createForOfIteratorHelper(this.builders),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var builder = _step2.value;
          builder.mode3D(on);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
}();
var PalettePane = exports.PalettePane = /*#__PURE__*/function () {
  function PalettePane(width) {
    (0, _classCallCheck2.default)(this, PalettePane);
    this.root = _context.default.canvas.canvas.group();
    this.width = width;
    this.height = 0;
    this.panes = this.root.group();
    this.currentCategory = null;
  }
  return (0, _createClass2.default)(PalettePane, [{
    key: "move",
    value: function move(x, y) {
      this.root.transform(new Snap.Matrix().translate(x, y));
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var contentHeight = this.height - this.panes.children().length * _context.default.PANE_MIN_HEIGHT;
      this.content.height = contentHeight;
      var height = -this.height / 2;
      var _iterator3 = _createForOfIteratorHelper(this.panes.children()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var paneRoot = _step3.value;
          paneRoot.owner.refresh();
          paneRoot.transform(new Snap.Matrix().translate(0, height + paneRoot.owner.height / 2));
          height += paneRoot.owner.height;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return this;
    }
  }, {
    key: "currentPane",
    value: function currentPane() {
      var _iterator4 = _createForOfIteratorHelper(this.panes.children()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var paneRoot = _step4.value;
          if (paneRoot.owner.opened) {
            return paneRoot.owner;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return null;
    }
  }, {
    key: "addContent",
    value: function addContent(content) {
      this.content = content;
      return this;
    }
  }, {
    key: "addPane",
    value: function addPane(pane) {
      var _this8 = this;
      pane.action(function (pane) {
        var _iterator5 = _createForOfIteratorHelper(_this8.panes.children()),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var paneRoot = _step5.value;
            if (paneRoot.owner === pane) {
              pane.open();
            } else {
              paneRoot.owner.close();
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        _this8.refresh();
      });
      pane.content = this.content;
      pane.width = this.width;
      this.panes.add(pane.root);
      if (this.panes.children().length === 1) {
        pane.open();
      }
      return this;
    }
  }]);
}();
var BoardItemBuilder = exports.BoardItemBuilder = /*#__PURE__*/function () {
  function BoardItemBuilder(proto, label, imageURL) {
    var _this9 = this;
    (0, _classCallCheck2.default)(this, BoardItemBuilder);
    this.proto = proto instanceof BoardElement ? new Set([proto]) : proto;
    var _iterator6 = _createForOfIteratorHelper(this.proto),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var element = _step6.value;
        element.root.remove();
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    this.width = 0;
    this.height = 0;
    this.x = 0;
    this.y = 0;
    this.pedestal = _context.default.canvas.canvas.group();
    this.pedestal.owner = this;
    this.altPedestal = this.pedestal.group();
    if (imageURL) {
      (0, _toolkit.pngImage)(imageURL, 0, 0, function (img) {
        _this9.altImg = _this9.altPedestal.image(imageURL, -img.width / 2, -img.height / 2, img.width, img.height);
        _this9.altImg.owner = _this9;
        var scale = Math.min(_this9.width / img.width, _this9.height / img.height);
        _this9.altPedestal.transform(new Snap.Matrix().scale(scale, scale, 0, 0));
        _this9.support.attr({
          opacity: 0.001
        });
      });
    }
    this.support = this.pedestal.group();
    this.downLayer = this.support.group();
    this.middleLayer = this.support.group();
    this.upLayer = this.support.group();
    this.coverLayer = this.support.group();
    this.labelSpec = label;
  }
  return (0, _createClass2.default)(BoardItemBuilder, [{
    key: "reset",
    value: function reset() {
      var _iterator7 = _createForOfIteratorHelper(this.currentItems),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var item = _step7.value;
          item.root.remove();
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      this._make();
    }
  }, {
    key: "setLabel",
    value: function setLabel(label, labelHeight) {
      this.labelSpec = label;
      this.label && this.label.remove();
      this.label = this.pedestal.group();
      var foreign = Snap.parse("<foreignObject width='".concat(this.width, "px' height='").concat(labelHeight, "px'></foreignObject>"));
      this.label.append(foreign);
      if (typeof this.labelSpec === "string") {
        this.label.children()[0].node.innerHTML = this.labelSpec;
      } else if (this.labelSpec instanceof Node) {
        this.label.children()[0].node.appendChild(this.labelSpec);
      }
      this.label.transform(new Snap.Matrix().translate(-this.width / 2, this.height / 2));
      this.label.attr({
        class: "catalog-label",
        cursor: "pointer"
      });
      return this;
    }
  }, {
    key: "mode3D",
    value: function mode3D(on) {
      if (on && this.altImg) {
        this.altPedestal.attr({
          visibility: "visible"
        });
        this.support.attr({
          opacity: 0.001
        });
      } else {
        this.altPedestal.attr({
          visibility: "hidden"
        });
        this.support.attr({
          opacity: 1
        });
      }
    }
  }, {
    key: "init",
    value: function init(builder, width, height, labelHeight) {
      this.support.owner = builder;
      this.width = width;
      this.height = height;
      this.labelHeight = labelHeight;
      this.setLabel(this.labelSpec, labelHeight);
      this._make();
      return this;
    }
  }, {
    key: "elementDescription",
    value: function (_elementDescription) {
      function elementDescription() {
        return _elementDescription.apply(this, arguments);
      }
      elementDescription.toString = function () {
        return _elementDescription.toString();
      };
      return elementDescription;
    }(function () {
      _context.default.canvas.openModal(elementDescription, {
        element: this,
        type: this.constructor.name,
        label: this.labelSpec
      }, function (data) {}, null, false);
    })
  }, {
    key: "move",
    value: function move(x, y) {
      this.x = x;
      this.y = y;
      this.pedestal.transform(new Snap.Matrix().translate(this.x, this.y));
      return this;
    }
  }, {
    key: "select",
    value: function select() {
      _context.default.selection.unselect();
      var _iterator8 = _createForOfIteratorHelper(this.currentItems),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var element = _step8.value;
          _context.default.selection.add(element);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "_make",
    value: function _make() {
      var mementoOpened = _context.default.memento.opened;
      _context.default.memento.opened = false;
      this.currentItems = _context.default.copyPasteManager.duplicatePaste(this.proto);
      _context.default.memento.opened = mementoOpened;
      var _iterator9 = _createForOfIteratorHelper(this.currentItems),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var item = _step9.value;
          this.observe(item);
          if (item.layer === "up") {
            this.upLayer.add(item.root);
          } else if (item.layer === "middle") {
            this.middleLayer.add(item.root);
          } else if (item.layer === "down") {
            this.downLayer.add(item.root);
          } else if (item.layer === "cover") {
            this.coverLayer.add(item.root);
          }
          item.root.attr({
            opacity: 0
          });
          item.root.animate({
            opacity: 1
          }, 1000);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      this._adjustSize();
      return this.currentItems;
    }
  }, {
    key: "_adjustSize",
    value: function _adjustSize() {
      var bbox = (0, _toolkit.boundingBox)(this.currentItems, this.support);
      var sizeWidthFactor = this.width / bbox.width;
      var sizeHeightFactor = this.height / bbox.height;
      var sizeFactor = Math.min(sizeWidthFactor, sizeHeightFactor, 2);
      this.support.transform(new Snap.Matrix().scale(sizeFactor, sizeFactor, 0, 0).translate(-bbox.x, -bbox.y));
    }
  }, {
    key: "observe",
    value: function observe(observable) {
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "forget",
    value: function forget() {
      var _iterator0 = _createForOfIteratorHelper(this.currentItems),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var observable = _step0.value;
          observable.register && observable.register();
          observable.observers.delete(this);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      return this;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      if (source instanceof BoardElement) {
        if (type === "removed") {
          this.forget();
          this._make();
        } else if (type === "geometry") {
          this._adjustSize();
        }
      }
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      return new _toolkit.List();
    }
  }]);
}();
var FavoriteItemBuilder = exports.FavoriteItemBuilder = /*#__PURE__*/function (_BoardItemBuilder) {
  function FavoriteItemBuilder(proto, label, favoriteId) {
    var _this0;
    (0, _classCallCheck2.default)(this, FavoriteItemBuilder);
    _this0 = _callSuper(this, FavoriteItemBuilder, [proto, label]);
    _this0._id = favoriteId;
    return _this0;
  }
  (0, _inherits2.default)(FavoriteItemBuilder, _BoardItemBuilder);
  return (0, _createClass2.default)(FavoriteItemBuilder, [{
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "setId",
    value: function setId(id) {
      this._id = id;
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      var _this1 = this;
      var options = _superPropGet(FavoriteItemBuilder, "collectMenuOptions", this, 3)([]);
      options.add(_context.default.renameFavoriteMenuOption.instance(function () {
        return _context.default.renameFavorite(_this1);
      }));
      options.add(_context.default.removeFromFavoritesMenuOption.instance(function () {
        return _context.default.removeFromFavorites(_this1);
      }));
      return options;
    }
  }]);
}(BoardItemBuilder);
var CatalogCategories = exports.CatalogCategories = /*#__PURE__*/function () {
  function CatalogCategories(width, action) {
    (0, _classCallCheck2.default)(this, CatalogCategories);
    this._action = action;
    this._width = width;
    this._height = 0;
    this.root = _context.default.canvas.canvas.group();
    //this.background = this.root.rect(-width/2, 0, width, 1).attr({fill:"#FFFFFF", stroke:"#A0A0A0"});
    this.root.remove();
    this.labels = [];
  }
  return (0, _createClass2.default)(CatalogCategories, [{
    key: "setCategories",
    value: function setCategories(categorySpecs) {
      var _this10 = this;
      var MARGIN = 5;
      var current = null;
      this._height = MARGIN;
      var x = -this._width / 2 + MARGIN;
      var y = -MARGIN;
      var _iterator1 = _createForOfIteratorHelper(categorySpecs),
        _step1;
      try {
        var _loop = function _loop() {
          var spec = _step1.value;
          var category = _this10.root.group();
          var text = category.text(0, 0, spec.label).attr({
            "text-anchor": "middle",
            "alignement-baseline": "middle",
            class: "category-unselected"
          });
          var bbox = category.getBBox();
          if (y <= 0 || x + bbox.width > _this10._width / 2 - MARGIN) {
            x = -_this10._width / 2 + MARGIN;
            y += bbox.height + MARGIN;
            _this10._height += bbox.height + MARGIN;
            //this.background.attr({height: this._height});
          }
          text.remove();
          category.rect(-bbox.width / 2, -bbox.height / 2 - MARGIN, bbox.width, bbox.height + MARGIN).attr({
            opacity: 0.001
          });
          category.add(text);
          category.click(function (event) {
            if (current === text) {
              current === null;
              text.attr({
                class: "category-unselected"
              });
            } else {
              if (current) {
                current.attr({
                  class: "category-unselected"
                });
              }
              _this10._category = spec.value;
              _this10._action();
              current = text;
              text.attr({
                class: "category-selected"
              });
            }
          });
          category.transform(new Snap.Matrix().translate(x + bbox.width / 2, y));
          x += bbox.width + MARGIN;
        };
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      return this;
    }
  }, {
    key: "filterCategory",
    get: function get() {
      return this._category;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
  }, {
    key: "move",
    value: function move(x, y) {
      this.root.transform(new Snap.Matrix().translate(x, y - this._height / 2));
    }
  }]);
}();
var CatalogFilter = exports.CatalogFilter = /*#__PURE__*/function () {
  function CatalogFilter(width, height, action) {
    var _this11 = this;
    (0, _classCallCheck2.default)(this, CatalogFilter);
    var filterValue = "";
    this.root = _context.default.canvas.canvas.group();
    this.root.remove();
    var input = this.root.group().transform(new Snap.Matrix().translate(-width / 2, -height / 2));
    input.append(this.filterInput(width, height));
    this.input = this.root.node.querySelector(".filtertext");
    this.input.addEventListener("mouseup", function (event) {
      event.stopPropagation();
    });
    this.input.addEventListener("input", function (event) {
      var fValue = _this11.filterValue;
      if (fValue !== filterValue) {
        filterValue = fValue;
        action(filterValue);
      }
    });
    this._setMagnifier(width, function (event) {
      filterValue = _this11.filterValue;
      action(filterValue);
    });
    this._setCross(width, function (event) {
      _this11.input.value = "";
      filterValue = _this11.filterValue;
      action(filterValue);
    });
    this.width = width;
    this.height = height;
  }
  return (0, _createClass2.default)(CatalogFilter, [{
    key: "_setCross",
    value: function _setCross(width, handler) {
      this.cross = (0, _toolkit.svgImage)(assets.icons.cross, 18, 18);
      this.crossHandler = this.root.group();
      this.crossHandler.rect(-12, -12, 24, 24).attr({
        fill: _context.default.LIGHT_GREY
      });
      this.crossHandler.click(handler);
      this.crossHandler.transform(new Snap.Matrix().translate(width / 2 - 16 - 24, 0));
      this.crossHandler.add(this.cross);
    }
  }, {
    key: "_setMagnifier",
    value: function _setMagnifier(width, handler) {
      this.magnifier = (0, _toolkit.svgImage)(assets.icons.magnifier, 18, 18);
      this.magnifierHandler = this.root.group();
      this.magnifierHandler.rect(-12, -12, 24, 24).attr({
        fill: _context.default.LIGHT_GREY
      });
      this.magnifierHandler.click(handler);
      this.magnifierHandler.transform(new Snap.Matrix().translate(width / 2 - 16, 0));
      this.magnifierHandler.add(this.magnifier);
    }
  }, {
    key: "filterInput",
    value: function filterInput(width, height) {
      return Snap.parse("<foreignObject width=\"".concat(width, "\" height=\"").concat(height, "\"><div><input class=\"filtertext\" size=\"100\" style=\"width:").concat(width - 80, "px\" id=\"filter\"></div></foreignObject>"));
    }
  }, {
    key: "filterValue",
    get: function get() {
      return this.input.value;
    }
  }, {
    key: "move",
    value: function move(x, y) {
      this.root.transform(new Snap.Matrix().translate(x, y));
    }
  }]);
}();
var CatalogPopup = exports.CatalogPopup = /*#__PURE__*/function (_ToolPopup) {
  function CatalogPopup(width, height, paneWidth, paneHeight, builderWidth, builderHeight, filterAction) {
    var _this12;
    (0, _classCallCheck2.default)(this, CatalogPopup);
    function createFilter() {
      var _this13 = this;
      this.filter = new CatalogFilter(width - 16, 30, function () {
        filterAction(_this13.filterValue, _this13.filterCategory);
      });
      this.add(this.filter);
    }
    function createCategories(width, height) {
      var _this14 = this;
      this.categories = new CatalogCategories(width - 16, function () {
        filterAction(_this14.filterValue, _this14.filterCategory);
      });
      this.add(this.categories);
    }
    function createPaneSet(width, height) {
      var _this15 = this;
      this.paneSet = new PalettePane(paneWidth, paneHeight);
      this.add(this.paneSet);
      this.paneSet.content = new PaneContent(builderWidth, builderHeight, paneWidth);
      this.modeOn = this.command(1, assets.icons.iconView, function () {
        _this15.paneSet.content.mode3D(true);
        _this15.modeOn.remove();
        _this15.title.add(_this15.modeOff);
      });
      this.modeOn.remove();
      this.modeOff = this.command(1, assets.icons.d3View, function () {
        _this15.paneSet.content.mode3D(false);
        _this15.modeOff.remove();
        _this15.title.add(_this15.modeOn);
      });
    }
    _this12 = _callSuper(this, CatalogPopup, [width, height]);
    createFilter.call(_this12, width, height);
    createCategories.call(_this12, width, height);
    createPaneSet.call(_this12, width, height);
    _this12.layout(width, height);
    return _this12;
  }
  (0, _inherits2.default)(CatalogPopup, _ToolPopup);
  return (0, _createClass2.default)(CatalogPopup, [{
    key: "layout",
    value: function layout(width, height) {
      var filled = _context.default.HEADER_HEIGHT;
      this.filter.move(0, -height / 2 + filled + this.filter.height / 2);
      filled += this.filter.height;
      this.categories.move(0, -height / 2 + filled + this.categories.height / 2);
      filled += this.categories.height;
      this.paneSet.height = height - filled - 5;
      this.paneSet.move(0, -height / 2 + filled + this.paneSet.height / 2);
    }
  }, {
    key: "filterValue",
    get: function get() {
      return this.filter.filterValue;
    }
  }, {
    key: "filterCategory",
    get: function get() {
      return this.categories.filterCategory;
    }
  }, {
    key: "currentPane",
    value: function currentPane() {
      return this.paneSet.currentPane();
    }
  }, {
    key: "addPane",
    value: function addPane(title) {
      this.paneSet.addPane(title);
      return this;
    }
  }, {
    key: "addBuilder",
    value: function addBuilder(builder) {
      this.paneSet.content.addBuilder(builder);
      return this;
    }
  }, {
    key: "removeBuilder",
    value: function removeBuilder(builder) {
      this.paneSet.content.removeBuilder(builder);
      return this;
    }
  }, {
    key: "builders",
    get: function get() {
      return this.paneSet.content.builders;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _iterator10 = _createForOfIteratorHelper(this.builders),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var builder = _step10.value;
          builder.reset();
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: "setCategories",
    value: function setCategories(categories) {
      this.categories.setCategories(categories);
      this.layout(this.width, this.height);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.paneSet.refresh();
      this.paneSet.content.refresh();
      return this;
    }
  }]);
}(ToolPopup);
function createCommandPalette() {
  var TOOL_WIDTH = 76;
  var TOOL_HEIGHT = 590;
  var TOOL_TOP = -285;
  var TOOL_ROW = 36;
  var ROW_MARGIN = 8;
  var LEFT_COL = -18;
  var RIGHT_COL = 18;
  var CommandsPopup = /*#__PURE__*/function (_ToolPopup2) {
    function CommandsPopup() {
      var _this16;
      (0, _classCallCheck2.default)(this, CommandsPopup);
      _this16 = _callSuper(this, CommandsPopup, [TOOL_WIDTH, TOOL_HEIGHT]);
      _this16.add(new ToolSet(TOOL_WIDTH, TOOL_HEIGHT).add(_context.default.selectCommand, LEFT_COL, TOOL_TOP + 1 * TOOL_ROW + 1 * ROW_MARGIN).add(_context.default.scrollCommand, RIGHT_COL, TOOL_TOP + 1 * TOOL_ROW + 1 * ROW_MARGIN).add(_context.default.selectPdfAreaCommand, LEFT_COL, TOOL_TOP + 2 * TOOL_ROW + 1 * ROW_MARGIN).add(_context.default.zoomInCommand, LEFT_COL, TOOL_TOP + 3 * TOOL_ROW + 2 * ROW_MARGIN).add(_context.default.zoomOutCommand, RIGHT_COL, TOOL_TOP + 3 * TOOL_ROW + 2 * ROW_MARGIN).add(_context.default.zoomExtentCommand, LEFT_COL, TOOL_TOP + 4 * TOOL_ROW + 2 * ROW_MARGIN).add(_context.default.zoomFitCommand, RIGHT_COL, TOOL_TOP + 4 * TOOL_ROW + 2 * ROW_MARGIN).add(_context.default.copyCommand, LEFT_COL, TOOL_TOP + 5 * TOOL_ROW + 3 * ROW_MARGIN).add(_context.default.pasteCommand, RIGHT_COL, TOOL_TOP + 5 * TOOL_ROW + 3 * ROW_MARGIN).add(_context.default.undoCommand, LEFT_COL, TOOL_TOP + 6 * TOOL_ROW + 3 * ROW_MARGIN).add(_context.default.redoCommand, RIGHT_COL, TOOL_TOP + 6 * TOOL_ROW + 3 * ROW_MARGIN).add(_context.default.groupCommand, LEFT_COL, TOOL_TOP + 7 * TOOL_ROW + 4 * ROW_MARGIN).add(_context.default.ungroupCommand, RIGHT_COL, TOOL_TOP + 7 * TOOL_ROW + 4 * ROW_MARGIN).add(_context.default.spanCommand, LEFT_COL, TOOL_TOP + 8 * TOOL_ROW + 5 * ROW_MARGIN).add(_context.default.magnetCommand, RIGHT_COL, TOOL_TOP + 8 * TOOL_ROW + 5 * ROW_MARGIN).add(_context.default.lockCommand, LEFT_COL, TOOL_TOP + 9 * TOOL_ROW + 5 * ROW_MARGIN).add(_context.default.unlockCommand, RIGHT_COL, TOOL_TOP + 9 * TOOL_ROW + 5 * ROW_MARGIN).add(_context.default.freeCommand, LEFT_COL, TOOL_TOP + 10 * TOOL_ROW + 5 * ROW_MARGIN).add(_context.default.commentsCommand, LEFT_COL, TOOL_TOP + 11 * TOOL_ROW + 6 * ROW_MARGIN).add(_context.default.favoritesCommand, RIGHT_COL, TOOL_TOP + 11 * TOOL_ROW + 6 * ROW_MARGIN).add(_context.default.infoCommand, LEFT_COL, TOOL_TOP + 12 * TOOL_ROW + 6 * ROW_MARGIN).add(_context.default.layersCommand, RIGHT_COL, TOOL_TOP + 12 * TOOL_ROW + 6 * ROW_MARGIN).add(_context.default.trashBinCommand, 0, TOOL_TOP + 13.5 * TOOL_ROW + 7 * ROW_MARGIN)).move(TOOL_WIDTH / 2 + 5, TOOL_HEIGHT / 2 + 5);
      _this16.intervalID = setInterval(function () {
        _context.default.refreshCommandActivation();
      }, 250);
      return _this16;
    }
    (0, _inherits2.default)(CommandsPopup, _ToolPopup2);
    return (0, _createClass2.default)(CommandsPopup, [{
      key: "close",
      value: function close() {
        clearInterval(this.intervalID);
      }
    }]);
  }(ToolPopup);
  _context.default.commands = new CommandsPopup();
}
function createCatalog() {
  var PALETTE_WIDTH = 360;
  var PALETTE_HEIGHT = 520;
  var PANE_WIDTH = 360;
  var PANE_HEIGHT = 440;
  var BUILDER_WIDTH = 120;
  var BUILDER_HEIGHT = 150;
  function catalogFilter(value, category) {
    _context.default.catalogFilter && _context.default.catalogFilter(value, category);
  }
  _context.default.catalog = new CatalogPopup(PALETTE_WIDTH, PALETTE_HEIGHT, PANE_WIDTH, PANE_HEIGHT, BUILDER_WIDTH, BUILDER_HEIGHT, catalogFilter).move(_context.default.canvas.clientWidth - PALETTE_WIDTH / 2 - 5, PALETTE_HEIGHT / 2 + 5);
}
function createPdfEditor() {
  var PDF_WIDTH = 400;
  var PDF_HEIGHT = 500;
  var PDF_CONTENT_X = -195;
  var PDF_CONTENT_Y = -245;
  var PDF_CONTENT_WIDTH = 390;
  var PDF_CONTENT_HEIGHT = 490;
  var content = {
    root: _context.default.canvas.canvas.group()
  };
  var foreign = Snap.parse("<foreignObject width='".concat(PDF_CONTENT_WIDTH, "px' height='").concat(PDF_CONTENT_HEIGHT, "px'></foreignObject>"));
  content.root.transform(new Snap.Matrix().translate(PDF_CONTENT_X, PDF_CONTENT_Y));
  content.root.append(foreign);
  if (_context.default.pdfEditorContent) {
    content.root.children()[0].node.appendChild(_context.default.pdfEditorContent);
  }
  _context.default.pdfEditor = new ToolPopup(PDF_WIDTH, PDF_HEIGHT).add(content).move(_context.default.canvas.clientWidth - PDF_WIDTH / 2 - 400, PDF_HEIGHT / 2 + 5);
}
var DUMMIES_WIDTH = 800;
var DUMMIES_HEIGHT = 90;
var NewbiesTool = exports.NewbiesTool = /*#__PURE__*/function (_ToolPopup3) {
  function NewbiesTool() {
    var _this17;
    (0, _classCallCheck2.default)(this, NewbiesTool);
    _this17 = _callSuper(this, NewbiesTool, [DUMMIES_WIDTH, DUMMIES_HEIGHT]);
    _this17.move(DUMMIES_WIDTH / 2 + 5, _context.default.canvas.clientHeight - DUMMIES_HEIGHT / 2 - 5);
    var reference = new Set([false]);
    _this17.intervalID = setInterval(function () {
      _this17.refresh();
    }, 200);
    return _this17;
  }
  (0, _inherits2.default)(NewbiesTool, _ToolPopup3);
  return (0, _createClass2.default)(NewbiesTool, [{
    key: "close",
    value: function close() {
      clearInterval(this.intervalID);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.content.clear();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      function updateBacks(lines, context) {
        var _iterator11 = _createForOfIteratorHelper(lines),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var line = _step11.value;
            line.back.attr({
              width: context.width + _context.default.MENU_MARGIN * 2 - 2
            });
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }
      if (this.content.parent()) {
        var content = this.contentSlot.group().attr({
          opacity: 0.001
        });
        var elements = _context.default.selection.workingSelection;
        var context = {
          width: 10,
          height: -this.height / 2 + _context.default.HEADER_HEIGHT + 5,
          left: -this.width / 2
        };
        var lines = new _toolkit.List();
        var size = 0;
        var _iterator12 = _createForOfIteratorHelper(_context.default.menuOptions),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var menuOption = _step12.value;
            if (menuOption.strategy !== _context.default.menuOptionStrategies.NONE) {
              size += menuOption.size;
              if (size > 4) {
                updateBacks(lines, context);
                lines.clear();
                context.height = -this.height / 2 + _context.default.HEADER_HEIGHT + 5;
                context.left += context.width + 50;
                context.width = 10;
                size = menuOption.size;
              }
              var options = elements.length ? menuOption.globalOptions(elements) : new Set();
              var instance = menuOption.globalInstance(options);
              lines.add(instance.line(content, context));
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        updateBacks(lines, context);
        if (this.content.node.innerHTML !== content.node.innerHTML) {
          this.clear();
          content.attr({
            opacity: 1
          });
          this.content.remove();
          this.content = content;
        } else {
          content.remove();
        }
      }
    }
  }]);
}(ToolPopup);
function createNewbiesTool() {
  _context.default.newbieTool = new NewbiesTool();
}
function tools() {
  _context.default.menus.renameFavoriteLabel = "Rename favorite";
  _context.default.menus.removeFromFavoritesLabel = "Remove from favorites";
  _context.default.renameFavoriteMenuOption = new _toolkit.TextMenuOption("renameFavoriteLabel", _context.default.menuOptionStrategies.NONE);
  _context.default.removeFromFavoritesMenuOption = new _toolkit.TextMenuOption("removeFromFavoritesLabel", _context.default.menuOptionStrategies.NONE);
  _context.default.dragPopup = new DragPopupOperation();
  _context.default.refreshCommandActivation = function () {};
  _context.default.HEADER_HEIGHT = 24;
  _context.default.HEADER_ICON_MARGIN = 12;
  _context.default.SCROLL_WHEEL_STEP = 40;
  _context.default.SCROLL_COMMAND_STEP = 80;
  _context.default.TITLE_MARGIN = 20;
  _context.default.PANE_TITLE_TEXT_MARGIN = 12;
  _context.default.TITLE_PANE_HEIGHT = 22;
  _context.default.PANE_MIN_HEIGHT = 24;
  _context.default.MENU_MARGIN = 10;
  _context.default.COLOR_ROW_LENGTH = 5;
  _context.default.COLOR_MARGIN = 5;
  _context.default.COLOR_WIDTH = 30;
  _context.default.COLOR_HEIGHT = 15;
  _context.default.selectAreaActivated = false;
  _context.default.selectPdfAreaActivated = false;
  _context.default.scrollActivated = false;
  _context.default.spikesMayCollide = true;
  _context.default.layerMenu = undefined;
  _context.default.commands = undefined;
  _context.default.isScrollActivated = function () {
    return _context.default.scrollActivated;
  };
  _context.default.isReadOnly = function () {
    return _context.default.readOnly || _context.default.selectPdfAreaActivated;
  };
  _context.default.copyFunction = function (element) {
    var elementsToCopy = new Set(_context.default.selection.extendedSelection());
    if (element) elementsToCopy.add(element);
    _context.default.copyPasteManager.copyModel(elementsToCopy);
  };
  _context.default.pasteFunction = function () {
    if (_context.default.selectPdfAreaActivated || !_context.default.isReadOnly()) {
      _context.default.memento.open();
      _context.default.copyPasteManager.paste();
    }
  };
  _context.default.cutFunction = function () {
    if (!_context.default.isReadOnly()) {
      _context.default.memento.open();
      _context.default.copyFunction();
      _context.default.deleteSelectedElements();
    }
  };
  _context.default.editSelected = function () {
    if (_context.default.selection.selection.length === 1 && !_context.default.isReadOnly()) {
      var element = _context.default.selection.selection[0];
      element.edit();
    }
  };
  _context.default._print = function (content, width, height) {
    var pwin = window.open("", "", "width=\"".concat(width, "\" height=\"").concat(height, "\""));
    pwin.document.write("<html><body>" + content + "</body></html>");
    pwin.document.close();
    pwin.print();
    pwin.close();
  };
  _context.default.print = function () {
    var paper = _context.default.table.paper;
    var content = paper.root.node.cloneNode(true);
    var root = _context.default.canvas.canvas.group().transform(new Snap.Matrix().translate(paper.width / 2, paper.height / 2));
    root.remove();
    root.add(new Snap(content));
    var toPrint = "<svg width=\"".concat(paper.width, "\" height=\"").concat(paper.height, "\">") + root.node.outerHTML + "</body></html>";
    this._print(toPrint, paper.width, paper.height);
  };
  _context.default.activateScroll = function () {
    if (!_context.default.isScrollActivated()) {
      _context.default.scrollActivated = true;
      _context.default.scrollCommand.activate();
      _context.default.selectPdfAreaActivated = false;
      _context.default.selectPdfAreaCommand.desactivate();
      _context.default.hidePdfTools();
      _context.default.catalog.hide();
      _context.default.selectAreaActivated = false;
      _context.default.selectCommand.desactivate();
      _context.default.canvas.base.node.style.cursor = "all-scroll";
    }
  };
  _context.default.activateSelectArea = function () {
    if (!_context.default.selectAreaActivated) {
      _context.default.selectAreaActivated = true;
      _context.default.selectCommand.activate();
      _context.default.selectPdfAreaActivated = false;
      _context.default.selectPdfAreaCommand.desactivate();
      _context.default.hidePdfTools();
      _context.default.catalog.show();
      _context.default.scrollActivated = false;
      _context.default.scrollCommand.desactivate();
      _context.default.canvas.base.node.style.cursor = "default";
    }
  };
  _context.default.activateSelectPdfArea = function () {
    if (!_context.default.selectPdfAreaActivated) {
      _context.default.selectPdfAreaActivated = true;
      _context.default.selectPdfAreaCommand.activate();
      _context.default.showPdfTools();
      _context.default.catalog.hide();
      _context.default.selectAreaActivated = false;
      _context.default.selectCommand.desactivate();
      _context.default.scrollActivated = false;
      _context.default.scrollCommand.desactivate();
      _context.default.canvas.base.node.style.cursor = "default";
    }
  };
  _context.default.showPdfTools = function () {
    _context.default.table.pdfLayer.show();
    //Context.pdfEditor.show();
  };
  _context.default.hidePdfTools = function () {
    _context.default.table.pdfLayer.hide();
    //Context.pdfEditor.hide();
  };
  _context.default.generateSvgForPdf = function () {
    function getModules(area) {
      function collectModules(modules, element, box) {
        var ebox = (0, _toolkit.boundingBox)(new _toolkit.List(element), _context.default.table.root);
        if (ebox.right > box.left && ebox.left < box.right && ebox.bottom > box.top && ebox.top < box.bottom) {
          if (element instanceof BoardModule && ebox.left > box.left && ebox.right < box.right && ebox.top > box.top && ebox.bottom < box.bottom) {
            modules.add({
              element: element,
              box: {
                left: ebox.left - box.left,
                top: ebox.top - box.top,
                right: ebox.right - box.left,
                bottom: ebox.bottom - box.top
              }
            });
          }
          var _iterator13 = _createForOfIteratorHelper(element.children()),
            _step13;
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var child = _step13.value;
              collectModules(modules, child, box);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
        }
      }
      var modules = new _toolkit.List();
      var box = (0, _toolkit.boundingBox)(new _toolkit.List(area), _context.default.table.root);
      collectModules(modules, _context.default.table, box);
      return modules;
    }
    function generatePdfAreaRecord(area) {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", area.width);
      svg.setAttribute("height", area.height);
      var pedestal = _context.default.canvas.canvas.group();
      pedestal.transform(new Snap.Matrix().translate(area.width / 2 - area.posX, area.height / 2 - area.posY));
      pedestal.append(new Snap(_context.default.table.baseLayer.root.node.cloneNode(true)));
      svg.appendChild(pedestal.node);
      var modules = getModules(area);
      return {
        width: area.width,
        height: area.height,
        svg: svg,
        module: modules
      };
    }
    var pdfs = new _toolkit.List();
    var pdfAreas = (0, _toolkit.getPdfAreas)(_context.default.table);
    var _iterator14 = _createForOfIteratorHelper(pdfAreas),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var area = _step14.value;
        pdfs.add(generatePdfAreaRecord(area));
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
    return pdfs;
  };
  _context.default.zoomInSelect = function () {
    var bbox = _context.default.selection.boundingBox();
    if (bbox !== null) {
      var matrix = _context.default.canvas.baseTransform();
      var cx = (bbox.left + bbox.right) / 2;
      var cy = (bbox.top + bbox.bottom) / 2;
      var pageX = matrix.x(cx, cy);
      var pageY = matrix.y(cx, cy);
      _context.default.canvas.zoomIn(pageX, pageY);
    } else {
      _context.default.canvas.zoomIn(_context.default.canvas.clientWidth / 2, _context.default.canvas.clientHeight / 2);
    }
  };
  _context.default.zoomOutSelect = function () {
    var bbox = _context.default.selection.boundingBox();
    if (bbox !== null) {
      var matrix = _context.default.canvas.baseTransform();
      var cx = (bbox.left + bbox.right) / 2;
      var cy = (bbox.top + bbox.bottom) / 2;
      var pageX = matrix.x(cx, cy);
      var pageY = matrix.y(cx, cy);
      _context.default.canvas.zoomOut(pageX, pageY);
    } else {
      _context.default.canvas.zoomOut(_context.default.canvas.clientWidth / 2, _context.default.canvas.clientHeight / 2);
    }
  };
  _context.default.zoomFit = function (elements) {
    var bbox = (0, _toolkit.boundingBox)(elements, _context.default.canvas.base);
    if (bbox !== null) {
      var width = bbox.right - bbox.left;
      var height = bbox.bottom - bbox.top;
      var scale = Math.min(_context.default.canvas.clientWidth / width, _context.default.canvas.clientHeight / height) * 0.9;
      _context.default.canvas.zoomSet(scale, 0, 0);
      var cx = (bbox.left + bbox.right) / 2;
      var cy = (bbox.top + bbox.bottom) / 2;
      _context.default.canvas.baseMove(cx, cy);
      _context.default.canvas.adjustBase();
    }
  };
  _context.default.zoomFitSelect = function () {
    _context.default.zoomFit(_context.default.selection.workingSelection);
  };
  _context.default.zoomFitPaper = function () {
    _context.default.zoomFit([_context.default.table.paper]);
  };
  _context.default.isWorkingSelectionNotEmplty = function () {
    return _context.default.selection.workingSelection.length > 0;
  };
  _context.default.zoomMin = function () {
    _context.default.canvas.zoomSet(_context.default.canvas.minZoom, _context.default.canvas.width / 2, _context.default.canvas.height / 2);
  };
  _context.default.isMaxZoom = function () {
    return _context.default.canvas.maxZoom - 0.001 <= _context.default.canvas.zoom;
  };
  _context.default.isMinZoom = function () {
    return _context.default.canvas.minZoom + 0.001 >= _context.default.canvas.zoom;
  };
  _context.default.isGroupable = function (element) {
    if (!_context.default.isReadOnly()) {
      if (!element) {
        var selection = _context.default.groupManager.selection();
        element = selection.length > 0 ? selection[0] : null;
      }
      return element && _context.default.groupManager.groupable(element);
    }
    return false;
  };
  _context.default.isUngroupable = function (element) {
    if (!_context.default.isReadOnly()) {
      var selection = _context.default.groupManager.selection();
      if (element) {
        selection.add(element);
      }
      if (selection.length === 0) return false;
      var _iterator15 = _createForOfIteratorHelper(selection),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _element = _step15.value;
          if (!_context.default.groupManager.ungroupable(_element)) {
            return false;
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return true;
    }
    return false;
  };
  _context.default.editComment = function (element) {
    function commonComment() {
      var commonComment = null;
      var first = true;
      var _iterator16 = _createForOfIteratorHelper(elements),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var _element2 = _step16.value;
          if (first) {
            commonComment = _element2.comment();
            first = false;
          } else if (commonComment !== _element2.comment()) {
            return null;
          }
          return commonComment;
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }
    function applyComment(comment) {
      if (!_context.default.isReadOnly()) {
        var _iterator17 = _createForOfIteratorHelper(elements),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var _element3 = _step17.value;
            _element3.comment(comment);
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
      }
    }
    var elements = (0, _construct2.default)(_toolkit.List, (0, _toConsumableArray2.default)(_context.default.selection.workingSelection));
    if (element && !elements.contains(element)) {
      elements.add(element);
    }
    _context.default.memento.open();
    if (elements.length > 0) {
      _context.default.canvas.openModal(editComment, {
        element: elements[0],
        commentText: commonComment()
      }, function (data) {
        applyComment(data.commentText);
      });
    }
  };
  _context.default.moveSelection = function (x, xRelative, y, yRelative, element) {
    _context.default.memento.open();
    var elements = new Set(_context.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator18 = _createForOfIteratorHelper(elements),
      _step18;
    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
        var _element4 = _step18.value;
        if (_element4.move) {
          _element4.move(x, xRelative, y, yRelative);
          _element4.parent()._dispatchChange("child-geometry", _element4);
        }
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
  };
  _context.default.selectionFixed = function (element) {
    var elements = new Set(_context.default.selection.workingSelection);
    if (element) elements.add(element);
    if (elements.length === 0) return false;
    var selectionFixed = true;
    var _iterator19 = _createForOfIteratorHelper(elements),
      _step19;
    try {
      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
        var _element5 = _step19.value;
        if (_element5.fixed !== undefined && !_element5.fixed && _context.default.isFixable(_element5)) {
          selectionFixed = false;
        }
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }
    return selectionFixed;
  };
  _context.default.selectionUnfixed = function (element) {
    var elements = new Set(_context.default.selection.workingSelection);
    if (element) elements.add(element);
    if (elements.length === 0) return false;
    var selectionUnfixed = true;
    var _iterator20 = _createForOfIteratorHelper(elements),
      _step20;
    try {
      for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
        var _element6 = _step20.value;
        if (_element6.fixed !== undefined && _element6.fixed && _context.default.isFixable(_element6)) {
          selectionUnfixed = false;
        }
      }
    } catch (err) {
      _iterator20.e(err);
    } finally {
      _iterator20.f();
    }
    return selectionUnfixed;
  };
  _context.default.fixSelection = function (fix, element) {
    if (!_context.default.isReadOnly()) {
      _context.default.memento.open();
      var elements = new Set(_context.default.selection.workingSelection);
      if (element) elements.add(element);
      var _iterator21 = _createForOfIteratorHelper(elements),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _element7 = _step21.value;
          if (_element7.fix) {
            _element7.fix(fix);
          }
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  };
  _context.default.highlightSelection = function (color, element) {
    _context.default.memento.open();
    var elements = new Set(_context.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator22 = _createForOfIteratorHelper(elements),
      _step22;
    try {
      for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
        var _element8 = _step22.value;
        if (color === "#FFFFFF") {
          _element8.removeHighlight();
        } else {
          _element8.applyHighlight(color);
        }
      }
    } catch (err) {
      _iterator22.e(err);
    } finally {
      _iterator22.f();
    }
  };
  function _deleteSelectedElements(element, predicate) {
    _context.default.memento.open();
    var elements = new Set(_context.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator23 = _createForOfIteratorHelper(elements),
      _step23;
    try {
      for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
        var _element9 = _step23.value;
        if (_element9.removable()) {
          if (predicate(_element9)) {
            _element9.removeMe();
          }
        }
      }
    } catch (err) {
      _iterator23.e(err);
    } finally {
      _iterator23.f();
    }
  }
  _context.default.deleteSelectedElements = function (element) {
    if (_context.default.selectPdfAreaActivated) {
      _deleteSelectedElements(element, function (element) {
        return element instanceof BoardPdfArea;
      });
    } else if (!_context.default.isReadOnly()) {
      _deleteSelectedElements(element, function (element) {
        return !(element instanceof BoardPdfArea);
      });
    }
  };
  _context.default.removableInSelection = function (element) {
    if (!_context.default.isReadOnly()) {
      var elements = new Set(_context.default.selection.workingSelection);
      if (element) elements.add(element);
      var _iterator24 = _createForOfIteratorHelper(elements),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _element0 = _step24.value;
          if (!_element0.removable()) {
            return false;
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return true;
    }
    return false;
  };
  _context.default.regroup = function (element) {
    if (!_context.default.isReadOnly()) {
      _context.default.memento.open();
      _context.default.groupManager.regroup(element);
      if (element) {
        _context.default.groupManager.addToSelection(element);
      }
    }
  };
  _context.default.ungroup = function (element) {
    if (!_context.default.isReadOnly()) {
      _context.default.memento.open();
      if (element) {
        _context.default.groupManager.addToSelection(element);
      }
      var _iterator25 = _createForOfIteratorHelper(_context.default.groupManager.groupSelection()),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _element1 = _step25.value;
          _context.default.groupManager.ungroup(_element1);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }
  };
  _context.default.menus.legendLayerShown = "\u2610 Legends";
  _context.default.menus.legendLayerHidden = "\uD83D\uDDF9 Legends";
  _context.default.menus.artworkLayerShown = "\u2610 Artwork";
  _context.default.menus.artworkLayerHidden = "\uD83D\uDDF9 Artwork";
  _context.default.menus.realisticLayerShown = "\u2610 Realistic";
  _context.default.menus.realisticLayerHidden = "\uD83D\uDDF9 Realistic";
  _context.default.menus.highlightLayerShown = "\u2610 Highlight";
  _context.default.menus.highlightLayerHidden = "\uD83D\uDDF9 Highlight";
  _context.default.menus.ticketsLayerShown = "\u2610 Tickets";
  _context.default.menus.ticketsLayerHidden = "\uD83D\uDDF9 Tickets";
  _context.default.menus.iconColorsLayerShown = "\u2610 Icon Colors";
  _context.default.menus.iconColorsLayerHidden = "\uD83D\uDDF9 Icon Colors";
  _context.default.menus.referenceLayerShown = "\u2610 Reference";
  _context.default.menus.referenceLayerHidden = "\uD83D\uDDF9 Reference";
  _context.default.menus.coverLayerShown = "\u2610 Blanking Graphics";
  _context.default.menus.coverLayerHidden = "\uD83D\uDDF9 Blanking Graphics";
  _context.default.menus.moduleLayerShown = "\u2610 Module";
  _context.default.menus.moduleLayerHidden = "\uD83D\uDDF9 Module";
  _context.default.visualizer.show("legend");
  _context.default.visualizer.show("artwork");
  _context.default.visualizer.hide("realistic");
  _context.default.visualizer.show("highlight");
  _context.default.visualizer.show("tickets");
  _context.default.visualizer.show("iconColors");
  _context.default.visualizer.show("cover");
  _context.default.visualizer.show("reference");
  _context.default.visualizer.show("module");
  _context.default.layerMenu = function (x, y) {
    function createOption(optionName, action) {
      var menuOptionName = optionName + "LayerMenuOption";
      if (!_context.default[menuOptionName]) {
        _context.default[menuOptionName] = new _toolkit.TextToggleMenuOption(optionName + "LayerShown", _context.default.menuOptionStrategies.NONE, optionName + "LayerHidden");
      }
      return _context.default[menuOptionName].instance(function () {
        _context.default.visualizer.show(optionName);
        action && action(true);
      }, function () {
        _context.default.visualizer.hide(optionName);
        action && action(false);
      }, function () {
        return _context.default.visualizer[optionName];
      });
    }
    var options = [createOption("legend"), createOption("artwork"), createOption("realistic"), createOption("highlight"), createOption("tickets"), createOption("iconColors"), createOption("reference"), createOption("cover"), createOption("module")];
    _context.default.canvas.openMenu(x, y, options, false);
  };
  _context.default.scrollCommand = new ToggleCommand(assets.icons.pan.off, assets.icons.pan.on, function () {
    _context.default.activateScroll();
  });
  _context.default.selectCommand = new ToggleCommand(assets.icons.selectMany.off, assets.icons.selectMany.on, function () {
    _context.default.activateSelectArea();
  });
  _context.default.selectPdfAreaCommand = new ToggleCommand(assets.icons.pdf.off, assets.icons.pdf.on, function () {
    _context.default.activateSelectPdfArea();
  });
  _context.default.zoomInCommand = new ToggleCommand(assets.icons.zoomIn.off, assets.icons.zoomIn.on, function () {
    _context.default.zoomInSelect();
  }).activateOn(function () {
    return !_context.default.isMaxZoom();
  });
  _context.default.zoomOutCommand = new ToggleCommand(assets.icons.zoomOut.off, assets.icons.zoomOut.on, function () {
    _context.default.zoomOutSelect();
  }).activateOn(function () {
    return !_context.default.isMinZoom();
  });
  _context.default.zoomExtentCommand = new ToggleCommand(assets.icons.zoomExtent.off, assets.icons.zoomExtent.on, function () {
    _context.default.zoomFitPaper();
  }).activateOn(function () {
    return !_context.default.isMinZoom();
  });
  _context.default.zoomFitCommand = new ToggleCommand(assets.icons.zoomSelection.off, assets.icons.zoomSelection.on, function () {
    _context.default.zoomFitSelect();
  }).activateOn(function () {
    return _context.default.isWorkingSelectionNotEmplty();
  });
  _context.default.copyCommand = new ToggleCommand(assets.icons.copy.off, assets.icons.copy.on, function () {
    _context.default.copyFunction();
  }).activateOn(function () {
    return _context.default.isWorkingSelectionNotEmplty();
  });
  _context.default.pasteCommand = new ToggleCommand(assets.icons.paste.off, assets.icons.paste.on, function () {
    _context.default.pasteFunction();
  }).activateOn(function () {
    return _context.default.copyPasteManager.pastable;
  });
  _context.default.undoCommand = new ToggleCommand(assets.icons.undo.off, assets.icons.undo.on, function () {
    _context.default.memento.undo();
  }).activateOn(function () {
    return _context.default.memento.undoable();
  });
  _context.default.redoCommand = new ToggleCommand(assets.icons.redo.off, assets.icons.redo.on, function () {
    _context.default.memento.redo();
  }).activateOn(function () {
    return _context.default.memento.redoable();
  });
  _context.default.groupCommand = new ToggleCommand(assets.icons.group.off, assets.icons.group.on, function () {
    _context.default.regroup();
  }).activateOn(function () {
    return _context.default.isGroupable();
  });
  _context.default.ungroupCommand = new ToggleCommand(assets.icons.ungroup.off, assets.icons.ungroup.on, function () {
    _context.default.ungroup();
  }).activateOn(function () {
    return _context.default.isUngroupable();
  });
  _context.default.freeCommand = new ToggleCommand(assets.icons.free.off, assets.icons.free.on, function () {
    _context.default.freeMode = !_context.default.freeMode;
  }).activateOn(function () {
    return _context.default.freeMode;
  });
  _context.default.spanCommand = new ToggleCommand(assets.icons.span.off, assets.icons.span.on, function () {
    _context.default.spikesMayCollide = !_context.default.spikesMayCollide;
  }).activateOn(function () {
    return !_context.default.spikesMayCollide;
  });
  _context.default.magnetCommand = new ToggleCommand(assets.icons.magnet.off, assets.icons.magnet.on, function () {
    _context.default.magnetActivated = !_context.default.magnetActivated;
  }).activateOn(function () {
    return _context.default.magnetActivated;
  });
  _context.default.lockCommand = new ToggleCommand(assets.icons.lock.off, assets.icons.lock.on, function () {
    _context.default.fixSelection(true);
  }).activateOn(function () {
    return !_context.default.selectionFixed();
  });
  _context.default.unlockCommand = new ToggleCommand(assets.icons.unlock.off, assets.icons.unlock.on, function () {
    _context.default.fixSelection(false);
  }).activateOn(function () {
    return !_context.default.selectionUnfixed();
  });
  _context.default.commentsCommand = new ToggleCommand(assets.icons.comments.off, assets.icons.comments.on, function () {
    _context.default.editComment();
  }).activateOn(function () {
    return _context.default.isWorkingSelectionNotEmplty();
  });
  _context.default.infoCommand = new Command(assets.icons.info.off, function () {
    _context.default.canvas.openModal(displayInfo, {}, function (data) {});
  });
  _context.default.favoritesCommand = new ToggleCommand(assets.icons.favorites.off, assets.icons.favorites.on, function () {
    _context.default.addToFavorites();
  }).activateOn(function () {
    return _context.default.isWorkingSelectionNotEmplty();
  });
  _context.default.LAYER_MENU_OFFSET_X = 25;
  _context.default.LAYER_MENU_OFFSET_Y = -50;
  _context.default.layersCommand = new ToggleCommand(assets.icons.layers.off, assets.icons.layers.on, function () {
    var matrix = _context.default.layersCommand.root.transform().globalMatrix;
    _context.default.layerMenu(matrix.x(_context.default.LAYER_MENU_OFFSET_X, _context.default.LAYER_MENU_OFFSET_Y), matrix.y(_context.default.LAYER_MENU_OFFSET_X, _context.default.LAYER_MENU_OFFSET_Y));
  });
  _context.default.trashBinCommand = new ToggleCommand(assets.icons.trash.off, assets.icons.trash.on, function () {
    _context.default.deleteSelectedElements();
  }, 64).activateOn(function () {
    return _context.default.removableInSelection();
  });
  _context.default.favoriteCount = 0;
  _context.default.isBuilder = function (element) {
    return element instanceof BoardItemBuilder;
  };
  _context.default.addToFavorites = function (element) {
    var elements = new Set(_context.default.selection.workingSelection);
    if (element) elements.add(element);
    var allElements = new Set();
    var _iterator26 = _createForOfIteratorHelper(elements),
      _step26;
    try {
      for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
        var _element10 = _step26.value;
        (0, _toolkit.addAssociated)(allElements, _element10);
      }
    } catch (err) {
      _iterator26.e(err);
    } finally {
      _iterator26.f();
    }
    var builder = new FavoriteItemBuilder(_context.default.copyPasteManager.duplicateList(allElements, _context.default.table), "favorite " + _context.default.favoriteCount++);
    _context.default.catalog.addBuilder(builder);
    _context.default.catalog.refresh();
    return builder;
  };
  _context.default.restoreFavorites = function (elements) {
    var builder = new FavoriteItemBuilder(_context.default.copyPasteManager.duplicatePaste(elements), "favorite " + _context.default.favoriteCount++);
    _context.default.catalog.addBuilder(builder);
    _context.default.catalog.refresh();
    return builder;
  };
  _context.default.renameFavorite = function (builder) {
    _context.default.canvas.openModal(renameFavorite, {
      builder: builder,
      label: builder.labelSpec
    }, function (data) {
      builder.setLabel(data.label, builder.labelHeight);
    });
  };
  _context.default.removeFromFavorites = function (builder) {
    _context.default.catalog.removeBuilder(builder);
    _context.default.catalog.refresh();
  };
  createCommandPalette();
  createCatalog();
  //createPdfEditor();
  createNewbiesTool();
}
},{"@babel/runtime/helpers/construct":"dJhE","@babel/runtime/helpers/toConsumableArray":"Fhqp","@babel/runtime/helpers/get":"J5UC","@babel/runtime/helpers/possibleConstructorReturn":"pxk2","@babel/runtime/helpers/getPrototypeOf":"UJE0","@babel/runtime/helpers/inherits":"d4H2","@babel/runtime/helpers/classCallCheck":"fcMS","@babel/runtime/helpers/createClass":"P8NW","./context":"FcC3","./toolkit":"m1yP"}],"WrMY":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SweepAndPrune = exports.SpikedRecord = exports.Spike = exports.Record = exports.PhysicsManager = exports.PhysicsBorder = exports.Physics = void 0;
exports.default = physics;
exports.dichotomicSearch = dichotomicSearch;
exports.insertionSort = insertionSort;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _context = _interopRequireDefault(require("./context"));
var _toolkit = require("./toolkit");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2.default)((0, _getPrototypeOf2.default)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function insertionSort(array) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
    return a - b;
  };
  var delta = array.length && array[0].removed ? 1 : 0;
  for (var index = 1; index < array.length; index++) {
    var tmp = array[index];
    if (tmp.removed) {
      delta++;
    } else {
      var idx2 = index - delta;
      while (idx2 > 0 && comparator(array[idx2 - 1], tmp) > 0) {
        array[idx2] = array[idx2 - 1];
        idx2 = idx2 - 1;
      }
      array[idx2] = tmp;
    }
  }
  array.length -= delta;
}
function dichotomicSearch(array, value) {
  var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
    return a - b;
  };
  var start = 0;
  var end = array.length - 1;
  while (start <= end) {
    var half = Math.floor((start + end) / 2);
    var cmp = comparator(value, array[half]);
    if (cmp === 0) return half;else if (cmp > 0) start = half + 1;else end = half - 1;
  }
  return start;
}
var Record = exports.Record = /*#__PURE__*/function () {
  function Record(element, xAxis, yAxis, elementsRegistry) {
    (0, _classCallCheck2.default)(this, Record);
    for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      args[_key - 4] = arguments[_key];
    }
    this.createBounds.apply(this, [element, xAxis, yAxis, elementsRegistry].concat(args));
  }
  return (0, _createClass2.default)(Record, [{
    key: "createBound",
    value: function createBound(element, xAxis, yAxis) {
      var slim = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var bound = {
        left: {
          first: true,
          value: 0,
          slim: slim,
          element: element,
          index: -1,
          opened: new Set([element])
        },
        right: {
          first: false,
          value: 0,
          slim: slim,
          element: element,
          index: -1,
          opened: new Set()
        },
        top: {
          first: true,
          value: 0,
          slim: slim,
          element: element,
          index: -1,
          opened: new Set([element])
        },
        bottom: {
          first: false,
          value: 0,
          slim: slim,
          element: element,
          index: -1,
          opened: new Set()
        }
      };
      bound.left.index = xAxis.length;
      bound.right.index = xAxis.length + 1;
      xAxis.push(bound.left, bound.right);
      bound.top.index = yAxis.length;
      bound.bottom.index = yAxis.length + 1;
      yAxis.push(bound.top, bound.bottom);
      xAxis.dirty = 2;
      yAxis.dirty = 2;
      return bound;
    }
  }, {
    key: "createBounds",
    value: function createBounds(element, xAxis, yAxis, elementsRegistry) {
      this.element = element;
      this.elementsRegistry = elementsRegistry;
      this.bound = this.createBound(element, xAxis, yAxis);
      elementsRegistry.set(element, this);
    }
  }, {
    key: "bounds",
    value: function bounds() {
      return [this.bound];
    }
  }, {
    key: "deleteBound",
    value: function deleteBound(bound) {
      bound.left.removed = true;
      bound.right.removed = true;
      bound.top.removed = true;
      bound.bottom.removed = true;
    }
  }, {
    key: "left",
    value: function left(element, value, xAxis) {
      if (value === undefined) {
        return this.bound.left.value;
      } else {
        this.bound.left.value = value;
        !xAxis.dirty && (xAxis.dirty = 1);
      }
    }
  }, {
    key: "right",
    value: function right(element, value, xAxis) {
      if (value === undefined) {
        return this.bound.right.value;
      } else {
        this.bound.right.value = value;
        !xAxis.dirty && (xAxis.dirty = 1);
      }
    }
  }, {
    key: "top",
    value: function top(element, value, yAxis) {
      if (value === undefined) {
        return this.bound.top.value;
      } else {
        this.bound.top.value = value;
        !yAxis.dirty && (yAxis.dirty = 1);
      }
    }
  }, {
    key: "bottom",
    value: function bottom(element, value, yAxis) {
      if (value === undefined) {
        return this.bound.bottom.value;
      } else {
        this.bound.bottom.value = value;
        !yAxis.dirty && (yAxis.dirty = 1);
      }
    }
  }, {
    key: "x",
    value: function x(element, value) {
      if (value === undefined) {
        return this._x;
      } else {
        this._x = value;
      }
    }
  }, {
    key: "y",
    value: function y(element, value) {
      if (value === undefined) {
        return this._y;
      } else {
        this._y = value;
      }
    }
  }, {
    key: "delete",
    value: function _delete(xAxis, yAxis) {
      this.deleteBound(this.bound);
      this.elementsRegistry.delete(this.element);
      xAxis.dirty = 2;
      yAxis.dirty = 2;
    }
  }]);
}();
var Spike = exports.Spike = /*#__PURE__*/function () {
  function Spike(element, spikeSize, delta) {
    (0, _classCallCheck2.default)(this, Spike);
    this.element = element;
    this.size = spikeSize;
    this.delta = delta;
  }
  return (0, _createClass2.default)(Spike, [{
    key: "parent",
    value: function parent() {
      return this.element.parent();
    }
  }, {
    key: "mayCollide",
    value: function mayCollide() {
      return _context.default.spikesMayCollide;
    }
  }, {
    key: "globalX",
    value: function globalX() {
      return this.element.globalX(this.delta, 0);
    }
  }, {
    key: "globalY",
    value: function globalY() {
      return this.element.globalY();
    }
  }]);
}();
var SpikedRecord = exports.SpikedRecord = /*#__PURE__*/function (_Record) {
  function SpikedRecord(element, xAxis, yAxis, elementRegistry, spikeSize) {
    (0, _classCallCheck2.default)(this, SpikedRecord);
    return _callSuper(this, SpikedRecord, [element, xAxis, yAxis, elementRegistry, spikeSize]);
  }
  (0, _inherits2.default)(SpikedRecord, _Record);
  return (0, _createClass2.default)(SpikedRecord, [{
    key: "createBounds",
    value: function createBounds(element, xAxis, yAxis, elementRegistry, spikeSize) {
      this.leftSpikeSpec = new Spike(element, spikeSize, -element.width / 2);
      this.rightSpikeSpec = new Spike(element, spikeSize, element.width / 2);
      this.leftSpike = this.createBound(this.leftSpikeSpec, xAxis, yAxis, true);
      _superPropGet(SpikedRecord, "createBounds", this, 3)([element, xAxis, yAxis, elementRegistry]);
      this.rightSpike = this.createBound(this.rightSpikeSpec, xAxis, yAxis, true);
      elementRegistry.set(this.leftSpikeSpec, this);
      elementRegistry.set(this.rightSpikeSpec, this);
    }
  }, {
    key: "bounds",
    value: function bounds() {
      return [this.leftSpike, this.bound, this.rightSpike];
    }
  }, {
    key: "left",
    value: function left(element, value, xAxis) {
      if (value !== undefined) {
        this.leftSpike.left.value = value;
        this.leftSpike._x = value;
        this.leftSpike.right.value = value;
        _superPropGet(SpikedRecord, "left", this, 3)([element, value, xAxis]);
      } else {
        if (element === this.element) return _superPropGet(SpikedRecord, "left", this, 3)([element]);else if (element === this.leftSpikeSpec) return this.leftSpike.left.value;else return this.rightSpike.left.value;
      }
    }
  }, {
    key: "right",
    value: function right(element, value, xAxis) {
      if (value !== undefined) {
        this.rightSpike.left.value = value;
        this.rightSpike._x = value;
        this.rightSpike.right.value = value;
        _superPropGet(SpikedRecord, "right", this, 3)([element, value, xAxis]);
      } else {
        if (element === this.element) return _superPropGet(SpikedRecord, "right", this, 3)([element]);else if (element === this.leftSpikeSpec) return this.leftSpike.right.value;else return this.rightSpike.right.value;
      }
    }
  }, {
    key: "top",
    value: function top(element, value, yAxis) {
      if (value !== undefined) {
        this.leftSpike.top.value = value - this.leftSpikeSpec.size;
        this.rightSpike.top.value = value - this.rightSpikeSpec.size;
        _superPropGet(SpikedRecord, "top", this, 3)([element, value, yAxis]);
      } else {
        if (element === this.element) return _superPropGet(SpikedRecord, "top", this, 3)([element]);else if (element === this.leftSpikeSpec) return this.leftSpike.top.value;else return this.rightSpike.top.value;
      }
    }
  }, {
    key: "bottom",
    value: function bottom(element, value, yAxis) {
      if (value !== undefined) {
        this.leftSpike.bottom.value = value + this.leftSpikeSpec.size;
        this.rightSpike.bottom.value = value + this.rightSpikeSpec.size;
        _superPropGet(SpikedRecord, "bottom", this, 3)([element, value, yAxis]);
      } else {
        if (element === this.element) return _superPropGet(SpikedRecord, "bottom", this, 3)([element]);else if (element === this.leftSpikeSpec) return this.leftSpike.bottom.value;else return this.rightSpike.bottom.value;
      }
    }
  }, {
    key: "x",
    value: function x(element, value) {
      if (value !== undefined) {
        _superPropGet(SpikedRecord, "x", this, 3)([element, value]);
      } else {
        if (element === this.element) return _superPropGet(SpikedRecord, "x", this, 3)([element]);else if (element === this.leftSpikeSpec) return this.leftSpike._x;else return this.rightSpike._x;
      }
    }
  }, {
    key: "y",
    value: function y(element, value) {
      if (value !== undefined) {
        this.leftSpike._y = value;
        this.rightSpike._y = value;
        _superPropGet(SpikedRecord, "y", this, 3)([element, value]);
      } else {
        if (element === this.element) return _superPropGet(SpikedRecord, "y", this, 3)([element]);else if (element === this.leftSpikeSpec) return this.leftSpike._y;else return this.rightSpike._y;
      }
    }
  }, {
    key: "delete",
    value: function _delete(xAxis, yAxis) {
      this.deleteBound(this.leftSpike);
      this.deleteBound(this.rightSpike);
      this.elementsRegistry.delete(this.leftSpikeSpec);
      this.elementsRegistry.delete(this.rightSpikeSpec);
      _superPropGet(SpikedRecord, "delete", this, 3)([xAxis, yAxis]);
    }
  }]);
}(Record);
var SweepAndPrune = exports.SweepAndPrune = /*#__PURE__*/function () {
  function SweepAndPrune() {
    (0, _classCallCheck2.default)(this, SweepAndPrune);
    this.id = SweepAndPrune.id++;
    this.elementsRegistry = new Map();
    this.xAxis = new _toolkit.List();
    this.yAxis = new _toolkit.List();
  }
  return (0, _createClass2.default)(SweepAndPrune, [{
    key: "clear",
    value: function clear() {
      this.elementsRegistry.clear();
      this.xAxis.clear();
      this.yAxis.clear();
    }
  }, {
    key: "elements",
    value: function elements() {
      return this.elementsRegistry.keys();
    }
  }, {
    key: "know",
    value: function know(element) {
      return this.elementsRegistry.has(element);
    }
  }, {
    key: "registerElement",
    value: function registerElement(element) {
      if (!this.know(element)) {
        this.createRecord(element);
        return true;
      }
      return false;
    }
  }, {
    key: "unregisterElement",
    value: function unregisterElement(element) {
      if (this.know(element)) {
        var record = this.record(element);
        record.delete(this.xAxis, this.yAxis);
        return true;
      }
      return false;
    }
  }, {
    key: "updateElement",
    value: function updateElement(element) {
      var _this = this;
      var updateOnAxis = function updateOnAxis(axis, startBoundary, endBoundary) {
        // Cas ou on fait reculer la borne de départ
        var index = startBoundary.index;
        while (index > 0 && _this.comparator(axis[index - 1], startBoundary) > 0) {
          var otherBoundary = axis[index - 1];
          axis[index - 1] = startBoundary;
          axis[index] = otherBoundary;
          startBoundary.index = index - 1;
          otherBoundary.index = index;
          otherBoundary.opened.add(startBoundary.element);
          if (otherBoundary.first) {
            startBoundary.opened.delete(otherBoundary.element);
          } else {
            startBoundary.opened.add(otherBoundary.element);
          }
          index--;
        }

        // Cas ou on fait avancer la borne de fin
        index = endBoundary.index;
        while (index < axis.length - 1 && _this.comparator(axis[index + 1], endBoundary) < 0) {
          var _otherBoundary = axis[index + 1];
          axis[index + 1] = endBoundary;
          axis[index] = _otherBoundary;
          endBoundary.index = index + 1;
          _otherBoundary.index = index;
          _otherBoundary.opened.add(endBoundary.element);
          if (_otherBoundary.first) {
            endBoundary.opened.add(_otherBoundary.element);
          } else {
            endBoundary.opened.delete(_otherBoundary.element);
          }
          index++;
        }

        // Cas ou on fait avancer la borne de début
        index = startBoundary.index;
        while (index < axis.length - 1 && _this.comparator(axis[index + 1], startBoundary) < 0) {
          var _otherBoundary2 = axis[index + 1];
          axis[index + 1] = startBoundary;
          axis[index] = _otherBoundary2;
          startBoundary.index = index + 1;
          _otherBoundary2.index = index;
          _otherBoundary2.opened.delete(startBoundary.element);
          if (_otherBoundary2.first) {
            startBoundary.opened.add(_otherBoundary2.element);
          } else {
            startBoundary.opened.delete(_otherBoundary2.element);
          }
          index++;
        }

        // Cas ou on fait reculer la borne de fin
        index = endBoundary.index;
        while (index > 0 && _this.comparator(axis[index - 1], endBoundary) > 0) {
          var _otherBoundary3 = axis[index - 1];
          axis[index - 1] = endBoundary;
          axis[index] = _otherBoundary3;
          endBoundary.index = index - 1;
          _otherBoundary3.index = index;
          _otherBoundary3.opened.delete(endBoundary.element);
          if (_otherBoundary3.first) {
            endBoundary.opened.delete(_otherBoundary3.element);
          } else {
            endBoundary.opened.add(_otherBoundary3.element);
          }
          index--;
        }
      };
      (0, _toolkit.evaluate)("SAP update element collisions", function () {
        if (_this.xAxis.dirty === 2 || _this.yAxis.dirty === 2) {
          _this.updateCollisions();
        } else {
          var record = _this.record(element);
          var _iterator = _createForOfIteratorHelper(record.bounds()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var bound = _step.value;
              updateOnAxis(_this.xAxis, bound.left, bound.right);
              updateOnAxis(_this.yAxis, bound.top, bound.bottom);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          delete _this.xAxis.dirty;
          delete _this.yAxis.dirty;
        }
      });
    }
  }, {
    key: "left",
    value: function left(element, value) {
      var record = this.record(element);
      return record.left(element, value, this.xAxis);
    }
  }, {
    key: "right",
    value: function right(element, value) {
      var record = this.record(element);
      return record.right(element, value, this.xAxis);
    }
  }, {
    key: "top",
    value: function top(element, value) {
      var record = this.record(element);
      return record.top(element, value, this.yAxis);
    }
  }, {
    key: "bottom",
    value: function bottom(element, value) {
      var record = this.record(element);
      return record.bottom(element, value, this.yAxis);
    }
  }, {
    key: "x",
    value: function x(element, value) {
      var record = this.record(element);
      return record.x(element, value);
    }
  }, {
    key: "y",
    value: function y(element, value) {
      var record = this.record(element);
      return record.y(element, value);
    }
  }, {
    key: "createRecord",
    value: function createRecord(element) {
      var record = _context.default.physicsManager.createRecord(element, this.xAxis, this.yAxis, this.elementsRegistry);
      return record;
    }
  }, {
    key: "record",
    value: function record(element) {
      return this.elementsRegistry.get(element);
    }
  }, {
    key: "elementsInPoint",
    value: function elementsInPoint(x, y) {
      var collectedOnX = new Set();
      var index = dichotomicSearch(this.xAxis, x, function (v, b) {
        return v - b.value;
      });
      if (index > 0) {
        var _iterator2 = _createForOfIteratorHelper(this.xAxis[index - 1].opened),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var element = _step2.value;
            // I verify that element may collide only on x axis because if element not selected here, it cannot be choosen then
            if (!element.mayCollide || element.mayCollide()) {
              collectedOnX.add(element);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var result = new _toolkit.List();
      index = dichotomicSearch(this.yAxis, y, function (v, b) {
        return v - b.value;
      });
      if (index > 0) {
        var _iterator3 = _createForOfIteratorHelper(this.yAxis[index - 1].opened),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _element = _step3.value;
            if (collectedOnX.delete(_element)) {
              result.add(_element);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return result;
    }
  }, {
    key: "elementsInBox",
    value: function elementsInBox(left, top, right, bottom) {
      var collectedOnX = new Set();
      var index = dichotomicSearch(this.xAxis, left + _context.default.COLLISION_MARGIN, function (v, b) {
        return v - b.value;
      });
      if (index > 0 && index < this.xAxis.length && this.xAxis[index].value > left) index--;
      while (this.xAxis[index] && this.xAxis[index].value < right - _context.default.COLLISION_MARGIN) {
        var _iterator4 = _createForOfIteratorHelper(this.xAxis[index].opened),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var element = _step4.value;
            // I verify that element may collide only on x axis because if element not selected here, it cannot be choosen then
            if (!element.mayCollide || element.mayCollide()) {
              collectedOnX.add(element);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        index++;
      }
      var result = new _toolkit.List();
      index = dichotomicSearch(this.yAxis, top + _context.default.COLLISION_MARGIN, function (v, b) {
        return v - b.value;
      });
      if (index > 0 && index < this.yAxis.length && this.yAxis[index].value > top) index--;
      while (this.yAxis[index] && this.yAxis[index].value < bottom - _context.default.COLLISION_MARGIN) {
        var _iterator5 = _createForOfIteratorHelper(this.yAxis[index].opened),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _element2 = _step5.value;
            if (collectedOnX.delete(_element2)) {
              result.add(_element2);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        index++;
      }
      return result;
    }
  }, {
    key: "comparator",
    value: function comparator(e1, e2) {
      var diff = e1.value - e2.value;
      if (diff) return diff;
      // Same element = slim element : first bound is before last bound
      if (e1.element === e2.element) {
        return e1.first ? -1 : 1;
      }
      // Same value... more complicated...
      else if (e1.first === e2.first) {
        // if an "element" is slim (width=0 or height=0), it is before or after not silm element but cannot be inside element
        var e1w = e1.slim === e1.first ? 0 : 1; // XOR slim and first
        var e2w = e2.slim === e2.first ? 0 : 1;
        return e1w - e2w;
      }
      // Deux éléments avec des bornes différentes : la "fin" de l'un précède le "début" de l'autre (afin qu'ils apparaissent disjoints)
      else {
        return e1.first ? 1 : -1;
      }
    }
  }, {
    key: "updateCollisions",
    value: function updateCollisions() {
      var _this2 = this;
      var sortAxis = function sortAxis() {
        if (_this2.xAxis.dirty) {
          insertionSort(_this2.xAxis, _this2.comparator);
          for (var index = 0; index < _this2.xAxis.length; index++) {
            _this2.xAxis[index].index = index;
          }
        }
        if (_this2.yAxis.dirty) {
          insertionSort(_this2.yAxis, _this2.comparator);
          for (var _index = 0; _index < _this2.yAxis.length; _index++) {
            _this2.yAxis[_index].index = _index;
          }
        }
        delete _this2.xAxis.dirty;
        delete _this2.yAxis.dirty;
      };
      var axisCollision = function axisCollision(axis) {
        var opened = new _toolkit.List();
        var _iterator6 = _createForOfIteratorHelper(axis),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var boundary = _step6.value;
            if (boundary.first) {
              opened.add(boundary.element);
              boundary.opened = new Set(opened);
            } else {
              opened.remove(boundary.element);
              boundary.opened = new Set(opened);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      };
      (0, _toolkit.evaluate)("SAP update collisions", function () {
        sortAxis();
        axisCollision(_this2.xAxis);
        axisCollision(_this2.yAxis);
      });
    }
  }, {
    key: "collidesWith",
    value: function collidesWith(element) {
      var result = this.elementsInBox(this.left(element), this.top(element), this.right(element), this.bottom(element));
      return result;
    }
  }, {
    key: "doesCollide",
    value: function doesCollide(element, target, x, y) {
      var left = this.left(element);
      var right = this.right(element);
      var top = this.top(element);
      var bottom = this.bottom(element);
      if (x !== undefined) {
        var lx = this.x(element);
        left += x - lx;
        right += x - lx;
      }
      if (y !== undefined) {
        var ly = this.y(element);
        top += y - ly;
        bottom += y - ly;
      }
      return left < this.right(target) && right > this.left(target) && top < this.bottom(target) && bottom > this.top(target);
    }
  }, {
    key: "onLeftSide",
    value: function onLeftSide(element) {
      return this.elementsInBox(this.left(element) - 1, this.top(element), this.left(element), this.bottom(element));
    }
  }, {
    key: "onRightSide",
    value: function onRightSide(element) {
      return this.elementsInBox(this.right(element), this.top(element), this.right(element) + 1, this.bottom(element));
    }
  }, {
    key: "onTopSide",
    value: function onTopSide(element) {
      return this.elementsInBox(this.left(element), this.top(element) - 1, this.right(element), this.top(element));
    }
  }, {
    key: "onBottomSide",
    value: function onBottomSide(element) {
      return this.elementsInBox(this.left(element), this.bottom(element), this.right(element), this.bottom(element) + 1);
    }
  }]);
}();
SweepAndPrune.id = 0;
var PhysicsManager = exports.PhysicsManager = /*#__PURE__*/function () {
  function PhysicsManager() {
    (0, _classCallCheck2.default)(this, PhysicsManager);
    this.reset();
    this.denyCarryingPredicates = new _toolkit.List();
    this.denyStickingPredicates = new _toolkit.List();
    this.recordCreators = new _toolkit.List();
  }
  return (0, _createClass2.default)(PhysicsManager, [{
    key: "reset",
    value: function reset() {
      this.sweepAndPrune = new SweepAndPrune();
      this.physics = new Set();
      this.observe(_context.default.moveDrag);
    }
  }, {
    key: "addDenyCarrying",
    value: function addDenyCarrying(predicate) {
      this.denyCarryingPredicates.add(predicate);
      return this;
    }
  }, {
    key: "addDenySticking",
    value: function addDenySticking(predicate) {
      this.denyStickingPredicates.add(predicate);
      return this;
    }
  }, {
    key: "addRecordCreator",
    value: function addRecordCreator(predicate) {
      this.recordCreators.add(predicate);
      return this;
    }
  }, {
    key: "createRecord",
    value: function createRecord(element, xAxis, yAxis, elementRegistry) {
      var _iterator7 = _createForOfIteratorHelper(this.recordCreators),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var creator = _step7.value;
          var record = creator(element, xAxis, yAxis, elementRegistry);
          if (record) return record;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return new Record(element, xAxis, yAxis, elementRegistry);
    }
  }, {
    key: "denyCarrying",
    value: function denyCarrying(support, element) {
      var _iterator8 = _createForOfIteratorHelper(this.denyCarryingPredicates),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var predicate = _step8.value;
          if (predicate(support, element)) return true;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return false;
    }
  }, {
    key: "denySticking",
    value: function denySticking(support, element) {
      var _iterator9 = _createForOfIteratorHelper(this.denyStickingPredicates),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var predicate = _step9.value;
          if (predicate(support, element)) return true;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return false;
    }
  }, {
    key: "observe",
    value: function observe(observable) {
      observable.register && observable.register();
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "forget",
    value: function forget(observable) {
      observable.register && observable.register();
      observable.observers.delete(this);
      return this;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      if (type === "drag-start-elements") {
        this.manageDragStart(value);
      } else if (type === "drag-move-elements") {
        this.manageDragMove(value);
      } else if (type === "drop-elements") {
        this.manageDrop(value);
      }
    }
  }, {
    key: "manageDragStart",
    value: function manageDragStart(elements) {
      var _iterator0 = _createForOfIteratorHelper(elements),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var element = _step0.value;
          element.validX = element.lastX;
          element.validY = element.lastY;
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      this._computeAllPositions();
      this.physicsForDrag = new Set();
    }
  }, {
    key: "manageDrop",
    value: function manageDrop(elements) {
      var _iterator1 = _createForOfIteratorHelper(this.physicsForDrag),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var _physics = _step1.value;
          _physics.manageDrop();
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      var _iterator10 = _createForOfIteratorHelper(elements),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var element = _step10.value;
          delete element.validX;
          delete element.validY;
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: "_computePosition",
    value: function _computePosition(physics) {
      var _computePosition2 = (0, _toolkit.computePosition)(physics.host.root, _context.default.table.root),
        x = _computePosition2.x,
        y = _computePosition2.y;
      this.sweepAndPrune.x(physics, x);
      this.sweepAndPrune.y(physics, y);
      this.sweepAndPrune.left(physics, x - physics.host.width / 2);
      this.sweepAndPrune.right(physics, x + physics.host.width / 2);
      this.sweepAndPrune.top(physics, y - physics.host.height / 2);
      this.sweepAndPrune.bottom(physics, y + physics.host.height / 2);
    }
  }, {
    key: "_computeAllPositions",
    value: function _computeAllPositions() {
      var allPhysics = new _toolkit.List();
      var index = 0;
      (function collectPhysics(element) {
        if (element.physics) {
          allPhysics.add(element.physics);
        }
        var _iterator11 = _createForOfIteratorHelper(element.children()),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var child = _step11.value;
            collectPhysics(child);
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      })(_context.default.table);
      var physicsToRemove = new Set(this.sweepAndPrune.elements());
      var _iterator12 = _createForOfIteratorHelper(allPhysics),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _physics2 = _step12.value;
          if (!physicsToRemove.delete(_physics2)) {
            this.sweepAndPrune.registerElement(_physics2);
          }
          this.sweepAndPrune.record(_physics2).index = index++;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      var _iterator13 = _createForOfIteratorHelper(physicsToRemove),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _physics3 = _step13.value;
          this.sweepAndPrune.unregisterElement(_physics3);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      var _iterator14 = _createForOfIteratorHelper(this.sweepAndPrune.elements()),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _physics4 = _step14.value;
          this._computePosition(_physics4);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      this.sweepAndPrune.updateCollisions();
    }
  }, {
    key: "manageDragMove",
    value: function manageDragMove(elements) {
      var physicsMap = new Map();
      var _iterator15 = _createForOfIteratorHelper(elements),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var element = _step15.value;
          var _computePosition3 = (0, _toolkit.computePosition)(element.root, _context.default.table.root),
            x = _computePosition3.x,
            y = _computePosition3.y;
          var physicsCandidates = this.sweepAndPrune.elementsInPoint(x, y);
          var possiblePhysics = new _toolkit.List();
          var _iterator18 = _createForOfIteratorHelper(physicsCandidates),
            _step18;
          try {
            for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
              var _physics6 = _step18.value;
              possiblePhysics.add(_physics6);
            }
          } catch (err) {
            _iterator18.e(err);
          } finally {
            _iterator18.f();
          }
          if (possiblePhysics.length > 0) {
            var _physics5 = possiblePhysics[0];
            for (var index = 1; index < possiblePhysics.length; index++) {
              if (this.sweepAndPrune.record(possiblePhysics[index]).index > this.sweepAndPrune.record(_physics5).index) _physics5 = possiblePhysics[index];
            }
            this.physicsForDrag.delete(_physics5);
            var draggeds = physicsMap.get(_physics5);
            if (!draggeds) {
              draggeds = new Set();
              physicsMap.set(_physics5, draggeds);
            }
            draggeds.add(element);
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      var _iterator16 = _createForOfIteratorHelper(this.physicsForDrag),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var _physics7 = _step16.value;
          _physics7.registerElements(new Set());
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      var _iterator17 = _createForOfIteratorHelper(physicsMap.keys()),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _physics8 = _step17.value;
          _physics8.registerElements(physicsMap.get(_physics8));
          _physics8.manageDrag();
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      this.physicsForDrag = new Set(physicsMap.keys());
    }
  }]);
}();
var PhysicsBorder = exports.PhysicsBorder = /*#__PURE__*/function () {
  function PhysicsBorder(host, x, y, width, height) {
    (0, _classCallCheck2.default)(this, PhysicsBorder);
    this.host = host;
    this.x = x;
    this.y = y;
    this.fwidth = width;
    this.fheight = height;
  }
  return (0, _createClass2.default)(PhysicsBorder, [{
    key: "width",
    get: function get() {
      return this.fwidth();
    }
  }, {
    key: "height",
    get: function get() {
      return this.fheight();
    }
  }, {
    key: "globalX",
    value: function globalX() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.host.globalX(x, y);
    }
  }, {
    key: "globalY",
    value: function globalY() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.host.globalY(x, y);
    }
  }]);
}();
var Physics = exports.Physics = /*#__PURE__*/function () {
  function Physics(host, accept, fallable) {
    (0, _classCallCheck2.default)(this, Physics);
    this.accept = accept;
    this.fallable = fallable || accept;
    this.host = host;
    this.fallingElements = new Set();
    this.launched = false;
    this.draggeds = new Set();
    this.sweepAndPrune = new SweepAndPrune();
    this.gridStep = 0;
    this.observe(host);
  }
  return (0, _createClass2.default)(Physics, [{
    key: "canFall",
    value: function canFall(element) {
      // Si l'élément a été entrainé dans un cancelDrop d'un élément support et est retourné dans une autre physique...
      if (!this.sweepAndPrune.know(element)) return false;
      if (element.stickedTo && element.stickedTo.size > 0) return false;
      return this.fallable(element);
    }
  }, {
    key: "observe",
    value: function observe(observable) {
      observable.register && observable.register();
      observable.observers.add(this);
      return this;
    }
  }, {
    key: "forget",
    value: function forget(observable) {
      observable.register && observable.register();
      observable.observers.delete(this);
      return this;
    }
  }, {
    key: "revert",
    value: function revert(elements) {
      this.fallingElements.clear();
      this.draggeds.clear();
      this.clean(elements);
    }
  }, {
    key: "clean",
    value: function clean(elements) {
      this.sweepAndPrune.clear();
      this._leftBorder && this.sweepAndPrune.registerElement(this._leftBorder);
      this._rightBorder && this.sweepAndPrune.registerElement(this._rightBorder);
      this._topBorder && this.sweepAndPrune.registerElement(this._topBorder);
      this._bottomBorder && this.sweepAndPrune.registerElement(this._bottomBorder);
      var elems = new Set();
      var _iterator19 = _createForOfIteratorHelper(elements),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var element = _step19.value;
          if (this.accept(element)) {
            this.sweepAndPrune.createRecord(element);
            elems.add(element);
          }
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      this._computeAllPositions();
      this._applyGravitationForSet(elems);
    }
  }, {
    key: "add",
    value: function add(element) {
      if (this.accept(element)) {
        this.sweepAndPrune.registerElement(element);
        this._checkForGravitation(element, true);
        this.observe(element);
      }
    }
  }, {
    key: "remove",
    value: function remove(element) {
      if (this.accept(element)) {
        this._checkForGravitation(element, false);
        this.sweepAndPrune.unregisterElement(element);
        this.forget(element);
      }
    }
  }, {
    key: "registerElements",
    value: function registerElements(elements) {
      var oldDraggeds = new Set(this.draggeds);
      var _iterator20 = _createForOfIteratorHelper(elements),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var element = _step20.value;
          if (oldDraggeds.delete(element)) {
            if (!this.hover(element)) {
              this.sweepAndPrune.unregisterElement(element);
              this.draggeds.delete(element);
            }
          } else if (this.accept(element) && this.hover(element)) {
            this.sweepAndPrune.registerElement(element);
            this.draggeds.add(element);
          }
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      var _iterator21 = _createForOfIteratorHelper(oldDraggeds),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _element3 = _step21.value;
          this.sweepAndPrune.unregisterElement(_element3);
          this.draggeds.delete(_element3);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  }, {
    key: "manageDrag",
    value: function manageDrag() {
      var _this3 = this;
      return (0, _toolkit.evaluate)("physic manage drag", function () {
        if (_this3.gridStep) {
          _this3.adjustElementsPositionOnGrid(_this3.draggeds);
        }
        _this3._computeAllPositions();
        _this3._avoidCollisionsForListOfElements(_this3.draggeds);
        return _this3.manageGravitation();
      });
    }
  }, {
    key: "adjustElementsPositionOnGrid",
    value: function adjustElementsPositionOnGrid(elements) {
      var _iterator22 = _createForOfIteratorHelper(elements),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var element = _step22.value;
          var _this$_getPosition = this._getPosition(element),
            x = _this$_getPosition.x,
            y = _this$_getPosition.y;
          this._setPosition(element, Math.round(x / this.gridStep) * this.gridStep, Math.round(y / this.gridStep) * this.gridStep);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }
  }, {
    key: "hover",
    value: function hover(element) {
      return this.host.hover(element);
    }
  }, {
    key: "contained",
    value: function contained(parent) {
      while (true) {
        if (!parent) return false;
        if (parent === this.host) return true;
        parent = parent.parent();
      }
    }
  }, {
    key: "manageDrop",
    value: function manageDrop() {
      this._computeAllPositions();
      var _iterator23 = _createForOfIteratorHelper(this.fallingElements),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var element = _step23.value;
          for (var _i = 0, _arr = (0, _toConsumableArray2.default)(element.carriedBy); _i < _arr.length; _i++) {
            var support = _arr[_i];
            support.removeCarried(element);
          }
          if (!this.contained(element.parent())) {
            this.fallingElements.delete(element);
          }
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      var _iterator24 = _createForOfIteratorHelper(this.draggeds),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _element4 = _step24.value;
          if (this.contained(_element4.parent())) {
            // La ligne qui suit est utile en cas de cancelDrop...
            if (this.sweepAndPrune.registerElement(_element4)) {
              this.sweepAndPrune.updateElement(_element4);
            }
            // Ce qui suit est utile en cas de drop réussit ou... cancel drop (car le drag a supprimé les attachements de départ)
            var topSide = this.sweepAndPrune.onTopSide(_element4);
            var _iterator25 = _createForOfIteratorHelper(topSide),
              _step25;
            try {
              for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                var sideElement = _step25.value;
                if (sideElement.stickOnBottom && !_context.default.physicsManager.denySticking(sideElement, _element4)) {
                  sideElement.stickOnBottom(_element4);
                }
              }
            } catch (err) {
              _iterator25.e(err);
            } finally {
              _iterator25.f();
            }
            var leftSide = this.sweepAndPrune.onLeftSide(_element4);
            var _iterator26 = _createForOfIteratorHelper(leftSide),
              _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var _sideElement = _step26.value;
                if (_sideElement.stickOnRight && !_context.default.physicsManager.denySticking(_sideElement, _element4)) {
                  _sideElement.stickOnRight(_element4);
                }
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
            var rightSide = this.sweepAndPrune.onRightSide(_element4);
            var _iterator27 = _createForOfIteratorHelper(rightSide),
              _step27;
            try {
              for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                var _sideElement2 = _step27.value;
                if (_sideElement2.stickOnLeft && !_context.default.physicsManager.denySticking(_sideElement2, _element4)) {
                  _sideElement2.stickOnLeft(_element4);
                }
              }
            } catch (err) {
              _iterator27.e(err);
            } finally {
              _iterator27.f();
            }
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      this.draggeds = new Set();
      return this.manageGravitation();
    }
  }, {
    key: "geometryChanged",
    value: function geometryChanged(element) {
      if (this.sweepAndPrune.know(element)) {
        this._computeAllPositions();
        var elements = new Set(this.sweepAndPrune.collidesWith(element));
        this._applyGravitationForSet(elements);
      }
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      if (type === "add") {
        this.add(value);
      } else if (type === "remove") {
        this.remove(value);
      } else if (type === "child-geometry") {
        this.geometryChanged(value);
      }
      if (type === "drag-drop") {
        this.manageDrop();
      }
    }
  }, {
    key: "manageGravitation",
    value: function manageGravitation() {
      var result = this._applyGravitationForSet(this.fallingElements);
      if (!result) {
        _context.default.memento.cancel();
      }
      this.fallingElements.clear();
      return result;
    }
  }, {
    key: "_checkForGravitation",
    value: function _checkForGravitation(element, inserted) {
      if (inserted) {
        this.fallingElements.add(element);
        this._requestExecution();
      } else {
        this.fallingElements.delete(element);
      }
      var _iterator28 = _createForOfIteratorHelper(element.carried),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var _supported = _step28.value;
          this._checkForGravitation(_supported.element, true);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      if (!inserted) {
        var _iterator29 = _createForOfIteratorHelper(element.sticked),
          _step29;
        try {
          for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
            var supported = _step29.value;
            this._checkForGravitation(supported.element, true);
          }
        } catch (err) {
          _iterator29.e(err);
        } finally {
          _iterator29.f();
        }
      }
    }

    /**
     * Repositionne un élément en fonction de coordonnées données selon le système de coordonnées de l'objet Physics, et
     * ce, que l'élément soit déjà posé sur l'objet propriétaire de la Physics ou bien la glace de Drag And Drop.
     * @param element element a repositionner
     * @param x abscisse de la position désirée selon le système de coordonées de la Physics
     * @param y ordonnée de la position désirée selon le système de coordonées de la Physics
     * @private
     */
  }, {
    key: "_setPosition",
    value: function _setPosition(element, px, py) {
      var _computePosition4 = (0, _toolkit.computePosition)(this.host.root, element.root.parent(), px, py),
        x = _computePosition4.x,
        y = _computePosition4.y;
      // MATRIX:  element.root.transform(new Snap.Matrix().translate(x, y));
      element.root.localMatrix = new Snap.Matrix().translate(x, y);
    }

    /**
     * Donne la position d'un élément en fonction de coordonnées données selon le système de coordonnées de l'objet Physics, et
     * ce, que l'élément soit déjà posé sur l'objet propriétaire de la Physics ou bien la glace de Drag And Drop.
     * @param element élément dont on cherche la position
     * @private
     */
  }, {
    key: "_getPosition",
    value: function _getPosition(element) {
      return (0, _toolkit.computePosition)(element.root.parent(), this.host.root, element.posX, element.posY);
    }
  }, {
    key: "_avoidCollisionForElement",
    value: function _avoidCollisionForElement(element) {
      var _this4 = this;
      var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
      var put = function put(element, x, y) {
        _this4._setPosition(element, x, y);
        _this4._updateCollisionInternals(element);
      };
      var adjustOnX = function adjustOnX(target, ox, hx) {
        if (ox > hx) {
          var rx = _this4.sweepAndPrune.right(target) + element.width / 2;
          return ox < rx || rx === hx ? null : rx;
        } else if (ox < hx) {
          var _rx = _this4.sweepAndPrune.left(target) - element.width / 2;
          return ox > _rx || _rx === hx ? null : _rx;
        } else return null;
      };
      var adjustOnY = function adjustOnY(target, oy, hy) {
        if (oy > hy) {
          var ry = _this4.sweepAndPrune.bottom(target) + element.height / 2;
          return oy < ry || ry === hy ? null : ry;
        } else if (oy < hy) {
          var _ry = _this4.sweepAndPrune.top(target) - element.height / 2;
          return oy > _ry || _ry === hy ? null : _ry;
        } else return null;
      };
      exclude.add(element);
      var _computePosition5 = (0, _toolkit.computePosition)(element.root, this.host.root),
        sx = _computePosition5.x,
        sy = _computePosition5.y;
      var hx = sx,
        hy = sy;
      var finished = false;
      var originMatrix = this.host.globalChange;
      var invertedMatrix = originMatrix.invert();
      var ox = invertedMatrix.x(element.validX, element.validY);
      var oy = invertedMatrix.y(element.validX, element.validY);
      var cycleCount = 0;
      while (!finished && cycleCount < 100) {
        cycleCount++;
        var cycleCase = 0;
        var targets = this._collidedTargets(element, exclude);
        if (targets.length > 0) {
          var target = targets[0];
          var fx = adjustOnX(target, ox, hx);
          var fy = adjustOnY(target, oy, hy);
          if (fx !== null && fy !== null) {
            cycleCase = 1;
            var dx = hx > fx ? hx - fx : fx - hx;
            var dy = hy > fy ? hy - fy : fy - hy;
            if (dx > dy) {
              hy = fy;
            } else {
              hx = fx;
            }
          } else if (fx !== null) {
            cycleCase = 2;
            hx = fx;
          } else if (fy !== null) {
            cycleCase = 3;
            hy = fy;
          } else {
            cycleCase = 4;
            hx = ox;
            hy = oy;
            finished = true;
          }
          put(element, hx, hy);
        } else {
          finished = true;
        }
      }
      if (Math.abs(hx - sx) > _context.default.ADJUST_MARGIN || Math.abs(hy - sy) > _context.default.ADJUST_MARGIN) {
        put(element, sx, sy, true);
        element.INVALID = true;
      } else {
        element.validX = originMatrix.x(hx, hy);
        element.validY = originMatrix.y(hx, hy);
        delete element.INVALID;
      }
      exclude.delete(element);
    }
  }, {
    key: "_avoidCollisionsForListOfElements",
    value: function _avoidCollisionsForListOfElements(set) {
      var _this5 = this;
      var exclude = new Set(set);
      var _iterator30 = _createForOfIteratorHelper(set),
        _step30;
      try {
        var _loop = function _loop() {
          var element = _step30.value;
          (0, _toolkit.evaluate)("avoidCollisitonForElement", function () {
            _this5._avoidCollisionForElement(element, exclude);
          });
        };
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }
  }, {
    key: "_computePosition",
    value: function _computePosition(element) {
      if (element instanceof PhysicsBorder) {
        this.sweepAndPrune.x(element, element.x());
        this.sweepAndPrune.y(element, element.y());
        this.sweepAndPrune.left(element, element.x() - element.width / 2);
        this.sweepAndPrune.right(element, element.x() + element.width / 2);
        this.sweepAndPrune.top(element, element.y() - element.height / 2);
        this.sweepAndPrune.bottom(element, element.y() + element.height / 2);
      } else if (this.contained(element.parent())) {
        this.sweepAndPrune.x(element, element.posX);
        this.sweepAndPrune.y(element, element.posY);
        this.sweepAndPrune.left(element, element.posLeft);
        this.sweepAndPrune.right(element, element.posRight);
        this.sweepAndPrune.top(element, element.posTop);
        this.sweepAndPrune.bottom(element, element.posBottom);
      } else {
        var _computePosition6 = (0, _toolkit.computePosition)(element.root, this.host.root),
          x = _computePosition6.x,
          y = _computePosition6.y;
        this.sweepAndPrune.x(element, x);
        this.sweepAndPrune.y(element, y);
        this.sweepAndPrune.left(element, x - element.width / 2);
        this.sweepAndPrune.right(element, x + element.width / 2);
        this.sweepAndPrune.top(element, y - element.height / 2);
        this.sweepAndPrune.bottom(element, y + element.height / 2);
      }
    }
  }, {
    key: "_computeAllPositions",
    value: function _computeAllPositions() {
      var _iterator31 = _createForOfIteratorHelper(this.sweepAndPrune.elements()),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var child = _step31.value;
          this._computePosition(child);
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      this.sweepAndPrune.updateCollisions();
    }
  }, {
    key: "_updateCollisionInternals",
    value: function _updateCollisionInternals(child) {
      this._computePosition(child);
      this.sweepAndPrune.updateElement(child);
    }
  }, {
    key: "_applyGravitation",
    value: function _applyGravitation(element, collides) {
      var _this6 = this;
      var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set(this.draggeds);
      var computeTop = function computeTop(exclude, elements, initialValue) {
        var top = initialValue;
        var targets = new _toolkit.List();
        var _iterator32 = _createForOfIteratorHelper(elements),
          _step32;
        try {
          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
            var elem = _step32.value;
            if (elem !== exclude) {
              var eTop = _this6.sweepAndPrune.top(elem);
              if (eTop < top) {
                top = eTop;
                targets.length = 0;
              }
              if (eTop === top) {
                targets.add(elem);
              }
            }
          }
        } catch (err) {
          _iterator32.e(err);
        } finally {
          _iterator32.f();
        }
        return {
          top: top,
          targets: targets
        };
      };
      var addCarried = function addCarried(element, targets) {
        var _iterator33 = _createForOfIteratorHelper(targets),
          _step33;
        try {
          for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
            var target = _step33.value;
            if (_context.default.physicsManager.denyCarrying(target, element)) {
              console.log("cancelDrop: deny carrying");
              return false;
            }
          }
        } catch (err) {
          _iterator33.e(err);
        } finally {
          _iterator33.f();
        }
        var _iterator34 = _createForOfIteratorHelper(targets),
          _step34;
        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var _target = _step34.value;
            _target.addCarried && _target.addCarried(element);
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }
        return true;
      };
      var result = true;
      if (this.canFall(element)) {
        exclude.add(element);
        //let pTop = -this.host.height / 2;
        var pBottom = this.host.height / 2;
        var elementMatrix = element.localTranslation;
        var cTop = elementMatrix.y(0, -element.height / 2);
        var cBottom = elementMatrix.y(0, element.height / 2);
        var cLeft = elementMatrix.x(-element.width / 2, 0);
        var cRight = elementMatrix.x(element.width / 2, 0);
        var check = this.sweepAndPrune.elementsInBox(cLeft, cTop, cRight, pBottom).filter(function (element) {
          return !exclude.has(element);
        });
        var _computeTop = computeTop(element, check, pBottom),
          top = _computeTop.top,
          targets = _computeTop.targets;
        if (addCarried(element, targets)) {
          var cx = elementMatrix.x(0, 0);
          var cy = elementMatrix.y(0, 0);
          var ny = top - cBottom + cy;
          if (ny < element.posY) {
            return false;
          }
          element.position(cx, ny);
        } else {
          return false;
        }
        if (this.sweepAndPrune.know(element)) {
          this._updateCollisionInternals(element);
          var collidedElements = this._collidedTargets(element, exclude);
          var _iterator35 = _createForOfIteratorHelper(collidedElements),
            _step35;
          try {
            for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
              var collideElement = _step35.value;
              if (this.canFall(collideElement)) {
                collides.add(collideElement);
              } else {
                collides.add(element);
              }
            }
            //result = pTop != top;
          } catch (err) {
            _iterator35.e(err);
          } finally {
            _iterator35.f();
          }
        }
      }
      exclude.delete(element);
      //return result;
      return true;
    }
  }, {
    key: "_applyGravitationForSet",
    value: function _applyGravitationForSet(fallingElements) {
      var _this7 = this;
      var applyGravitation = function applyGravitation(fallingElements, collide) {
        if (fallingElements.size > 0) {
          var elements = (0, _toConsumableArray2.default)(fallingElements.keys()).sort(function (c1, c2) {
            var c1Bottom = _this7.sweepAndPrune.bottom(c1);
            var c2Bottom = _this7.sweepAndPrune.bottom(c2);
            return c2Bottom - c1Bottom;
          });
          var exclude = new Set(elements);
          var _result = true;
          var _iterator36 = _createForOfIteratorHelper(_this7.draggeds),
            _step36;
          try {
            for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
              var element = _step36.value;
              exclude.add(element);
            }
          } catch (err) {
            _iterator36.e(err);
          } finally {
            _iterator36.f();
          }
          var _iterator37 = _createForOfIteratorHelper(elements),
            _step37;
          try {
            for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
              var child = _step37.value;
              if (!_this7._applyGravitation(child, collide, exclude)) {
                _result = false;
              }
            }
          } catch (err) {
            _iterator37.e(err);
          } finally {
            _iterator37.f();
          }
          return _result;
        }
        return true;
      };
      if (fallingElements.size > 0) {
        this._computeAllPositions();
      }
      var result = true;
      var loops = 0;
      while (fallingElements.size > 0 && loops < _context.default.MAX_LOOPS) {
        var collide = new Set();
        var aResult = applyGravitation(fallingElements, collide);
        result = result && aResult;
        fallingElements = collide;
        loops++;
      }
      return result;
    }
  }, {
    key: "_collidedTargets",
    value: function _collidedTargets(element, exclude) {
      var collidedTargets = this.sweepAndPrune.collidesWith(element);
      var result = new _toolkit.List();
      var _iterator38 = _createForOfIteratorHelper(collidedTargets),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var target = _step38.value;
          if (!exclude.has(target) && this.sweepAndPrune.doesCollide(element, target)) {
            result.add(target);
          }
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
      return result;
    }
  }, {
    key: "_requestExecution",
    value: function _requestExecution() {
      var _this8 = this;
      if (!this.launched) {
        setTimeout(function () {
          _this8.launched = false;
          _this8.manageGravitation();
        }, 0);
        this.launched = true;
      }
    }
  }, {
    key: "leftBorder",
    value: function leftBorder() {
      var _this9 = this;
      this._leftBorder = new PhysicsBorder(this.host, function () {
        return -_this9.host.width / 2;
      }, function () {
        return 0;
      }, function () {
        return 0;
      }, function () {
        return _this9.host.height;
      });
      this.sweepAndPrune.registerElement(this._leftBorder);
      return this;
    }
  }, {
    key: "rightBorder",
    value: function rightBorder() {
      var _this0 = this;
      this._rightBorder = new PhysicsBorder(this.host, function () {
        return _this0.host.width / 2;
      }, function () {
        return 0;
      }, function () {
        return 0;
      }, function () {
        return _this0.host.height;
      });
      this.sweepAndPrune.registerElement(this._rightBorder);
      return this;
    }
  }, {
    key: "topBorder",
    value: function topBorder() {
      var _this1 = this;
      this._topBorder = new PhysicsBorder(this.host, function () {
        return 0;
      }, function () {
        return -_this1.host.height / 2;
      }, function () {
        return _this1.host.width;
      }, function () {
        return 0;
      });
      this.sweepAndPrune.registerElement(this._topBorder);
      return this;
    }
  }, {
    key: "bottomBorder",
    value: function bottomBorder() {
      var _this10 = this;
      this._bottomBorder = new PhysicsBorder(this.host, function () {
        return 0;
      }, function () {
        return _this10.host.height / 2;
      }, function () {
        return _this10.host.width;
      }, function () {
        return 0;
      });
      this.sweepAndPrune.registerElement(this._bottomBorder);
      return this;
    }
  }, {
    key: "elementsInBox",
    value: function elementsInBox(left, top, right, bottom) {
      return this.sweepAndPrune.elementsInBox(left, top, right, bottom);
    }
  }, {
    key: "updateElement",
    value: function updateElement(element) {
      this.sweepAndPrune.updateElement(element);
    }
  }]);
}();
function physics() {
  _context.default.physicsManager = undefined;
  _context.default.COLLISION_MARGIN = 0.001;
  _context.default.ADJUST_MARGIN = 40;
  _context.default.MAX_LOOPS = 10;
  _context.default.physicsManager = new PhysicsManager();
}
},{"@babel/runtime/helpers/toConsumableArray":"Fhqp","@babel/runtime/helpers/possibleConstructorReturn":"pxk2","@babel/runtime/helpers/getPrototypeOf":"UJE0","@babel/runtime/helpers/get":"J5UC","@babel/runtime/helpers/inherits":"d4H2","@babel/runtime/helpers/classCallCheck":"fcMS","@babel/runtime/helpers/createClass":"P8NW","./context":"FcC3","./toolkit":"m1yP"}],"deFW":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elements;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _snap = _interopRequireDefault(require("../snap"));
var _context5 = _interopRequireDefault(require("./context"));
var _physics = require("./physics");
var _toolkit = require("./toolkit");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2.default)((0, _getPrototypeOf2.default)(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var HOOK_SEARCH_MARGIN = 50;
var FIXING_WIDTH = 16;
var FIXING_HEIGHT = 6;
var FIXING_DEVICE_RADIUS = 2;
var PAPER_MARGIN = 10;
window.BoardPaneContent = /*#__PURE__*/function (_BoardItem) {
  function BoardPaneContent(pane, width, height) {
    var _this;
    (0, _classCallCheck2.default)(this, BoardPaneContent);
    _this = _callSuper(this, BoardPaneContent, [width, height]);
    _this.pane = pane;
    _this._dragOperation(_context5.default.parentDrag);
    //this._doubleClickHandler(event => this.pane.doubleClickHdlImpl(event));
    _this.createOwnedStructure(width, height);
    _this.createContentStructure();
    return _this;
  }
  (0, _inherits2.default)(BoardPaneContent, _BoardItem);
  return (0, _createClass2.default)(BoardPaneContent, [{
    key: "createOwnedStructure",
    value: function createOwnedStructure(width, height) {
      this.fr = this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.MIDDLE_GREY,
        fill: _context5.default.WHITE
      });
      this.fr.owner = this;
      this.el = this.plain.rect(-width / 2, -height / 2, width, height);
      this.el.owner = this;
      this.legends = this.owned.group();
      this.legends.attr({
        opacity: _context5.default.visualizer.legend ? 1 : 0
      });
    }
  }, {
    key: "_visualization",
    value: function _visualization() {
      _superPropGet(BoardPaneContent, "_visualization", this, 3)([]);
      this.legends && this.legends.attr({
        opacity: _context5.default.visualizer.legend ? 1 : 0
      });
      this.coverLayer && this.coverLayer.attr({
        opacity: _context5.default.visualizer.cover ? 1 : 0
      });
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      var _this2 = this;
      this._addMenuOption(_context5.default.generateLaddersMenuOption.instance(function () {
        _this2.editLadderGeneration();
      }));
      this._addMenuOption(_context5.default.generateFixingsMenuOption.instance(function () {
        _this2.editFixingGeneration();
      }));
      this._addMenuOption(_context5.default.generateHooksMenuOption.instance(function () {
        _this2.editHookGeneration();
      }));
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      return (0, _construct2.default)(_toolkit.List, (0, _toConsumableArray2.default)(this.pane.collectMenuOptions()).concat((0, _toConsumableArray2.default)(this.menuOptions)));
    }
  }, {
    key: "createContentStructure",
    value: function createContentStructure() {
      this.downLayer = this.content.group();
      this.middleLayer = this.content.group();
      this.upLayer = this.content.group();
      this.coverLayer = this.content.group();
      this.observers.add(this);
      this.physics = new _physics.Physics(this, function (element) {
        var result = !element.free && (element instanceof BoardShelf || element instanceof BoardModule || element instanceof BoardBlister || element instanceof BoardDivider || element instanceof BoardCaddy);
        return result;
      }, function (element) {
        var result = element instanceof BoardModule;
        return result;
      }).leftBorder().rightBorder().bottomBorder();
      this.coverLayer.attr({
        opacity: _context5.default.visualizer.cover ? 1 : 0
      });
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this.pane.selectable();
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      var _this3 = this;
      _superPropGet(BoardPaneContent, "changed", this, 3)([source, type, value]);
      if (source === this && (type === "add" || type === "remove" || type === "child-geometry")) {
        if (!this.legendComputed) {
          this.legendComputed = true;
          setTimeout(function () {
            _this3.computeLegend();
            delete _this3.legendComputed;
          }, 0);
        }
      }
    }
  }, {
    key: "computeLegend",
    value: function computeLegend() {
      var _this4 = this;
      var collect = function collect(element, xs, ys) {
        if (_this4.legendElement(element)) {
          xs.add(element.posX);
          ys.add(element.posY);
        }
      };
      var label = function label(index) {
        if (index < 26) {
          return String.fromCharCode(65 + index);
        }
        if (index < 26 + 26 * 26) {
          return String.fromCharCode(65 + Math.floor((index - 26) / 26)) + String.fromCharCode(65 + (index - 26) % 26);
        }
        return String.fromCharCode(65 + Math.floor((index - 26 - 26 * 26) / 26 * 26)) + String.fromCharCode(65 + Math.floor((index - 26 - 26 * 26) % (26 * 26) / 26)) + String.fromCharCode(65 + (index - 26 - 26 * 26) % 26);
      };
      var xs = new Set();
      var ys = new Set();
      var _iterator = _createForOfIteratorHelper(this.children()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          collect(element, xs, ys);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.legends.remove();
      this.legends = this.owned.group();
      var xIndex = 0;
      var xt = (0, _toConsumableArray2.default)(xs).sort(function (a, b) {
        return a - b;
      });
      var _iterator2 = _createForOfIteratorHelper(xt),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var x = _step2.value;
          var line = x === xt[0] ? this.legends.line(x, -this.height / 2, x, this.height / 2 + _context5.default.LEGEND_MARGIN * 3) : this.legends.line(x, -this.height / 2, x, this.height / 2 + _context5.default.LEGEND_MARGIN * 2);
          line.attr({
            stroke: _context5.default.MIDDLE_GREY
          });
          line.owner = this;
          if (x === xt[0]) {
            this.legends.text(x + _context5.default.TEXT_LEGEND_MARGIN, this.height / 2 + _context5.default.LEGEND_MARGIN * 3, this.pane.label).attr({
              fill: _context5.default.MIDDLE_GREY,
              "alignment-baseline": "text-after-edge"
            });
          }
          this.legends.text(x + _context5.default.TEXT_LEGEND_MARGIN, this.height / 2 + _context5.default.LEGEND_MARGIN * 2, label(xIndex++)).attr({
            fill: _context5.default.MIDDLE_GREY,
            "alignment-baseline": "text-after-edge"
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var yIndex = 1;
      var yt = (0, _toConsumableArray2.default)(ys).sort(function (a, b) {
        return b - a;
      });
      var _iterator3 = _createForOfIteratorHelper(yt),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var y = _step3.value;
          var _line = this.legends.line(-this.width / 2 - _context5.default.LEGEND_MARGIN, y, this.width / 2, y).attr({
            stroke: _context5.default.MIDDLE_GREY
          });
          _line.owner = this;
          this.legends.text(-this.width / 2 - _context5.default.LEGEND_MARGIN, y - _context5.default.TEXT_LEGEND_MARGIN, "" + yIndex++).attr({
            fill: _context5.default.MIDDLE_GREY
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "editGrid",
    value: function (_editGrid) {
      function editGrid() {
        return _editGrid.apply(this, arguments);
      }
      editGrid.toString = function () {
        return _editGrid.toString();
      };
      return editGrid;
    }(function () {
      var _this5 = this;
      if (editGrid !== undefined) {
        _context5.default.canvas.openModal(editGrid, {
          gridStep: this.physics.gridStep / _context5.default.rescaleFactor
        }, function (data) {
          _this5.physics.gridStep = data.gridStep * _context5.default.rescaleFactor;
        });
      } else {
        this.physics.gridStep = this.physics.gridStep ? 0 : 10;
      }
    })
  }, {
    key: "editLadderGeneration",
    value: function editLadderGeneration() {
      var _this6 = this;
      _context5.default.canvas.openModal(generateLadders, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        element: this
      }, function (data) {
        _this6.generateLadders(data);
      });
    }
  }, {
    key: "editFixingGeneration",
    value: function editFixingGeneration() {
      var _this7 = this;
      _context5.default.canvas.openModal(generateFixings, {
        element: this,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor
      }, function (data) {
        _this7.generateFixings(data);
      });
    }
  }, {
    key: "editHookGeneration",
    value: function editHookGeneration() {
      var _this8 = this;
      _context5.default.canvas.openModal(generateHooks, {
        element: this,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor
      }, function (data) {
        _this8.generateHooks(data);
      });
    }
  }, {
    key: "generateLadders",
    value: function generateLadders(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        var leftLadder = BoardLadder.create(data.ladderWidth, data.ladderHeight, data.topPawl, data.bottomPawl, data.pawlInterval).position(data.left * _context5.default.rescaleFactor + data.ladderWidth * _context5.default.rescaleFactor / 2, data.y * _context5.default.rescaleFactor);
        this.add(leftLadder);
        var rightLadder = BoardLadder.create(data.ladderWidth, data.ladderHeight, data.topPawl, data.bottomPawl, data.pawlInterval).position(data.right * _context5.default.rescaleFactor - data.ladderWidth * _context5.default.rescaleFactor / 2, data.y * _context5.default.rescaleFactor);
        this.add(rightLadder);
        var width = (data.right - data.left) * _context5.default.rescaleFactor;
        for (var index = 1; index <= data.intermediateLaddersCount; index++) {
          var x = width * index / (data.intermediateLaddersCount + 1) + data.left * _context5.default.rescaleFactor;
          var ladder = BoardDoubleLadder.create(data.ladderWidth * 2, data.ladderHeight, data.topPawl, data.bottomPawl, data.pawlInterval).position(x, data.y * _context5.default.rescaleFactor);
          this.add(ladder);
        }
      }
    }
  }, {
    key: "generateFixings",
    value: function generateFixings(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        for (var x = data.left * _context5.default.rescaleFactor; x <= data.right * _context5.default.rescaleFactor; x += data.caddyWidth * _context5.default.rescaleFactor) {
          for (var y = data.top * _context5.default.rescaleFactor; y <= data.bottom * _context5.default.rescaleFactor; y += data.caddyHeight * _context5.default.rescaleFactor) {
            var fixing = BoardFixing.create().position(x, y);
            fixing.fixed = true;
            fixing.fixing();
            this.add(fixing);
          }
        }
      }
    }
  }, {
    key: "generateHooks",
    value: function generateHooks(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        for (var x = data.left * _context5.default.rescaleFactor; x <= data.right * _context5.default.rescaleFactor; x += data.blisterWidth * _context5.default.rescaleFactor) {
          for (var y = data.top * _context5.default.rescaleFactor; y <= data.bottom * _context5.default.rescaleFactor; y += data.blisterHeight * _context5.default.rescaleFactor) {
            var hook = BoardHook.create().position(x, y);
            this.add(hook);
          }
        }
      }
    }
  }, {
    key: "_resize",
    value: function _resize(width, height) {
      _superPropGet(BoardPaneContent, "_resize", this, 3)([width, height]);
      this.fr.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
      this.el.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.register();
      this._resize(width, height);
      this._dispatchChange("geometry");
      if (this.parent() && this.parent()._dispatchChange) {
        this.parent()._dispatchChange("child-geometry", this);
      }
    }
  }, {
    key: "update",
    value: function update(data) {
      this.register();
      this.fix(data.fixed);
      this.resize(data.contentWidth * _context5.default.rescaleFactor, data.contentHeight * _context5.default.rescaleFactor);
      this.computeLegend();
    }
  }, {
    key: "editPaneExtension",
    value: function editPaneExtension() {
      var _this9 = this;
      _context5.default.canvas.openModal(extendsPane, {
        element: this,
        contentWidth: this.width / _context5.default.rescaleFactor,
        contentHeight: this.height / _context5.default.rescaleFactor
      }, function (data) {
        if (!_context5.default.isReadOnly()) {
          _context5.default.memento.open();
          _this9.extendsPane(data);
        }
      });
    }
  }, {
    key: "extendsPane",
    value: function extendsPane(data) {
      var width = data.contentWidth * _context5.default.rescaleFactor;
      var height = data.contentHeight * _context5.default.rescaleFactor;
      var dWidth = width - this.width;
      var dHeight = height - this.height;
      var pWidth = this.pane.width + dWidth;
      var pHeight = this.pane.height + dHeight;
      this.resize(width, height);
      this.pane.resize(pWidth, pHeight);
      this.pane.paneHeader.resize(pWidth, this.pane.paneHeader.height);
      this.pane.paneFooter.resize(pWidth, this.pane.paneFooter.height);
      var _iterator4 = _createForOfIteratorHelper(this.children()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var element = _step4.value;
          var x = element.posX;
          var y = element.posY + dHeight / 2;
          if (data.direction === "l") {
            x += dWidth / 2;
          } else {
            x -= dWidth / 2;
          }
          element.position(x, y);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.computeLegend();
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      _superPropGet(BoardPaneContent, "linkContent", this, 3)([elements]);
      var copy = elements.get(this);
      copy.physics.clean(copy.children());
      copy.computeLegend();
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardPaneContent, "memento", this, 3)([]);
      memento.width = this.width;
      memento.height = this.height;
      memento.fr = this.fr;
      memento.el = this.el;
      memento.legends = this.legends;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardPaneContent, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this._resize(memento.width, memento.height);
      this.legends = memento.legends;
    }
  }, {
    key: "recover",
    value: function recover(memento) {
      this.computeLegend();
      this.physics.revert(this.children());
    }
  }, {
    key: "_add",
    value: function _add(element) {
      if (element.layer === "cover") {
        this.coverLayer.add(element.root);
      } else if (element.layer === "up") {
        this.upLayer.add(element.root);
      } else if (element.layer === "middle") {
        this.middleLayer.add(element.root);
      } else if (element.layer === "down") {
        this.downLayer.add(element.root);
      }
    }
  }, {
    key: "_children",
    value: function _children() {
      var children = new _toolkit.List();
      var _iterator5 = _createForOfIteratorHelper(this.downLayer.children()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var child = _step5.value;
          child.owner && children.add(child.owner);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var _iterator6 = _createForOfIteratorHelper(this.middleLayer.children()),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _child = _step6.value;
          _child.owner && children.add(_child.owner);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      var _iterator7 = _createForOfIteratorHelper(this.upLayer.children()),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _child2 = _step7.value;
          _child2.owner && children.add(_child2.owner);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      var _iterator8 = _createForOfIteratorHelper(this.coverLayer.children()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _child3 = _step8.value;
          _child3.owner && children.add(_child3.owner);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return children;
    }
  }, {
    key: "legendElement",
    value: function legendElement(element) {
      return element instanceof BoardHook || element instanceof BoardFixing || element instanceof BoardShelf;
    }
  }, {
    key: "clipsableElement",
    value: function clipsableElement(element) {
      return element instanceof BoardShelf || element instanceof BoardAbstractCaddy || element instanceof BoardBlister;
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardPaneContent, "receiveDrop", this, 3)([element]);
      if (result === undefined) {
        result = this.add(element);
        if (this.clipsableElement(element)) {
          result = element.tryToClip(this);
        }
      }
      return result;
    }
  }, {
    key: "adjustDrop",
    value: function adjustDrop(element) {
      if (this.clipsableElement(element)) {
        element.executeClip();
      }
    }
  }, {
    key: "searchPawl",
    value: function searchPawl(x, y, margin) {
      var result;
      var _iterator9 = _createForOfIteratorHelper(this.children()),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var element = _step9.value;
          if (element.searchPawl) {
            var lresult = element.searchPawl(x, y, margin);
            if (lresult && (!result || result.distance > lresult.distance)) {
              result = lresult;
            }
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return result;
    }
  }, {
    key: "searchFixing",
    value: function searchFixing(x, y, margin) {
      var result;
      var _iterator0 = _createForOfIteratorHelper(this.children()),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var element = _step0.value;
          if (element.searchFixing && Math.abs(element.posX - x) <= margin) {
            var lresult = element.searchFixing(x, y, margin);
            if (lresult && (!result || result.distance > lresult.distance)) {
              result = lresult;
            }
          }
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      return result;
    }
  }, {
    key: "searchHook",
    value: function searchHook(x, y, margin) {
      var result;
      var _iterator1 = _createForOfIteratorHelper(this.children()),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var element = _step1.value;
          if (element.searchHook && Math.abs(element.posX - x) <= margin) {
            var lresult = element.searchHook(x, y, margin);
            if (lresult && (!result || result.distance > lresult.distance)) {
              result = lresult;
            }
          }
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      return result;
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }]);
}(BoardItem);
window.BoardPane = /*#__PURE__*/function (_BoardItem2) {
  function BoardPane(width, height, contentX, contentY, contentWidth, contentHeight, headerHeight, footerHeight, label, leftAdhesive, rightAdhesive) {
    var _this0;
    (0, _classCallCheck2.default)(this, BoardPane);
    _this0 = _callSuper(this, BoardPane, [width, height]);
    _this0.label = _this0.createLabel();
    _this0.leftAdhesive = leftAdhesive;
    _this0.rightAdhesive = rightAdhesive;
    _this0.paneContent = _this0.createPaneContent(contentX, contentY, contentWidth, contentHeight).position(contentX, contentY);
    _this0._add(_this0.paneContent);
    _this0.paneHeader = _this0.createPaneHeader(width, height, headerHeight).position(0, -height / 2 + headerHeight / 2);
    _this0.paneFooter = _this0.createPaneFooter(width, height, footerHeight).position(0, height / 2 - footerHeight / 2);
    _this0._add(_this0.paneHeader);
    _this0._add(_this0.paneFooter);
    _this0._dragOperation(_context5.default.standardDrag);
    _this0.fr = _this0.frame.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context5.default.BLACK,
      fill: _context5.default.WHITE
    });
    _this0.fr.owner = _this0;
    _this0.el = _this0.plain.rect(-width / 2, -height / 2, width, height);
    _this0.el.owner = _this0;
    _this0._visualizeArtwork();
    _this0.showLabel();
    return _this0;
  }
  (0, _inherits2.default)(BoardPane, _BoardItem2);
  return (0, _createClass2.default)(BoardPane, [{
    key: "makeHeaderAndFooterRetractable",
    value: function makeHeaderAndFooterRetractable() {
      var _this1 = this;
      var headerAndFooterMenuOption = _context5.default.headerAndFooterMenuOption.instance(function () {
        _context5.default.showHeaderAndFooter(_this1);
      }, function () {
        _context5.default.hideHeaderAndFooter(_this1);
      }, function () {
        return _context5.default.headerAndFooterVisible(_this1);
      });
      this._addMenuOption(headerAndFooterMenuOption);
    }
  }, {
    key: "makeGridActive",
    value: function makeGridActive() {
      var _this10 = this;
      var gridMenuOption = _context5.default.gridMenuOption.instance(function () {
        _this10.paneContent.editGrid();
      }, function () {
        _this10.paneContent.physics.gridStep = 0;
      }, function () {
        return !!_this10.paneContent.physics.gridStep;
      });
      this._addMenuOption(gridMenuOption);
    }
  }, {
    key: "makePaneExtendable",
    value: function makePaneExtendable() {
      var _this11 = this;
      this._addMenuOption(_context5.default.extendsPaneMenuOption.instance(function () {
        _this11.paneContent.editPaneExtension();
      }));
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardPane, "createContextMenu", this, 3)([]);
      this.makeHeaderAndFooterRetractable();
      this.makeGridActive();
      this.makePaneExtendable();
    }
  }, {
    key: "createPaneContent",
    value: function createPaneContent(contentX, contentY, contentWidth, contentHeight) {
      return new BoardPaneContent(this, contentWidth, contentHeight);
    }
  }, {
    key: "createPaneHeader",
    value: function createPaneHeader(width, height, headerHeight) {
      return new BoardCover(this, width, headerHeight);
    }
  }, {
    key: "createPaneFooter",
    value: function createPaneFooter(width, height, footerHeight) {
      return new BoardCover(this, width, footerHeight);
    }
  }, {
    key: "createLabel",
    value: function createLabel() {
      var panes = [].concat((0, _toConsumableArray2.default)(_context5.default.table.children()), (0, _toConsumableArray2.default)(_context5.default.table.paper.allChildren()), (0, _toConsumableArray2.default)(_context5.default.selection.extendedSelection())).filter(function (element) {
        return element instanceof BoardPane;
      });
      var index = 0,
        found = false;
      var label = "";
      while (!found) {
        index++;
        label = ("00" + index).substring(("00" + index).length - 3);
        found = true;
        var _iterator10 = _createForOfIteratorHelper(panes),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var pane = _step10.value;
            if (pane.label === label) {
              found = false;
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      return label;
    }
  }, {
    key: "showLabel",
    value: function showLabel() {
      var label = this.decorate.group();
    }
  }, {
    key: "_visualizeArtwork",
    value: function _visualizeArtwork() {
      if (_context5.default.visualizer.artwork) {
        this.paneHeader && this.paneHeader.show();
        this.paneFooter && this.paneFooter.show();
      } else {
        this.paneHeader && this.paneHeader.hide();
        this.paneFooter && this.paneFooter.hide();
      }
    }
  }, {
    key: "_visualization",
    value: function _visualization() {
      _superPropGet(BoardPane, "_visualization", this, 3)([]);
      this._visualizeArtwork();
    }
  }, {
    key: "applyHighlight",
    value: function applyHighlight(color) {
      _superPropGet(BoardPane, "applyHighlight", this, 3)([color]);
      this.paneContent.applyHighlight(color);
      this.paneHeader.applyHighlight(color);
      this.paneFooter.applyHighlight(color);
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      _superPropGet(BoardPane, "removeHighlight", this, 3)([]);
      this.paneContent.removeHighlight();
      this.paneHeader.removeHighlight();
      this.paneFooter.removeHighlight();
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this12 = this;
      _context5.default.canvas.openModal(editBoardPane, {
        element: this,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        label: this.label,
        contentX: this.paneContent.posX / _context5.default.rescaleFactor,
        contentY: this.paneContent.posY / _context5.default.rescaleFactor,
        contentWidth: this.paneContent.width / _context5.default.rescaleFactor,
        contentHeight: this.paneContent.height / _context5.default.rescaleFactor,
        headerHeight: this.paneHeader.height / _context5.default.rescaleFactor,
        footerHeight: this.paneFooter.height / _context5.default.rescaleFactor,
        leftAdhesive: this.leftAdhesive,
        rightAdhesive: this.rightAdhesive,
        fixed: this.fixed
      }, function (data) {
        _this12.update(data);
      });
    }
  }, {
    key: "stickOnLeft",
    value: function stickOnLeft(element) {
      if (this.leftAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "stickOnRight",
    value: function stickOnRight(element) {
      if (this.rightAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "stickOnBottom",
    value: function stickOnBottom(element) {
      if (this.bottomAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "_resize",
    value: function _resize(width, height) {
      _superPropGet(BoardPane, "_resize", this, 3)([width, height]);
      this.fr.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
      this.el.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.register();
      this._resize(width, height);
      this.paneHeader.position(0, -height / 2 + this.paneHeader.height / 2);
      this.paneFooter.position(0, height / 2 - this.paneFooter.height / 2);
      this._dispatchChange("geometry");
      if (this.parent() && this.parent()._dispatchChange) {
        this.parent()._dispatchChange("child-geometry", this);
      }
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        this.label = data.label, this.resize(data.width * _context5.default.rescaleFactor, data.height * _context5.default.rescaleFactor);
        this.paneContent.position(data.contentX * _context5.default.rescaleFactor, data.contentY * _context5.default.rescaleFactor);
        this.paneContent.update(data);
        this.paneHeader.position(0, -data.height * _context5.default.rescaleFactor / 2 + data.headerHeight * _context5.default.rescaleFactor / 2);
        this.paneHeader.update(data, "headerHeight");
        this.paneFooter.position(0, data.height * _context5.default.rescaleFactor / 2 - data.footerHeight * _context5.default.rescaleFactor / 2);
        this.paneFooter.update(data, "footerHeight");
        this.leftAdhesive = data.leftAdhesive;
        this.rightAdhesive = data.rightAdhesive;
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Pane|w:" + this.width + "|h:" + this.height + "|l:" + this.label + "|cx:" + this.paneContent.posX + "|cy:" + this.paneContent.posY + "|cw:" + this.paneContent.width + "|ch:" + this.paneContent.height + "|hh:" + this.paneHeader.height + "|fh:" + this.paneFooter.height + "|la:" + this.leftAdhesive + "|ra:" + this.rightAdhesive;
    }
  }, {
    key: "type",
    get: function get() {
      return "Pane";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardPane, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        contentX: this.paneContent.posX / _context5.default.rescaleFactor,
        contentY: this.paneContent.posY / _context5.default.rescaleFactor,
        contentWidth: this.paneContent.width / _context5.default.rescaleFactor,
        contentHeight: this.paneContent.height / _context5.default.rescaleFactor,
        headerHeight: this.paneHeader.height / _context5.default.rescaleFactor,
        footerHeight: this.paneFooter.height / _context5.default.rescaleFactor,
        label: this.label,
        leftAdhesive: this.leftAdhesive,
        rightAdhesive: this.rightAdhesive
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardPane, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor,
        children: [],
        header: [],
        footer: []
      });
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      this.serializePaneContent(models, current, objects);
      current.header = [];
      var _iterator11 = _createForOfIteratorHelper(this.paneHeader.children()),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var element = _step11.value;
          var result = element.serialize(models, objects);
          current.header.push(result);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      current.footer = [];
      var _iterator12 = _createForOfIteratorHelper(this.paneFooter.children()),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _element = _step12.value;
          var _result = _element.serialize(models, objects);
          current.footer.push(_result);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }, {
    key: "serializePaneContent",
    value: function serializePaneContent(models, current, objects) {
      var _iterator13 = _createForOfIteratorHelper(this.paneContent.children()),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var element = _step13.value;
          this.serializeChild(element, models, current, objects);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      if (spec.children) {
        var _iterator14 = _createForOfIteratorHelper(spec.children),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var childSpec = _step14.value;
            this.paneContent._add(this.startDeserializeChild(childSpec, models, built));
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      }
      if (spec.free) {
        var _iterator15 = _createForOfIteratorHelper(spec.free),
          _step15;
        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var _childSpec = _step15.value;
            this.paneContent._add(this.startDeserializeFreeChild(_childSpec, models, built));
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
      }
      this.paneContent.computeLegend();
      var _iterator16 = _createForOfIteratorHelper(spec.header),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var _childSpec2 = _step16.value;
          this.paneHeader.add(BoardElement.deserializeItem(_childSpec2, models, built));
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      var _iterator17 = _createForOfIteratorHelper(spec.footer),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var _childSpec3 = _step17.value;
          this.paneFooter.add(BoardElement.deserializeItem(_childSpec3, models, built));
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      _superPropGet(BoardPane, "endDeserialize", this, 3)([spec, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
      this.paneContent.physics.clean(this.paneContent.children());
    }
  }, {
    key: "endDeserializeChildren",
    value: function endDeserializeChildren(spec, built) {
      _superPropGet(BoardPane, "endDeserializeChildren", this, 3)([spec, built]);
      var _iterator18 = _createForOfIteratorHelper(spec.header),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var childSpec = _step18.value;
          var element = built.get(childSpec.id);
          element.endDeserialize(childSpec, built);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      var _iterator19 = _createForOfIteratorHelper(spec.footer),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _childSpec4 = _step19.value;
          var _element2 = built.get(_childSpec4.id);
          _element2.endDeserialize(_childSpec4, built);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardPane(this.width, this.height, this.paneContent.posX, this.paneContent.posY, this.paneContent.width, this.paneContent.height, this.paneHeader.height, this.paneFooter.height, this.label, this.leftAdhesive, this.rightAdhesive);
      return copy;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardPane, "memento", this, 3)([]);
      memento.width = this.width;
      memento.height = this.height;
      memento.fr = this.fr;
      memento.el = this.el;
      memento.paneContent = this.paneContent;
      memento.paneHeader = this.paneHeader;
      memento.paneFooter = this.paneFooter;
      memento.label = this.label, memento.leftAdhesive = this.leftAdhesive;
      memento.rightAdhesive = this.rightAdhesive;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardPane, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this._resize(memento.width, memento.height);
      this.paneContent = memento.paneContent;
      this.paneHeader = memento.paneHeader;
      this.paneFooter = memento.paneFooter;
      this.label = memento.label, this.leftAdhesive = memento.leftAdhesive;
      this.rightAdhesive = memento.rightAdhesive;
    }
  }, {
    key: "copyContent",
    value: function copyContent(copy, elements) {
      elements.set(this.paneContent, copy.paneContent);
      this.paneContent.copyContent(copy.paneContent, elements);
      elements.set(this.paneHeader, copy.paneHeader);
      this.paneHeader.copyContent(copy.paneHeader, elements);
      elements.set(this.paneFooter, copy.paneFooter);
      this.paneFooter.copyContent(copy.paneFooter, elements);
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardPane, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      return false;
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardPane.create(model.width, model.height, model.contentX, model.contentY, model.contentWidth, model.contentHeight, model.headerHeight, model.footerHeight, model.label, model.leftAdhesive, model.rightAdhesive);
    }
  }]);
}(BoardItem);
BoardPane.create = function (width, height, contentX, contentY, contentWidth, contentHeight, headerHeight, footerHeight, label, leftAdhesive, rightAdhesive) {
  return new BoardPane(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, contentX * _context5.default.rescaleFactor, contentY * _context5.default.rescaleFactor, contentWidth * _context5.default.rescaleFactor, contentHeight * _context5.default.rescaleFactor, headerHeight * _context5.default.rescaleFactor, footerHeight * _context5.default.rescaleFactor, label, leftAdhesive, rightAdhesive);
};
window.BoardBlankingGraphic = /*#__PURE__*/function (_BoardItem3) {
  function BoardBlankingGraphic(width, height) {
    var _this13;
    (0, _classCallCheck2.default)(this, BoardBlankingGraphic);
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    _this13 = _callSuper(this, BoardBlankingGraphic, [width, height].concat(args));
    _this13.dragOperation(_context5.default.standardDrag);
    return _this13;
  }
  (0, _inherits2.default)(BoardBlankingGraphic, _BoardItem3);
  return (0, _createClass2.default)(BoardBlankingGraphic, [{
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeRemovable();
      this.makeFixable();
      this.makeGroupable();
      this.makeHighlightable();
      this.makeFavorizable();
    }
  }, {
    key: "createShape",
    value: function createShape(width, height) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }
      _superPropGet(BoardBlankingGraphic, "createShape", this, 3)([width, height].concat(args));
      this.createFrame.apply(this, [width, height].concat(args));
      this.createPlain.apply(this, [width, height].concat(args));
    }
  }, {
    key: "createFrame",
    value: function createFrame(width, height, color) {
      this.color = color;
      this.fr = this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: color
      });
      this.fr.owner = this;
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height) {
      this.el = this.plain.rect(-width / 2, -height / 2, width, height);
      this.el.owner = this;
    }
  }, {
    key: "_visualizeRealistic",
    value: function _visualizeRealistic() {
      if (_context5.default.visualizer.realistic) {
        this.plain.node.append(this.el.node);
      } else {
        this.el.node.remove();
      }
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardBlankingGraphic, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        color: this.color
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardBlankingGraphic, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardBlankingGraphic, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardBlankingGraphic, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      if (this.color) {
        memento.color = this.color;
      }
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardBlankingGraphic, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      if (memento.color) {
        this.color = memento.color;
      } else {
        delete this.color;
      }
    }
  }, {
    key: "layer",
    get: function get() {
      return "cover";
    }
  }, {
    key: "dropTarget",
    value: function dropTarget(elementTarget) {
      while (elementTarget) {
        if (elementTarget instanceof BoardPaneContent) return elementTarget;
        elementTarget = elementTarget.parent();
      }
      return null;
    }
  }]);
}(BoardItem);
window.BoardImageBlankingGraphic = /*#__PURE__*/function (_BoardBlankingGraphic) {
  function BoardImageBlankingGraphic(width, height, imageURL, plainURL) {
    var _this14;
    (0, _classCallCheck2.default)(this, BoardImageBlankingGraphic);
    _this14 = _callSuper(this, BoardImageBlankingGraphic, [width, height, imageURL, plainURL]);
    _this14.imageURL = imageURL;
    _this14.plainURL = plainURL;
    _this14.createImageFrame(width, height, imageURL);
    _this14.createImagePlain(width, height, plainURL);
    return _this14;
  }
  (0, _inherits2.default)(BoardImageBlankingGraphic, _BoardBlankingGraphic);
  return (0, _createClass2.default)(BoardImageBlankingGraphic, [{
    key: "createFrame",
    value: function createFrame(width, height, imageURL, plainURL) {
      this.fr = this.frame.group();
      this.fr.owner = this;
      if (!imageURL) {
        this.fr.rect(-width / 2, -height / 2, width, height).attr({
          stroke: _context5.default.BLACK,
          fill: _context5.default.GREY
        });
      }
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height, imageURL, plainURL) {
      this.el = this.plain.group();
      this.el.owner = this;
      if (!plainURL) {
        this.el.rect(-width / 2, -height / 2, width, height).attr({
          stroke: _context5.default.BLACK,
          fill: _context5.default.GREY
        });
      }
    }
  }, {
    key: "createImageFrame",
    value: function createImageFrame(width, height, imageURL) {
      var _this15 = this;
      if (imageURL) {
        var image = (0, _toolkit.svgImage)(imageURL, width, height, function () {
          _this15._dispatchChange("geometry");
        });
        image.owner = this;
        this.fr.add(image);
      }
    }
  }, {
    key: "createImagePlain",
    value: function createImagePlain(width, height, realisticURL) {
      var _this16 = this;
      if (realisticURL) {
        var image;
        (0, _toolkit.pngImage)(realisticURL, width, height, function (img, width, height) {
          image = _this16.el.image(realisticURL, -width / 2, -height / 2, width, height);
          image.owner = _this16;
        });
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "ImageBlankingGraphic|w:" + this.width + "|h:" + this.height + "|cfi:" + this.imageURL + "|cpi:" + this.plainURL;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardImageBlankingGraphic, "memento", this, 3)([]);
      memento.imageURL = this.imageURL;
      memento.plainURL = this.plainURL;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardImageBlankingGraphic, "revert", this, 3)([memento]);
      this.imageURL = memento.imageURL;
      this.plainURL = memento.plainURL;
    }
  }, {
    key: "type",
    get: function get() {
      return "ImageBlankingGraphic";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardImageBlankingGraphic, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        imageURL: this.imageURL,
        plainURL: this.plainURL
      });
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardImageBlankingGraphic(this.width, this.height, this.imageURL, this.plainURL);
      return copy;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardImageBlankingGraphic.create(model.width, model.height, model.imageURL, model.plainURL);
    }
  }]);
}(BoardBlankingGraphic);
BoardImageBlankingGraphic.create = function (width, height, imageURL, plainURL) {
  return new BoardImageBlankingGraphic(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, imageURL, plainURL);
};
window.BoardVisual = /*#__PURE__*/function (_BoardItem4) {
  function BoardVisual(width, height) {
    var _this17;
    (0, _classCallCheck2.default)(this, BoardVisual);
    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }
    _this17 = _callSuper(this, BoardVisual, [width, height].concat(args));
    _this17.dragOperation(_context5.default.standardDrag);
    return _this17;
  }
  (0, _inherits2.default)(BoardVisual, _BoardItem4);
  return (0, _createClass2.default)(BoardVisual, [{
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeRemovable();
      this.makeFixable();
      this.makeGroupable();
      this.makeHighlightable();
      this.makeFavorizable();
    }
  }, {
    key: "createShape",
    value: function createShape(width, height) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }
      _superPropGet(BoardVisual, "createShape", this, 3)([width, height].concat(args));
      this.createFrame.apply(this, [width, height].concat(args));
      this.createPlain.apply(this, [width, height].concat(args));
      this.createHandle(width, height);
    }
  }, {
    key: "createHandle",
    value: function createHandle(width, height) {
      var _this18 = this;
      var w = -width / 2;
      var dw = width / 20;
      var hw = width / 20;
      this.handle = this.owned.path("M".concat(w, ",").concat(-height / 2, "L").concat(w + dw, ",").concat(-height / 2, "\n        C").concat(w + dw + hw, " ").concat(-height / 3, ",").concat(w + dw + hw, " ").concat(height / 3, ",").concat(w + hw, " ").concat(height / 2, "\n        L").concat(w, ",").concat(height / 2, "L").concat(w, ",").concat(-height / 2)).attr({
        fill: "#add8e6",
        class: "handle",
        stroke: "none"
      });
      var parentDrag = false;
      var dragMove = function dragMove(dx, dy, x, y, event) {
        if (parentDrag) {
          _context5.default.parentDrag._onDragMove(_this18, dx, dy, x, y, event);
          event.stopPropagation();
        }
      };
      var dragStart = function dragStart(x, y, event) {
        _this18.handleSelect(event);
        if (_this18.parent() && _this18.isTarget(_this18.parent())) {
          parentDrag = true;
          if (_context5.default.parentDrag._accept(_this18, x, y, event)) {
            _context5.default.parentDrag._onDragStart(_this18, x, y, event);
          }
          event.stopPropagation();
        }
      };
      var dragEnd = function dragEnd(event) {
        if (parentDrag) {
          parentDrag = false;
          _context5.default.parentDrag._onDrop(_this18, event);
          event.stopPropagation();
        }
      };
      this.handle.drag(dragMove, dragStart, dragEnd);
      this.handle.click(function (event) {
        return _this18.handleSelect(event);
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(event) {
      if (this.parent() && this.isTarget(this.parent())) {
        if (!_context5.default.selection.selected(this.parent().selectable())) {
          _context5.default.groupManager.selectElement(this.parent().selectable(), event, true);
        }
        event.stopPropagation();
      }
    }
  }, {
    key: "createFrame",
    value: function createFrame(width, height, color) {
      this.color = color;
      this.fr = this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: color
      });
      this.fr.owner = this;
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height) {
      this.el = this.plain.rect(-width / 2, -height / 2, width, height);
      this.el.owner = this;
    }
  }, {
    key: "_visualizeRealistic",
    value: function _visualizeRealistic() {
      if (_context5.default.visualizer.realistic) {
        this.plain.node.append(this.el.node);
      } else {
        this.el.node.remove();
      }
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardVisual, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        color: this.color
      });
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardVisual, "startDeserialize", this, 3)([spec, models, built]);
      this.position(0, 0);
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardVisual, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      if (this.color) {
        memento.color = this.color;
      }
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardVisual, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      if (memento.color) {
        this.color = memento.color;
      } else {
        delete this.color;
      }
    }
  }]);
}(BoardItem);
window.BoardCoverVisual = /*#__PURE__*/function (_BoardVisual) {
  function BoardCoverVisual(width, height) {
    (0, _classCallCheck2.default)(this, BoardCoverVisual);
    for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
      args[_key5 - 2] = arguments[_key5];
    }
    return _callSuper(this, BoardCoverVisual, [width, height].concat(args));
  }
  (0, _inherits2.default)(BoardCoverVisual, _BoardVisual);
  return (0, _createClass2.default)(BoardCoverVisual, [{
    key: "modelId",
    value: function modelId() {
      var color = this.fr.attr("fill");
      return "CoverVisual|w:" + this.width + "|h:" + this.height + "|c:" + color;
    }
  }, {
    key: "type",
    get: function get() {
      return "CoverVisual";
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardCoverVisual(this.width, this.height, this.color);
      return copy;
    }
  }, {
    key: "isTarget",
    value: function isTarget(element) {
      return element instanceof BoardCover;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardCoverVisual.create(model.width, model.height, model.color);
    }
  }]);
}(BoardVisual);
BoardCoverVisual.create = function (width, height, color) {
  return new BoardCoverVisual(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, color);
};
window.BoardImageCoverVisual = /*#__PURE__*/function (_BoardCoverVisual) {
  function BoardImageCoverVisual(width, height, imageURL, plainURL) {
    var _this19;
    var modelId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    (0, _classCallCheck2.default)(this, BoardImageCoverVisual);
    _this19 = _callSuper(this, BoardImageCoverVisual, [width, height, imageURL, plainURL]);
    _this19.imageURL = imageURL;
    _this19.plainURL = plainURL;
    _this19._modelId = modelId;
    _this19.createImageFrame(width, height, imageURL);
    _this19.createImagePlain(width, height, plainURL);
    return _this19;
  }
  (0, _inherits2.default)(BoardImageCoverVisual, _BoardCoverVisual);
  return (0, _createClass2.default)(BoardImageCoverVisual, [{
    key: "createFrame",
    value: function createFrame(width, height, imageURL, plainURL) {
      this.fr = this.frame.group();
      this.fr.owner = this;
      if (!imageURL) {
        this.fr.rect(-width / 2, -height / 2, width, height).attr({
          stroke: _context5.default.BLACK,
          fill: _context5.default.GREY
        });
      }
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height, imageURL, plainURL) {
      this.el = this.plain.group();
      this.el.owner = this;
      if (!plainURL) {
        this.el.rect(-width / 2, -height / 2, width, height).attr({
          stroke: _context5.default.BLACK,
          fill: _context5.default.GREY
        });
      }
    }
  }, {
    key: "createImageFrame",
    value: function createImageFrame(width, height, imageURL) {
      var _this20 = this;
      if (imageURL) {
        var image = (0, _toolkit.svgImage)(imageURL, width, height, function () {
          _this20._dispatchChange("geometry");
        });
        image.owner = this;
        this.fr.add(image);
      }
    }
  }, {
    key: "createImagePlain",
    value: function createImagePlain(width, height, realisticURL) {
      var _this21 = this;
      if (realisticURL) {
        var image;
        (0, _toolkit.pngImage)(realisticURL, width, height, function (img, width, height) {
          image = _this21.el.image(realisticURL, -width / 2, -height / 2, width, height);
          image.owner = _this21;
        });
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return this._modelId || "ImageCover|w:" + this.width + "|h:" + this.height + "|cfi:" + this.imageURL + "|cpi:" + this.plainURL;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardImageCoverVisual, "memento", this, 3)([]);
      memento.imageURL = this.imageURL;
      memento.plainURL = this.plainURL;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardImageCoverVisual, "revert", this, 3)([memento]);
      this.imageURL = memento.imageURL;
      this.plainURL = memento.plainURL;
    }
  }, {
    key: "type",
    get: function get() {
      return "ImageCoverVisual";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardImageCoverVisual, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        imageURL: this.imageURL,
        plainURL: this.plainURL
      });
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardImageCoverVisual(this.width, this.height, this.imageURL, this.plainURL, this._modelId);
      return copy;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardImageCoverVisual.create(model.width, model.height, model.imageURL, model.plainURL, spec.model);
    }
  }]);
}(BoardCoverVisual);
BoardImageCoverVisual.create = function (width, height, imageURL, plainURL, modelId) {
  return new BoardImageCoverVisual(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, imageURL, plainURL, modelId);
};
window.BoardFascia = /*#__PURE__*/function (_BoardVisual2) {
  function BoardFascia(width, height) {
    (0, _classCallCheck2.default)(this, BoardFascia);
    for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
      args[_key6 - 2] = arguments[_key6];
    }
    return _callSuper(this, BoardFascia, [width, height].concat(args));
  }
  (0, _inherits2.default)(BoardFascia, _BoardVisual2);
  return (0, _createClass2.default)(BoardFascia, [{
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardFascia(this.width, this.height, this.color);
      return copy;
    }
  }, {
    key: "modelId",
    value: function modelId() {
      var color = this.fr.attr("fill");
      return "Fascia|w:" + this.width + "|h:" + this.height + "|c:" + color;
    }
  }, {
    key: "type",
    get: function get() {
      return "Fascia";
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardFascia, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      if (element instanceof BoardFrame) {
        return this.host.receiveDrop(element);
      } else if (element instanceof BoardModule) {
        this.host.caddyContent.add(element);
        return true;
      }
      return false;
    }
  }, {
    key: "isTarget",
    value: function isTarget(element) {
      return element instanceof BoardSupport;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardFascia.create(model.width, model.height, model.color);
    }
  }]);
}(BoardVisual);
BoardFascia.create = function (width, height, color) {
  return new BoardFascia(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, color);
};
window.BoardImageFascia = /*#__PURE__*/function (_BoardFascia) {
  function BoardImageFascia(width, height, imageURL, plainURL, modelId) {
    var _this22;
    (0, _classCallCheck2.default)(this, BoardImageFascia);
    _this22 = _callSuper(this, BoardImageFascia, [width, height, imageURL, plainURL]);
    _this22.imageURL = imageURL;
    _this22.plainURL = plainURL;
    _this22._modelId = modelId;
    _this22.createImageFrame(width, height, imageURL);
    _this22.createImagePlain(width, height, plainURL);
    return _this22;
  }
  (0, _inherits2.default)(BoardImageFascia, _BoardFascia);
  return (0, _createClass2.default)(BoardImageFascia, [{
    key: "createFrame",
    value: function createFrame(width, height, imageURL, plainURL) {
      this.fr = this.frame.group();
      this.fr.owner = this;
      if (!imageURL) {
        this.fr.rect(-width / 2, -height / 2, width, height).attr({
          stroke: _context5.default.BLACK,
          fill: _context5.default.GREY,
          opacity: 0.2
        });
      }
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height, imageURL, plainURL) {
      this.el = this.plain.group();
      this.el.owner = this;
      if (!plainURL) {
        this.el.rect(-width / 2, -height / 2, width, height).attr({
          stroke: _context5.default.BLACK,
          fill: _context5.default.GREY,
          opacity: 0.2
        });
      }
    }
  }, {
    key: "createImageFrame",
    value: function createImageFrame(width, height, imageURL) {
      var _this23 = this;
      if (imageURL) {
        var image = (0, _toolkit.svgImage)(imageURL, width, height, function () {
          _this23._dispatchChange("geometry");
        });
        image.owner = this;
        this.fr.add(image);
      }
    }
  }, {
    key: "createImagePlain",
    value: function createImagePlain(width, height, plainURL) {
      var _this24 = this;
      if (plainURL) {
        var image;
        (0, _toolkit.pngImage)(plainURL, width, height, function (img, width, height) {
          image = _this24.el.image(plainURL, -width / 2, -height / 2, width, height);
          image.owner = _this24;
        });
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return this._modelId || "ImageFascia|w:" + this.width + "|h:" + this.height + "|cfi:" + this.imageURL + "|cpi:" + this.plainURL;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardImageFascia, "memento", this, 3)([]);
      memento.imageURL = this.imageURL;
      memento.plainURL = this.plainURL;
      memento._modelId = this._modelId;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardImageFascia, "revert", this, 3)([memento]);
      this.imageURL = memento.imageURL;
      this.plainURL = memento.plainURL;
      this._modelId = memento._modelId;
    }
  }, {
    key: "type",
    get: function get() {
      return "ImageFascia";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardImageFascia, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        imageURL: this.imageURL,
        plainURL: this.plainURL
      });
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardImageFascia(this.width, this.height, this.imageURL, this.plainURL, this._modelId);
      return copy;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardImageFascia.create(model.width, model.height, model.imageURL, model.plainURL, spec.model);
    }
  }]);
}(BoardFascia);
BoardImageFascia.create = function (width, height, imageURL, plainURL, modelId) {
  return new BoardImageFascia(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, imageURL, plainURL, modelId);
};
window.BoardFrame = /*#__PURE__*/function (_BoardVisual3) {
  function BoardFrame(width, height) {
    (0, _classCallCheck2.default)(this, BoardFrame);
    for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
      args[_key7 - 2] = arguments[_key7];
    }
    return _callSuper(this, BoardFrame, [width, height].concat(args));
  }
  (0, _inherits2.default)(BoardFrame, _BoardVisual3);
  return (0, _createClass2.default)(BoardFrame, [{
    key: "createFrame",
    value: function createFrame(width, height, frameWidth, color) {
      this.frameWidth = frameWidth;
      this.color = color;
      var lw = width / 2;
      var lh = height / 2;
      var sw = lw - frameWidth;
      var sh = lh - frameWidth;
      this.fr = this.frame.polygon(-lw, lh, -lw, -lh, lw, -lh, lw, lh, sw, lh, sw, -sh, -sw, -sh, -sw, lh).attr({
        stroke: _context5.default.BLACK,
        fill: _context5.default.WHITE
      });
      this.fr.owner = this;
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height, frameWidth) {
      var lw = width / 2;
      var lh = height / 2;
      var sw = lw - frameWidth;
      var sh = lh - frameWidth;
      this.el = this.plain.polygon(-lw, lh, -lw, -lh, lw, -lh, lw, lh, sw, lh, sw, -sh, -sw, -sh, -sw, lh).attr({
        stroke: this.color,
        fill: this.color
      });
      this.el.owner = this;
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardFrame(this.width, this.height, this.frameWidth, this.color);
      return copy;
    }
  }, {
    key: "modelId",
    value: function modelId() {
      var color = this.fr.attr("fill");
      return "Frame|w:" + this.width + "|h:" + this.height + "|fw:" + this.frameWidth + "|c:" + this.color;
    }
  }, {
    key: "type",
    get: function get() {
      return "Frame";
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardFrame, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      if (element instanceof BoardModule) {
        this.host.caddyContent.add(element);
        return true;
      }
      return false;
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardFrame, "serializeModel", this, 3)([])), {}, {
        frameWidth: this.frameWidth / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardFrame, "memento", this, 3)([]);
      if (this.frameWidth) {
        memento.frameWidth = this.frameWidth;
      }
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardFrame, "revert", this, 3)([memento]);
      if (memento.frameWidth) {
        this.frameWidth = memento.frameWidth;
      } else {
        delete this.frameWidth;
      }
    }
  }, {
    key: "isTarget",
    value: function isTarget(element) {
      return element instanceof BoardSupport;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardFrame.create(model.width, model.height, model.frameWidth, model.color);
    }
  }]);
}(BoardVisual);
BoardFrame.create = function (width, height, frameWidth, color) {
  return new BoardFrame(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, frameWidth * _context5.default.rescaleFactor, color);
};
window.BoardAbstractCaddyContent = /*#__PURE__*/function (_BoardItem5) {
  function BoardAbstractCaddyContent(box, width, height, x, y) {
    var _this25;
    (0, _classCallCheck2.default)(this, BoardAbstractCaddyContent);
    _this25 = _callSuper(this, BoardAbstractCaddyContent, [width, height]);
    _this25.box = box;
    _this25._dragOperation(_context5.default.parentDrag);
    //this._doubleClickHandler(event => this.box.doubleClickHdlImpl(event));
    _this25.fr = _this25.frame.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context5.default.BLACK,
      fill: _context5.default.WHITE
    });
    _this25.fr.owner = _this25;
    _this25.el = _this25.plain.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context5.default.BLACK,
      fill: _context5.default.GREY
    });
    _this25.el.owner = _this25;
    _this25.downLayer = _this25.content.group();
    _this25.middleLayer = _this25.content.group();
    _this25.upLayer = _this25.content.group();
    _this25.physics = _this25.createPhysics().leftBorder().rightBorder().topBorder().bottomBorder();
    _this25.position(x, y);
    _this25.drawClips();
    return _this25;
  }
  (0, _inherits2.default)(BoardAbstractCaddyContent, _BoardItem5);
  return (0, _createClass2.default)(BoardAbstractCaddyContent, [{
    key: "drawClips",
    value: function drawClips() {
      var _iterator20 = _createForOfIteratorHelper(this.box.clipDevices),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var device = _step20.value;
          var x = device.x - this.posX;
          var y = device.y - this.posY;
          this.frame.line(x, y - 5, x, y + 5).attr({
            stroke: _context5.default.SMOOTH_GREY
          });
          this.frame.line(x - 5, y, x + 5, y).attr({
            stroke: _context5.default.SMOOTH_GREY
          });
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
    }
  }, {
    key: "_children",
    value: function _children() {
      var children = new _toolkit.List();
      var _iterator21 = _createForOfIteratorHelper(this.downLayer.children()),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var child = _step21.value;
          child.owner && children.add(child.owner);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      var _iterator22 = _createForOfIteratorHelper(this.middleLayer.children()),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _child4 = _step22.value;
          _child4.owner && children.add(_child4.owner);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      var _iterator23 = _createForOfIteratorHelper(this.upLayer.children()),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _child5 = _step23.value;
          _child5.owner && children.add(_child5.owner);
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      return children;
    }
  }, {
    key: "_add",
    value: function _add(element) {
      if (element.layer === "up") {
        this.upLayer.add(element.root);
      } else if (element.layer === "middle") {
        this.middleLayer.add(element.root);
      } else if (element.layer === "down") {
        this.downLayer.add(element.root);
      }
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      _superPropGet(BoardAbstractCaddyContent, "linkContent", this, 3)([elements]);
      var copy = elements.get(this);
      copy.physics.clean(copy.children());
    }
  }, {
    key: "update",
    value: function update(data) {
      this.register();
      this.fr.attr({
        width: "" + data.contentWidth * _context5.default.rescaleFactor,
        height: "" + data.contentHeight * _context5.default.rescaleFactor,
        x: -data.contentWidth * _context5.default.rescaleFactor / 2,
        y: -data.contentHeight * _context5.default.rescaleFactor / 2
      });
      this.el.attr({
        width: "" + data.contentWidth * _context5.default.rescaleFactor,
        height: "" + data.contentHeight * _context5.default.rescaleFactor,
        x: -data.contentWidth * _context5.default.rescaleFactor / 2,
        y: -data.contentHeight * _context5.default.rescaleFactor / 2
      });
      this._dispatchChange("geometry");
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this.box.selectable();
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardAbstractCaddyContent, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardAbstractCaddyContent, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
    }
  }, {
    key: "recover",
    value: function recover(memento) {
      this.physics.revert(this.children());
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      return this.box.collectMenuOptions();
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }]);
}(BoardItem);
window.BoardCaddyContent = /*#__PURE__*/function (_BoardAbstractCaddyCo) {
  function BoardCaddyContent(box, width, height, x, y, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval, intermediateLadderCount) {
    var _this26;
    (0, _classCallCheck2.default)(this, BoardCaddyContent);
    _this26 = _callSuper(this, BoardCaddyContent, [box, width, height, x, y]);
    _this26.leftLadder = new BoardBaseLadder(_this26, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval);
    _this26._add(_this26.leftLadder);
    _this26.rightLadder = new BoardBaseLadder(_this26, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval);
    _this26._add(_this26.rightLadder);
    _this26.intermediateLadders = new _toolkit.List();
    for (var index = 0; index < intermediateLadderCount; index++) {
      var ladder = new BoardBaseDoubleLadder(_this26, ladderWidth * 2, ladderHeight, topPawl, bottomPawl, pawlInterval);
      _this26.intermediateLadders.add(ladder);
      _this26._add(ladder);
    }
    _this26.positionLadders();
    return _this26;
  }
  (0, _inherits2.default)(BoardCaddyContent, _BoardAbstractCaddyCo);
  return (0, _createClass2.default)(BoardCaddyContent, [{
    key: "createPhysics",
    value: function createPhysics() {
      return new _physics.Physics(this, function (element) {
        var result = !element.free && (element instanceof BoardShelf || element instanceof BoardModule);
        return result;
      }, function (element) {
        var result = element instanceof BoardModule;
        return result;
      });
    }
  }, {
    key: "copyContent",
    value: function copyContent(copy, elements) {
      elements.set(this.leftLadder, copy.leftLadder);
      elements.set(this.rightLadder, copy.rightLadder);
      this.leftLadder.copyContent(copy.leftLadder, elements);
      this.rightLadder.copyContent(copy.rightLadder, elements);
      for (var index = 0; index < this.intermediateLadders.length; index++) {
        elements.set(this.intermediateLadders[index], copy.intermediateLadders[index]);
        this.intermediateLadders[index].copyContent(copy.intermediateLadders[index], elements);
      }
      _superPropGet(BoardCaddyContent, "copyContent", this, 3)([copy, elements]);
    }
  }, {
    key: "update",
    value: function update(data) {
      _superPropGet(BoardCaddyContent, "update", this, 3)([data]);
      var ladderData = {
        width: data.ladderWidth,
        height: data.ladderHeight,
        topPawl: data.topPawl,
        bottomPawl: data.bottomPawl,
        pawlInterval: data.pawlInterval
      };
      this.leftLadder.update(ladderData);
      this.rightLadder.update(ladderData);
      for (var index = 0; index < this.intermediateLadders.length; index++) {
        var ladder = this.intermediateLadders[index - 1];
        ladder.update(ladderData);
      }
      this.positionLadders();
    }
  }, {
    key: "positionLadders",
    value: function positionLadders() {
      this.leftLadder.position(-this.width / 2 + this.leftLadder.width / 2, this.height / 2 - this.leftLadder.height / 2);
      this.rightLadder.position(this.width / 2 - this.rightLadder.width / 2, this.height / 2 - this.rightLadder.height / 2);
      for (var index = 0; index < this.intermediateLadders.length; index++) {
        var x = this.width * (index + 1) / (this.intermediateLadders.length + 1);
        var ladder = this.intermediateLadders[index];
        ladder.position(x - this.width / 2, this.height / 2 - ladder.height / 2);
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardCaddyContent, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      if (element instanceof BoardFascia || element instanceof BoardFrame) {
        var _result2 = this.box.receiveDrop(element);
        return _result2;
      }
      if (element instanceof BoardModule) {
        this.add(element);
        return true;
      }
      if (element instanceof BoardShelf) {
        this.add(element);
        var _result3 = element.tryToClip(this);
        return _result3;
      }
      return false;
    }
  }, {
    key: "adjustDrop",
    value: function adjustDrop(element) {
      if (element instanceof BoardShelf) {
        element.executeClip();
      }
    }
  }, {
    key: "searchPawl",
    value: function searchPawl(x, y, margin) {
      var result;
      var _iterator24 = _createForOfIteratorHelper(this.children()),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var element = _step24.value;
          if (element.searchPawl) {
            var lresult = element.searchPawl(x, y, margin);
            if (lresult && (!result || result.distance > lresult.distance)) {
              result = lresult;
            }
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return result;
    }
  }]);
}(BoardAbstractCaddyContent);
window.BoardSlotCaddyContent = /*#__PURE__*/function (_BoardAbstractCaddyCo2) {
  function BoardSlotCaddyContent(box, width, height, x, y, slotCount) {
    var _this27;
    (0, _classCallCheck2.default)(this, BoardSlotCaddyContent);
    _this27 = _callSuper(this, BoardSlotCaddyContent, [box, width, height, x, y]);
    _this27.slotCount = slotCount;
    return _this27;
  }
  (0, _inherits2.default)(BoardSlotCaddyContent, _BoardAbstractCaddyCo2);
  return (0, _createClass2.default)(BoardSlotCaddyContent, [{
    key: "createPhysics",
    value: function createPhysics() {
      return new _physics.Physics(this, function (element) {
        var result = !element.free && element instanceof BoardModule;
        return result;
      }, function (element) {
        var result = element instanceof BoardModule;
        return result;
      });
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardSlotCaddyContent, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      if (element instanceof BoardModule) {
        this.add(element);
        var slotWidth = this.width / this.slotCount;
        var slotNeeded = Math.ceil(element.width / slotWidth);
        var lx = element.posX;
        var distance = Infinity;
        var position = lx;
        var margin = slotNeeded / 2 * slotWidth;
        for (var pos = -this.width / 2 + margin; pos + margin <= this.width / 2; pos += slotWidth) {
          var _distance = Math.abs(pos - lx);
          if (_distance < distance) {
            distance = _distance;
            position = pos;
          }
        }
        element.position(position, element.posY);
        return true;
      }
      return false;
    }
  }]);
}(BoardAbstractCaddyContent);
window.BoardCover = /*#__PURE__*/function (_BoardItem6) {
  function BoardCover(box, width, height, labelText) {
    var _this28;
    (0, _classCallCheck2.default)(this, BoardCover);
    _this28 = _callSuper(this, BoardCover, [width, height]);
    _this28.box = box;
    _this28.dragOperation(_context5.default.parentDrag);
    _this28.doubleClickHandler(function (event) {
      return _this28.box.doubleClickHdlImpl(event);
    });
    _this28.fr = _this28.frame.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context5.default.BLACK,
      fill: _context5.default.WHITE
    });
    _this28.fr.owner = _this28;
    _this28.el = _this28.plain.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context5.default.BLACK,
      fill: _context5.default.GREY
    });
    _this28.el.owner = _this28;
    _this28._makeLabels(labelText);
    return _this28;
  }
  (0, _inherits2.default)(BoardCover, _BoardItem6);
  return (0, _createClass2.default)(BoardCover, [{
    key: "_resize",
    value: function _resize(width, height) {
      _superPropGet(BoardCover, "_resize", this, 3)([width, height]);
      this.fr.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
      this.el.attr({
        width: "" + width,
        height: "" + height,
        x: -width / 2,
        y: -height / 2
      });
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.register();
      this._resize(width, height);
      this._dispatchChange("geometry");
      if (this.parent() && this.parent()._dispatchChange) {
        this.parent()._dispatchChange("child-geometry", this);
      }
    }
  }, {
    key: "update",
    value: function update(data, height) {
      this.register();
      this._makeLabels(data.labelText);
      this.resize(data.width * _context5.default.rescaleFactor, data[height] * _context5.default.rescaleFactor);
    }
  }, {
    key: "_makeLabels",
    value: function _makeLabels(labelText) {
      this.labelText = labelText;
      this.frLabel && this.frLabel.remove();
      this.frLabelSupport = this.frame.group();
      this.frLabel = this.frLabelSupport.text(0, 0, this.labelText).attr({
        "font-size": "6px",
        "text-anchor": "middle",
        "alignment-baseline": "central"
      });
      var bbox = this.frLabel.getBBox();
      var scale = this.width * 0.8 / bbox.width;
      this.frLabel.owner = this;
      this.elLabel && this.elLabel.remove();
      this.elLabelSupport = this.plain.group();
      this.elLabel = this.elLabelSupport.text(0, 0, this.labelText).attr({
        "font-size": "6px",
        "text-anchor": "middle",
        "alignment-baseline": "central"
      });
      this.elLabel.owner = this;
      if (scale < 1) {
        this.frLabelSupport.transform(new _snap.default.Matrix().scale(scale));
        this.elLabelSupport.transform(new _snap.default.Matrix().scale(scale));
      }
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this.box.selectable();
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardCover, "memento", this, 3)([]);
      memento.labelText = this.labelText;
      memento.fr = this.fr;
      memento.el = this.el;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardCover, "revert", this, 3)([memento]);
      this._makeLabels(memento.labelText);
      this.fr = memento.fr;
      this.el = memento.el;
    }
  }, {
    key: "collectMenuOptions",
    value: function collectMenuOptions() {
      return this.box.collectMenuOptions();
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardCover, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      if (this.children().length > 0) return false;
      if (element instanceof BoardCoverVisual) {
        if (element.width !== this.width || element.height !== this.height) {
          return false;
        }
        element.position(0, 0);
        return true;
      }
      return false;
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }]);
}(BoardItem);
window.BoardAbstractCaddy = /*#__PURE__*/function (_BoardItem7) {
  function BoardAbstractCaddy(width, height, coverHeight, clipDevices, leftAdhesive, rightAdhesive, bottomAdhesive, labelText) {
    var _this29;
    (0, _classCallCheck2.default)(this, BoardAbstractCaddy);
    _this29 = _callSuper(this, BoardAbstractCaddy, [width, height, coverHeight, labelText]);
    _this29.leftAdhesive = leftAdhesive;
    _this29.rightAdhesive = rightAdhesive;
    _this29.bottomAdhesive = bottomAdhesive;
    _this29.clipDevices = (0, _toolkit.arrayDuplicate)(clipDevices);
    _this29.dragOperation(_context5.default.standardDrag);
    var coverMenuOption = _context5.default.coverMenuOption.instance(function () {
      _context5.default.showCoversAndFascias(_this29);
    }, function () {
      _context5.default.hideCoversAndFascias(_this29);
    }, function () {
      return _context5.default.coversAndFasciasVisible(_this29);
    });
    _this29.addMenuOption(coverMenuOption);
    return _this29;
  }
  (0, _inherits2.default)(BoardAbstractCaddy, _BoardItem7);
  return (0, _createClass2.default)(BoardAbstractCaddy, [{
    key: "createShape",
    value: function createShape(width, height, coverHeight, labelText) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 4 ? _len8 - 4 : 0), _key8 = 4; _key8 < _len8; _key8++) {
        args[_key8 - 4] = arguments[_key8];
      }
      _superPropGet(BoardAbstractCaddy, "createShape", this, 3)([width, height, coverHeight].concat(args));
      this.fr = this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: _context5.default.WHITE
      });
      this.fr.owner = this;
      this.el = this.plain.rect(-width / 2, -height / 2, width, height);
      this.el.owner = this;
      this.caddyCover = this.createCaddyCover(width, coverHeight, labelText);
      this.caddyCover.position(0, height / 2 - coverHeight / 2);
      this.fasciaSupport = this.createFasciaSupport(width, width - coverHeight);
      this.fasciaSupport.position(0, -coverHeight / 2);
      this.frameSupport = this.createFrameSupport(width, width - coverHeight);
      this.frameSupport.position(0, 0);
    }
  }, {
    key: "createCaddyCover",
    value: function createCaddyCover(width, coverHeight, labelText) {
      return new BoardCover(this, width, coverHeight, labelText);
    }
  }, {
    key: "createFasciaSupport",
    value: function createFasciaSupport(width, fasciaHeight) {
      return new BoardSupport();
    }
  }, {
    key: "createFrameSupport",
    value: function createFrameSupport(width, frameHeight) {
      return new BoardSupport();
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardAbstractCaddy, "createContextMenu", this, 3)([]);
    }
  }, {
    key: "_visualizeArtwork",
    value: function _visualizeArtwork() {
      if (_context5.default.visualizer.artwork) {
        this.caddyCover.show();
        this.fasciaSupport.show();
        this.frameSupport.show();
      } else {
        this.caddyCover.hide();
        this.fasciaSupport.hide();
        this.frameSupport.hide();
      }
    }
  }, {
    key: "_visualization",
    value: function _visualization() {
      _superPropGet(BoardAbstractCaddy, "_visualization", this, 3)([]);
      this._visualizeArtwork();
    }
  }, {
    key: "applyHighlight",
    value: function applyHighlight(color) {
      _superPropGet(BoardAbstractCaddy, "applyHighlight", this, 3)([color]);
      this.caddyContent.applyHighlight(color);
      this.caddyCover.applyHighlight(color);
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      _superPropGet(BoardAbstractCaddy, "removeHighlight", this, 3)([]);
      this.caddyContent.removeHighlight();
      this.caddyCover.removeHighlight();
    }
  }, {
    key: "stickOnLeft",
    value: function stickOnLeft(element) {
      if (this.leftAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "stickOnRight",
    value: function stickOnRight(element) {
      if (this.rightAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "stickOnBottom",
    value: function stickOnBottom(element) {
      if (this.bottomAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        this.fr.attr({
          width: "" + data.width * _context5.default.rescaleFactor,
          height: "" + data.height * _context5.default.rescaleFactor,
          x: -data.width * _context5.default.rescaleFactor / 2,
          y: -data.height * _context5.default.rescaleFactor / 2
        });
        this.el.attr({
          width: "" + data.width * _context5.default.rescaleFactor,
          height: "" + data.height * _context5.default.rescaleFactor,
          x: -data.width * _context5.default.rescaleFactor / 2,
          y: -data.height * _context5.default.rescaleFactor / 2
        });
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
        this.caddyContent.position(data.contentX * _context5.default.rescaleFactor, data.contentY * _context5.default.rescaleFactor);
        this.caddyContent.update(data);
        this.caddyCover.position(0, data.height * _context5.default.rescaleFactor / 2 - data.coverHeight * _context5.default.rescaleFactor / 2);
        this.caddyCover.update(data, "coverHeight");
        this.fasciaSupport.position(0, -data.coverHeight * _context5.default.rescaleFactor / 2);
        this.frameSupport.position(0, -data.coverHeight * _context5.default.rescaleFactor / 2);
        this.leftAdhesive = data.leftAdhesive;
        this.rightAdhesive = data.rightAdhesive;
        this.bottomAdhesive = data.bottomAdhesive;
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "|w:" + this.width + "|h:" + this.height + "|cx:" + this.caddyContent.posX + "|cy:" + this.caddyContent.posY + "|cw:" + this.caddyContent.width + "|ch:" + this.caddyContent.height + "|cv:" + this.caddyCover.height + "|cld:" + JSON.stringify(this.justModel(this.clipDevices)) + "|la:" + this.leftAdhesive + "|ra:" + this.rightAdhesive + "|ba:" + this.bottomAdhesive + "|lt:" + this.caddyCover.labelText;
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardAbstractCaddy, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        contentX: this.caddyContent.posX / _context5.default.rescaleFactor,
        contentY: this.caddyContent.posY / _context5.default.rescaleFactor,
        contentWidth: this.caddyContent.width / _context5.default.rescaleFactor,
        contentHeight: this.caddyContent.height / _context5.default.rescaleFactor,
        coverHeight: this.caddyCover.height / _context5.default.rescaleFactor,
        clipDevices: this.justModel(this.clipDevices),
        leftAdhesive: this.leftAdhesive,
        rightAdhesive: this.rightAdhesive,
        bottomAdhesive: this.bottomAdhesive,
        labelText: this.caddyCover.labelText
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var justData = function justData(clipDevices) {
        var result = [];
        var _iterator25 = _createForOfIteratorHelper(clipDevices),
          _step25;
        try {
          for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
            var clipDevice = _step25.value;
            result.push({
              support: clipDevice.support.id
            });
          }
        } catch (err) {
          _iterator25.e(err);
        } finally {
          _iterator25.f();
        }
        return result;
      };
      var result = _objectSpread(_objectSpread({}, _superPropGet(BoardAbstractCaddy, "serializeSpec", this, 3)([])), {}, {
        children: [],
        cover: []
      });
      if (this.clipDevices.length && this.clipDevices[0].support) {
        result.clipped = justData(this.clipDevices);
      }
      return result;
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      current.cover = [];
      var _iterator26 = _createForOfIteratorHelper(this.children()),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var element = _step26.value;
          if (element.free) {
            this.serializeChild(element, models, current, objects);
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      var _iterator27 = _createForOfIteratorHelper(this.caddyCover.children()),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _element3 = _step27.value;
          var result = _element3.serialize(models, objects);
          current.cover.push(result);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      if (this.fasciaSupport.child) {
        current.fascia = this.fasciaSupport.child.serialize(models, objects);
      }
      if (this.frameSupport.child) {
        current.frame = this.frameSupport.child.serialize(models, objects);
      }
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      if (spec.free) {
        var _iterator28 = _createForOfIteratorHelper(spec.free),
          _step28;
        try {
          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
            var element = _step28.value;
            this.startDeserializeChild(element, models, built);
          }
        } catch (err) {
          _iterator28.e(err);
        } finally {
          _iterator28.f();
        }
      }
      var _iterator29 = _createForOfIteratorHelper(spec.cover),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var childSpec = _step29.value;
          this.caddyCover._add(BoardElement.deserializeItem(childSpec, models, built));
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
      if (spec.fascia) {
        this.fasciaSupport._add(BoardElement.deserializeItem(spec.fascia, models, built));
      }
      if (spec.frame) {
        this.frameSupport.add(BoardElement.deserializeItem(spec.frame, models, built));
      }
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      _superPropGet(BoardAbstractCaddy, "endDeserialize", this, 3)([spec, built]);
      if (spec.clipped) {
        var clips = new _toolkit.List();
        var _iterator30 = _createForOfIteratorHelper(spec.clipped),
          _step30;
        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var clip = _step30.value;
            clips.add({
              support: built.get(clip.support)
            });
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
        this.deserializeClips(clips);
      }
      this.caddyContent.physics.clean(this.caddyContent.children());
    }
  }, {
    key: "endDeserializeChildren",
    value: function endDeserializeChildren(spec, built) {
      _superPropGet(BoardAbstractCaddy, "endDeserializeChildren", this, 3)([spec, built]);
      var _iterator31 = _createForOfIteratorHelper(spec.cover),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var childSpec = _step31.value;
          var _element5 = built.get(childSpec.id);
          _element5.endDeserialize(childSpec, built);
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      if (spec.fascia) {
        var element = built.get(spec.fascia.id);
        element.endDeserialize(spec.fascia, built);
      }
      if (spec.frame) {
        var _element4 = built.get(spec.frame.id);
        _element4.endDeserialize(spec.frame, built);
      }
    }
  }, {
    key: "justModel",
    value: function justModel(clipDevices) {
      var result = [];
      var _iterator32 = _createForOfIteratorHelper(clipDevices),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var clipDevice = _step32.value;
          result.push({
            x: clipDevice.x / _context5.default.rescaleFactor,
            y: clipDevice.y / _context5.default.rescaleFactor
          });
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      return result;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardAbstractCaddy, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      memento.caddyContent = this.caddyContent;
      memento.caddyCover = this.caddyCover;
      memento.fasciaSupport = this.fasciaSupport;
      memento.frameSupport = this.frameSupport;
      memento.clipDevices = (0, _toolkit.arrayDuplicate)(this.clipDevices);
      memento.leftAdhesive = this.leftAdhesive;
      memento.rightAdhesive = this.rightAdhesive;
      memento.bottomAdhesive = this.bottomAdhesive;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardAbstractCaddy, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this.caddyContent = memento.caddyContent;
      this.caddyCover = memento.caddyCover;
      this.fasciaSupport = memento.fasciaSupport;
      this.frameSupport = memento.frameSupport;
      this.clipDevices = (0, _toolkit.arrayDuplicate)(memento.clipDevices);
      this.leftAdhesive = memento.leftAdhesive;
      this.rightAdhesive = memento.rightAdhesive;
      this.bottomAdhesive = memento.bottomAdhesive;
    }
  }, {
    key: "cancelDrop",
    value: function cancelDrop() {
      _superPropGet(BoardAbstractCaddy, "cancelDrop", this, 3)([]);
      var _iterator33 = _createForOfIteratorHelper(this.clipDevices),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var device = _step33.value;
          if (device.support) {
            device.support.clips(this);
          }
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
    }
  }, {
    key: "clips",
    value: function clips() {
      var matrix = this.localTranslation;
      var clips = [];
      var _iterator34 = _createForOfIteratorHelper(this.clipDevices),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var device = _step34.value;
          clips.push({
            x: matrix.x(device.x, device.y),
            y: matrix.y(device.x, device.y)
          });
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      return clips;
    }
  }, {
    key: "clipsOn",
    value: function clipsOn(clips) {
      this.register();
      var clip = clips[0];
      var device = this.clipDevices[0];
      this.adjustPosition(clip.support.posX - device.x, clip.support.posY - device.y);
      this._clipsOn(clips);
    }
  }, {
    key: "deserializeClips",
    value: function deserializeClips(clips) {
      var clip = clips[0];
      var device = this.clipDevices[0];
      this._adjustPosition(clip.support.posX - device.x, clip.support.posY - device.y);
      this._clipsOn(clips);
    }
  }, {
    key: "_clipsOn",
    value: function _clipsOn(clips) {
      for (var index = 0; index < clips.length; index++) {
        var clip = clips[index];
        var device = this.clipDevices[index];
        clip.support.clips(this);
        device.support = clip.support;
      }
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      _superPropGet(BoardAbstractCaddy, "linkContent", this, 3)([elements]);
      var copy = elements.get(this);
      for (var index = 0; index < this.clipDevices.length; index++) {
        var clipDevice = this.clipDevices[index];
        // notons que cela gere le cas ou il n'y a pas de support, ou que le support n'est pas dans la copie...
        // Dans ce cas, elements.get renvoie "undefined"
        copy.clipDevices[index].support = elements.get(clipDevice.support);
      }
    }
  }, {
    key: "copyContent",
    value: function copyContent(copy, elements) {
      elements.set(this.caddyContent, copy.caddyContent);
      this.caddyContent.copyContent(copy.caddyContent, elements);
      elements.set(this.caddyCover, copy.caddyCover);
      this.caddyCover.copyContent(copy.caddyCover, elements);
      elements.set(this.fasciaSupport, copy.fasciaSupport);
      this.fasciaSupport.copyContent(copy.fasciaSupport, elements);
      elements.set(this.frameSupport, copy.frameSupport);
      this.frameSupport.copyContent(copy.frameSupport, elements);
    }
  }, {
    key: "tryToClip",
    value: function tryToClip(host) {
      var clips = this.clips();
      var firstClip = clips[0];
      var firstResult = host.searchFixing(firstClip.x, firstClip.y, _context5.default.FIXING_SEARCH_MARGIN);
      if (!firstResult) return false;
      var results = new _toolkit.List();
      results.add(firstResult);
      for (var index = 1; index < clips.length; index++) {
        var clip = clips[index];
        var rx = clip.x + firstResult.x - firstClip.x;
        var ry = clip.y + firstResult.y - firstClip.y;
        var result = host.searchFixing(rx, ry, _context5.default.CLIPS_MARGIN);
        if (!result) return false;
        results.add(result);
      }
      this._clips = results;
      return true;
    }
  }, {
    key: "executeClip",
    value: function executeClip() {
      if (this._clips) {
        this.clipsOn(this._clips);
        delete this._clips;
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      function receiveFascia(element) {
        if (element instanceof BoardFascia) {
          if (this.fasciaSupport.child !== null) {
            return false;
          }
          if (element.width !== this.width || element.height !== this.height - this.caddyCover.height) {
            return false;
          }
          element.position(0, 0);
          this.fasciaSupport.add(element);
          return true;
        }
        return false;
      }
      function receiveFrame(element) {
        if (element instanceof BoardFrame) {
          if (this.frameSupport.child !== null) {
            return false;
          }
          if (element.width !== this.width || element.height !== this.height) {
            return false;
          }
          element.position(0, 0);
          this.frameSupport.add(element);
          return true;
        }
        return false;
      }
      var result = _superPropGet(BoardAbstractCaddy, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      return receiveFascia.call(this, element) || receiveFrame.call(this, element);
    }
  }, {
    key: "hostable",
    get: function get() {
      return this;
    }
  }]);
}(BoardItem);
window.BoardCaddy = /*#__PURE__*/function (_BoardAbstractCaddy) {
  function BoardCaddy(width, height, contentX, contentY, contentWidth, contentHeight, coverHeight, clipDevices, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval, intermediateLadderCount, leftAdhesive, rightAdhesive, bottomAdhesive, labelText) {
    var _this30;
    (0, _classCallCheck2.default)(this, BoardCaddy);
    _this30 = _callSuper(this, BoardCaddy, [width, height, coverHeight, clipDevices, leftAdhesive, rightAdhesive, bottomAdhesive, labelText]);
    _this30.caddyContent = _this30.createCaddyContent(contentWidth, contentHeight, contentX, contentY, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval, intermediateLadderCount);
    _this30.add(_this30.caddyContent);
    _this30.add(_this30.caddyCover);
    _this30.add(_this30.fasciaSupport);
    _this30.add(_this30.frameSupport);
    return _this30;
  }
  (0, _inherits2.default)(BoardCaddy, _BoardAbstractCaddy);
  return (0, _createClass2.default)(BoardCaddy, [{
    key: "type",
    get: function get() {
      return "Caddy";
    }
  }, {
    key: "createCaddyContent",
    value: function createCaddyContent(contentWidth, contentHeight, contentX, contentY, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval, intermediateLadderCount) {
      return new BoardCaddyContent(this, contentWidth, contentHeight, contentX, contentY, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval, intermediateLadderCount);
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this31 = this;
      _context5.default.canvas.openModal(editBoardCaddy, {
        element: this,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        contentX: this.caddyContent.posX / _context5.default.rescaleFactor,
        contentY: this.caddyContent.posY / _context5.default.rescaleFactor,
        contentWidth: this.caddyContent.width / _context5.default.rescaleFactor,
        contentHeight: this.caddyContent.height / _context5.default.rescaleFactor,
        coverHeight: this.caddyCover.height / _context5.default.rescaleFactor,
        ladderWidth: this.caddyContent.leftLadder.width / _context5.default.rescaleFactor,
        ladderHeight: this.caddyContent.leftLadder.height / _context5.default.rescaleFactor,
        topPawl: this.caddyContent.leftLadder.topPawl / _context5.default.rescaleFactor,
        bottomPawl: this.caddyContent.leftLadder.bottomPawl / _context5.default.rescaleFactor,
        pawlInterval: this.caddyContent.leftLadder.pawlInterval / _context5.default.rescaleFactor,
        leftAdhesive: this.leftAdhesive,
        rightAdhesive: this.rightAdhesive,
        bottomAdhesive: this.bottomAdhesive,
        fixed: this.fixed,
        labelText: this.caddyCover.labelText
      }, function (data) {
        _this31.update(data);
      });
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Caddy" + _superPropGet(BoardCaddy, "modelId", this, 3)([]) + "|lw:" + this.caddyContent.leftLadder.width + "|lh:" + this.caddyContent.leftLadder.height + "|tp:" + this.caddyContent.leftLadder.topPawl + "|bp:" + this.caddyContent.leftLadder.bottomPawl + "|pi:" + this.caddyContent.leftLadder.pawlInterval + "|ilc:" + this.caddyContent.intermediateLadders.length + "|lt:" + this.caddyCover.labelText;
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardCaddy, "serializeModel", this, 3)([])), {}, {
        ladderWidth: this.caddyContent.leftLadder.width / _context5.default.rescaleFactor,
        ladderHeight: this.caddyContent.leftLadder.height / _context5.default.rescaleFactor,
        topPawl: this.caddyContent.leftLadder.topPawl / _context5.default.rescaleFactor,
        bottomPawl: this.caddyContent.leftLadder.bottomPawl / _context5.default.rescaleFactor,
        pawlInterval: this.caddyContent.leftLadder.pawlInterval / _context5.default.rescaleFactor,
        intermediateLaddersCount: this.caddyContent.intermediateLadders.length
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardCaddy, "serializeSpec", this, 3)([])), {}, {
        ladders: []
      });
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      var _iterator35 = _createForOfIteratorHelper(this.caddyContent.children()),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var element = _step35.value;
          if (element.free || !(element instanceof BoardBaseAbstractLadder)) {
            this.serializeChild(element, models, current, objects);
          } else {
            current.ladders.push(element.id);
          }
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      _superPropGet(BoardCaddy, "serializeChildren", this, 3)([models, current, objects]);
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      var children = this.caddyContent.children();
      for (var index = 0; index < spec.ladders.length; index++) {
        built.set(spec.ladders[index], children[index]);
      }
      var _iterator36 = _createForOfIteratorHelper(spec.children),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var _childSpec5 = _step36.value;
          this.caddyContent._add(this.startDeserializeChild(_childSpec5, models, built));
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      if (spec.free) {
        var _iterator37 = _createForOfIteratorHelper(spec.free),
          _step37;
        try {
          for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
            var childSpec = _step37.value;
            this.caddyContent._add(this.startDeserializeFreeChild(childSpec, models, built));
          }
        } catch (err) {
          _iterator37.e(err);
        } finally {
          _iterator37.f();
        }
      }
      _superPropGet(BoardCaddy, "startDeserializeChildren", this, 3)([spec, models, built]);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      function duplicateDevices(clipDevices) {
        var result = [];
        var _iterator38 = _createForOfIteratorHelper(clipDevices),
          _step38;
        try {
          for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
            var clipDevice = _step38.value;
            result.push({
              x: clipDevice.x,
              y: clipDevice.y
            });
          }
        } catch (err) {
          _iterator38.e(err);
        } finally {
          _iterator38.f();
        }
        return result;
      }
      var copy = new BoardCaddy(this.width, this.height, this.caddyContent.posX, this.caddyContent.posY, this.caddyContent.width, this.caddyContent.height, this.caddyCover.height, duplicateDevices(this.clipDevices), this.caddyContent.leftLadder.width, this.caddyContent.leftLadder.height, this.caddyContent.leftLadder.topPawl, this.caddyContent.leftLadder.bottomPawl, this.caddyContent.leftLadder.pawlInterval, this.caddyContent.intermediateLadders.length, this.leftAdhesive, this.rightAdhesive, this.bottomAdhesive, this.caddyCover.labelText);
      return copy;
    }
  }, {
    key: "searchPawl",
    value: function searchPawl(x, y, margin) {
      return this.caddyContent.searchPawl(x, y, margin);
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardCaddy.create(model.width, model.height, model.contentX, model.contentY, model.contentWidth, model.contentHeight, model.coverHeight, model.clipDevices, model.ladderWidth, model.ladderHeight, model.topPawl, model.bottomPawl, model.pawlInterval, model.intermediateLaddersCount, model.leftAdhesive, model.rightAdhesive, model.bottomAdhesive, model.labelText);
    }
  }]);
}(BoardAbstractCaddy);
BoardCaddy.create = function (width, height, contentX, contentY, contentWidth, contentHeight, coverHeight, clipDevices, ladderWidth, ladderHeight, topPawl, bottomPawl, pawlInterval, intermediateLadderCount, leftAdhesive, rightAdhesive, bottomAdhesive, labelText) {
  function rescale(devices) {
    var rescaledDevices = new _toolkit.List();
    var _iterator39 = _createForOfIteratorHelper(devices),
      _step39;
    try {
      for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
        var device = _step39.value;
        rescaledDevices.add({
          x: device.x * _context5.default.rescaleFactor,
          y: device.y * _context5.default.rescaleFactor
        });
      }
    } catch (err) {
      _iterator39.e(err);
    } finally {
      _iterator39.f();
    }
    return rescaledDevices;
  }
  return new BoardCaddy(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, contentX * _context5.default.rescaleFactor, contentY * _context5.default.rescaleFactor, contentWidth * _context5.default.rescaleFactor, contentHeight * _context5.default.rescaleFactor, coverHeight * _context5.default.rescaleFactor, rescale(clipDevices), ladderWidth * _context5.default.rescaleFactor, ladderHeight * _context5.default.rescaleFactor, topPawl * _context5.default.rescaleFactor, bottomPawl * _context5.default.rescaleFactor, pawlInterval * _context5.default.rescaleFactor, intermediateLadderCount, leftAdhesive, rightAdhesive, bottomAdhesive, labelText);
};
window.BoardSlotCaddy = /*#__PURE__*/function (_BoardAbstractCaddy2) {
  function BoardSlotCaddy(width, height, contentX, contentY, contentWidth, contentHeight, coverHeight, clipDevices, slotCount, leftAdhesive, rightAdhesive, bottomAdhesive, labelText) {
    var _this32;
    (0, _classCallCheck2.default)(this, BoardSlotCaddy);
    _this32 = _callSuper(this, BoardSlotCaddy, [width, height, coverHeight, clipDevices, leftAdhesive, rightAdhesive, bottomAdhesive, labelText]);
    _this32.caddyContent = _this32.createCaddyContent(contentWidth, contentHeight, contentX, contentY, slotCount);
    _this32.add(_this32.caddyContent);
    _this32.add(_this32.caddyCover);
    return _this32;
  }
  (0, _inherits2.default)(BoardSlotCaddy, _BoardAbstractCaddy2);
  return (0, _createClass2.default)(BoardSlotCaddy, [{
    key: "type",
    get: function get() {
      return "SlotCaddy";
    }
  }, {
    key: "createCaddyContent",
    value: function createCaddyContent(contentWidth, contentHeight, contentX, contentY, slotCount) {
      return new BoardSlotCaddyContent(this, contentWidth, contentHeight, contentX, contentY, slotCount);
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this33 = this;
      _context5.default.canvas.openModal(editBoardSlotCaddy, {
        element: this,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        contentX: this.caddyContent.posX / _context5.default.rescaleFactor,
        contentY: this.caddyContent.posY / _context5.default.rescaleFactor,
        contentWidth: this.caddyContent.width / _context5.default.rescaleFactor,
        contentHeight: this.caddyContent.height / _context5.default.rescaleFactor,
        leftAdhesive: this.leftAdhesive,
        rightAdhesive: this.rightAdhesive,
        bottomAdhesive: this.bottomAdhesive,
        fixed: this.fixed,
        labelText: this.caddyCover.labelText
      }, function (data) {
        _this33.update(data);
      });
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "SlotCaddy" + _superPropGet(BoardSlotCaddy, "modelId", this, 3)([]) + "|sc:" + this.caddyContent.slotCount;
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardSlotCaddy, "serializeModel", this, 3)([])), {}, {
        slotCount: this.caddyContent.slotCount
      });
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      var _iterator40 = _createForOfIteratorHelper(this.caddyContent.children()),
        _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var element = _step40.value;
          this.serializeChild(element, models, current, objects);
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      _superPropGet(BoardSlotCaddy, "serializeChildren", this, 3)([models, current, objects]);
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      var _iterator41 = _createForOfIteratorHelper(spec.children),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var _childSpec6 = _step41.value;
          this.caddyContent._add(this.startDeserializeChild(_childSpec6, models, built));
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
      if (spec.free) {
        var _iterator42 = _createForOfIteratorHelper(spec.free),
          _step42;
        try {
          for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
            var childSpec = _step42.value;
            this.caddyContent._add(this.startDeserializeFreeChild(childSpec, models, built));
          }
        } catch (err) {
          _iterator42.e(err);
        } finally {
          _iterator42.f();
        }
      }
      _superPropGet(BoardSlotCaddy, "startDeserializeChildren", this, 3)([spec, models, built]);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      function duplicateDevices(clipDevices) {
        var result = [];
        var _iterator43 = _createForOfIteratorHelper(clipDevices),
          _step43;
        try {
          for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
            var clipDevice = _step43.value;
            result.push({
              x: clipDevice.x,
              y: clipDevice.y
            });
          }
        } catch (err) {
          _iterator43.e(err);
        } finally {
          _iterator43.f();
        }
        return result;
      }
      var copy = new BoardSlotCaddy(this.width, this.height, this.caddyContent.posX, this.caddyContent.posY, this.caddyContent.width, this.caddyContent.height, this.caddyCover.height, duplicateDevices(this.clipDevices), this.caddyContent.slotCount, this.leftAdhesive, this.rightAdhesive, this.bottomAdhesive, this.caddyCover.labelText);
      return copy;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardSlotCaddy.create(model.width, model.height, model.contentX, model.contentY, model.contentWidth, model.contentHeight, model.coverHeight, model.clipDevices, model.slotCount, model.leftAdhesive, model.rightAdhesive, model.bottomAdhesive, model.labelText);
    }
  }]);
}(BoardAbstractCaddy);
BoardSlotCaddy.create = function (width, height, contentX, contentY, contentWidth, contentHeight, coverHeight, clipDevices, slotCount, leftAdhesive, rightAdhesive, bottomAdhesive, labelText) {
  function rescale(devices) {
    var rescaledDevices = new _toolkit.List();
    var _iterator44 = _createForOfIteratorHelper(devices),
      _step44;
    try {
      for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
        var device = _step44.value;
        rescaledDevices.add({
          x: device.x * _context5.default.rescaleFactor,
          y: device.y * _context5.default.rescaleFactor
        });
      }
    } catch (err) {
      _iterator44.e(err);
    } finally {
      _iterator44.f();
    }
    return rescaledDevices;
  }
  return new BoardSlotCaddy(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, contentX * _context5.default.rescaleFactor, contentY * _context5.default.rescaleFactor, contentWidth * _context5.default.rescaleFactor, contentHeight * _context5.default.rescaleFactor, coverHeight * _context5.default.rescaleFactor, rescale(clipDevices), slotCount, leftAdhesive, rightAdhesive, bottomAdhesive, labelText);
};
window.BoardModule = /*#__PURE__*/function (_BoardItem8) {
  function BoardModule(label, width, height) {
    var _this35, _this36;
    var _this34;
    (0, _classCallCheck2.default)(this, BoardModule);
    _this34 = _callSuper(this, BoardModule, [width, height]);
    _this34._dragOperation(_context5.default.standardDrag);
    _this34.label = label;
    for (var _len9 = arguments.length, args = new Array(_len9 > 3 ? _len9 - 3 : 0), _key9 = 3; _key9 < _len9; _key9++) {
      args[_key9 - 3] = arguments[_key9];
    }
    _this34.args = [width, height].concat(args);
    _this34.fr = (_this35 = _this34).createFrame.apply(_this35, [width, height].concat(args));
    _this34.fr.owner = _this34;
    _this34.el = (_this36 = _this34).createPlain.apply(_this36, [width, height].concat(args));
    _this34.el.owner = _this34;
    return _this34;
  }
  (0, _inherits2.default)(BoardModule, _BoardItem8);
  return (0, _createClass2.default)(BoardModule, [{
    key: "_visualization",
    value: function _visualization() {
      _superPropGet(BoardModule, "_visualization", this, 3)([]);
      if (!_context5.default.visualizer.module) {
        this.root.attr({
          visibility: "hidden"
        });
      } else {
        this.root.attr({
          visibility: "visible"
        });
      }
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardModule, "createContextMenu", this, 3)([]);
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this37 = this;
      _context5.default.canvas.openModal(editBoardModule, {
        element: this,
        fixed: this.fixed,
        label: this.label
      }, function (data) {
        _this37.update(data);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        console.log("module edited :)");
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "createFrame",
    value: function createFrame(width, height, color) {
      return this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: color
      });
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height) {
      return this.plain.rect(-width / 2, -height / 2, width, height);
    }
  }, {
    key: "modelId",
    value: function modelId() {
      var color = this.fr.attr("fill");
      return "Module|l:" + this.label + "w:" + this.width + "|h:" + this.height + "|c:" + color;
    }
  }, {
    key: "type",
    get: function get() {
      return "Module";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      var color = this.fr.attr("fill");
      return _objectSpread(_objectSpread({}, _superPropGet(BoardModule, "serializeModel", this, 3)([])), {}, {
        label: this.label,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        color: color
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = _objectSpread(_objectSpread({}, _superPropGet(BoardModule, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
      return result;
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardModule, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = (0, _construct2.default)(BoardModule, [this.label].concat((0, _toConsumableArray2.default)(this.args)));
      return copy;
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardModule, "receiveDrop", this, 3)([element]);
      if (result !== undefined) {
        return result;
      } else {
        return this.parent().receiveDrop(element);
      }
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardModule, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      memento.label = this.label;
      memento.args = this.args;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardModule, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this.label = memento.label;
      this.args = memento.args;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardModule.create(model.label, model.width, model.height, model.color);
    }
  }]);
}(BoardItem);
BoardModule.create = function (label, width, height) {
  for (var _len0 = arguments.length, args = new Array(_len0 > 3 ? _len0 - 3 : 0), _key0 = 3; _key0 < _len0; _key0++) {
    args[_key0 - 3] = arguments[_key0];
  }
  return (0, _construct2.default)(BoardModule, [label, width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor].concat(args));
};
window.BoardImageModule = /*#__PURE__*/function (_BoardModule) {
  function BoardImageModule(label, width, height) {
    (0, _classCallCheck2.default)(this, BoardImageModule);
    for (var _len1 = arguments.length, args = new Array(_len1 > 3 ? _len1 - 3 : 0), _key1 = 3; _key1 < _len1; _key1++) {
      args[_key1 - 3] = arguments[_key1];
    }
    return _callSuper(this, BoardImageModule, [label, width, height].concat(args));
  }
  (0, _inherits2.default)(BoardImageModule, _BoardModule);
  return (0, _createClass2.default)(BoardImageModule, [{
    key: "createFrame",
    value: function createFrame(width, height, imageURL, plainURL) {
      var fr = this.frame.group();
      fr.rect(-width / 2, -height / 2, width, height).attr({
        stroke: "none",
        fill: _context5.default.LIGHT_GREY
      });
      this.prepareImage(width, height);
      fr.add(this.frImage);
      return fr;
    }
  }, {
    key: "prepareImage",
    value: function prepareImage(width, height) {
      var _this38 = this;
      this.frImage && this.frImage.remove();
      this.frImage = (0, _toolkit.rasterizedSvgImage)(this.imageURL, this._hiddenLayers(), width, height, function (img) {
        var imgWidth = parseFloat(img.children()[0].attr("width"));
        var imgHeight = parseFloat(img.children()[0].attr("height"));
        _this38.fr.add(_this38.frImage);
        _this38.frImage.attr({
          opacity: 1
        });
        _this38.frImage.transform(new _snap.default.Matrix().translate(-_this38.width / 2, -_this38.height / 2).scale(_this38.width / imgWidth, _this38.height / imgHeight, 0, 0));
        if (_this38.shadeColorsImage && _context5.default.visualizer.iconColors) {
          _this38.frImage.add(_this38.shadeColorsImage);
        }
        if (_this38.shadeReferenceImage && _context5.default.visualizer.reference) {
          _this38.frImage.add(_this38.shadeReferenceImage);
        }
        //this._dispatchChange("geometry");
      });
      this.frImage.attr({
        opacity: 0
      });
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height, imageURL, plainURL) {
      var _this39 = this;
      var el = this.plain.group();
      this.elImage = el.group();
      if (plainURL) {
        (0, _toolkit.pngImage)(plainURL, width, height, function (img, width, height) {
          _this39.elImage.image(plainURL, -width / 2, -height / 2, width, height);
        });
      }
      return el;
    }
  }, {
    key: "_visualization",
    value: function _visualization() {
      _superPropGet(BoardImageModule, "_visualization", this, 3)([]);
      this._visualizeLayers();
    }
  }, {
    key: "_hiddenLayers",
    value: function _hiddenLayers() {
      var layers = [];
      if (!_context5.default.visualizer.ticket) {
        layers.push("ETIQUETTE");
      }
      if (!_context5.default.visualizer.iconColors) {
        layers.push("FILL");
      }
      if (!_context5.default.visualizer.reference) {
        layers.push("TEXTE");
      }
      return layers;
    }
  }, {
    key: "_visualizeLayers",
    value: function _visualizeLayers() {
      if (this.frImage) {
        this.prepareImage(this.width, this.height);
        this.fr.add(this.frImage);
      }
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardImageModule, "memento", this, 3)([]);
      memento.frImage = this.frImage;
      memento.elImage = this.elImage;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardImageModule, "revert", this, 3)([memento]);
      this.frImage = memento.frImage;
      this.fr.clear();
      this.fr.add(this.frImage);
      this.elImage = memento.elImage;
      this.el.clear();
      this.el.add(this.elImage);
    }
  }, {
    key: "_changeFrImage",
    value: function _changeFrImage(frImageNode) {
      this.frImage = (0, _snap.default)(frImageNode.cloneNode(true));
      this.fr.clear();
      this.fr.rect(-this.width / 2, -this.height / 2, this.width, this.height).attr({
        stroke: "none",
        fill: _context5.default.LIGHT_GREY
      });
      this.fr.add(this.frImage);
      return this;
    }
  }, {
    key: "_changeElImage",
    value: function _changeElImage(elImageNode) {
      this.elImage = (0, _snap.default)(elImageNode.cloneNode(true));
      this.el.clear();
      this.el.add(this.elImage);
      return this;
    }
  }, {
    key: "changeImage",
    value: function changeImage(frImageNode, elImageNode) {
      _superPropGet(BoardImageModule, "register", this, 3)([]);
      this._changeFrImage(frImageNode);
      this._changeElImage(elImageNode);
      this._dispatchChange("geometry");
      return this;
    }
  }, {
    key: "imageURL",
    get: function get() {
      return this.args[2];
    }
  }, {
    key: "realisticURL",
    get: function get() {
      return this.args[3];
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "ImageModule|l:" + this.label + "w:" + this.width + "|h:" + this.height + "|url:" + this.imageURL;
    }
  }, {
    key: "type",
    get: function get() {
      return "ImageModule";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardImageModule, "serializeModel", this, 3)([])), {}, {
        label: this.label,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        imageURL: this.imageURL,
        realisticURL: this.realisticURL
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = _objectSpread(_objectSpread({}, _superPropGet(BoardImageModule, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
      return result;
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = (0, _construct2.default)(BoardImageModule, [this.label].concat((0, _toConsumableArray2.default)(this.args)));
      if (this.frImage.children().length > 0) {
        copy._changeFrImage(this.frImage.node);
        copy._changeElImage(this.elImage.node);
        if (this.shadeColorsImage) {
          copy.shadeColorsImage = this.shadeColorsImage.clone();
        }
        if (this.shadeReferenceImage) {
          copy.shadeReferenceImage = this.shadeReferenceImage.clone();
        }
      }
      return copy;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardImageModule.create(model.label, model.width, model.height, model.imageURL, model.realisticURL);
    }
  }]);
}(BoardModule);
BoardImageModule.create = function (label, width, height) {
  for (var _len10 = arguments.length, args = new Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }
  return (0, _construct2.default)(BoardImageModule, [label, width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor].concat(args));
};
window.BoardBlister = /*#__PURE__*/function (_BoardItem9) {
  function BoardBlister(width, height, clipDevice, clipRadius) {
    var _this41, _this42;
    var _this40;
    (0, _classCallCheck2.default)(this, BoardBlister);
    _this40 = _callSuper(this, BoardBlister, [width, height]);
    _this40.dragOperation(_context5.default.standardDrag);
    for (var _len11 = arguments.length, args = new Array(_len11 > 4 ? _len11 - 4 : 0), _key11 = 4; _key11 < _len11; _key11++) {
      args[_key11 - 4] = arguments[_key11];
    }
    _this40.args = [width, height, clipDevice, clipRadius].concat(args);
    _this40.clipDevice = clipDevice;
    _this40.clipRadius = clipRadius;
    _this40.fr = (_this41 = _this40).createFrame.apply(_this41, [width, height].concat(args));
    _this40.fr.owner = _this40;
    _this40.el = (_this42 = _this40).createPlain.apply(_this42, [width, height].concat(args));
    _this40.el.owner = _this40;
    return _this40;
  }
  (0, _inherits2.default)(BoardBlister, _BoardItem9);
  return (0, _createClass2.default)(BoardBlister, [{
    key: "createFrame",
    value: function createFrame(width, height, color) {
      var result = this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: color
      });
      this.frame.circle(this.clipDevice.x, this.clipDevice.y, this.clipRadius).attr({
        stroke: _context5.default.BLACK,
        fill: _context5.default.WHITE
      });
      return result;
    }
  }, {
    key: "createPlain",
    value: function createPlain(width, height) {
      var result = this.plain.rect(-width / 2, -height / 2, width, height);
      this.plain.circle(this.clipDevice.x, this.clipDevice.y, this.clipRadius).attr({
        stroke: _context5.default.BLACK,
        fill: _context5.default.WHITE
      });
      return result;
    }
  }, {
    key: "justModel",
    value: function justModel(clipDevice) {
      return {
        x: clipDevice.x / _context5.default.rescaleFactor,
        y: clipDevice.y / _context5.default.rescaleFactor
      };
    }
  }, {
    key: "modelId",
    value: function modelId() {
      var color = this.fr.attr("fill");
      return "Blister|w:" + this.width + "|h:" + this.height + "|r:" + this.clipRadius + "|c:" + color + "|cld:" + JSON.stringify(this.justModel(this.clipDevice));
    }
  }, {
    key: "type",
    get: function get() {
      return "Blister";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      var color = this.fr.attr("fill");
      return _objectSpread(_objectSpread({}, _superPropGet(BoardBlister, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        clipRadius: this.clipRadius / _context5.default.rescaleFactor,
        color: color,
        clipDevice: this.justModel(this.clipDevice)
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = _superPropGet(BoardBlister, "serializeSpec", this, 3)([]);
      if (this.clipDevice.support) {
        result.clipped = {
          support: this.clipDevice.support.id
        };
      }
      return result;
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      _superPropGet(BoardBlister, "endDeserialize", this, 3)([spec, built]);
      if (spec.clipped) {
        var support = built.get(spec.clipped.support);
        var clip = support._hook();
        this.deserializeClip(clip);
      }
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = (0, _construct2.default)(BoardBlister, (0, _toConsumableArray2.default)(this.args));
      return copy;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardBlister, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      memento.args = this.args;
      memento.clipDevice = this.clipDevice;
      memento.clipRadius = this.clipRadius;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardBlister, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this.args = memento.args;
      this.clipDevice = memento.clipDevice;
      this.clipRadius = memento.clipRadius;
    }
  }, {
    key: "cancelDrop",
    value: function cancelDrop() {
      _superPropGet(BoardBlister, "cancelDrop", this, 3)([]);
      if (this.clipDevice.support) {
        this.clipDevice.support.clips(this, this.clipDevice.sx, this.clipDevice.sy);
      }
    }
  }, {
    key: "clips",
    value: function clips() {
      var matrix = this.localTranslation;
      return {
        x: matrix.x(this.clipDevice.x, this.clipDevice.y),
        y: matrix.y(this.clipDevice.x, this.clipDevice.y)
      };
    }
  }, {
    key: "clipsOn",
    value: function clipsOn(clip) {
      this.register();
      this.adjustPosition(clip.x - this.clipDevice.x, clip.y - this.clipDevice.y);
      this._clipsOn(clip);
    }
  }, {
    key: "deserializeClip",
    value: function deserializeClip(clip) {
      this._adjustPosition(clip.x - this.clipDevice.x, clip.y - this.clipDevice.y);
      this._clipsOn(clip);
    }
  }, {
    key: "_clipsOn",
    value: function _clipsOn(clip) {
      clip.support.clips(this, clip.x, clip.y);
      this.clipDevice.support = clip.support;
      this.clipDevice.sx = clip.x;
      this.clipDevice.sy = clip.y;
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      _superPropGet(BoardBlister, "linkContent", this, 3)([elements]);
      var copy = elements.get(this);
      if (this.clipDevice.support && elements.get(this.clipDevice.support)) {
        copy.clipDevice.support = elements.get(this.clipDevice.support);
        copy.clipDevice.sx = this.clipDevice.sx;
        copy.clipDevice.sy = this.clipDevice.sy;
      }
    }
  }, {
    key: "tryToClip",
    value: function tryToClip(host) {
      var clip = this.clips();
      var result = host.searchHook(clip.x, clip.y, HOOK_SEARCH_MARGIN);
      if (!result) return false;
      this._clips = result;
      return true;
    }
  }, {
    key: "executeClip",
    value: function executeClip() {
      if (this._clips) {
        this.clipsOn(this._clips);
        delete this.clips;
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardBlister, "receiveDrop", this, 3)([element]);
      return result === undefined ? false : result;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardBlister.create(model.width, model.height, model.clipDevice, model.clipRadius, model.color);
    }
  }]);
}(BoardItem);
BoardBlister.create = function (width, height, clipDevice, clipRadius) {
  function rescale(clipDevice) {
    return {
      x: clipDevice.x * _context5.default.rescaleFactor,
      y: clipDevice.y * _context5.default.rescaleFactor
    };
  }
  for (var _len12 = arguments.length, args = new Array(_len12 > 4 ? _len12 - 4 : 0), _key12 = 4; _key12 < _len12; _key12++) {
    args[_key12 - 4] = arguments[_key12];
  }
  return (0, _construct2.default)(BoardBlister, [width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, rescale(clipDevice), clipRadius * _context5.default.rescaleFactor].concat(args));
};
window.BoardDivider = /*#__PURE__*/function (_BoardItem0) {
  function BoardDivider(width, height) {
    var _this43;
    (0, _classCallCheck2.default)(this, BoardDivider);
    _this43 = _callSuper(this, BoardDivider, [width, height]);
    _this43.dragOperation(_context5.default.standardDrag);
    _this43.fr = _this43.frame.rect(-width / 2, -height / 2, width, height).attr({
      stroke: _context5.default.BLACK,
      fill: _context5.default.WHITE
    });
    _this43.fr.owner = _this43;
    _this43.el = _this43.plain.rect(-width / 2, -height / 2, width, height);
    _this43.el.owner = _this43;
    return _this43;
  }
  (0, _inherits2.default)(BoardDivider, _BoardItem0);
  return (0, _createClass2.default)(BoardDivider, [{
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardDivider, "createContextMenu", this, 3)([]);
      this.makeMoveable();
    }
  }, {
    key: "move",
    value: function move(x, xRelative, y, yRelative) {
      var fx = xRelative ? this.posX + x : x;
      var fy = yRelative ? this.posY + y : y;
      this.position(fx, fy);
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this44 = this;
      _context5.default.canvas.openModal(editBoardSeparator, {
        element: this,
        height: this.height / _context5.default.rescaleFactor,
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor,
        fixed: this.fixed
      }, function (data) {
        _this44.update(data);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        this.fr.attr({
          height: "" + data.height * _context5.default.rescaleFactor,
          y: -data.height * _context5.default.rescaleFactor / 2
        });
        this.el.attr({
          height: "" + data.height * _context5.default.rescaleFactor,
          y: -data.height * _context5.default.rescaleFactor / 2
        });
        this.position(data.x * _context5.default.rescaleFactor, data.y * _context5.default.rescaleFactor);
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Divider|w:" + this.width + "|h:" + this.height;
    }
  }, {
    key: "type",
    get: function get() {
      return "Divider";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardDivider, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardDivider, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardDivider, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardDivider(this.width, this.height);
      return copy;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardDivider, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardDivider, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardDivider, "receiveDrop", this, 3)([element]);
      return result === undefined ? false : result;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardDivider.create(model.width, model.height);
    }
  }]);
}(BoardItem);
BoardDivider.create = function (width, height) {
  return new BoardDivider(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor);
};
window.BoardBaseAbstractLadder = /*#__PURE__*/function (_BoardItem1) {
  function BoardBaseAbstractLadder(width, height, topPawl, bottomPawl, pawlInterval) {
    var _this45;
    (0, _classCallCheck2.default)(this, BoardBaseAbstractLadder);
    _this45 = _callSuper(this, BoardBaseAbstractLadder, [width, height]);
    _this45.createFrame(width, height);
    _this45.frPawls = _this45.frame.group();
    _this45.elPawls = _this45.plain.group();
    _this45.topPawl = topPawl;
    _this45.bottomPawl = bottomPawl;
    _this45.pawlInterval = pawlInterval;
    _this45.clippsed = new Map();
    _this45.createPawls();
    return _this45;
  }
  (0, _inherits2.default)(BoardBaseAbstractLadder, _BoardItem1);
  return (0, _createClass2.default)(BoardBaseAbstractLadder, [{
    key: "createFrame",
    value: function createFrame(width, height) {}
  }, {
    key: "indexFromTop",
    value: function indexFromTop(index, count) {
      return index;
    }
  }, {
    key: "indexFromBottom",
    value: function indexFromBottom(index, count) {
      return count - index + 1;
    }
  }, {
    key: "createPawls",
    value: function createPawls() {
      if (this.frPawlsContent) {
        this.frPawlsContent.remove();
      }
      if (this.elPawlsContent) {
        this.elPawlsContent.remove();
      }
      this.elPawlsContent = this.elPawls.group();
      this.frPawlsContent = this.frPawls.group();
      var pawlSize = Math.min(2, this.pawlInterval / 6);
      var _iterator45 = _createForOfIteratorHelper(this.pawls()),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var pawl = _step45.value;
          this.frPawlsContent.circle(pawl.x, pawl.y, pawlSize).attr({
            fill: _context5.default.BLACK
          });
          this.elPawlsContent.circle(pawl.x, pawl.y, pawlSize).attr({
            fill: _context5.default.BLACK
          });
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
    }
  }, {
    key: "update",
    value: function update(data) {
      this.register();
      this.topPawl = data.topPawl * _context5.default.rescaleFactor;
      this.bottomPawl = data.bottomPawl * _context5.default.rescaleFactor;
      this.pawlInterval = data.pawlInterval * _context5.default.rescaleFactor;
      this.createPawls();
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardBaseAbstractLadder, "memento", this, 3)([]);
      memento.frPawls = this.frPawls;
      memento.elPawls = this.elPawls;
      memento.topPawl = this.topPawl;
      memento.bottomPawl = this.bottomPawl;
      memento.pawlInterval = this.pawlInterval;
      memento.clippsed = new Map(this.clippsed);
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardBaseAbstractLadder, "revert", this, 3)([memento]);
      this.frPawls = memento.frPawls;
      this.elPawls = memento.elPawls;
      this.topPawl = memento.topPawl;
      this.bottomPawl = memento.bottomPawl;
      this.pawlInterval = memento.pawlInterval;
      this.clippsed = new Map(memento.clippsed);
      this.createPawls();
    }
  }, {
    key: "searchPawl",
    value: function searchPawl(x, y, margin) {
      var _this46 = this;
      var alreadyUsed = function alreadyUsed(pawl) {
        var _iterator46 = _createForOfIteratorHelper(_this46.clippsed.values()),
          _step46;
        try {
          for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
            var position = _step46.value;
            if (Math.abs(position.x - pawl.x) < _context5.default.CLIPS_MARGIN && Math.abs(position.y - pawl.y) < _context5.default.CLIPS_MARGIN) {
              return true;
            }
          }
        } catch (err) {
          _iterator46.e(err);
        } finally {
          _iterator46.f();
        }
        return false;
      };
      if (!this.accept(x, margin)) return null;
      var matrix = this.localTranslation.invert();
      var lx = matrix.x(x, y);
      var ly = matrix.y(x, y);
      var sx, sy, sdistance;
      var pawls = (0, _toConsumableArray2.default)(this.pawls());
      var idx = 1;
      var index = 0;
      var _iterator47 = _createForOfIteratorHelper(pawls),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var pawl = _step47.value;
          var distance = (lx - pawl.x) * (lx - pawl.x) + (ly - pawl.y) * (ly - pawl.y);
          if (sdistance === undefined || sdistance > distance) {
            if (!alreadyUsed(pawl)) {
              sdistance = distance;
              sx = pawl.x;
              sy = pawl.y;
              index = idx;
            }
          }
          idx++;
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
      if (sdistance <= margin * margin) {
        matrix = this.localTranslation;
        return {
          support: this,
          x: matrix.x(sx, sy),
          y: matrix.y(sx, sy),
          index: index,
          count: pawls.length,
          distance: Math.sqrt(sdistance)
        };
      } else return null;
    }
  }, {
    key: "clips",
    value: function clips(element, x, y) {
      this.register();
      var matrix = this.localTranslation.invert();
      this.clippsed.set(element, {
        x: matrix.x(x, y),
        y: matrix.y(x, y)
      });
      this.observe(element);
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      var copy = elements.get(this);
      var _iterator48 = _createForOfIteratorHelper(this.clippsed.keys()),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var element = _step48.value;
          var clip = this.clippsed.get(element);
          var copyClippsed = elements.get(element);
          if (copyClippsed) {
            copy.clippsed.set(copyClippsed, {
              x: clip.x,
              y: clip.y
            });
            copy.observe(copyClippsed);
          }
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
      _superPropGet(BoardBaseAbstractLadder, "linkContent", this, 3)([elements]);
    }
  }, {
    key: "unclips",
    value: function unclips(element) {
      this.register();
      if (this.clippsed.delete(element)) {
        element.unclips();
        this.forget(element);
        return true;
      }
      return false;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      _superPropGet(BoardBaseAbstractLadder, "changed", this, 3)([source, type, value]);
      if (type === "removed" && this.clippsed.has(source)) {
        this.unclips(source);
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardBaseAbstractLadder, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      var _computePosition = (0, _toolkit.computePosition)(this.root, this.host.root, element.posX, element.posY),
        x = _computePosition.x,
        y = _computePosition.y;
      element.position(x, y);
      this.host.add(element);
      return this.host.receiveDrop(element);
    }
  }, {
    key: "adjustDrop",
    value: function adjustDrop(element) {
      this.host.adjustDrop(element);
    }
  }]);
}(BoardItem);
window.BoardBaseLadder = /*#__PURE__*/function (_BoardBaseAbstractLad) {
  function BoardBaseLadder(owner, width, height, topPawl, bottomPawl, pawlInterval) {
    var _this47;
    (0, _classCallCheck2.default)(this, BoardBaseLadder);
    _this47 = _callSuper(this, BoardBaseLadder, [width, height, topPawl, bottomPawl, pawlInterval]);
    _this47.owner = owner;
    return _this47;
  }
  (0, _inherits2.default)(BoardBaseLadder, _BoardBaseAbstractLad);
  return (0, _createClass2.default)(BoardBaseLadder, [{
    key: "pawls",
    value: /*#__PURE__*/_regenerator.default.mark(function pawls() {
      var y;
      return _regenerator.default.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            y = this.topPawl;
          case 1:
            if (!(y <= this.bottomPawl)) {
              _context.next = 3;
              break;
            }
            _context.next = 2;
            return {
              x: 0,
              y: y
            };
          case 2:
            y += this.pawlInterval;
            _context.next = 1;
            break;
          case 3:
          case "end":
            return _context.stop();
        }
      }, pawls, this);
    })
  }, {
    key: "accept",
    value: function accept(x, margin) {
      return Math.abs(x - this.posX) <= margin;
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this.owner.selectable();
    }
  }]);
}(BoardBaseAbstractLadder);
window.BoardBaseDoubleLadder = /*#__PURE__*/function (_BoardBaseAbstractLad2) {
  function BoardBaseDoubleLadder(owner, width, height, topPawl, bottomPawl, pawlInterval) {
    var _this48;
    (0, _classCallCheck2.default)(this, BoardBaseDoubleLadder);
    _this48 = _callSuper(this, BoardBaseDoubleLadder, [width, height, topPawl, bottomPawl, pawlInterval]);
    _this48.owner = owner;
    return _this48;
  }
  (0, _inherits2.default)(BoardBaseDoubleLadder, _BoardBaseAbstractLad2);
  return (0, _createClass2.default)(BoardBaseDoubleLadder, [{
    key: "pawls",
    value: /*#__PURE__*/_regenerator.default.mark(function pawls() {
      var width, y;
      return _regenerator.default.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            width = this.width;
            y = this.topPawl;
          case 1:
            if (!(y <= this.bottomPawl)) {
              _context2.next = 4;
              break;
            }
            _context2.next = 2;
            return {
              x: -width / 4,
              y: y
            };
          case 2:
            _context2.next = 3;
            return {
              x: width / 4,
              y: y
            };
          case 3:
            y += this.pawlInterval;
            _context2.next = 1;
            break;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, pawls, this);
    })
  }, {
    key: "indexFromTop",
    value: function indexFromTop(index, count) {
      return Math.floor((index + 1) / 2);
    }
  }, {
    key: "indexFromBottom",
    value: function indexFromBottom(index, count) {
      return Math.floor(count / 2) - this.indexFromTop(index, count) + 1;
    }
  }, {
    key: "accept",
    value: function accept(x, margin) {
      return Math.abs(x - this.posX + this.width / 4) <= margin || Math.abs(x - this.posX - this.width / 4) <= margin;
    }
  }, {
    key: "selectable",
    value: function selectable() {
      return this.owner.selectable();
    }
  }]);
}(BoardBaseAbstractLadder);
window.BoardAbstractLadder = /*#__PURE__*/function (_BoardBaseAbstractLad3) {
  function BoardAbstractLadder(width, height, topPawl, bottomPawl, pawlInterval) {
    var _this49;
    (0, _classCallCheck2.default)(this, BoardAbstractLadder);
    _this49 = _callSuper(this, BoardAbstractLadder, [width, height, topPawl, bottomPawl, pawlInterval]);
    _this49.dragOperation(_context5.default.standardDrag);
    return _this49;
  }
  (0, _inherits2.default)(BoardAbstractLadder, _BoardBaseAbstractLad3);
  return (0, _createClass2.default)(BoardAbstractLadder, [{
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardAbstractLadder, "createContextMenu", this, 3)([]);
      this.makeMoveable();
    }
  }, {
    key: "move",
    value: function move(x, xRelative, y, yRelative) {
      var fx = xRelative ? this.posX + x : x;
      var fy = yRelative ? this.posY + y : y;
      this.position(fx, fy);
    }
  }, {
    key: "layer",
    get: function get() {
      return "down";
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "|w:" + this.width + "|h:" + this.height + "|tp:" + this.topPawl + "|bp:" + this.bottomPawl + "|pi:" + this.pawlInterval;
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardAbstractLadder, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this50 = this;
      _context5.default.canvas.openModal(editBoardLadder, {
        element: this,
        x: this.posX / _context5.default.rescaleFactor,
        top: (this.posY - this.height / 2) / _context5.default.rescaleFactor,
        bottom: (this.posY + this.height / 2) / _context5.default.rescaleFactor,
        topPawl: this.topPawl / _context5.default.rescaleFactor,
        bottomPawl: this.bottomPawl / _context5.default.rescaleFactor,
        pawlInterval: this.pawlInterval / _context5.default.rescaleFactor,
        fixed: this.fixed
      }, function (data) {
        _this50.update(data);
      });
    }
  }, {
    key: "createFrame",
    value: function createFrame(width, height) {
      this.fr = this.frame.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: _context5.default.WHITE
      });
      this.fr.owner = this;
      this.frPawls = this.frame.group();
      this.el = this.plain.rect(-width / 2, -height / 2, width, height).attr({
        stroke: _context5.default.BLACK,
        fill: _context5.default.GREY
      });
      this.el.owner = this;
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        _superPropGet(BoardAbstractLadder, "update", this, 3)([data]);
        var y = (data.top + data.bottom) * _context5.default.rescaleFactor / 2;
        var height = (data.bottom - data.top) * _context5.default.rescaleFactor;
        this.position(data.x * _context5.default.rescaleFactor, y);
        this.fr.attr({
          height: height,
          y: -height / 2
        });
        this.el.attr({
          height: height,
          y: -height / 2
        });
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "isFixed",
    value: function isFixed() {
      return _superPropGet(BoardAbstractLadder, "isFixed", this, 3)([]) || this.clippsed.size > 0;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardAbstractLadder, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardAbstractLadder, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
    }
  }, {
    key: "clips",
    value: function clips(element, x, y) {
      _superPropGet(BoardAbstractLadder, "clips", this, 3)([element, x, y]);
      this.fixing();
    }
  }, {
    key: "unclips",
    value: function unclips(element) {
      var result = _superPropGet(BoardAbstractLadder, "unclips", this, 3)([element]);
      this.fixing();
      return result;
    }
  }]);
}(BoardBaseAbstractLadder);
window.BoardLadder = /*#__PURE__*/function (_BoardAbstractLadder) {
  function BoardLadder(width, height, topPawl, bottomPawl, pawlInterval) {
    (0, _classCallCheck2.default)(this, BoardLadder);
    return _callSuper(this, BoardLadder, [width, height, topPawl, bottomPawl, pawlInterval]);
  }
  (0, _inherits2.default)(BoardLadder, _BoardAbstractLadder);
  return (0, _createClass2.default)(BoardLadder, [{
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardLadder(this.width, this.height, this.topPawl, this.bottomPawl, this.pawlInterval);
      return copy;
    }
  }, {
    key: "pawls",
    value: /*#__PURE__*/_regenerator.default.mark(function pawls() {
      var y;
      return _regenerator.default.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            y = this.topPawl;
          case 1:
            if (!(y <= this.bottomPawl)) {
              _context3.next = 3;
              break;
            }
            _context3.next = 2;
            return {
              x: 0,
              y: y
            };
          case 2:
            y += this.pawlInterval;
            _context3.next = 1;
            break;
          case 3:
          case "end":
            return _context3.stop();
        }
      }, pawls, this);
    })
  }, {
    key: "accept",
    value: function accept(x, margin) {
      return Math.abs(x - this.posX) <= margin;
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Ladder" + _superPropGet(BoardLadder, "modelId", this, 3)([]);
    }
  }, {
    key: "type",
    get: function get() {
      return "Ladder";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardLadder, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        topPawl: this.topPawl / _context5.default.rescaleFactor,
        bottomPawl: this.bottomPawl / _context5.default.rescaleFactor,
        pawlInterval: this.pawlInterval / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardLadder, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardLadder.create(model.width, model.height, model.topPawl, model.bottomPawl, model.pawlInterval);
    }
  }]);
}(BoardAbstractLadder);
BoardLadder.create = function (width, height, topPawl, bottomPawl, pawlInterval) {
  return new BoardLadder(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, topPawl * _context5.default.rescaleFactor, bottomPawl * _context5.default.rescaleFactor, pawlInterval * _context5.default.rescaleFactor);
};
window.BoardDoubleLadder = /*#__PURE__*/function (_BoardAbstractLadder2) {
  function BoardDoubleLadder(width, height, topPawl, bottomPawl, pawlInterval) {
    (0, _classCallCheck2.default)(this, BoardDoubleLadder);
    return _callSuper(this, BoardDoubleLadder, [width, height, topPawl, bottomPawl, pawlInterval]);
  }
  (0, _inherits2.default)(BoardDoubleLadder, _BoardAbstractLadder2);
  return (0, _createClass2.default)(BoardDoubleLadder, [{
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardDoubleLadder(this.width, this.height, this.topPawl, this.bottomPawl, this.pawlInterval);
      return copy;
    }
  }, {
    key: "pawls",
    value: /*#__PURE__*/_regenerator.default.mark(function pawls() {
      var width, y;
      return _regenerator.default.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            width = this.width;
            y = this.topPawl;
          case 1:
            if (!(y <= this.bottomPawl)) {
              _context4.next = 4;
              break;
            }
            _context4.next = 2;
            return {
              x: -width / 4,
              y: y
            };
          case 2:
            _context4.next = 3;
            return {
              x: width / 4,
              y: y
            };
          case 3:
            y += this.pawlInterval;
            _context4.next = 1;
            break;
          case 4:
          case "end":
            return _context4.stop();
        }
      }, pawls, this);
    })
  }, {
    key: "accept",
    value: function accept(x, margin) {
      return Math.abs(x - this.posX + this.width / 4) <= margin || Math.abs(x - this.posX - this.width / 4) <= margin;
    }
  }, {
    key: "indexFromTop",
    value: function indexFromTop(index, count) {
      return Math.floor((index + 1) / 2);
    }
  }, {
    key: "indexFromBottom",
    value: function indexFromBottom(index, count) {
      return Math.floor(count / 2) - this.indexFromTop(index, count) + 1;
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "DoubleLadder" + _superPropGet(BoardDoubleLadder, "modelId", this, 3)([]);
    }
  }, {
    key: "type",
    get: function get() {
      return "DoubleLadder";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardDoubleLadder, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        topPawl: this.topPawl / _context5.default.rescaleFactor,
        bottomPawl: this.bottomPawl / _context5.default.rescaleFactor,
        pawlInterval: this.pawlInterval / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardDoubleLadder, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardDoubleLadder.create(model.width, model.height, model.topPawl, model.bottomPawl, model.pawlInterval);
    }
  }]);
}(BoardAbstractLadder);
BoardDoubleLadder.create = function (width, height, topPawl, bottomPawl, pawlInterval) {
  return new BoardDoubleLadder(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, topPawl * _context5.default.rescaleFactor, bottomPawl * _context5.default.rescaleFactor, pawlInterval * _context5.default.rescaleFactor);
};
window.BoardFixing = /*#__PURE__*/function (_BoardItem10) {
  function BoardFixing() {
    var _this51;
    (0, _classCallCheck2.default)(this, BoardFixing);
    var createGraphics = function createGraphics(group, strokeColor, fillColor) {
      var base = group.group();
      var item = base.rect(-FIXING_WIDTH / 2, -FIXING_HEIGHT / 2, FIXING_WIDTH, FIXING_HEIGHT).attr({
        stroke: strokeColor,
        fill: fillColor
      });
      item.owner = (0, _assertThisInitialized2.default)(_this51);
      item = base.circle(-FIXING_WIDTH / 4, 0, FIXING_DEVICE_RADIUS).attr({
        stroke: strokeColor,
        fill: fillColor
      });
      item.owner = (0, _assertThisInitialized2.default)(_this51);
      item = base.circle(FIXING_WIDTH / 4, 0, FIXING_DEVICE_RADIUS).attr({
        stroke: strokeColor,
        fill: fillColor
      });
      item.owner = (0, _assertThisInitialized2.default)(_this51);
      return base;
    };
    _this51 = _callSuper(this, BoardFixing, [FIXING_WIDTH, FIXING_HEIGHT]);
    _this51.dragOperation(_context5.default.standardDrag);
    _this51.fr = createGraphics(_this51.frame, _context5.default.BLACK, _context5.default.WHITE);
    _this51.el = createGraphics(_this51.plain, _context5.default.BLACK, _context5.default.GREY);
    _this51.clippsed = null;
    return _this51;
  }
  (0, _inherits2.default)(BoardFixing, _BoardItem10);
  return (0, _createClass2.default)(BoardFixing, [{
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardFixing, "createContextMenu", this, 3)([]);
      this.makeMoveable();
    }
  }, {
    key: "move",
    value: function move(x, xRelative, y, yRelative) {
      var fx = xRelative ? this.posX + x : x;
      var fy = yRelative ? this.posY + y : y;
      this.position(fx, fy);
    }
  }, {
    key: "layer",
    get: function get() {
      return "down";
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this52 = this;
      _context5.default.canvas.openModal(editBoardFixing, {
        element: this,
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor,
        fixed: this.fixed
      }, function (data) {
        _this52.update(data);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        this.position(data.x * _context5.default.rescaleFactor, data.y * _context5.default.rescaleFactor);
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "isFixed",
    value: function isFixed() {
      return _superPropGet(BoardFixing, "isFixed", this, 3)([]) || this.clippsed != null;
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Fixing";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return {
        id: this.modelId(),
        type: "Fixing"
      };
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardFixing, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardFixing, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardFixing();
      return copy;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardFixing, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      memento.clippsed = this.clippsed;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardFixing, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this.clippsed = memento.clippsed;
    }
  }, {
    key: "searchFixing",
    value: function searchFixing(x, y, margin) {
      if (!this.clippsed) {
        var matrix = this.localTranslation.invert();
        var lx = matrix.x(x, y);
        var ly = matrix.y(x, y);
        var distance = lx * lx + ly * ly;
        if (distance <= margin * margin) {
          matrix = this.localTranslation;
          return {
            support: this,
            x: matrix.x(0, 0),
            y: matrix.y(0, 0),
            distance: Math.sqrt(distance)
          };
        }
      }
      return null;
    }
  }, {
    key: "clips",
    value: function clips(element, x, y) {
      this.register();
      var matrix = this.localTranslation.invert();
      this.clippsed = {
        element: element
      };
      this.fixing();
      this.observe(element);
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      if (this.clippsed) {
        var copy = elements.get(this);
        var copyClippsed = elements.get(this.clippsed.element);
        if (copyClippsed) {
          copy.clippsed = {
            element: copyClippsed
          };
          copy.observe(copyClippsed);
        }
      }
      _superPropGet(BoardFixing, "linkContent", this, 3)([elements]);
    }
  }, {
    key: "unclips",
    value: function unclips(element) {
      this.register();
      if (this.clippsed && this.clippsed.element === element) {
        this.clippsed = null;
        this.fixing();
        this.forget(element);
        return true;
      }
      return false;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      _superPropGet(BoardFixing, "changed", this, 3)([source, type, value]);
      if (type === "removed" && this.clippsed && source === this.clippsed.element) {
        this.unclips(source);
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardFixing, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      var _computePosition2 = (0, _toolkit.computePosition)(this.root, this.host.root, element.posX, element.posY),
        x = _computePosition2.x,
        y = _computePosition2.y;
      element.position(x, y);
      this.host.add(element);
      result = this.host.receiveDrop(element);
      return result;
    }
  }, {
    key: "adjustDrop",
    value: function adjustDrop(element) {
      this.host.adjustDrop(element);
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardFixing.create();
    }
  }]);
}(BoardItem);
BoardFixing.create = function () {
  return new BoardFixing();
};
window.BoardHook = /*#__PURE__*/function (_BoardItem11) {
  function BoardHook() {
    var _this53;
    (0, _classCallCheck2.default)(this, BoardHook);
    function pathString(w, b, h, r) {
      return "M ".concat(-w / 2, " ").concat(b, " L ").concat(-w / 2, " ").concat(b - h + r, " Q ").concat(-w / 2, " ").concat(b - h, " 0 ").concat(b - h, " Q ").concat(w / 2, " ").concat(b - h, " ").concat(w / 2, " ").concat(b - h + r, " L ").concat(w / 2, " ").concat(b, " L ").concat(-w / 2, " ").concat(b);
    }
    var createGraphics = function createGraphics(group, strokeColor, fillColor) {
      var base = group.group();
      var item = base.path(pathString(_context5.default.HOOK_WIDTH, _context5.default.HOOK_HEIGHT / 2, _context5.default.HOOK_HEIGHT, _context5.default.HOOK_RADIUS) + " " + pathString(_context5.default.HOOK_WIDTH - _context5.default.HOOK_SIZE * 2, _context5.default.HOOK_HEIGHT / 2, _context5.default.HOOK_HEIGHT - _context5.default.HOOK_SIZE, _context5.default.HOOK_RADIUS - _context5.default.HOOK_SIZE / 2)).attr({
        stroke: strokeColor,
        fill: fillColor
      });
      item.owner = (0, _assertThisInitialized2.default)(_this53);
      return base;
    };
    _this53 = _callSuper(this, BoardHook, [_context5.default.HOOK_WIDTH, _context5.default.HOOK_HEIGHT, true]);
    _this53.dragOperation(_context5.default.standardDrag);
    _this53.fr = createGraphics(_this53.frame, _context5.default.BLACK, _context5.default.WHITE);
    _this53.el = createGraphics(_this53.plain, _context5.default.BLACK, _context5.default.GREY);
    _this53.root.add(_this53.owned);
    _this53.clippsed = null;
    return _this53;
  }
  (0, _inherits2.default)(BoardHook, _BoardItem11);
  return (0, _createClass2.default)(BoardHook, [{
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardHook, "createContextMenu", this, 3)([]);
      this.makeMoveable();
    }
  }, {
    key: "move",
    value: function move(x, xRelative, y, yRelative) {
      var fx = xRelative ? this.posX + x : x;
      var fy = yRelative ? this.posY + y : y;
      this.position(fx, fy);
    }
  }, {
    key: "layer",
    get: function get() {
      return "up";
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this54 = this;
      _context5.default.canvas.openModal(editBoardHook, {
        element: this,
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor,
        fixed: this.fixed
      }, function (data) {
        _this54.update(data);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        this.fix(data.fixed);
        this.position(data.x * _context5.default.rescaleFactor, data.y * _context5.default.rescaleFactor);
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "isFixed",
    value: function isFixed() {
      return _superPropGet(BoardHook, "isFixed", this, 3)([]) || this.clippsed != null;
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Hook";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return {
        id: this.modelId(),
        type: "Hook"
      };
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardHook, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor
      });
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardHook, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardHook();
      return copy;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardHook, "memento", this, 3)([]);
      memento.fr = this.fr;
      memento.el = this.el;
      memento.clippsed = this.clippsed;
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardHook, "revert", this, 3)([memento]);
      this.fr = memento.fr;
      this.el = memento.el;
      this.clippsed = memento.clippsed;
    }
  }, {
    key: "_hook",
    value: function _hook() {
      var matrix = this.localTranslation;
      return {
        support: this,
        x: matrix.x(0, 0),
        y: matrix.y(0, 0)
      };
    }
  }, {
    key: "searchHook",
    value: function searchHook(x, y, margin) {
      if (!this.clippsed) {
        var matrix = this.localTranslation.invert();
        var lx = matrix.x(x, y);
        var ly = matrix.y(x, y);
        var distance = lx * lx + ly * ly;
        if (distance <= margin * margin) {
          var hook = this._hook();
          hook.distance = Math.sqrt(distance);
          matrix = this.localTranslation;
          return hook;
        }
      }
      return null;
    }
  }, {
    key: "clips",
    value: function clips(element, x, y) {
      this.register();
      var matrix = this.localTranslation.invert();
      this.clippsed = {
        element: element
      };
      this.fixing();
      this.observe(element);
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      if (this.clippsed) {
        var copy = elements.get(this);
        var copyClippsed = elements.get(this.clippsed.element);
        if (copyClippsed) {
          copy.clippsed = {
            element: copyClippsed
          };
          copy.observe(copyClippsed);
        }
      }
      _superPropGet(BoardHook, "linkContent", this, 3)([elements]);
    }
  }, {
    key: "unclips",
    value: function unclips(element) {
      this.register();
      if (this.clippsed && this.clippsed.element === element) {
        this.clippsed = null;
        this.fixing();
        this.forget(element);
        return true;
      }
      return false;
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      _superPropGet(BoardHook, "changed", this, 3)([source, type, value]);
      if (type === "removed" && this.clippsed && source === this.clippsed.element) {
        this.unclips(source);
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardHook, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      var _computePosition3 = (0, _toolkit.computePosition)(this.root, this.host.root, element.posX, element.posY),
        x = _computePosition3.x,
        y = _computePosition3.y;
      element.position(x, y);
      this.host.add(element);
      return this.host.receiveDrop(element);
    }
  }, {
    key: "adjustDrop",
    value: function adjustDrop(element) {
      this.host.adjustDrop(element);
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardHook.create();
    }
  }]);
}(BoardItem);
BoardHook.create = function () {
  return new BoardHook();
};
window.BoardShelf = /*#__PURE__*/function (_BoardItem12) {
  function BoardShelf(width, height, coverHeight, coverY, leftClip, rightClip, labelText, bottomAdhesive) {
    var _this55;
    (0, _classCallCheck2.default)(this, BoardShelf);
    _this55 = _callSuper(this, BoardShelf, [width, height]);
    _this55.leftClip = {
      x: leftClip.x,
      y: leftClip.y
    };
    _this55.rightClip = {
      x: rightClip.x,
      y: rightClip.y
    };
    _this55.coverHeight = coverHeight;
    _this55.coverY = coverY;
    _this55.bottomAdhesive = bottomAdhesive;
    _this55.dragOperation(_context5.default.standardDrag);
    _this55.cover = new BoardCover(_this55, width, coverHeight, labelText);
    _this55.add(_this55.cover.position(0, _this55.coverY));
    _this55.drawClip(_this55.leftClip);
    _this55.drawClip(_this55.rightClip);
    return _this55;
  }
  (0, _inherits2.default)(BoardShelf, _BoardItem12);
  return (0, _createClass2.default)(BoardShelf, [{
    key: "drawClip",
    value: function drawClip(clip) {
      this.decorate.line(clip.x, clip.y - 5, clip.x, clip.y + 5).attr({
        stroke: _context5.default.SMOOTH_GREY
      });
      this.decorate.line(clip.x - 5, clip.y, clip.x + 5, clip.y).attr({
        stroke: _context5.default.SMOOTH_GREY
      });
    }
  }, {
    key: "createContextMenu",
    value: function createContextMenu() {
      this.makeEditable();
      _superPropGet(BoardShelf, "createContextMenu", this, 3)([]);
    }
  }, {
    key: "layer",
    get: function get() {
      return "up";
    }
  }, {
    key: "copyContent",
    value: function copyContent(copy, elements) {
      elements.set(this.cover, copy.cover);
      this.cover.copyContent(copy.cover, elements);
    }
  }, {
    key: "edit",
    value: function edit() {
      var _this56 = this;
      _context5.default.canvas.openModal(editBoardShelf, {
        element: this,
        fixed: this.fixed,
        labelText: this.cover.labelText,
        height: this.height / _context5.default.rescaleFactor,
        coverHeight: this.coverHeight / _context5.default.rescaleFactor,
        coverY: this.coverY / _context5.default.rescaleFactor,
        bottomAdhesive: this.bottomAdhesive
      }, function (data) {
        _this56.update(data);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!_context5.default.isReadOnly()) {
        _context5.default.memento.open();
        this.register();
        data.width = this.width / _context5.default.rescaleFactor;
        this.fix(data.fixed);
        this.bottomAdhesive = data.bottomAdhesive;
        this.coverHeight = data.coverHeight * _context5.default.rescaleFactor;
        this.coverY = data.coverY * _context5.default.rescaleFactor;
        this._height = data.height * _context5.default.rescaleFactor;
        this.cover.update(data, "coverHeight");
        this.cover.position(0, this.coverY);
        this._dispatchChange("geometry");
        if (this.parent() && this.parent()._dispatchChange) {
          this.parent()._dispatchChange("child-geometry", this);
        }
      }
    }
  }, {
    key: "stickOnBottom",
    value: function stickOnBottom(element) {
      if (this.bottomAdhesive) {
        if (element instanceof BoardModule) {
          this.addSticked(element);
        }
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Shelf|w:" + this.width + "|h:" + this.height + "|lm:" + this.leftClip.x + "," + this.leftClip.y + "|rm:" + this.rightClip.x + "," + this.rightClip.y + "|ba:" + this.bottomAdhesive;
    }
  }, {
    key: "type",
    get: function get() {
      return "Shelf";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      var justModel = function justModel(clip) {
        return {
          x: clip.x / _context5.default.rescaleFactor,
          y: clip.y / _context5.default.rescaleFactor
        };
      };
      return _objectSpread(_objectSpread({}, _superPropGet(BoardShelf, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        coverHeight: this.coverHeight / _context5.default.rescaleFactor,
        coverY: this.coverY / _context5.default.rescaleFactor,
        leftClip: justModel(this.leftClip),
        rightClip: justModel(this.rightClip),
        bottomAdhesive: this.bottomAdhesive
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var justData = function justData(clip) {
        return {
          support: clip.support.id,
          index: clip.index,
          count: clip.count
        };
      };
      var result = _objectSpread(_objectSpread({}, _superPropGet(BoardShelf, "serializeSpec", this, 3)([])), {}, {
        x: this.posX / _context5.default.rescaleFactor,
        y: this.posY / _context5.default.rescaleFactor,
        labelText: this.cover.labelText
      });
      if (this.leftClip) result.leftClip = justData(this.leftClip);
      if (this.rightClip) result.rightClip = justData(this.rightClip);
      return result;
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      current.cover = [];
      var _iterator49 = _createForOfIteratorHelper(this.cover.children()),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var element = _step49.value;
          var result = element.serialize(models, objects);
          current.cover.push(result);
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
    }
  }, {
    key: "startDeserialize",
    value: function startDeserialize(spec, models, built) {
      _superPropGet(BoardShelf, "startDeserialize", this, 3)([spec, models, built]);
      this.position(spec.x * _context5.default.rescaleFactor, spec.y * _context5.default.rescaleFactor);
      this.cover._makeLabels(spec.labelText);
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      var _iterator50 = _createForOfIteratorHelper(spec.cover),
        _step50;
      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var childSpec = _step50.value;
          this.cover._add(BoardElement.deserializeItem(childSpec, models, built));
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      var justClip = function justClip(thisClip, clip) {
        return {
          support: built.get(clip.support),
          x: thisClip.x,
          y: thisClip.y,
          index: clip.index,
          count: clip.count
        };
      };
      _superPropGet(BoardShelf, "endDeserialize", this, 3)([spec, built]);
      if (spec.leftClip) {
        this.deserializeClips(justClip(this.leftClip, spec.leftClip), justClip(this.rightClip, spec.rightClip));
      }
    }
  }, {
    key: "duplicate",
    value: function duplicate() {
      var copy = new BoardShelf(this.width, this.height, this.coverHeight, this.coverY, this.leftClip, this.rightClip, this.cover.labelText, this.bottomAdhesive);
      return copy;
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardShelf, "memento", this, 3)([]);
      memento.bottomAdhesive = this.bottomAdhesive;
      memento.leftClip = (0, _toolkit.duplicate)(this.leftClip);
      memento.rightClip = (0, _toolkit.duplicate)(this.rightClip);
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardShelf, "revert", this, 3)([memento]);
      this.bottomAdhesive = memento.bottomAdhesive;
      this.leftClip = (0, _toolkit.duplicate)(memento.leftClip);
      this.rightClip = (0, _toolkit.duplicate)(memento.rightClip);
      this.showAnchors();
    }
  }, {
    key: "cancelDrop",
    value: function cancelDrop() {
      _superPropGet(BoardShelf, "cancelDrop", this, 3)([]);
      if (this.leftClip.support) {
        this.leftClip.support.clips(this, this.posX + this.leftClip.x, this.poxY + this.leftClip.y);
      }
      if (this.rightClip.support) {
        this.rightClip.support.clips(this, this.posX + this.rightClip.x, this.posY + this.rightClip.y);
      }
    }
  }, {
    key: "clips",
    value: function clips() {
      var matrix = this.localTranslation;
      return {
        left: {
          x: matrix.x(this.leftClip.x, this.leftClip.y),
          y: matrix.y(this.leftClip.x, this.leftClip.y)
        },
        right: {
          x: matrix.x(this.rightClip.x, this.rightClip.y),
          y: matrix.y(this.rightClip.x, this.rightClip.y)
        }
      };
    }
  }, {
    key: "linkContent",
    value: function linkContent(elements) {
      _superPropGet(BoardShelf, "linkContent", this, 3)([elements]);
      var copy = elements.get(this);
      var leftSupport = elements.get(this.leftClip.support);
      var rightSupport = elements.get(this.rightClip.support);
      if (leftSupport && rightSupport) {
        if (this.leftClip) {
          copy.leftClip = {
            support: leftSupport,
            x: this.leftClip.x,
            y: this.leftClip.y,
            index: this.leftClip.index,
            count: this.leftClip.count
          };
        }
        if (this.rightClip) {
          copy.rightClip = {
            support: rightSupport,
            x: this.rightClip.x,
            y: this.rightClip.y,
            index: this.rightClip.index,
            count: this.rightClip.count
          };
        }
        copy.showAnchors();
      }
    }
  }, {
    key: "clipsOn",
    value: function clipsOn(leftClip, rightClip) {
      this.register();
      this.adjustPosition((leftClip.x + rightClip.x) / 2, (leftClip.y + rightClip.y) / 2);
      this._clipsOn(leftClip, rightClip);
    }
  }, {
    key: "unclips",
    value: function unclips() {
      this.register();
      this._unclips();
    }
  }, {
    key: "deserializeClips",
    value: function deserializeClips(leftClip, rightClip) {
      this._clipsOn({
        support: leftClip.support,
        x: this.posX + leftClip.x,
        y: this.posY + leftClip.y,
        index: leftClip.index,
        count: leftClip.count
      }, {
        support: rightClip.support,
        x: this.posX + rightClip.x,
        y: this.posY + rightClip.y,
        index: rightClip.index,
        count: rightClip.count
      });
    }
  }, {
    key: "_unclips",
    value: function _unclips() {
      delete this.leftClip.support;
      delete this.leftClip.index;
      delete this.leftClip.count;
      delete this.rightClip.support;
      delete this.rightClip.index;
      delete this.rightClip.count;
      if (this.leftAnchor) {
        this.leftAnchor.remove();
        delete this.leftAnchor;
      }
      if (this.rightAnchor) {
        this.rightAnchor.remove();
        delete this.rightAnchor;
      }
    }
  }, {
    key: "_clipsOn",
    value: function _clipsOn(leftClip, rightClip) {
      leftClip.support.clips(this, leftClip.x, leftClip.y);
      rightClip.support.clips(this, rightClip.x, rightClip.y);
      this.leftClip.support = leftClip.support;
      this.leftClip.index = leftClip.index;
      this.leftClip.count = leftClip.count;
      this.rightClip.support = rightClip.support;
      this.rightClip.index = rightClip.index;
      this.rightClip.count = rightClip.count;
      this.showAnchors();
    }
  }, {
    key: "showAnchors",
    value: function showAnchors() {
      if (this.leftClip.support && this.rightClip.support) {
        this.leftAnchor = this.decorate.group().transform(new _snap.default.Matrix().translate(-this.width / 2, 0)).text(2, 0, this.leftClip.support.indexFromTop(this.leftClip.index, this.leftClip.count) + "/" + this.leftClip.support.indexFromBottom(this.leftClip.index, this.leftClip.count)).attr({
          "font-size": 8,
          "text-anchor": "start",
          "alignment-baseline": "central"
        });
        this.rightAnchor = this.decorate.group().transform(new _snap.default.Matrix().translate(this.width / 2, 0)).text(-2, 0, this.rightClip.support.indexFromTop(this.rightClip.index, this.rightClip.count) + "/" + this.rightClip.support.indexFromBottom(this.rightClip.index, this.rightClip.count)).attr({
          "font-size": 8,
          "text-anchor": "end",
          "alignment-baseline": "central"
        });
      }
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardShelf, "receiveDrop", this, 3)([element]);
      return result === undefined ? false : result;
    }
  }, {
    key: "tryToClip",
    value: function tryToClip(host) {
      var clips = this.clips();
      var leftResult = host.searchPawl(clips.left.x, clips.left.y, _context5.default.PAWL_SEARCH_MARGIN);
      if (!leftResult) return false;
      var rx = clips.right.x + leftResult.x - clips.left.x;
      var ry = clips.right.y + leftResult.y - clips.left.y;
      var rightResult = host.searchPawl(rx, ry, _context5.default.CLIPS_MARGIN);
      if (!rightResult) return false;
      this._clips = {
        leftResult: leftResult,
        rightResult: rightResult
      };
      return true;
    }
  }, {
    key: "executeClip",
    value: function executeClip() {
      if (this._clips) {
        this.clipsOn(this._clips.leftResult, this._clips.rightResult);
        delete this._clips;
      }
    }
  }, {
    key: "addCarried",
    value: function addCarried(element) {
      var _this57 = this;
      _superPropGet(BoardShelf, "addCarried", this, 3)([element]);
      setTimeout(function () {
        if (_context5.default.magnetActivated) {
          _this57.magnetise();
        }
      }, 0);
    }
  }, {
    key: "magnetise",
    value: function magnetise() {
      function getPhysics() {
        var parent = this.parent();
        while (parent) {
          if (parent.physics) return parent.physics;
          parent = parent.parent();
        }
        return null;
      }
      if (!_context5.default.isReadOnly()) {
        var _elements = new _toolkit.List();
        var _iterator51 = _createForOfIteratorHelper(this.carried.values()),
          _step51;
        try {
          for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
            var record = _step51.value;
            _elements.add(record.element);
          }
        } catch (err) {
          _iterator51.e(err);
        } finally {
          _iterator51.f();
        }
        var physics = getPhysics.call(this);
        _elements.sort(function (e1, e2) {
          return e1.posX - e2.posX;
        });
        _elements[0].position(this.posLeft + _elements[0].width / 2, _elements[0].posY);
        for (var index = 1; index < _elements.length; index++) {
          var left = _elements[index - 1].posRight;
          var right = _elements[index].posLeft;
          var top = _elements[index].posTop;
          var bottom = this.posTop;
          _elements[index].position(_elements[index - 1].posRight + _elements[index].width / 2, _elements[index].posY);
          physics && physics.updateElement(_elements[index]);
        }
      }
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return BoardShelf.create(model.width, model.height, model.coverHeight, model.coverY, model.leftClip, model.rightClip, model.bottomAdhesive);
    }
  }]);
}(BoardItem);
BoardShelf.create = function (width, height, coverHeight, coverY, leftClip, rightClip, labelText, bottomAdhesive) {
  return new BoardShelf(width * _context5.default.rescaleFactor, height * _context5.default.rescaleFactor, coverHeight * _context5.default.rescaleFactor, coverY * _context5.default.rescaleFactor, {
    x: leftClip.x * _context5.default.rescaleFactor,
    y: leftClip.y * _context5.default.rescaleFactor
  }, {
    x: rightClip.x * _context5.default.rescaleFactor,
    y: rightClip.y * _context5.default.rescaleFactor
  }, labelText, bottomAdhesive);
};
window.BoardDraftLayer = /*#__PURE__*/function (_BoardLayer) {
  function BoardDraftLayer(paper, margin) {
    var _this58;
    (0, _classCallCheck2.default)(this, BoardDraftLayer);
    _this58 = _callSuper(this, BoardDraftLayer, [paper, margin]);
    _this58.downLayer = _this58.content.group();
    _this58.middleLayer = _this58.content.group();
    _this58.upLayer = _this58.content.group();
    return _this58;
  }
  (0, _inherits2.default)(BoardDraftLayer, _BoardLayer);
  return (0, _createClass2.default)(BoardDraftLayer, [{
    key: "_add",
    value: function _add(element) {
      if (element.layer === "up") {
        this.upLayer.add(element.root);
      } else if (element.layer === "middle") {
        this.middleLayer.add(element.root);
      } else if (element.layer === "down") {
        this.downLayer.add(element.root);
      }
    }
  }, {
    key: "_children",
    value: function _children() {
      var children = new _toolkit.List();
      var _iterator52 = _createForOfIteratorHelper(this.downLayer.children()),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var child = _step52.value;
          child.owner && children.add(child.owner);
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      var _iterator53 = _createForOfIteratorHelper(this.middleLayer.children()),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _child6 = _step53.value;
          _child6.owner && children.add(_child6.owner);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
      var _iterator54 = _createForOfIteratorHelper(this.upLayer.children()),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var _child7 = _step54.value;
          _child7.owner && children.add(_child7.owner);
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return children;
    }
  }]);
}(BoardLayer);
window.BoardPaper = /*#__PURE__*/function (_BoardArea) {
  function BoardPaper(width, height, background) {
    var _this59;
    (0, _classCallCheck2.default)(this, BoardPaper);
    _this59 = _callSuper(this, BoardPaper, [width, height, background]);
    _this59.rect.attr({
      x: -width / 2,
      y: -height / 2
    });
    _this59.baseLayer = new BoardLayer(_this59, PAPER_MARGIN);
    _this59.add(_this59.baseLayer);
    _this59.draftLayer = new BoardDraftLayer(_this59, 0);
    _this59.add(_this59.draftLayer);
    _this59.physics = new _physics.Physics(_this59.baseLayer, function (element) {
      var result = !element.free && (element instanceof BoardPane || element instanceof BoardModule);
      return result;
    });
    _this59.observe(_this59.draftLayer);
    _this59.observe(_context5.default.copyPasteManager);
    _this59.makeResizeable();
    return _this59;
  }
  (0, _inherits2.default)(BoardPaper, _BoardArea);
  return (0, _createClass2.default)(BoardPaper, [{
    key: "editSize",
    value: function editSize() {
      var _this60 = this;
      _context5.default.canvas.openModal(editPaper, {
        element: this,
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor
      }, function (data) {
        _this60.update(data);
      });
    }
  }, {
    key: "update",
    value: function update(data) {
      function move(elements, offset) {
        var _iterator55 = _createForOfIteratorHelper(elements),
          _step55;
        try {
          for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
            var element = _step55.value;
            element.position(element.posX + offset, element.posY);
          }
        } catch (err) {
          _iterator55.e(err);
        } finally {
          _iterator55.f();
        }
      }
      _context5.default.memento.open();
      var dwidth = data.width * _context5.default.rescaleFactor - this.width;
      if (data.direction === "right") {
        move(this.baseLayer.children(), -dwidth / 2);
      } else if (data.direction === "left") {
        move(this.baseLayer.children(), dwidth / 2);
      }
      this.setSize(data.width * _context5.default.rescaleFactor, data.height * _context5.default.rescaleFactor);
    }
  }, {
    key: "allChildren",
    value: function allChildren() {
      return [].concat((0, _toConsumableArray2.default)(this.baseLayer.children()), (0, _toConsumableArray2.default)(this.draftLayer.children()));
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      _superPropGet(BoardPaper, "changed", this, 3)([source, type, value]);
      if (source === _context5.default.copyPasteManager && type === "paste-model") {
        var offset = this._pasteOffset !== undefined ? this._pasteOffset : 0;
        this._pasteOffset = (offset + 10) % 100;
        var _iterator56 = _createForOfIteratorHelper(value),
          _step56;
        try {
          for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
            var copy = _step56.value;
            if (!(copy instanceof BoardPdfArea)) {
              var x = copy.posX + offset;
              var y = copy.posY + offset;
              copy._setPosition(x, y);
              this.draftLayer.add(copy);
            }
          }
        } catch (err) {
          _iterator56.e(err);
        } finally {
          _iterator56.f();
        }
      } else if (source === this.draftLayer) {
        if (type === "add") {
          value.root.attr({
            filter: _context5.default.draftShadow
          });
        } else if (type === "remove") {
          value.root.attr({
            filter: null
          });
        }
      }
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      this.register();
      this.rect.attr({
        width: width,
        height: height,
        x: -width / 2,
        y: -height / 2
      });
      this.physics.clean(this.baseLayer.children());
      this._dispatchChange("geometry");
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Paper|w:" + this.width + "|h:" + this.height + "|c:" + this.color;
    }
  }, {
    key: "type",
    get: function get() {
      return "Paper";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardPaper, "serializeModel", this, 3)([])), {}, {
        width: this.width / _context5.default.rescaleFactor,
        height: this.height / _context5.default.rescaleFactor,
        color: this.color
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = {
        id: this.id,
        model: this.modelId(),
        children: []
      };
      return result;
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      var _iterator57 = _createForOfIteratorHelper(this.baseLayer.children()),
        _step57;
      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var element = _step57.value;
          this.serializeChild(element, models, current, objects);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
    }
  }, {
    key: "endSerialize",
    value: function endSerialize(models, objects) {
      this.baseLayer.endSerialize(models, objects);
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      if (spec.children) {
        var _iterator58 = _createForOfIteratorHelper(spec.children),
          _step58;
        try {
          for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
            var childSpec = _step58.value;
            this.baseLayer._add(this.startDeserializeChild(childSpec, models, built));
          }
        } catch (err) {
          _iterator58.e(err);
        } finally {
          _iterator58.f();
        }
      }
      if (spec.free) {
        var _iterator59 = _createForOfIteratorHelper(spec.free),
          _step59;
        try {
          for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
            var _childSpec7 = _step59.value;
            this.baseLayer._add(this.startDeserializeFreeChild(_childSpec7, models, built));
          }
        } catch (err) {
          _iterator59.e(err);
        } finally {
          _iterator59.f();
        }
      }
    }
  }, {
    key: "endDeserialize",
    value: function endDeserialize(spec, built) {
      _superPropGet(BoardPaper, "endDeserialize", this, 3)([spec, built]);
      this.physics.clean(this.baseLayer.children());
    }
  }, {
    key: "recover",
    value: function recover(memento) {
      this.physics.revert(this.baseLayer.children());
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardPaper, "memento", this, 3)([]);
      return memento;
    }
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardPaper, "revert", this, 3)([memento]);
    }
  }, {
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardPaper, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      if (element instanceof BoardPane || element instanceof BoardModule) {
        if (element.posX - element.width / 2 < -this.width / 2 || element.posX + element.width / 2 > this.width / 2 || element.height > this.height * 0.95) {
          return false;
        }
        this.baseLayer.add(element);
        return true;
      }
      return false;
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      return new BoardPaper(model.width * _context5.default.rescaleFactor, model.height * _context5.default.rescaleFactor, model.color);
    }
  }]);
}(BoardArea);
window.BoardTable = /*#__PURE__*/function (_BoardArea2) {
  function BoardTable(width, height, background, paperWidth, paperHeight, paperBackground) {
    var _this61;
    (0, _classCallCheck2.default)(this, BoardTable);
    _this61 = _callSuper(this, BoardTable, [width, height, background]);
    _this61.position(width / 2, height / 2);
    _context5.default.canvas.setSize(width, height);
    _this61.baseLayer = new BoardLayer(_this61, 0);
    _this61.add(_this61.baseLayer);
    _this61.pdfLayer = new BoardPdfLayer(_this61, 0);
    _this61.add(_this61.pdfLayer);
    if (!_context5.default.selectPdfAreaActivated) {
      _this61.pdfLayer.hide();
    }
    _this61.paper = new BoardPaper(paperWidth, paperHeight, paperBackground);
    _this61.widthMargin = width - paperWidth;
    _this61.heightMargin = height - paperHeight;
    _this61.observe(_this61.paper);
    _this61.observe(_context5.default.canvas);
    _this61.observe(_context5.default.copyPasteManager);
    _this61.baseLayer.add(_this61.paper);
    _context5.default.canvas.addToBase(_this61.root);
    return _this61;
  }
  (0, _inherits2.default)(BoardTable, _BoardArea2);
  return (0, _createClass2.default)(BoardTable, [{
    key: "receiveDrop",
    value: function receiveDrop(element) {
      var result = _superPropGet(BoardTable, "receiveDrop", this, 3)([element]);
      if (result !== undefined) return result;
      this.addElement(element);
      return true;
    }
  }, {
    key: "addElement",
    value: function addElement(element) {
      if (element instanceof BoardPdfArea) {
        this.pdfLayer.add(element);
      } else {
        this.baseLayer.add(element);
      }
    }
  }, {
    key: "memento",
    value: function memento() {
      var memento = _superPropGet(BoardTable, "memento", this, 3)([]);
      memento.paper = this.paper;
      memento.widthMargin = this.widthMargin;
      memento.heightMargin = this.heightMargin;
      return memento;
    }
  }, {
    key: "revertRoot",
    value: function revertRoot(memento) {}
  }, {
    key: "revert",
    value: function revert(memento) {
      _superPropGet(BoardTable, "revert", this, 3)([memento]);
      this.paper = memento.paper;
      this.widthMargin = memento.widthMargin;
      this.heightMargin = memento.heightMargin;
      _context5.default.canvas.setSize(memento.width, memento.height);
    }
  }, {
    key: "changed",
    value: function changed(source, type, value) {
      if (source === _context5.default.copyPasteManager && type === "paste-model") {
        var _iterator60 = _createForOfIteratorHelper(value),
          _step60;
        try {
          for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
            var copy = _step60.value;
            if (copy instanceof BoardPdfArea) {
              this.pdfLayer.add(copy);
            }
          }
        } catch (err) {
          _iterator60.e(err);
        } finally {
          _iterator60.f();
        }
      } else if (source === this.paper && type === "geometry") {
        this.adjustSize();
      } else if (source === _context5.default.canvas && type === "geometry") {
        this.adjustSize();
      }
    }
  }, {
    key: "adjustSize",
    value: function adjustSize() {
      var width = this.paper.width + this.widthMargin;
      var height = this.paper.height + this.heightMargin;
      var _iterator61 = _createForOfIteratorHelper(this.children()),
        _step61;
      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var element = _step61.value;
          if (element != this.paper) {
            var dx = element.posX - element.width / 2;
            if (dx < -width / 2) width = -dx * 2;
            dx = element.posX + element.width / 2;
            if (dx > width / 2) width = dx * 2;
            var dy = element.posY - element.height / 2;
            if (dy < -height / 2) height = -dy * 2;
            dy = element.posY + element.height / 2;
            if (dy > height / 2) height = dy * 2;
          }
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
      var awidth = height / _context5.default.canvas.clientHeight * _context5.default.canvas.clientWidth;
      var aheight = width / _context5.default.canvas.clientWidth * _context5.default.canvas.clientHeight;
      width = Math.max(width, awidth);
      height = Math.max(height, aheight);
      if (width != this.width || height != this.height) {
        var pw = this.width - this.widthMargin;
        var ph = this.height - this.heightMargin;
        this.setSize(width, height);
      }
    }
  }, {
    key: "children",
    value: function children() {
      return (0, _construct2.default)(_toolkit.List, (0, _toConsumableArray2.default)(this.baseLayer.children()).concat((0, _toConsumableArray2.default)(this.pdfLayer.children())));
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      if (this.width !== width || this.height !== height) {
        _superPropGet(BoardTable, "setSize", this, 3)([width, height]);
        _context5.default.canvas.setSize(width, height);
        this.position(width / 2, height / 2);
      }
    }
  }, {
    key: "modelId",
    value: function modelId() {
      return "Table|c:" + this.color;
    }
  }, {
    key: "type",
    get: function get() {
      return "Table";
    }
  }, {
    key: "serializeModel",
    value: function serializeModel() {
      return _objectSpread(_objectSpread({}, _superPropGet(BoardTable, "serializeModel", this, 3)([])), {}, {
        width: (this.widthMargin + this.paper.width) / _context5.default.rescaleFactor,
        height: (this.heightMargin + this.paper.height) / _context5.default.rescaleFactor,
        color: this.color
      });
    }
  }, {
    key: "serializeSpec",
    value: function serializeSpec() {
      var result = {
        id: this.id,
        model: this.modelId(),
        children: []
      };
      return result;
    }
  }, {
    key: "serializeChildren",
    value: function serializeChildren(models, current, objects) {
      var _iterator62 = _createForOfIteratorHelper(this.children()),
        _step62;
      try {
        for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
          var element = _step62.value;
          var result = element.serialize(models, objects);
          if (element === this.paper) {
            current.paper = result;
          } else {
            result.x = element.posX / _context5.default.rescaleFactor;
            result.y = element.posY / _context5.default.rescaleFactor;
            current.children.push(result);
          }
        }
      } catch (err) {
        _iterator62.e(err);
      } finally {
        _iterator62.f();
      }
    }
  }, {
    key: "startDeserializeChildren",
    value: function startDeserializeChildren(spec, models, built) {
      this.paper.startDeserialize(spec.paper, models, built);
      this.paper.id = spec.paper.id;
      if (spec.children) {
        var _iterator63 = _createForOfIteratorHelper(spec.children),
          _step63;
        try {
          for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
            var childSpec = _step63.value;
            var element = this.startDeserializeChild(childSpec, models, built);
            element.position(childSpec.x * _context5.default.rescaleFactor, childSpec.y * _context5.default.rescaleFactor);
            this.addElement(element);
          }
        } catch (err) {
          _iterator63.e(err);
        } finally {
          _iterator63.f();
        }
      }
      if (spec.free) {
        var _iterator64 = _createForOfIteratorHelper(spec.free),
          _step64;
        try {
          for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
            var _childSpec8 = _step64.value;
            this.addElement(this.startDeserializeFreeChild(_childSpec8, models, built));
          }
        } catch (err) {
          _iterator64.e(err);
        } finally {
          _iterator64.f();
        }
      }
    }
  }, {
    key: "endDeserializeChildren",
    value: function endDeserializeChildren(spec, built) {
      this.paper.endDeserialize(spec.paper, built);
      _superPropGet(BoardTable, "endDeserializeChildren", this, 3)([spec, built]);
      _context5.default.canvas.setSize(this.width, this.height);
    }
  }], [{
    key: "build",
    value: function build(spec, models) {
      var model = models.get(spec.model);
      var paperModel = models.get(spec.paper.model);
      return new BoardTable(model.width * _context5.default.rescaleFactor, model.height * _context5.default.rescaleFactor, model.color, paperModel.width * _context5.default.rescaleFactor, paperModel.height * _context5.default.rescaleFactor, paperModel.color);
    }
  }]);
}(BoardArea);
function elements() {
  _context5.default.menus.generateLaddersLabel = "Generate ladders";
  _context5.default.menus.generateFixingsLabel = "Generate fixings";
  _context5.default.menus.generateHooksLabel = "Generate hooks";
  _context5.default.menus.extendsPaneLabel = "Extend pane";
  _context5.default.menus.gridLabel = "\u2610 Grid";
  _context5.default.menus.ungridLabel = "\uD83D\uDDF9 Grid";
  _context5.default.LEGEND_MARGIN = 20;
  _context5.default.TEXT_LEGEND_MARGIN = 2;
  _context5.default.generateLaddersMenuOption = new _toolkit.TextMenuOption("generateLaddersLabel", _context5.default.menuOptionStrategies.NONE);
  _context5.default.generateFixingsMenuOption = new _toolkit.TextMenuOption("generateFixingsLabel", _context5.default.menuOptionStrategies.NONE);
  _context5.default.generateHooksMenuOption = new _toolkit.TextMenuOption("generateHooksLabel", _context5.default.menuOptionStrategies.NONE);
  _context5.default.extendsPaneMenuOption = new _toolkit.TextMenuOption("extendsPaneLabel", _context5.default.menuOptionStrategies.UNIQUE);
  _context5.default.gridMenuOption = new _toolkit.TextToggleMenuOption("gridLabel", _context5.default.menuOptionStrategies.SHAREABLE, "ungridLabel");
  _context5.default.headerAndFooterMenuOption = new _toolkit.TextToggleMenuOption("showHeaderAndFooterLabel", _context5.default.menuOptionStrategies.SHAREABLE, "hideHeaderAndFooterLabel");
  _context5.default.coverMenuOption = new _toolkit.TextToggleMenuOption("showCoverAndFasciasLabel", _context5.default.menuOptionStrategies.SHAREABLE, "hideCoverAndFasciasLabel");
  _context5.default.menus.hideCoverAndFasciasLabel = "Hide cover and fascias";
  _context5.default.menus.showCoverAndFasciasLabel = "Show cover and fascias";
  _context5.default.SHELF_SPIKE_SPIKE = 5;
  _context5.default.physicsManager.addRecordCreator(function (element, xAxis, yAxis, elementRegistry) {
    if (element instanceof BoardShelf) {
      return new _physics.SpikedRecord(element, xAxis, yAxis, elementRegistry, _context5.default.SHELF_SPIKE_SPIKE);
    }
  });
  _context5.default.table = undefined;
  _context5.default.PAWL_SEARCH_MARGIN = 20;
  _context5.default.FIXING_SEARCH_MARGIN = 50;
  _context5.default.CLIPS_MARGIN = 0.01;
  _context5.default.HOOK_WIDTH = 10;
  _context5.default.HOOK_HEIGHT = 10;
  _context5.default.HOOK_RADIUS = 6;
  _context5.default.HOOK_SIZE = 2;
  _context5.default.INITIAL_TABLE_WIDTH = 4000;
  _context5.default.INITIAL_TABLE_HEIGHT = 2000;
  _context5.default.INITIAL_PAPER_WIDTH = 1200;
  _context5.default.INITIAL_PAPER_HEIGHT = 800;
  _context5.default.table = new BoardTable(_context5.default.INITIAL_TABLE_WIDTH, _context5.default.INITIAL_TABLE_HEIGHT, _context5.default.LIGHT_GREY, _context5.default.INITIAL_PAPER_WIDTH, _context5.default.INITIAL_PAPER_HEIGHT, _context5.default.WHITE);
  _context5.default.zoomMin();
  _context5.default.canvas.baseMove(_context5.default.INITIAL_TABLE_WIDTH / 2, _context5.default.INITIAL_TABLE_HEIGHT / 2);
  _context5.default.serialize = function (elements) {
    var models = new Map();
    var specs = new Map();
    var content = [];
    var _iterator65 = _createForOfIteratorHelper(elements),
      _step65;
    try {
      for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
        var element = _step65.value;
        content.push(element.serialize(models, specs));
      }
    } catch (err) {
      _iterator65.e(err);
    } finally {
      _iterator65.f();
    }
    var _iterator66 = _createForOfIteratorHelper(elements),
      _step66;
    try {
      for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
        var _element6 = _step66.value;
        _element6.endSerialize(models, specs);
      }
    } catch (err) {
      _iterator66.e(err);
    } finally {
      _iterator66.f();
    }
    var groupSpecs = serializeGroups(specs);
    var builder = {
      models: (0, _toConsumableArray2.default)(models.values()),
      content: content
    };
    if (groupSpecs.length) builder.groups = groupSpecs;
    return builder;
  };
  _context5.default.deserialize = function (description) {
    if (description) {
      _context5.default.memento.opened = false;
      var built = new Map();
      var models = new Map();
      var _iterator67 = _createForOfIteratorHelper(description.models),
        _step67;
      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var model = _step67.value;
          models.set(model.id, model);
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
      var _elements2 = new Map();
      var _iterator68 = _createForOfIteratorHelper(description.content),
        _step68;
      try {
        for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
          var elementSpec = _step68.value;
          var element = BoardElement.deserializeItem(elementSpec, models, built);
          element.removeMe();
          _elements2.set(element, elementSpec);
        }
      } catch (err) {
        _iterator68.e(err);
      } finally {
        _iterator68.f();
      }
      var _iterator69 = _createForOfIteratorHelper(_elements2.keys()),
        _step69;
      try {
        for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
          var _element7 = _step69.value;
          _element7.endDeserialize(_elements2.get(_element7), built);
        }
      } catch (err) {
        _iterator69.e(err);
      } finally {
        _iterator69.f();
      }
      _context5.default.memento.opened = true;
      return (0, _construct2.default)(_toolkit.List, (0, _toConsumableArray2.default)(_elements2.keys()));
    }
    return new _toolkit.List();
  };
  function serializeGroups(objects) {
    function addGroup(groups, group) {
      if (!groups.has(group)) {
        groups.add(group);
        var _iterator70 = _createForOfIteratorHelper(group.content()),
          _step70;
        try {
          for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
            var child = _step70.value;
            if (child instanceof _toolkit.Group) {
              addGroup(groups, child);
            }
          }
        } catch (err) {
          _iterator70.e(err);
        } finally {
          _iterator70.f();
        }
      }
    }
    var specs = [];
    var groups = new Set();
    var _iterator71 = _createForOfIteratorHelper(objects.keys()),
      _step71;
    try {
      for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
        var element = _step71.value;
        var group = _context5.default.groupManager.group(element);
        if (group) addGroup(groups, group);
      }
    } catch (err) {
      _iterator71.e(err);
    } finally {
      _iterator71.f();
    }
    var _iterator72 = _createForOfIteratorHelper(groups),
      _step72;
    try {
      for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
        var _group = _step72.value;
        var groupSpec = {
          id: _group.id
        };
        var _iterator73 = _createForOfIteratorHelper(_group.content()),
          _step73;
        try {
          for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
            var _element8 = _step73.value;
            if (_element8 instanceof _toolkit.Group) {
              if (!groupSpec.groups) groupSpec.groups = [];
              groupSpec.groups.push(_element8.id);
            } else {
              if (!groupSpec.elements) groupSpec.elements = [];
              groupSpec.elements.push(_element8.id);
            }
          }
        } catch (err) {
          _iterator73.e(err);
        } finally {
          _iterator73.f();
        }
        specs.push(groupSpec);
      }
    } catch (err) {
      _iterator72.e(err);
    } finally {
      _iterator72.f();
    }
    return specs;
  }
  function deserializeGroups(groupsSpec, built) {
    var groups = new Map();
    var _iterator74 = _createForOfIteratorHelper(groupsSpec),
      _step74;
    try {
      for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
        var groupSpec = _step74.value;
        var group = new _toolkit.Group();
        group.id = groupSpec.id;
        groups.set(groupSpec.id, group);
        if (groupSpec.elements) {
          var _iterator77 = _createForOfIteratorHelper(groupSpec.elements),
            _step77;
          try {
            for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
              var elementId = _step77.value;
              group._content.add(built.get(elementId));
            }
          } catch (err) {
            _iterator77.e(err);
          } finally {
            _iterator77.f();
          }
        }
      }
    } catch (err) {
      _iterator74.e(err);
    } finally {
      _iterator74.f();
    }
    var rootGroups = new Set(groups.values());
    var _iterator75 = _createForOfIteratorHelper(groupsSpec),
      _step75;
    try {
      for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
        var _groupSpec = _step75.value;
        var _group2 = groups.get(_groupSpec.id);
        if (_groupSpec.groups) {
          var _iterator78 = _createForOfIteratorHelper(_groupSpec.groups),
            _step78;
          try {
            for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
              var groupId = _step78.value;
              var child = groups.get(groupId);
              rootGroups.delete(child);
              _group2._content.add(child);
            }
          } catch (err) {
            _iterator78.e(err);
          } finally {
            _iterator78.f();
          }
        }
      }
    } catch (err) {
      _iterator75.e(err);
    } finally {
      _iterator75.f();
    }
    var _iterator76 = _createForOfIteratorHelper(rootGroups),
      _step76;
    try {
      for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
        var _group3 = _step76.value;
        _context5.default.groupManager.registerGroup(_group3);
      }
    } catch (err) {
      _iterator76.e(err);
    } finally {
      _iterator76.f();
    }
  }
  _context5.default.save = function () {
    var models = new Map();
    var specs = new Map();
    var content = _context5.default.table.serialize(models, specs);
    _context5.default.table.endSerialize(models, specs);
    var groupSpecs = serializeGroups(specs);
    var plano = {
      models: (0, _toConsumableArray2.default)(models.values()),
      content: content
    };
    if (groupSpecs.length) plano.groups = groupSpecs;
    return plano;
  };
  _context5.default.load = function (description) {
    if (description) {
      _context5.default.memento.opened = false;
      _context5.default.memento.reset();
      _context5.default.visualizer.reset();
      _context5.default.groupManager.reset();
      _context5.default.selection.reset();
      _context5.default.copyPasteManager.reset();
      _context5.default.physicsManager.reset();
      _context5.default.catalog.reset();
      _context5.default.table.removeMe();
      var built = new Map();
      var models = new Map();
      var _iterator79 = _createForOfIteratorHelper(description.models),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var model = _step79.value;
          models.set(model.id, model);
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
      (0, _toolkit.evaluate)("start deserialize", function () {
        _context5.default.table = BoardElement.deserializeItem(description.content, models, built);
      }, "load");
      (0, _toolkit.evaluate)("end deserialize", function () {
        _context5.default.table.endDeserializeChildren(description.content, built);
      }, "load");
      if (description.groups) {
        deserializeGroups(description.groups, built);
      }
      _context5.default.table.adjustSize();
      _context5.default.memento.opened = true;
    }
  };
  _context5.default.showCoversAndFascias = function (element) {
    var elements = new Set(_context5.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator80 = _createForOfIteratorHelper(elements),
      _step80;
    try {
      for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
        var _element9 = _step80.value;
        if (_element9.caddyCover) _element9.caddyCover.show();
        if (_element9.fasciaSupport) _element9.fasciaSupport.show();
        if (_element9.frameSupport) _element9.frameSupport.show();
      }
    } catch (err) {
      _iterator80.e(err);
    } finally {
      _iterator80.f();
    }
  };
  _context5.default.hideCoversAndFascias = function (element) {
    var elements = new Set(_context5.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator81 = _createForOfIteratorHelper(elements),
      _step81;
    try {
      for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
        var _element0 = _step81.value;
        if (_element0.caddyCover) _element0.caddyCover.hide();
        if (_element0.fasciaSupport) _element0.fasciaSupport.hide();
        if (_element0.frameSupport) _element0.frameSupport.hide();
      }
    } catch (err) {
      _iterator81.e(err);
    } finally {
      _iterator81.f();
    }
  };
  _context5.default.coversAndFasciasVisible = function (element) {
    var elements = new Set(_context5.default.selection.workingSelection);
    if (element) elements.add(element);
    var visible = true;
    var _iterator82 = _createForOfIteratorHelper(elements),
      _step82;
    try {
      for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
        var _element1 = _step82.value;
        if (_element1.caddyCover && !_element1.caddyCover.visible()) {
          visible = false;
        }
      }
    } catch (err) {
      _iterator82.e(err);
    } finally {
      _iterator82.f();
    }
    return visible;
  };
  _context5.default.showHeaderAndFooter = function (element) {
    var elements = new Set(_context5.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator83 = _createForOfIteratorHelper(elements),
      _step83;
    try {
      for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
        var _element10 = _step83.value;
        _element10.paneHeader && _element10.paneHeader.show();
        _element10.paneFooter && _element10.paneFooter.show();
      }
    } catch (err) {
      _iterator83.e(err);
    } finally {
      _iterator83.f();
    }
  };
  _context5.default.hideHeaderAndFooter = function (element) {
    var elements = new Set(_context5.default.selection.workingSelection);
    if (element) elements.add(element);
    var _iterator84 = _createForOfIteratorHelper(elements),
      _step84;
    try {
      for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
        var _element11 = _step84.value;
        _element11.paneHeader && _element11.paneHeader.hide();
        _element11.paneFooter && _element11.paneFooter.hide();
      }
    } catch (err) {
      _iterator84.e(err);
    } finally {
      _iterator84.f();
    }
  };
  _context5.default.headerAndFooterVisible = function (element) {
    var elements = new Set(_context5.default.selection.workingSelection);
    if (element) elements.add(element);
    var visible = true;
    var _iterator85 = _createForOfIteratorHelper(elements),
      _step85;
    try {
      for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
        var _element12 = _step85.value;
        if (_element12.paneHeader && !_element12.paneHeader.visible()) {
          visible = false;
        }
      }
    } catch (err) {
      _iterator85.e(err);
    } finally {
      _iterator85.f();
    }
    return visible;
  };
}
},{"@babel/runtime/helpers/assertThisInitialized":"E7HD","@babel/runtime/helpers/defineProperty":"IxO8","@babel/runtime/helpers/construct":"dJhE","@babel/runtime/helpers/toConsumableArray":"Fhqp","@babel/runtime/helpers/classCallCheck":"fcMS","@babel/runtime/helpers/createClass":"P8NW","@babel/runtime/helpers/possibleConstructorReturn":"pxk2","@babel/runtime/helpers/getPrototypeOf":"UJE0","@babel/runtime/helpers/get":"J5UC","@babel/runtime/helpers/inherits":"d4H2","@babel/runtime/regenerator":"PMvg","../snap":"BQ54","./context":"FcC3","./physics":"WrMY","./toolkit":"m1yP"}],"ulXG":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTrads = setTrads;
var _context = _interopRequireDefault(require("./js/context"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var trads = {
  allPane: {
    fr: "Tous",
    en: "All"
  },
  furniturePane: {
    fr: "Meubles",
    en: "Furniture"
  },
  modulePane: {
    fr: "Modules",
    en: "Modules"
  },
  favoritesPane: {
    fr: "Favoris",
    en: "Favorites"
  },
  menus: {
    hideHeaderAndFooterLabel: {
      en: "Hide header and footer",
      fr: "Cacher fronton et base"
    },
    showHeaderAndFooterLabel: {
      en: "Show header and footer",
      fr: "Afficher fronton et base"
    },
    fixLabel: {
      fr: "Verrouiller",
      en: "Lock"
    },
    unfixLabel: {
      fr: "Déverrouiller",
      en: "Unlock"
    },
    editLabel: {
      fr: "Editer",
      en: "Edit"
    },
    removeLabel: {
      fr: "Supprimer",
      en: "Remove"
    },
    groupLabel: {
      fr: "Grouper",
      en: "Group"
    },
    ungroupLabel: {
      fr: "Dégrouper",
      en: "Ungroup"
    },
    highlightLabel: {
      fr: "Mêttre en surbrillance",
      en: "Highlight"
    },
    addToFavoritesLabel: {
      fr: "Ajouter aux favoris",
      en: "Add to favorites"
    },
    removeFromFavoritesLabel: {
      fr: "Retirer des favoris",
      en: "Remove from favorites"
    },
    generateLaddersLabel: {
      fr: "Générer les échelles",
      en: "Generate ladders"
    },
    generateFixingsLabel: {
      fr: "Générer les fixations",
      en: "Generate fixings"
    },
    generateHooksLabel: {
      fr: "Générer les crochets",
      en: "Generate hooks"
    },
    hideCoverAndFascias: {
      fr: "Cacher masque et fascias",
      en: "Hide cover and fascias"
    },
    hideCoverAndFasciasLabel: {
      fr: "Cacher masque et fascias",
      en: "Hide cover and fascias"
    },
    showCoverAndFascias: {
      fr: "Montrer masque et fascias",
      en: "Show cover and fascias"
    },
    extendsPaneLabel: {
      en: "Extend pane",
      fr: "Étendre la carcasse"
    },
    ungridLabel: {
      en: "☑ Grid",
      fr: "☑ Grille"
    },
    gridLabel: {
      en: "☐ Grid",
      fr: "☐ Grille"
    },
    editSizeLabel: {
      en: "Resize Paper",
      fr: "Redimensionner le papier"
    },
    moveLabel: {
      en: "Move",
      fr: "Déplacer"
    },
    legendLayerShown: {
      en: "☐ Legend",
      fr: "☐ Légende"
    },
    legendLayerHidden: {
      en: "☑ Legend",
      fr: "☑ Légende"
    },
    artworkLayerShown: {
      en: "☐ Artwork",
      fr: "☐ Artwork"
    },
    artworkLayerHidden: {
      en: "☑ Artwork",
      fr: "☑ Artwork"
    },
    realisticLayerHidden: {
      en: "☑ Realistic",
      fr: "☑ Réaliste"
    },
    realisticLayerShown: {
      en: "☐ Realistic",
      fr: "☐ Réaliste"
    },
    highlightLayerShown: {
      en: "☐ Highlight",
      fr: "☐ Highlight"
    },
    highlightLayerHidden: {
      en: "☑ Highlight",
      fr: "☑ Highlight"
    },
    ticketsLayerShown: {
      en: "☐ Tickets",
      fr: "☐ Tickets"
    },
    ticketsLayerHidden: {
      en: "☑ Tickets",
      fr: "☑ Tickets"
    },
    iconColorsLayerShown: {
      en: "☐ Icon Colors",
      fr: "☐ Icônes"
    },
    iconColorsLayerHidden: {
      en: "☑ Icon Colors",
      fr: "☑ Icônes"
    },
    referenceLayerShown: {
      en: "☐ Reference",
      fr: "☐ Réferences"
    },
    referenceLayerHidden: {
      en: "☑ Reference",
      fr: "☑ Réferences"
    },
    coverLayerShown: {
      en: "☐ Blanking Graphics",
      fr: "☐ Visuels pré-vente"
    },
    coverLayerHidden: {
      en: "☑ Blanking Graphics",
      fr: "☑ Visuels pré-vente"
    },
    moduleLayerShown: {
      en: "☐ Module",
      fr: "☐ Modules"
    },
    moduleLayerHidden: {
      en: "☑ Module",
      fr: "☑ Modules"
    }
  }
};
function setTrads(locale, panes, items) {
  for (var _i = 0, _Object$values = Object.values(panes); _i < _Object$values.length; _i++) {
    var pane = _Object$values[_i];
    pane.instance.setTitle(pane.data.label[locale]);
  }
  for (var _i2 = 0, _Object$values2 = Object.values(items); _i2 < _Object$values2.length; _i2++) {
    var item = _Object$values2[_i2];
    if (item.data.label.root) {
      item.data.label.name.innerText = item.data.label.trads.name[locale];
      item.data.label.diamRef.innerText = item.data.label.trads.diamRef && item.data.label.trads.diamRef[locale] || "";
      item.data.label.clientRef.innerText = item.data.label.trads.clientRef && item.data.label.trads.clientRef[locale] || "";
    }
  }
  for (var key in trads.menus) {
    _context.default.menus[key] = trads.menus[key][locale];
  }
}
},{"./js/context":"FcC3"}],"hWNS":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toolkit = _interopRequireDefault(require("./js/toolkit"));
var _tools = _interopRequireWildcard(require("./js/tools"));
var _physics = _interopRequireDefault(require("./js/physics"));
var _elements = _interopRequireDefault(require("./js/elements"));
var _context = _interopRequireDefault(require("./js/context"));
var _trads = require("./trads");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//

var catalogPanes = {};
function createCatalogPane(data) {
  var pane = new _tools.CatalogPane(data.label.en, data.predicate);
  _context.default.catalog.addPane(pane);
  return {
    instance: pane,
    data: data
  };
}
function updateCatalogPane(data, previous) {
  console.warn("update pane", data, previous);
}
function deleteCatalogPane(key) {
  var pane = catalogPanes[key];
  delete catalogPanes[key];
  pane.instance.root.node.remove();
}
function updateCatalogPanes(newCatalogPanes, previousPanes) {
  for (var _i = 0, _Object$keys = Object.keys(newCatalogPanes || {}); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (!catalogPanes[key]) {
      catalogPanes[key] = createCatalogPane(newCatalogPanes[key]);
    } else if (catalogPanes[key].data !== previousPanes[key]) {
      updateCatalogPane(newCatalogPanes[key], previousPanes[key]);
    }
  }
  for (var _i2 = 0, _Object$keys2 = Object.keys(previousPanes || {}); _i2 < _Object$keys2.length; _i2++) {
    var _key = _Object$keys2[_i2];
    if (!newCatalogPanes[_key]) {
      deleteCatalogPane(_key);
    }
  }
  _context.default.catalog.refresh();
}
var catalogItems = {};
function createCatalogItem(data) {
  var element = data.builder();
  if (data.data && data.data.status) {
    element.status = data.data.status;
    element.addDecoration(assets.icons.status[element.status.name], 3);
  }
  var item = new _tools.BoardItemBuilder(element, data.label.root, data.image);
  _context.default.catalog.addBuilder(item);
  return {
    instance: item,
    data: data
  };
}
function deleteCatalogItem(key) {
  var item = catalogItems[key];
  delete catalogItems[key];
  _context.default.catalog.removeBuilder(item.instance);
}
function updateCatalogItems(newCatalogItems, previousItems) {
  for (var _i3 = 0, _Object$keys3 = Object.keys(newCatalogItems || {}); _i3 < _Object$keys3.length; _i3++) {
    var key = _Object$keys3[_i3];
    if (!catalogItems[key]) {
      catalogItems[key] = createCatalogItem(newCatalogItems[key]);
    }
  }
  for (var _i4 = 0, _Object$keys4 = Object.keys(previousItems || {}); _i4 < _Object$keys4.length; _i4++) {
    var _key2 = _Object$keys4[_i4];
    if (!newCatalogItems[_key2]) {
      deleteCatalogItem(_key2);
    }
  }
  _context.default.catalog.refresh();
}
function translateAll(locale) {
  (0, _trads.setTrads)(locale, catalogPanes, catalogItems);
}
var _default = exports.default = {
  props: {
    assets: {},
    locale: String,
    catalogPanes: Object,
    catalogItems: Object
  },
  data: function data() {
    return {
      drawing: "drawing",
      previousCatalogPanes: undefined
    };
  },
  watch: {
    catalogPanes: updateCatalogPanes,
    catalogItems: updateCatalogItems,
    assets: function assets(value) {
      window.assets = value;
    },
    locale: translateAll
  },
  created: function created() {
    _context.default.catalogFilter = this.searchChanged;
    window.assets = this.assets;
  },
  mounted: function mounted() {
    window.addEventListener("focus-plano", this.focusPlanoListener);
    (0, _toolkit.default)(this.$refs.drawing.firstChild);
    (0, _tools.default)();
    (0, _physics.default)();
    (0, _elements.default)();
    updateCatalogItems(this.catalogItems);
    updateCatalogPanes(this.catalogPanes);
    translateAll(this.locale);
    _context.default.start();
  },
  methods: {
    focusPlanoListener: function focusPlanoListener() {
      this.$refs.drawing.focus();
    },
    searchChanged: function searchChanged(e) {
      this.$emit("search-changed", e);
    }
  },
  beforeDestroy: function beforeDestroy() {
    _context.default.catalogFilter = undefined;
    updateCatalogItems({}, this.catalogItems);
    updateCatalogPanes({}, this.catalogPanes);
    window.removeEventListener("focus-plano", this.focusPlanoListener);
    _context.default.stop();
  }
};
        var $763ecc = exports.default || module.exports;
      
      if (typeof $763ecc === 'function') {
        $763ecc = $763ecc.options;
      }
    
        /* template */
        Object.assign($763ecc, (function () {
          var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{ref:"drawing",staticClass:"drawing",attrs:{"id":"svgfocus","tabindex":"0"}},[_c('svg')])])}
var staticRenderFns = []

          return {
            render: render,
            staticRenderFns: staticRenderFns,
            _compiled: true,
            _scopeId: "data-v-763ecc",
            functional: undefined
          };
        })());
      
},{"./js/toolkit":"m1yP","./js/tools":"wHGe","./js/physics":"WrMY","./js/elements":"deFW","./js/context":"FcC3","./trads":"ulXG"}],"Focm":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Context", {
  enumerable: true,
  get: function () {
    return _context5.default;
  }
});
exports.Tools = exports.Toolkit = exports.Physics = exports.Elements = void 0;
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _app.default;
  }
});
exports.load = load;
exports.save = save;
exports.start = start;
exports.stop = stop;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _app = _interopRequireDefault(require("./app"));
var Tools = _interopRequireWildcard(require("./js/tools"));
exports.Tools = Tools;
var Toolkit = _interopRequireWildcard(require("./js/toolkit"));
exports.Toolkit = Toolkit;
var Elements = _interopRequireWildcard(require("./js/elements"));
exports.Elements = Elements;
var Physics = _interopRequireWildcard(require("./js/physics"));
exports.Physics = Physics;
var _context5 = _interopRequireDefault(require("./js/context"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function save() {
  return _context5.default.save.apply(_context5.default, arguments);
}
function waitUntil(_x, _x2) {
  return _waitUntil.apply(this, arguments);
}
function _waitUntil() {
  _waitUntil = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(image, cb) {
    var secureCounter, secureTimesMax;
    return _regenerator.default.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          secureCounter = 0;
          secureTimesMax = 30;
        case 1:
          if (!true) {
            _context.next = 5;
            break;
          }
          if (!cb()) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          if (!(secureCounter >= secureTimesMax)) {
            _context.next = 3;
            break;
          }
          console.warn("From the load : This Image is not loaded", image);
          return _context.abrupt("return");
        case 3:
          _context.next = 4;
          return new Promise(function (resolve) {
            setTimeout(resolve, 10);
          });
        case 4:
          secureCounter++;
          _context.next = 1;
          break;
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _waitUntil.apply(this, arguments);
}
function load(_x3) {
  return _load.apply(this, arguments);
}
function _load() {
  _load = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(plano) {
    var loadingImages, imageKeys, _iterator, _step, _loop, _t;
    return _regenerator.default.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          loadingImages = {};
          _context4.next = 1;
          return _context5.default.load(plano);
        case 1:
          imageKeys = ["imageURL", "plainURL", "realisticURL"];
          _iterator = _createForOfIteratorHelper(plano.models);
          _context4.prev = 2;
          _loop = /*#__PURE__*/_regenerator.default.mark(function _loop() {
            var model, _loop2, _i, _imageKeys;
            return _regenerator.default.wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  model = _step.value;
                  _loop2 = /*#__PURE__*/_regenerator.default.mark(function _loop2() {
                    var imageKey;
                    return _regenerator.default.wrap(function (_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          imageKey = _imageKeys[_i];
                          if (model[imageKey] && !loadingImages[model[imageKey]]) {
                            loadingImages[model[imageKey]] = waitUntil(model[imageKey], function () {
                              return _context5.default.images[model[imageKey]] !== undefined || _context5.default.svgImages[model[imageKey]] !== undefined;
                            });
                          }
                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }, _loop2);
                  });
                  _i = 0, _imageKeys = imageKeys;
                case 1:
                  if (!(_i < _imageKeys.length)) {
                    _context3.next = 3;
                    break;
                  }
                  return _context3.delegateYield(_loop2(), "t0", 2);
                case 2:
                  _i++;
                  _context3.next = 1;
                  break;
                case 3:
                case "end":
                  return _context3.stop();
              }
            }, _loop);
          });
          _iterator.s();
        case 3:
          if ((_step = _iterator.n()).done) {
            _context4.next = 5;
            break;
          }
          return _context4.delegateYield(_loop(), "t0", 4);
        case 4:
          _context4.next = 3;
          break;
        case 5:
          _context4.next = 7;
          break;
        case 6:
          _context4.prev = 6;
          _t = _context4["catch"](2);
          _iterator.e(_t);
        case 7:
          _context4.prev = 7;
          _iterator.f();
          return _context4.finish(7);
        case 8:
          _context4.next = 9;
          return Promise.all(Object.values(loadingImages));
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee2, null, [[2, 6, 7, 8]]);
  }));
  return _load.apply(this, arguments);
}
function start() {
  return _context5.default.start.apply(_context5.default, arguments);
}
function stop() {
  return _context5.default.stop.apply(_context5.default, arguments);
}
},{"@babel/runtime/helpers/asyncToGenerator":"agGE","@babel/runtime/regenerator":"PMvg","./app":"hWNS","./js/tools":"wHGe","./js/toolkit":"m1yP","./js/elements":"deFW","./js/physics":"WrMY","./js/context":"FcC3"}]},{},["Focm"], null)
//# sourceMappingURL=/index.js.map


//////////////////
// WEBPACK FOOTER
// ../plano_engine/dist/index.js
// module id = 38
// module chunks = 0